import { _ as _objectWithoutProperties, a as _extends } from './_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';

var IconAccountAttentionSolid = function IconAccountAttentionSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-account-attention-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M349.5 249.1A136.4 136.4 0 0 1 475.9 102.3 136.4 136.4 0 0 1 601.8 249.1 136.4 136.4 0 0 1 475.9 396.4 136.4 136.4 0 0 1 349.5 249.1ZM681.8 712.3L659.1 444.5A235.5 235.5 0 0 0 610.9 418.2 41.8 41.8 0 0 0 570 425 150.9 150.9 0 0 1 378.2 425 41.8 41.8 0 0 0 337.3 418.2 237.7 237.7 0 0 0 186.4 638.6V723.2A39.5 39.5 0 0 0 225.9 762.7H712.7A67.3 67.3 0 0 1 681.8 712.3ZM727.3 708.2A22.3 22.3 0 0 0 747.7 730L751.8 730A23.6 23.6 0 0 0 775.9 707.3L810.5 326.4A25 25 0 0 0 786.4 300H718.2A25 25 0 0 0 694.1 326.4L709.1 490ZM751.8 776.4A60.9 60.9 0 1 0 812.3 836.8 60.9 60.9 0 0 0 753.2 776.4Z"
  }));
};
IconAccountAttentionSolid.defaultProps = {
  title: 'account attention solid'
};
IconAccountAttentionSolid.propTypes = {
  title: PropTypes.string
};

var IconAccountAttention = function IconAccountAttention(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-account-attention",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M465 390.5A136.4 136.4 0 0 0 590.9 243.6 136.4 136.4 0 0 0 464.5 96.4 136.4 136.4 0 0 0 339.1 243.6 136.4 136.4 0 0 0 465 390.5ZM465 130.9A104.1 104.1 0 0 1 555.9 243.6 104.1 104.1 0 0 1 465 356.4 104.1 104.1 0 0 1 374.1 243.6 104.1 104.1 0 0 1 465 130.9ZM737.7 746.8L743.2 746.8A45.5 45.5 0 0 0 788.6 703.6L823.2 322.7A49.1 49.1 0 0 0 810.9 286.8 45.5 45.5 0 0 0 777.3 272.7H707.7A45.5 45.5 0 0 0 662.3 323.6L674.5 460A234.5 234.5 0 0 0 601.8 414.5 41.8 41.8 0 0 0 560.5 421.4 150 150 0 0 1 369.1 421.4 41.8 41.8 0 0 0 328.2 415 237.3 237.3 0 0 0 177.3 635V719.5A40 40 0 0 0 216.8 759.5H712.3A40 40 0 0 0 736.8 746.8ZM699.1 310.9A12.3 12.3 0 0 1 708.6 306.8H777.3A13.2 13.2 0 0 1 786.8 310.9 12.7 12.7 0 0 1 790 320.5L755.5 701.8A12.3 12.3 0 0 1 742.3 713.6 12.3 12.3 0 0 1 729.5 701.8L695 320.9A13.2 13.2 0 0 1 698.2 310.9ZM215.5 723.2A5.5 5.5 0 0 1 210 717.3V632.7A203.2 203.2 0 0 1 339.1 444.5 7.3 7.3 0 0 1 346.4 444.5 185 185 0 0 0 580.5 444.5 8.2 8.2 0 0 1 588.2 444.5 201.4 201.4 0 0 1 675.9 511.4 4.5 4.5 0 0 0 678.2 511.4L695.5 702.7A49.1 49.1 0 0 0 700.5 721.4ZM742.3 759.1A72.3 72.3 0 1 0 814.5 831.4 72.3 72.3 0 0 0 742.3 759.1ZM742.3 869.1A37.7 37.7 0 0 1 704.5 831.4 38.2 38.2 0 1 1 742.3 869.1Z"
  }));
};
IconAccountAttention.defaultProps = {
  title: 'account attention'
};
IconAccountAttention.propTypes = {
  title: PropTypes.string
};

var IconAccountSettingsSolid = function IconAccountSettingsSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-account-settings-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M247.7 260A142.7 142.7 0 0 1 378.2 108.2 142.3 142.3 0 0 1 508.2 260 142.3 142.3 0 0 1 378.2 411.8 142.7 142.7 0 0 1 247.7 260ZM425.9 710V648.6A64.1 64.1 0 0 1 486.8 584.5 190 190 0 0 1 509.5 545 63.6 63.6 0 0 1 534.5 460.5L550 451.4A191.8 191.8 0 0 0 517.7 435.9 42.7 42.7 0 0 0 475.9 442.7 156.8 156.8 0 0 1 276.4 442.7 42.3 42.3 0 0 0 234.5 435.9 245.9 245.9 0 0 0 78.6 663.2V750.9A40.5 40.5 0 0 0 119.1 791.4H495.5A158.6 158.6 0 0 1 486.8 773.6 64.1 64.1 0 0 1 425.9 710ZM921.4 648.6V710A18.6 18.6 0 0 1 902.7 729.1H874.5L874.5 732.7A190 190 0 0 1 832.7 805.9L829.5 808.6 843.6 833.2A17.3 17.3 0 0 1 843.6 847.3 17.3 17.3 0 0 1 835 859.1L781.8 889.5A16.8 16.8 0 0 1 773.6 891.8H772.7L766.8 891.8 764.5 891.8A17.3 17.3 0 0 1 758.2 885.5L744.1 860.9 740 860.9A161.8 161.8 0 0 1 698.2 865.9 185.5 185.5 0 0 1 655.9 860.9L651.8 860.9 637.7 885.5A21.4 21.4 0 0 1 626.4 894.1H620A18.6 18.6 0 0 1 611.8 891.8L558.6 861.4A20.9 20.9 0 0 1 550 849.5 17.3 17.3 0 0 1 550 835.5L564.1 810.9 560.9 808.2A202.3 202.3 0 0 1 539.1 778.2L536.4 772.7A175 175 0 0 1 519.5 733.6L519.5 730H491.8A19.1 19.1 0 0 1 472.7 710.9V648.6A18.6 18.6 0 0 1 491.8 630H519.5L519.5 625.9A185 185 0 0 1 561.4 553.2L564.5 550 550.5 525.5A17.3 17.3 0 0 1 550.5 511.4 20.9 20.9 0 0 1 559.1 499.5L584.5 485 612.3 469.1A18.6 18.6 0 0 1 620.5 466.8H626.4A20.9 20.9 0 0 1 638.2 475.5L652.3 500 656.4 500A184.5 184.5 0 0 1 698.2 495 191.8 191.8 0 0 1 740.5 500L744.5 500 758.6 475.5A17.3 17.3 0 0 1 765 469.1L767.3 469.1 773.2 469.1H772.7A16.8 16.8 0 0 1 780.9 471.4L834.1 501.8A17.3 17.3 0 0 1 842.7 513.6 17.3 17.3 0 0 1 842.7 527.7L828.6 552.3 831.8 555A181.8 181.8 0 0 1 856.8 589.1 175 175 0 0 1 873.6 628.2L873.6 632.3H901.8A18.6 18.6 0 0 1 921.4 648.6ZM766.8 638.6A78.6 78.6 0 0 0 717.7 600.9 71.8 71.8 0 0 0 696.4 597.7 84.1 84.1 0 0 0 655.9 608.6 81.4 81.4 0 0 0 675.5 757.7 69.1 69.1 0 0 0 694.5 760.5H700L714.1 760.5 719.5 760.5A97.3 97.3 0 0 0 737.3 753.2 81.8 81.8 0 0 0 766.8 641.8Z"
  }));
};
IconAccountSettingsSolid.defaultProps = {
  title: 'account settings solid'
};
IconAccountSettingsSolid.propTypes = {
  title: PropTypes.string
};

var IconAccountSettings = function IconAccountSettings(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-account-settings",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M366.8 400A141.8 141.8 0 0 0 496.8 248.2 142.3 142.3 0 0 0 366.8 96.4 142.7 142.7 0 0 0 236.4 248.2 142.3 142.3 0 0 0 366.8 400ZM366.8 130.9A108.6 108.6 0 0 1 462.7 248.2 108.6 108.6 0 0 1 366.8 365.9 108.6 108.6 0 0 1 272.7 248.2 108.6 108.6 0 0 1 366.8 130.9ZM891.4 595.5H879.5A246.4 246.4 0 0 0 865 564.1 248.6 248.6 0 0 0 845 535.5L850.9 525.5A42.3 42.3 0 0 0 855 494.1 42.7 42.7 0 0 0 835.5 468.6L782.3 437.7A41.8 41.8 0 0 0 727.3 454.5L721.4 464.5A220 220 0 0 0 652.3 464.5L644.5 454.5A42.7 42.7 0 0 0 619.1 435 42.3 42.3 0 0 0 587.7 439.1L560 455A227.3 227.3 0 0 0 506.4 425.9 42.7 42.7 0 0 0 464.5 432.7 157.7 157.7 0 0 1 265 432.7 42.3 42.3 0 0 0 223.2 425.9 245.9 245.9 0 0 0 67.3 653.2V740.9A40.5 40.5 0 0 0 107.7 781.4H511.4C515.9 788.2 520 795 525 801.4L519.5 811.4A40 40 0 0 0 515 842.7 42.7 42.7 0 0 0 534.5 868.2L587.7 898.6A42.7 42.7 0 0 0 608.6 904.5 34.1 34.1 0 0 0 619.5 904.5 40.5 40.5 0 0 0 644.5 885.5L650.5 875A207.3 207.3 0 0 0 719.5 875L725.5 885A41.8 41.8 0 0 0 782.3 900L835.5 869.5A42.7 42.7 0 0 0 855 844.1 42.3 42.3 0 0 0 850.9 812.7L845 802.7A221.8 221.8 0 0 0 879.5 742.3H891.4A41.4 41.4 0 0 0 932.7 700.9V636.4A41.8 41.8 0 0 0 891.4 595.5ZM107.7 746.4A6.4 6.4 0 0 1 101.4 740V652.3A210.5 210.5 0 0 1 235.5 454.5 7.7 7.7 0 0 1 243.6 454.5 191.8 191.8 0 0 0 485.9 454.5 8.2 8.2 0 0 1 494.1 454.5 188.6 188.6 0 0 1 528.6 471.8 42.7 42.7 0 0 0 515 491.8 40.9 40.9 0 0 0 519.5 523.6L525 533.6A212.7 212.7 0 0 0 490.5 593.6H479.1A41.8 41.8 0 0 0 437.3 635.5V696.8A41.8 41.8 0 0 0 479.1 738.2H490.5L493.2 744.5ZM898.6 698.6A7.3 7.3 0 0 1 891.4 705.9H854.5L850.9 718.2A175.9 175.9 0 0 1 811.8 786.4L803.2 795.9 821.4 827.3A9.1 9.1 0 0 1 818.6 837.7L765.5 868.2A7.7 7.7 0 0 1 755 865.5L736.8 834.1 724.5 836.8A178.6 178.6 0 0 1 645.5 836.8L633.2 833.6 615 865.5A7.3 7.3 0 0 1 610.5 869.1L615 885.5 604.5 868.2 551.8 837.7A7.3 7.3 0 0 1 548.2 833.2 6.8 6.8 0 0 1 548.2 827.3L566.4 795.9 557.7 786.4A160.5 160.5 0 0 1 534.1 754.5 152.3 152.3 0 0 1 518.2 718.2L514.5 705.9H478.2A7.3 7.3 0 0 1 470.5 698.6V636.4A7.7 7.7 0 0 1 478.2 628.6H514.5L518.2 616.8A176.4 176.4 0 0 1 557.7 548.2L566.4 539.1 548.2 507.7A6.8 6.8 0 0 1 548.2 501.8 6.4 6.4 0 0 1 551.8 497.3L604.5 466.4A9.1 9.1 0 0 1 610.5 466.4 7.3 7.3 0 0 1 615 470L633.2 501.4 645.5 500A166.4 166.4 0 0 1 724.5 500L736.8 502.7 755 471.4A8.2 8.2 0 0 1 765.5 468.2L818.2 500A9.1 9.1 0 0 1 820.9 510.5L802.7 541.8 811.4 550.9A190.5 190.5 0 0 1 835 583.2 171.4 171.4 0 0 1 850.5 619.5L854.5 631.4H890.9A7.7 7.7 0 0 1 898.2 639.1ZM711.8 567.3A101.4 101.4 0 0 0 633.2 577.7 104.1 104.1 0 0 0 658.2 768.6 112.3 112.3 0 0 0 685.5 772.3 110.9 110.9 0 0 0 737.3 758.2 103.6 103.6 0 0 0 785.5 695H785.5A103.6 103.6 0 0 0 711.8 567.3ZM752.7 685.9A70 70 0 0 1 666.8 735.5 66.8 66.8 0 0 1 624.5 702.7 69.5 69.5 0 0 1 650 607.3 68.6 68.6 0 0 1 685 597.7 63.2 63.2 0 0 1 703.2 600.5 69.1 69.1 0 0 1 752.7 685.9Z"
  }));
};
IconAccountSettings.defaultProps = {
  title: 'account settings'
};
IconAccountSettings.propTypes = {
  title: PropTypes.string
};

var IconAccountSolid = function IconAccountSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-account-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M249.1 254.5A142.7 142.7 0 0 1 380 102.3 142.7 142.7 0 0 1 510.5 254.5 142.7 142.7 0 0 1 380 409.1 142.7 142.7 0 0 1 249.1 254.5ZM331.8 557.7A96.4 96.4 0 0 1 387.3 540.5 95 95 0 0 1 449.5 563.6L524.1 626.8 629.5 516.8A245.9 245.9 0 0 0 520.5 431.4 42.3 42.3 0 0 0 478.6 438.2 157.7 157.7 0 0 1 278.2 438.2 45.5 45.5 0 0 0 235.9 431.4 247.3 247.3 0 0 0 79.1 658.6V746.4A40.9 40.9 0 0 0 120 787.3H367.7L305.9 694.1A100.9 100.9 0 0 1 331.8 557.7ZM909.1 355.5H909.1A42.3 42.3 0 0 0 878.6 342.7H878.6A41.8 41.8 0 0 0 847.7 355.9L654.5 557.7 528.6 689.5 421.4 598.6A41.8 41.8 0 0 0 405 590.9 24.1 24.1 0 0 0 399.5 590.9 45.5 45.5 0 0 0 388.2 590.9 42.3 42.3 0 0 0 377.7 590.9L372.7 590.9A45.5 45.5 0 0 0 358.2 597.7 54.5 54.5 0 0 0 344.1 671.8L421.8 791.4 470.5 863.6A75 75 0 0 0 488.6 883.2 73.2 73.2 0 0 0 534.1 898.2L545.5 898.2A75.5 75.5 0 0 0 595.5 866.8L913.6 415A45.5 45.5 0 0 0 909.1 355.5Z"
  }));
};
IconAccountSolid.defaultProps = {
  title: 'account solid'
};
IconAccountSolid.propTypes = {
  title: PropTypes.string
};

var IconAccount = function IconAccount(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-account",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M374.1 401.4A143.2 143.2 0 0 0 505 249.1 143.2 143.2 0 0 0 374.1 96.4 143.2 143.2 0 0 0 243.6 249.1 143.2 143.2 0 0 0 374.1 401.4ZM374.1 128.6A109.5 109.5 0 0 1 470.9 247.3 109.1 109.1 0 0 1 374.1 365.5 109.1 109.1 0 0 1 277.7 247.3 109.5 109.5 0 0 1 374.1 130.5ZM909.1 341.8H909.1A54.5 54.5 0 0 0 870.5 325.5H870.5A53.2 53.2 0 0 0 831.8 342.3L640.9 541.8A242.7 242.7 0 0 0 514.1 425.9 42.3 42.3 0 0 0 471.8 432.7 158.2 158.2 0 0 1 272.7 432.7 41.4 41.4 0 0 0 230.9 425.5 246.8 246.8 0 0 0 74.1 652.7V740.5A40.5 40.5 0 0 0 114.5 780.9H402.7L454.5 863.6A95.5 95.5 0 0 0 475.5 885.5 84.5 84.5 0 0 0 526.4 903.2 61.8 61.8 0 0 0 539.5 903.2 87.7 87.7 0 0 0 597.3 867.3L915.5 415.5A57.3 57.3 0 0 0 909.1 341.8ZM112.7 750.9A6.4 6.4 0 0 1 106.4 744.5V654.5A212.7 212.7 0 0 1 242.7 457.3 9.1 9.1 0 0 1 250.9 457.3 193.2 193.2 0 0 0 494.1 457.3 8.2 8.2 0 0 1 502.3 457.3 209.1 209.1 0 0 1 616.8 567.3L520.5 668.2 421.8 584.1A62.3 62.3 0 0 0 345.9 580 65.9 65.9 0 0 0 329.1 670.9L380.5 749.5ZM885.5 396.8L567.3 851.4A51.8 51.8 0 0 1 532.7 873.2 49.5 49.5 0 0 1 494.1 863.2 45.5 45.5 0 0 1 481.4 849.5L357.7 651.4A31.4 31.4 0 0 1 363.6 608.2 25.5 25.5 0 0 1 379.5 603.2 28.6 28.6 0 0 1 398.2 610L521.4 715 855.5 365.9A19.5 19.5 0 0 1 870 359.5 14.5 14.5 0 0 1 884.1 365.9 22.3 22.3 0 0 1 888.2 394.5Z"
  }));
};
IconAccount.defaultProps = {
  title: 'account'
};
IconAccount.propTypes = {
  title: PropTypes.string
};

var IconAirportSolid = function IconAirportSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-airport-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M720.9 234.5C751.4 265 675.5 346.4 625.9 400L651.8 627.3A10.5 10.5 0 0 1 648.6 636.4L627.3 658.2A2.7 2.7 0 0 1 624.5 658.2 6.4 6.4 0 0 1 619.5 655L574.1 560 563.2 569.1A5 5 0 0 1 559.5 569.1 5.5 5.5 0 0 1 555.5 569.1L549.5 563.2A6.4 6.4 0 0 1 549.5 555.5L563.2 540 534.1 481.8C486.4 521.8 434.5 561.4 403.6 585.9V662.7A10.5 10.5 0 0 1 400.5 671.8L392.7 681.8 390 681.8A4.1 4.1 0 0 1 386.4 679.1L346.8 607.3 272.7 567.3A3.2 3.2 0 0 1 272.7 561.4L278.6 555A27.3 27.3 0 0 1 287.7 551.8H363.6C388.2 521.4 428.2 469.1 468.2 421.8L409.1 392.3 395.9 409.1A5.5 5.5 0 0 1 391.8 409.1S388.6 409.1 388.2 409.1L381.8 401.8A7.7 7.7 0 0 1 381.8 394.1L392.7 383.2 297.7 337.7C294.5 337.7 293.2 332.7 297.7 330L318.2 306.4A25.5 25.5 0 0 1 327.7 303.6L555 329.5C600.5 284.1 664.5 227.3 702.3 227.3A25.5 25.5 0 0 1 720.9 234.5ZM909.1 425.5C909.1 570 839.1 712.3 706.8 836.8A960.9 960.9 0 0 1 505 983.2 9.1 9.1 0 0 1 500 983.2 11.4 11.4 0 0 1 494.5 983.2 1009.1 1009.1 0 0 1 293.2 834.5C160.9 709.1 90.9 567.3 90.9 425.5A409.1 409.1 0 1 1 909.1 425.5ZM743.2 211.8A57.3 57.3 0 0 0 702.3 195.5C665 195.5 619.1 225 544.1 296.4L330.5 272.7H326.8A55 55 0 0 0 303.2 279.1L298.6 279.1 295 282.7 272.7 305.5A35 35 0 0 0 262.3 337.3 36.4 36.4 0 0 0 283.2 363.6L349.1 396.4A36.4 36.4 0 0 0 359.5 423.6L363.6 430.5A37.3 37.3 0 0 0 390 440.9 38.2 38.2 0 0 0 415.5 431.4L417.7 431.4C400 454.5 381.4 480 363.6 500L347.7 519.5H288.2A45.5 45.5 0 0 0 265 526.4L260.5 528.6 256.8 532.3 250.5 538.2A36.8 36.8 0 0 0 240.5 569.1 37.7 37.7 0 0 0 260.5 595.5L323.2 630 358.6 694.1A35 35 0 0 0 390 713.2 34.1 34.1 0 0 0 415 702.7L421.4 696.8A42.7 42.7 0 0 0 433.6 665V604.1C440 599.1 446.8 594.1 453.6 588.2L521.8 534.5 521.8 537.7A36.8 36.8 0 0 0 513.2 561.8 36.4 36.4 0 0 0 523.6 588.2L530 594.5A36.4 36.4 0 0 0 556.4 605H556.4L590.9 671.8A36.8 36.8 0 0 0 624.1 692.7 33.6 33.6 0 0 0 650.9 680L670.9 660.5A42.7 42.7 0 0 0 683.2 628.6V625L658.6 411.4C720 346.4 793.6 262.3 743.2 211.8Z"
  }));
};
IconAirportSolid.defaultProps = {
  title: 'airport solid'
};
IconAirportSolid.propTypes = {
  title: PropTypes.string
};

var IconAirport = function IconAirport(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-airport",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 10A415.5 415.5 0 0 0 85.5 425.5C85.5 770.9 475.5 979.5 494.5 988.2A17.3 17.3 0 0 0 510 988.2C526.8 979.5 919.1 777.3 919.1 425.5A415.9 415.9 0 0 0 500 10ZM500 954.5C445 923.2 119.5 727.3 119.5 426.4A380.9 380.9 0 1 1 880.9 426.4C880.9 729.5 555 923.2 500 954.5ZM702.3 195.5C665 195.5 619.1 225 544.1 296.4L330.5 272.7H326.8A55 55 0 0 0 303.2 279.1L298.6 279.1 295 282.7 272.7 305.5A35 35 0 0 0 262.3 337.3 36.4 36.4 0 0 0 283.2 363.6L349.1 396.4A36.4 36.4 0 0 0 359.5 423.6L363.6 430.5A37.3 37.3 0 0 0 390 440.9 38.2 38.2 0 0 0 415.5 431.4L417.7 431.4C400 454.5 381.4 480 363.6 500L347.7 519.5H288.2A45.5 45.5 0 0 0 265 526.4L260.5 528.6 256.8 532.3 250.5 538.2A36.8 36.8 0 0 0 240.5 569.1 37.7 37.7 0 0 0 260.5 595.5L323.2 630 358.6 694.1A35 35 0 0 0 390 713.2 34.1 34.1 0 0 0 415 702.7L421.4 696.8A42.7 42.7 0 0 0 433.6 665V604.1C440 599.1 446.8 594.1 453.6 588.2L521.8 534.5 521.8 537.7A36.8 36.8 0 0 0 513.2 561.8 36.4 36.4 0 0 0 523.6 588.2L530 594.5A36.4 36.4 0 0 0 556.4 605H556.4L590.9 671.8A36.8 36.8 0 0 0 624.1 692.7 33.6 33.6 0 0 0 650.9 680L670.9 660.5A42.7 42.7 0 0 0 683.2 628.6V625L658.6 411.4C719.5 346.4 795 262.3 742.7 211.8A57.3 57.3 0 0 0 702.3 195.5ZM625.9 400L651.8 627.3A10.5 10.5 0 0 1 648.6 636.4L627.3 658.2A2.7 2.7 0 0 1 624.5 658.2 6.4 6.4 0 0 1 619.5 655L574.1 560 563.2 569.1A5 5 0 0 1 559.5 569.1 5.5 5.5 0 0 1 555.5 569.1L549.5 563.2A6.4 6.4 0 0 1 549.5 555.5L563.2 540 534.1 481.8C486.4 521.8 434.5 561.4 403.6 585.9V662.7A10.5 10.5 0 0 1 400.5 671.8L392.7 681.8 390 681.8A4.1 4.1 0 0 1 386.4 679.1L346.8 607.3 272.7 567.3A3.2 3.2 0 0 1 272.7 561.4L278.6 555A27.3 27.3 0 0 1 287.7 551.8H363.6C388.2 521.4 428.2 469.1 468.2 421.8L409.1 392.3 395.9 409.1A5.5 5.5 0 0 1 391.8 409.1S388.6 409.1 388.2 409.1L381.8 401.8A7.7 7.7 0 0 1 381.8 394.1L392.7 383.2 297.7 337.7C294.5 337.7 293.2 332.7 297.7 330L318.2 306.4A25.5 25.5 0 0 1 327.7 303.6L555 329.5C600.5 284.1 664.5 227.3 702.3 227.3A25.5 25.5 0 0 1 720.9 234.5C751.4 265 676.4 346.4 625.9 400Z"
  }));
};
IconAirport.defaultProps = {
  title: 'airport'
};
IconAirport.propTypes = {
  title: PropTypes.string
};

var IconAppsSolid = function IconAppsSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-apps-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M483.2 608.2V818.2A90.9 90.9 0 0 1 392.3 909.1H181.8A90.9 90.9 0 0 1 90.9 818.2V608.2A90.9 90.9 0 0 1 181.8 517.3H392.3A90.9 90.9 0 0 1 483.2 608.2ZM392.3 90.9H181.8A90.9 90.9 0 0 0 90.9 181.8V391.8A90.9 90.9 0 0 0 181.8 482.7H392.3A90.9 90.9 0 0 0 483.2 391.8V181.8A90.9 90.9 0 0 0 392.3 90.9ZM818.2 517.3H608.2A90.9 90.9 0 0 0 517.3 608.2V818.2A90.9 90.9 0 0 0 608.2 909.1H818.2A90.9 90.9 0 0 0 909.1 818.2V608.2A90.9 90.9 0 0 0 818.2 517.3ZM818.2 90.9H608.2A90.9 90.9 0 0 0 517.3 181.8V391.8A90.9 90.9 0 0 0 608.2 482.7H818.2A90.9 90.9 0 0 0 909.1 391.8V181.8A90.9 90.9 0 0 0 818.2 90.9Z"
  }));
};
IconAppsSolid.defaultProps = {
  title: 'apps solid'
};
IconAppsSolid.propTypes = {
  title: PropTypes.string
};

var IconApps = function IconApps(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-apps",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M391.8 90.9H181.8A90.9 90.9 0 0 0 90.9 181.8V391.8A90.9 90.9 0 0 0 181.8 482.7H391.8A90.9 90.9 0 0 0 482.7 391.8V181.8A90.9 90.9 0 0 0 391.8 90.9ZM449.1 391.8A57.7 57.7 0 0 1 391.8 449.1H181.8A57.3 57.3 0 0 1 125 391.8V181.8A56.8 56.8 0 0 1 181.8 125H391.8A57.3 57.3 0 0 1 449.1 181.8ZM818.2 90.9H608.2A90.9 90.9 0 0 0 517.3 181.8V391.8A90.9 90.9 0 0 0 608.2 482.7H818.2A90.9 90.9 0 0 0 909.1 391.8V181.8A90.9 90.9 0 0 0 818.2 90.9ZM875 391.8A57.3 57.3 0 0 1 818.2 449.1H608.2A57.7 57.7 0 0 1 550.9 391.8V181.8A57.3 57.3 0 0 1 608.2 125H818.2A56.8 56.8 0 0 1 875 181.8ZM391.8 517.3H181.8A90.9 90.9 0 0 0 90.9 608.2V818.2A90.9 90.9 0 0 0 181.8 909.1H391.8A90.9 90.9 0 0 0 482.7 818.2V608.2A90.9 90.9 0 0 0 391.8 517.3ZM449.1 818.2A57.3 57.3 0 0 1 391.8 875H181.8A56.8 56.8 0 0 1 125 818.2V608.2A57.3 57.3 0 0 1 181.8 550.9H391.8A57.7 57.7 0 0 1 449.1 608.2ZM818.2 517.3H608.2A90.9 90.9 0 0 0 517.3 608.2V818.2A90.9 90.9 0 0 0 608.2 909.1H818.2A90.9 90.9 0 0 0 909.1 818.2V608.2A90.9 90.9 0 0 0 818.2 517.3ZM875 818.2A56.8 56.8 0 0 1 818.2 875H608.2A57.3 57.3 0 0 1 550.9 818.2V608.2A57.7 57.7 0 0 1 608.2 550.9H818.2A57.3 57.3 0 0 1 875 608.2Z"
  }));
};
IconApps.defaultProps = {
  title: 'apps'
};
IconApps.propTypes = {
  title: PropTypes.string
};

var IconArchiveSolid = function IconArchiveSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-archive-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M863.6 193.2H136.4A69.5 69.5 0 0 0 68.2 262.7V737.3A69.5 69.5 0 0 0 136.4 806.8H863.6A69.5 69.5 0 0 0 933.2 737.3V262.7A69.5 69.5 0 0 0 863.6 193.2ZM711.4 445.9H288.6A28.6 28.6 0 0 1 288.6 389.1H711.4A28.6 28.6 0 0 1 711.4 445.9ZM893.2 313.6H105.9V268.2A38.2 38.2 0 0 1 146.4 232.3H853.2A38.6 38.6 0 0 1 894.1 268.2Z"
  }));
};
IconArchiveSolid.defaultProps = {
  title: 'archive solid'
};
IconArchiveSolid.propTypes = {
  title: PropTypes.string
};

var IconArchive = function IconArchive(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-archive",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M288.6 434.5H711.4A16.8 16.8 0 0 0 727.3 417.7 17.3 17.3 0 0 0 710.5 400.5H288.6A17.3 17.3 0 0 0 272.7 417.7 16.8 16.8 0 0 0 288.6 434.5ZM863.6 193.2H136.4A69.5 69.5 0 0 0 68.2 262.7V737.3A69.5 69.5 0 0 0 136.4 806.8H863.6A69.5 69.5 0 0 0 933.2 737.3V262.7A69.5 69.5 0 0 0 863.6 193.2ZM895.5 731.4A40.9 40.9 0 0 1 854.5 772.3H146.8A40.9 40.9 0 0 1 105.9 731.4V314.1H894.1Z"
  }));
};
IconArchive.defaultProps = {
  title: 'archive'
};
IconArchive.propTypes = {
  title: PropTypes.string
};

var IconArrowBigDown = function IconArrowBigDown(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-arrow-big-down",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M545.5 822.3L761.8 605.9A28.6 28.6 0 1 0 721.4 565L527.7 758.6V187.7A29.1 29.1 0 0 0 477.7 166.8 30 30 0 0 0 469.1 187.7V759.1L276.8 565A28.6 28.6 0 1 0 236.4 605.9L454.5 822.3A68.2 68.2 0 0 0 500 841.8H500A68.2 68.2 0 0 0 545.5 822.3Z"
  }));
};
IconArrowBigDown.defaultProps = {
  title: 'arrow big down'
};
IconArrowBigDown.propTypes = {
  title: PropTypes.string
};

var IconArrowBigLeft = function IconArrowBigLeft(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-arrow-big-left",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M177.7 545.5L394.1 763.6A28.6 28.6 0 1 0 435 723.2L241.4 529.5H812.3A29.1 29.1 0 0 0 833.2 479.5 30 30 0 0 0 812.3 470.9H240.9L435 276.8A28.6 28.6 0 1 0 394.1 236.4L177.7 454.5A68.2 68.2 0 0 0 158.2 500H158.2A68.2 68.2 0 0 0 177.7 545.5Z"
  }));
};
IconArrowBigLeft.defaultProps = {
  title: 'arrow big left'
};
IconArrowBigLeft.propTypes = {
  title: PropTypes.string
};

var IconArrowBigRight = function IconArrowBigRight(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-arrow-big-right",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M822.3 454.5L605.9 236.4A28.6 28.6 0 1 0 565 276.8L758.6 470.5H187.7A29.1 29.1 0 0 0 166.8 520.5 30 30 0 0 0 187.7 529.1H759.1L565 723.2A28.6 28.6 0 1 0 605.9 763.6L822.3 545.5A68.2 68.2 0 0 0 841.8 500H841.8A68.2 68.2 0 0 0 822.3 454.5Z"
  }));
};
IconArrowBigRight.defaultProps = {
  title: 'arrow big right'
};
IconArrowBigRight.propTypes = {
  title: PropTypes.string
};

var IconArrowBigUp = function IconArrowBigUp(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-arrow-big-up",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M454.5 177.7L236.4 394.1A28.6 28.6 0 1 0 276.8 435L470.5 241.4V812.3A29.1 29.1 0 0 0 520.5 833.2 30 30 0 0 0 529.1 812.3V240.9L723.2 435A28.6 28.6 0 1 0 763.6 394.1L545.5 177.7A68.2 68.2 0 0 0 500 158.2H500A68.2 68.2 0 0 0 454.5 177.7Z"
  }));
};
IconArrowBigUp.defaultProps = {
  title: 'arrow big up'
};
IconArrowBigUp.propTypes = {
  title: PropTypes.string
};

var IconArrowDown = function IconArrowDown(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-arrow-down",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M236.4 365.9A28.2 28.2 0 0 1 276.8 365.9L493.2 582.3A8.2 8.2 0 0 0 506.8 582.3L723.2 365.9A28.6 28.6 0 0 1 763.6 406.4L545.5 622.7A66.4 66.4 0 0 1 500 642.3H500A66.4 66.4 0 0 1 454.5 622.7L236.4 406.4A28.2 28.2 0 0 1 236.4 365.9Z"
  }));
};
IconArrowDown.defaultProps = {
  title: 'arrow down'
};
IconArrowDown.propTypes = {
  title: PropTypes.string
};

var IconArrowLeft = function IconArrowLeft(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-arrow-left",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M636.4 236.4A28.2 28.2 0 0 1 636.4 276.8L417.7 493.2A8.2 8.2 0 0 0 417.7 506.8L636.4 723.2A28.6 28.6 0 0 1 595.9 763.6L377.3 545.5A66.4 66.4 0 0 1 357.7 500H357.7A66.4 66.4 0 0 1 377.3 454.5L593.6 236.4A28.2 28.2 0 0 1 636.4 236.4Z"
  }));
};
IconArrowLeft.defaultProps = {
  title: 'arrow left'
};
IconArrowLeft.propTypes = {
  title: PropTypes.string
};

var IconArrowRight = function IconArrowRight(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-arrow-right",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M365.9 763.6A28.2 28.2 0 0 1 365.9 723.2L582.3 506.8A8.2 8.2 0 0 0 582.3 493.2L365.9 276.8A28.6 28.6 0 0 1 406.4 236.4L622.7 454.5A66.4 66.4 0 0 1 642.3 500H642.3A66.4 66.4 0 0 1 622.7 545.5L406.4 763.6A28.2 28.2 0 0 1 365.9 763.6Z"
  }));
};
IconArrowRight.defaultProps = {
  title: 'arrow right'
};
IconArrowRight.propTypes = {
  title: PropTypes.string
};

var IconArrowUp = function IconArrowUp(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-arrow-up",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M763.6 626.4A28.2 28.2 0 0 1 723.2 626.4L506.8 409.1A8.6 8.6 0 0 0 493.2 409.1L276.8 626.4A28.6 28.6 0 1 1 236.4 585.9L454.5 369.5A66.4 66.4 0 0 1 500 350H500A66.4 66.4 0 0 1 545.5 369.5L761.8 585.9A28.2 28.2 0 0 1 763.6 626.4Z"
  }));
};
IconArrowUp.defaultProps = {
  title: 'arrow up'
};
IconArrowUp.propTypes = {
  title: PropTypes.string
};

var IconAttentionSolid = function IconAttentionSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-attention-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 90.9A409.1 409.1 0 1 0 909.1 500 409.1 409.1 0 0 0 500 90.9ZM471.8 240.9A28.2 28.2 0 0 1 528.2 240.9V614.5A28.2 28.2 0 1 1 471.8 614.5ZM500 803.6A45.5 45.5 0 1 1 545.5 758.2 45.5 45.5 0 0 1 500 803.6Z"
  }));
};
IconAttentionSolid.defaultProps = {
  title: 'attention solid'
};
IconAttentionSolid.propTypes = {
  title: PropTypes.string
};

var IconAttention = function IconAttention(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-attention",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M477.3 614.5V240.9A22.7 22.7 0 0 1 522.7 240.9V614.5A22.7 22.7 0 0 1 477.3 614.5ZM920.5 500A420.5 420.5 0 1 1 500 79.5 420.9 420.9 0 0 1 920.5 500ZM875 500A375 375 0 1 0 500 875 375.5 375.5 0 0 0 875 500ZM500 709.5A37.3 37.3 0 1 0 537.3 746.8 37.3 37.3 0 0 0 500 709.5Z"
  }));
};
IconAttention.defaultProps = {
  title: 'attention'
};
IconAttention.propTypes = {
  title: PropTypes.string
};

var IconAudioSolid = function IconAudioSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-audio-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 90.9A409.1 409.1 0 1 0 909.1 500 409.1 409.1 0 0 0 500 90.9ZM660.9 276.8H545.5V653.2A113.6 113.6 0 1 1 500 562.3V233.6H660A21.8 21.8 0 0 1 660 279.1Z"
  }));
};
IconAudioSolid.defaultProps = {
  title: 'audio solid'
};
IconAudioSolid.propTypes = {
  title: PropTypes.string
};

var IconAudio = function IconAudio(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-audio",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 85.5A414.5 414.5 0 1 0 914.5 500 415 415 0 0 0 500 85.5ZM500 880.9A380.9 380.9 0 1 1 880.9 500 381.4 381.4 0 0 1 500 880.9ZM677.7 255.5A16.8 16.8 0 0 1 660.9 272.3H540V653.2A108.6 108.6 0 0 1 507.7 730 108.6 108.6 0 0 1 354.1 730 108.6 108.6 0 0 1 505.5 574.1V238.2H660.9A16.8 16.8 0 0 1 677.7 255.5Z"
  }));
};
IconAudio.defaultProps = {
  title: 'audio'
};
IconAudio.propTypes = {
  title: PropTypes.string
};

var IconBeachSolid = function IconBeachSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-beach-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M957.7 398.6A10.9 10.9 0 0 1 954.5 409.1 13.6 13.6 0 0 1 947.3 409.1H944.5L671.8 336.4V336.4L568.6 727.3H863.6A28.6 28.6 0 1 1 863.6 784.1H805.9L832.7 884.1A28.2 28.2 0 0 1 812.7 918.6 20.5 20.5 0 0 1 805.5 918.6 28.2 28.2 0 0 1 778.2 897.3L747.3 782.7H553.2L522.7 897.3A28.6 28.6 0 0 1 495.5 918.6 23.2 23.2 0 0 1 487.7 918.6 28.2 28.2 0 0 1 467.7 884.1L494.5 784.1H349.5L318.2 896.4A29.1 29.1 0 0 1 290.5 917.7L283.2 917.7A28.2 28.2 0 0 1 263.2 883.2L290 783.2H223.6A26.8 26.8 0 0 1 203.6 772.7L50.5 620.9A28.6 28.6 0 1 1 90.9 580.5L235.5 727.3H508.2L615.5 325.9 615.5 325.9 342.7 253.2A10.9 10.9 0 0 1 335 246.8 11.8 11.8 0 0 1 335 236.4C409.1 114.1 667.3 77.3 705.9 87.7S954.5 252.3 957.7 398.6Z"
  }));
};
IconBeachSolid.defaultProps = {
  title: 'beach solid'
};
IconBeachSolid.propTypes = {
  title: PropTypes.string
};

var IconBeach = function IconBeach(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-beach",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M704.1 87.3H704.1C663.2 75.9 403.6 111.4 326.8 238.6A15 15 0 0 0 326.8 253.6 15.9 15.9 0 0 0 338.2 263.6L620 339.5 511.4 745H222.3L74.1 597.3A16.8 16.8 0 0 0 50 621.4L203.2 772.7A16.4 16.4 0 0 0 215 777.7H297.3L266.4 891.8A17.3 17.3 0 0 0 278.6 912.7H283.2A17.3 17.3 0 0 0 299.5 900.5L332.3 777.3H500L469.5 891.4A16.8 16.8 0 0 0 481.4 912.3H485.9A17.3 17.3 0 0 0 502.3 900L535 776.8H746.8L779.5 900A17.3 17.3 0 0 0 795.9 912.3H800.5A16.8 16.8 0 0 0 812.3 891.4L781.8 777.3H854.1A17.3 17.3 0 1 0 854.1 743.2H545.5L651.8 346.4 933.6 421.8H938.2A15.5 15.5 0 0 0 948.6 418.2 16.8 16.8 0 0 0 954.5 409.1C951.8 258.2 744.5 98.2 704.1 87.3ZM369.5 237.3C454.5 139.1 670.5 113.6 695 120S895.9 256.4 918.6 384.5Z"
  }));
};
IconBeach.defaultProps = {
  title: 'beach'
};
IconBeach.propTypes = {
  title: PropTypes.string
};

var IconBeer = function IconBeer(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-beer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M840.9 617.3A96.8 96.8 0 0 1 777.7 708.2V670.9A63.6 63.6 0 0 0 789.1 572.7 52.7 52.7 0 0 0 777.7 563.6V526.4A103.2 103.2 0 0 1 812.7 549.1 95.5 95.5 0 0 1 840.9 617.3ZM369.1 426.8A15.9 15.9 0 0 0 352.3 440.9V793.6A12.3 12.3 0 0 0 357.3 803.6 17.7 17.7 0 0 0 369.1 807.7 15.9 15.9 0 0 0 385.9 793.6V440.9A15.9 15.9 0 0 0 369.1 426.8ZM603.2 426.8A15.5 15.5 0 0 0 586.4 440.9V793.6A12.3 12.3 0 0 0 591.4 803.6 16.8 16.8 0 0 0 603.2 807.7 15.9 15.9 0 0 0 620 793.6V440.9A15.9 15.9 0 0 0 603.2 426.8ZM485.9 426.8A15.5 15.5 0 0 0 469.5 440.9V793.6A13.2 13.2 0 0 0 474.1 803.6 17.7 17.7 0 0 0 485.9 807.7 15.5 15.5 0 0 0 502.7 793.6V440.9A15.5 15.5 0 0 0 485.9 426.8ZM740.5 322.3A37.7 37.7 0 0 1 743.6 336.8V948.2A36.8 36.8 0 0 1 706.8 985H265.5A36.8 36.8 0 0 1 227.3 948.2V336.8A36.8 36.8 0 0 1 227.3 324.5 113.6 113.6 0 0 1 272.7 105.5H280A158.2 158.2 0 0 1 566.4 105.5 111.8 111.8 0 0 1 611.8 112.3 123.2 123.2 0 1 1 738.2 321.8ZM272.7 299.5A79.1 79.1 0 0 0 328.2 276.8L338.6 267.3 350 275.5A126.4 126.4 0 0 0 496.8 275.5L508.2 267.3 518.2 276.8A81.8 81.8 0 0 0 620.9 284.1L630.5 277.3 640 283.6A90.9 90.9 0 0 0 690.9 299.5 90.9 90.9 0 0 0 690.9 117.7 88.2 88.2 0 0 0 628.6 142.7L620 150.9 609.5 145.5A75.9 75.9 0 0 0 559.1 138.6L545.5 140.9 540.5 127.7A125.5 125.5 0 0 0 305.9 127.7L300.9 140.9 287.3 138.6 272.7 139.1A80.5 80.5 0 0 0 272.7 299.5ZM710 331.4L690.9 331.4A119.1 119.1 0 0 1 630.9 318.2 115 115 0 0 1 515.5 318.2H492.3A160 160 0 0 1 355.9 318.2H330.9A113.6 113.6 0 0 1 272.7 332.7H262.3V948.2A3.2 3.2 0 0 0 265.5 951.4S708.6 951.4 706.8 951.4A3.2 3.2 0 0 0 710 948.2Z"
  }));
};
IconBeer.defaultProps = {
  title: 'beer'
};
IconBeer.propTypes = {
  title: PropTypes.string
};

var IconBikeSolid = function IconBikeSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-bike-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1019 1019"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M813.6 393.6A214.1 214.1 0 0 0 771.8 398.2L727.3 281.4 808.6 251.8A28.6 28.6 0 0 0 789.1 198.2L652.7 247.3 681.8 314.5 496.8 535 435.5 369.1H435.5L423.6 335.9H448.2A28.6 28.6 0 0 0 448.2 279.1H327.3A28.6 28.6 0 1 0 327.3 335.9H363.6L371.8 358.6 313.6 425.9A201.8 201.8 0 0 0 205 393.6 205 205 0 1 0 409.1 627.7H481.4A28.2 28.2 0 0 0 503.2 617.3L705.5 376.4 720.9 418.2A203.2 203.2 0 1 0 815.9 393.6ZM450 570.9H409.1A203.6 203.6 0 0 0 359.1 462.7L395.5 419.5ZM318.2 506.8A149.1 149.1 0 0 1 348.2 570.9H266.4ZM205 746.8A148.2 148.2 0 0 1 205 450.5 149.1 149.1 0 0 1 276.8 470L181.8 580.9A28.6 28.6 0 0 0 178.2 611.4 28.2 28.2 0 0 0 203.6 627.7H350A148.6 148.6 0 0 1 205 746.8ZM813.6 746.8A148.2 148.2 0 0 1 665.9 598.6 146.8 146.8 0 0 1 738.2 472.3L787.7 608.6A27.7 27.7 0 0 0 814.5 627.3L824.1 627.3A28.6 28.6 0 0 0 840.9 590.9L791.8 454.5A177.7 177.7 0 0 1 813.6 452.3 148.2 148.2 0 1 1 813.6 748.6Z"
  }));
};
IconBikeSolid.defaultProps = {
  title: 'bike solid'
};
IconBikeSolid.propTypes = {
  title: PropTypes.string
};

var IconBike = function IconBike(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-bike",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M804.5 405A194.1 194.1 0 0 0 755.5 412.3L705.5 275.9 796.4 242.3A16.8 16.8 0 0 0 784.5 210.5L660.9 255.9 687.3 328.6H687.3L485.5 569.1 397.7 323.6H438.6A17.3 17.3 0 0 0 438.6 289.5H318.2A17.3 17.3 0 0 0 318.2 323.6H363.6L376.8 360 306.8 440.9A193.2 193.2 0 1 0 387.3 616.4H481.4A15.9 15.9 0 0 0 494.1 610L701.4 363.6 723.2 424.1A191.8 191.8 0 1 0 804.5 405.5ZM454.5 582.3H387.3A195.5 195.5 0 0 0 333.2 462.7L388.2 397.3ZM310.9 489.1A157.7 157.7 0 0 1 353.2 582.3H232.7ZM195.5 757.7A159.5 159.5 0 1 1 286.4 466.8L181.8 588.2A17.7 17.7 0 0 0 179.5 606.4 17.3 17.3 0 0 0 195 616.4H353.2A159.1 159.1 0 0 1 195.5 757.7ZM804.5 757.7A158.6 158.6 0 0 1 735 454.5L789.1 602.7A16.8 16.8 0 0 0 805 613.6 13.6 13.6 0 0 0 810.9 613.6 16.8 16.8 0 0 0 820.9 591.8L767.3 444.1A164.1 164.1 0 0 1 804.5 439.1 159.5 159.5 0 0 1 804.5 757.3Z"
  }));
};
IconBike.defaultProps = {
  title: 'bike'
};
IconBike.propTypes = {
  title: PropTypes.string
};

var IconBirthdaySolid = function IconBirthdaySolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-birthday-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M897.7 611.4V702.3A95 95 0 0 1 884.5 688.6L884.5 688.6H884.5L863.6 661.8A110.5 110.5 0 0 0 787.3 634.5 136.4 136.4 0 0 0 689.1 680L662.7 701.4A45.5 45.5 0 0 1 638.2 711.4 51.8 51.8 0 0 1 592.7 685.5L569.5 660.5A107.3 107.3 0 0 0 493.2 633.2 136.4 136.4 0 0 0 395.5 678.6L363.6 702.7A45.5 45.5 0 0 1 339.1 712.7 52.3 52.3 0 0 1 293.6 686.8L270.5 661.8A108.2 108.2 0 0 0 193.6 636.4 128.6 128.6 0 0 0 102.7 676.8V613.2A102.3 102.3 0 0 1 204.5 509.1H434.1V304.1A11.4 11.4 0 0 1 445.5 292.7H554.5A11.4 11.4 0 0 1 565.9 304.1V509.1H795.5A102.3 102.3 0 0 1 897.7 611.4ZM863.6 762.3A74.1 74.1 0 0 1 854.5 754.5L830.5 727.3C815.9 710 808.6 701.4 785 701.4A51.4 51.4 0 0 0 754.1 711.8L728.2 734.5 719.5 741.4A130 130 0 0 1 635.9 779.5 112.3 112.3 0 0 1 559.5 753.6L535 727.3C520.5 709.5 513.2 700.9 489.5 700.9A52.7 52.7 0 0 0 458.6 711.4L433.2 734.1A56.8 56.8 0 0 0 424.5 740.9 131.4 131.4 0 0 1 340.5 779.1 110 110 0 0 1 264.5 753.2L242.7 730.9 242.7 728.6 242.7 726.4C228.6 709.5 220.9 700.9 197.3 700.9A69.1 69.1 0 0 0 151.8 725.5C148.2 729.5 115.5 754.5 115.5 754.5L108.2 761.4V802.3A102.3 102.3 0 0 0 204.5 906.4H795.5A102.3 102.3 0 0 0 897.7 804.1V784.1L893.6 780.9ZM468.6 252.3A56.8 56.8 0 0 0 496.8 259.5 60 60 0 0 0 527.3 251.4 58.6 58.6 0 0 0 556.8 200C556.8 171.8 548.2 96.8 508.2 94.1 492.7 94.1 487.7 108.6 485 116.4A20.9 20.9 0 0 1 485 120.5 115.5 115.5 0 0 1 464.1 153.6 81.8 81.8 0 0 0 445.9 218.6 45.5 45.5 0 0 0 468.6 252.3Z"
  }));
};
IconBirthdaySolid.defaultProps = {
  title: 'birthday solid'
};
IconBirthdaySolid.propTypes = {
  title: PropTypes.string
};

var IconBirthday = function IconBirthday(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-birthday",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M795.5 503.2H571.4V304.1A16.4 16.4 0 0 0 554.5 287.3H445.5A16.4 16.4 0 0 0 428.6 304.1V503.2H204.5A108.6 108.6 0 0 0 96.4 611.4V804.1A108.2 108.2 0 0 0 204.5 911.8H795.5A108.2 108.2 0 0 0 903.6 804.1V611.4A108.6 108.6 0 0 0 795.5 503.2ZM462.7 321.4H537.3V503.2H462.7ZM869.1 804.1A73.6 73.6 0 0 1 795.5 877.7H204.5A73.6 73.6 0 0 1 130.9 804.1V718.2L133.6 715.5A86.8 86.8 0 0 1 193.6 685.5 66.4 66.4 0 0 1 252.3 718.2L252.3 718.2H252.3A101.4 101.4 0 0 0 338.6 763.6 114.5 114.5 0 0 0 411.8 729.5L420.9 722.3H420.9L428.2 715.5A84.5 84.5 0 0 1 487.7 685.5 65.5 65.5 0 0 1 546.4 718.2L546.4 718.2H546.4A102.3 102.3 0 0 0 633.2 763.6 113.2 113.2 0 0 0 705.9 729.5L715 722.3H715L722.3 715.5A84.5 84.5 0 0 1 781.8 685.5 65.5 65.5 0 0 1 840.5 718.2L840.5 718.2H840.5A172.3 172.3 0 0 0 864.5 742.3ZM869.1 695.5A99.1 99.1 0 0 0 785 650 117.3 117.3 0 0 0 701.4 689.5L697.3 693.6H697.3L686.8 702.3A85 85 0 0 1 635.9 728.2 67.3 67.3 0 0 1 575.5 696.4L575.5 696.4H575.5A99.5 99.5 0 0 0 490.5 650.9 117.3 117.3 0 0 0 406.8 690.5 17.3 17.3 0 0 1 402.7 694.5H402.7L392.3 703.2A83.6 83.6 0 0 1 341.4 729.1 68.2 68.2 0 0 1 280.9 697.3L280.9 697.3H280.9A100.9 100.9 0 0 0 133.6 674.5V611.4A73.6 73.6 0 0 1 204.5 537.3H795.5A73.6 73.6 0 0 1 869.1 611.4ZM465.9 257.3A62.7 62.7 0 0 0 496.8 265.5 65.9 65.9 0 0 0 562.3 200C562.3 162.7 551.4 91.4 508.6 88.2 488.2 88.2 482.3 107.3 478.6 118.2A113.6 113.6 0 0 1 458.2 150 90.9 90.9 0 0 0 438.6 220 54.1 54.1 0 0 0 465.9 257.3ZM484.5 171.8A146.8 146.8 0 0 0 510 131.8 34.5 34.5 0 0 1 510 126.8 151.8 151.8 0 0 1 526.4 200 31.4 31.4 0 0 1 511.4 226.8 30 30 0 0 1 480.5 226.8 18.6 18.6 0 0 1 470.5 212.7 51.8 51.8 0 0 1 484.5 171.8Z"
  }));
};
IconBirthday.defaultProps = {
  title: 'birthday'
};
IconBirthday.propTypes = {
  title: PropTypes.string
};

var IconBookSolid = function IconBookSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-book-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M920.5 178.2H884.1V138.6A40.9 40.9 0 0 0 855.9 100.5 394.1 394.1 0 0 0 500 169.1 391.8 391.8 0 0 0 144.1 100.5 40.5 40.5 0 0 0 115.9 138.6V178.2H79.5A39.5 39.5 0 0 0 40 218.2V754.1A39.5 39.5 0 0 0 79.5 793.6H605.9V875.5A40.5 40.5 0 0 0 625 910 41.8 41.8 0 0 0 646.8 916.4 38.6 38.6 0 0 0 665 911.8L690.9 899.1 710.5 908.6V913.2H719.5A41.4 41.4 0 0 0 756.8 910 40 40 0 0 0 776.4 875.5L776.4 793.6H919.5A39.5 39.5 0 0 0 959.1 754.1V218.2A39.5 39.5 0 0 0 920.5 178.2ZM471.8 706.8L444.1 691.8 436.4 688.2 432.3 688.2A409.1 409.1 0 0 0 389.5 672.3L378.6 669.1A503.6 503.6 0 0 0 256.8 653.2H211.4L172.3 656.8V151.4A332.3 332.3 0 0 1 471.4 218.6ZM719.5 850L703.6 841.8A30.9 30.9 0 0 0 690.9 838.6 32.7 32.7 0 0 0 678.2 841.8L662.7 849.5V716.4A122.7 122.7 0 0 1 721.4 712.7ZM827.3 656.8L787.3 652.7H769.5C758.2 652.7 747.3 652.7 735.9 652.7H718.2L695 652.7A197.3 197.3 0 0 0 654.1 658.6L650 658.6 641.4 658.6 625 662.7C615.9 665 606.8 667.7 596.4 671.4L583.6 675.9A223.2 223.2 0 0 0 557.7 687.3L553.6 689.5 545.5 693.2A175 175 0 0 0 528.2 703.6V218.6A332.3 332.3 0 0 1 827.3 151.4Z"
  }));
};
IconBookSolid.defaultProps = {
  title: 'book solid'
};
IconBookSolid.propTypes = {
  title: PropTypes.string
};

var IconBook = function IconBook(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-book",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M920.5 189.5H872.7V138.6A28.6 28.6 0 0 0 852.3 111.4 376.8 376.8 0 0 0 500 184.1 377.7 377.7 0 0 0 147.3 111.4 28.6 28.6 0 0 0 127.3 138.6V189.5H81.8A28.6 28.6 0 0 0 53.2 218.2V754.1A28.6 28.6 0 0 0 81.8 782.3H617.3V875.5A29.5 29.5 0 0 0 660 901.8L690.9 886.4 721.8 901.8H721.8A29.5 29.5 0 0 0 750.9 901.8 30 30 0 0 0 765 876.8L765 783.6H919.5A28.6 28.6 0 0 0 948.2 755.5V218.2A28.6 28.6 0 0 0 920.5 189.5ZM85.5 748.2V223.6H127.3V689.1A17.7 17.7 0 0 0 133.2 702.3 17.7 17.7 0 0 0 147.3 705.9L173.6 702.3 203.6 699.1 223.2 699.1H268.6L298.2 699.1 311.8 699.1C323.2 699.1 334.1 702.3 345 704.5L352.7 704.5A347.3 347.3 0 0 1 425.9 730.5L433.6 735 450.9 745.5ZM482.7 727.3H482.7A310.5 310.5 0 0 0 439.5 701.4L428.2 696.4Q409.1 688.6 388.2 681.8L375.5 678.2A469.1 469.1 0 0 0 258.6 663.2H252.7L230 663.2H212.7C195.9 663.2 179.1 665.9 161.4 668.2V142.7A342.3 342.3 0 0 1 482.7 213.6ZM619.1 747.3H548.6L569.5 734.5 575 731.8C585.9 726.4 597.3 721.8 609.1 717.3L617.3 715ZM732.7 867.3L700.5 850.9A21.4 21.4 0 0 0 692.7 850.9 24.1 24.1 0 0 0 685 850.9L653.2 867.3V708.2A136.4 136.4 0 0 1 734.5 703.6ZM738.2 662.3H720.5L696.8 662.3A170 170 0 0 0 657.7 668.2L645.5 670.5 630 674.1 603.6 681.8 589.5 686.8 564.5 698.2 552.7 703.6A266.8 266.8 0 0 0 525.9 720.5L519.5 724.5H519.5V213.6A343.6 343.6 0 0 1 840.9 142.7V669.1H832.3C817.7 666.8 803.2 665.5 786.8 664.5H769.5C758.2 663.2 747.3 662.7 736.4 663.2ZM916.4 747.3H766.4V697.7L796.8 697.7 803.6 697.7C819.5 697.7 835.9 700.9 852.3 703.6A17.7 17.7 0 0 0 866.4 700 17.7 17.7 0 0 0 872.3 686.8V223.6H914.1Z"
  }));
};
IconBook.defaultProps = {
  title: 'book'
};
IconBook.propTypes = {
  title: PropTypes.string
};

var IconBoosterSolid = function IconBoosterSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-booster-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M304.5 235.5A114.5 114.5 0 1 1 419.1 350 114.5 114.5 0 0 1 304.5 235.5ZM859.1 517.7A204.1 204.1 0 0 0 752.3 489.5 236.8 236.8 0 0 0 652.7 511.4 12.3 12.3 0 0 1 636.4 504.5L598.6 459.1A12.3 12.3 0 0 1 602.7 443.6C606.4 441.4 611.8 439.1 618.2 435.9A268.2 268.2 0 0 0 672.7 405.5 286.4 286.4 0 0 0 718.2 357.7 62.7 62.7 0 0 0 727.3 282.7 58.6 58.6 0 0 0 681.8 260.9H681.8A40.9 40.9 0 0 0 649.1 276.8 494.1 494.1 0 0 1 609.1 318.6 420.9 420.9 0 0 1 555 353.6C545.9 357.7 497.7 377.3 475.9 383.2A77.3 77.3 0 0 0 423.6 428.6 122.7 122.7 0 0 0 433.2 532.7L493.6 637.3A106.8 106.8 0 0 0 556.8 692.3 96.8 96.8 0 0 0 581.8 695.5 119.5 119.5 0 0 0 638.6 681.8 153.2 153.2 0 0 0 687.3 636.4L689.5 633.6A86.4 86.4 0 0 1 735 603.2 100.5 100.5 0 0 1 821.8 615.9 48.2 48.2 0 0 0 867.3 620.9 50.5 50.5 0 0 0 895.5 590.9C900.9 569.5 899.1 541.4 859.1 517.7ZM681.8 740.5H531.4A76.4 76.4 0 0 1 464.5 701.8L232.3 300.5A70.5 70.5 0 0 0 149.1 267.3 70 70 0 0 0 111.4 367.7C136.4 409.1 351.4 785 357.3 794.1A190.5 190.5 0 0 0 518.2 879.1H685A69.5 69.5 0 0 0 753.2 797.3 71.8 71.8 0 0 0 681.8 740.5Z"
  }));
};
IconBoosterSolid.defaultProps = {
  title: 'booster solid'
};
IconBoosterSolid.propTypes = {
  title: PropTypes.string
};

var IconBooster = function IconBooster(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-booster",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M419.1 355.9A120.5 120.5 0 1 0 298.6 235.5 120.5 120.5 0 0 0 419.1 355.9ZM419.1 149.5A86.4 86.4 0 1 1 332.7 235.5 86.4 86.4 0 0 1 419.1 149.5ZM862.3 513.2A201.4 201.4 0 0 0 752.3 483.6 256.8 256.8 0 0 0 650.5 505.9C648.2 505.9 645.5 505.9 642.7 500.9L605.5 455.5A5.5 5.5 0 0 1 605.5 448.2 85 85 0 0 1 620 440.9 280.9 280.9 0 0 0 677.7 409.1 272.7 272.7 0 0 0 727.3 359.1 67.7 67.7 0 0 0 731.8 279.5 63.2 63.2 0 0 0 681.8 255 48.6 48.6 0 0 0 644.5 273.2 449.1 449.1 0 0 1 605.5 314.5 400.9 400.9 0 0 1 552.7 348.6C543.6 352.7 495.9 371.8 474.1 377.7A85 85 0 0 0 418.2 427.7 129.1 129.1 0 0 0 428.2 536.8L488.6 641.4A112.3 112.3 0 0 0 555.5 699.1 102.3 102.3 0 0 0 581.8 702.3 120.5 120.5 0 0 0 642.3 685.5 172.3 172.3 0 0 0 695 640 82.7 82.7 0 0 1 736.8 611.4 97.7 97.7 0 0 1 820 623.2 53.2 53.2 0 0 0 868.6 628.6 53.6 53.6 0 0 0 901.8 591.4 65.9 65.9 0 0 0 863.6 513.2ZM868.2 581.4A20 20 0 0 1 855.5 595.9 20 20 0 0 1 837.3 595.9 130.5 130.5 0 0 0 730 579.1 120 120 0 0 0 665.5 624.5 129.1 129.1 0 0 1 624.5 660.5 80.9 80.9 0 0 1 563.6 670.5 79.1 79.1 0 0 1 518.2 629.1L457.7 524.1A94.1 94.1 0 0 1 450 445 45.5 45.5 0 0 1 482.3 409.1 847.7 847.7 0 0 0 567.3 377.3 445.5 445.5 0 0 0 626.8 338.2 433.2 433.2 0 0 0 672.3 292.7 14.5 14.5 0 0 1 681.8 289.1 32.3 32.3 0 0 1 704.1 300.9C709.1 306.8 711.8 316.4 697.7 340A295 295 0 0 1 657.7 381.8 318.2 318.2 0 0 1 608.6 409.1 181.8 181.8 0 0 0 590.5 417.7 40.9 40.9 0 0 0 578.2 474.1L615 519.5A39.1 39.1 0 0 0 664.1 536.8 223.2 223.2 0 0 1 751.4 517.3 174.5 174.5 0 0 1 842.3 540L844.5 540C874.5 559.5 870 575.5 868.2 581.4ZM681.8 735H531.4A71.4 71.4 0 0 1 469.5 699.1L237.3 297.3A76.8 76.8 0 0 0 146.4 261.8 76.4 76.4 0 0 0 100.9 307.3 74.5 74.5 0 0 0 106.4 370.9C130.9 413.6 346.4 788.6 352.3 797.3A193.2 193.2 0 0 0 517.7 885H684.5A75 75 0 0 0 758.2 796.8 77.3 77.3 0 0 0 681.8 735ZM716.4 835.9A39.5 39.5 0 0 1 685 850.5H519.1A160 160 0 0 1 382.7 778.6C375.5 769.1 218.2 496.4 136.4 353.2A40 40 0 0 1 133.2 318.2 42.3 42.3 0 0 1 158.6 293.6 35.5 35.5 0 0 1 170.5 293.6 45.5 45.5 0 0 1 207.7 315.9L440 717.7A105.9 105.9 0 0 0 530.9 770.5H681.8A45.5 45.5 0 0 1 727.3 803.6 42.3 42.3 0 0 1 716.4 835.9Z"
  }));
};
IconBooster.defaultProps = {
  title: 'booster'
};
IconBooster.propTypes = {
  title: PropTypes.string
};

var IconBulbSolid = function IconBulbSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-bulb-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M371.4 847.3H628.6A70 70 0 0 1 558.6 914.5H441.4A70 70 0 0 1 371.4 847.3ZM371.4 790.5H628.6V779.5H371.4ZM500 237.7A233.6 233.6 0 0 0 262.3 465 288.6 288.6 0 0 0 323.6 641.4L330.5 651.4A200.5 200.5 0 0 1 368.6 721.8H631.4A200.5 200.5 0 0 1 669.5 651.4L676.4 641.4A288.6 288.6 0 0 0 737.7 465 233.6 233.6 0 0 0 500 237.7ZM867.7 474.5H776.8A22.7 22.7 0 0 0 776.8 520H867.7A22.7 22.7 0 1 0 867.7 474.5ZM272.7 306.8A21.8 21.8 0 0 0 288.6 313.2 21.8 21.8 0 0 0 310.9 290.9 23.6 23.6 0 0 0 303.6 272.7L239.5 210.9A22.3 22.3 0 0 0 207.7 242.7ZM500 220.5A22.7 22.7 0 0 0 522.7 198.2V107.3A22.7 22.7 0 0 0 477.3 107.3V198.2A22.7 22.7 0 0 0 500 220.5ZM712.3 311.4A23.6 23.6 0 0 0 727.3 306.8L790.9 242.7A25.5 25.5 0 0 0 799.1 227.3 23.2 23.2 0 0 0 792.3 211.4 22.3 22.3 0 0 0 760.5 211.4L696.4 272.7A22.7 22.7 0 0 0 712.3 311.4ZM222.7 474.5H131.8A22.7 22.7 0 1 0 131.8 520H222.7A22.7 22.7 0 0 0 222.7 474.5Z"
  }));
};
IconBulbSolid.defaultProps = {
  title: 'bulb solid'
};
IconBulbSolid.propTypes = {
  title: PropTypes.string
};

var IconBulb = function IconBulb(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-bulb",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M483.2 199.1V108.2A16.8 16.8 0 0 1 500 90.9 17.3 17.3 0 0 1 517.3 108.2V199.1A17.3 17.3 0 0 1 500 215.9 16.8 16.8 0 0 1 483.2 199.1ZM727.3 304.1L791.4 240A16.8 16.8 0 1 0 767.3 215.9L701.8 280A16.8 16.8 0 1 0 725.9 304.1ZM871.4 482.7H780.5A17.3 17.3 0 0 0 780.5 517.3H871.4A17.3 17.3 0 0 0 871.4 482.7ZM222.3 482.7H131.4A17.3 17.3 0 0 0 131.4 517.3H222.3A17.3 17.3 0 0 0 222.3 482.7ZM272.7 304.1A16.8 16.8 0 1 0 296.8 280L234.1 215.9A16.8 16.8 0 0 0 210 240ZM727.3 468.2A282.7 282.7 0 0 1 667.7 639.5 184.5 184.5 0 0 0 617.3 748.6V850A59.5 59.5 0 0 1 559.1 909.1H440.9A59.5 59.5 0 0 1 381.8 850V748.6A184.5 184.5 0 0 0 331.4 639.5 282.7 282.7 0 0 1 272.7 468.2 224.5 224.5 0 0 1 500 250 224.5 224.5 0 0 1 727.3 468.2ZM583.2 840.9H415.9V850A25 25 0 0 0 440.9 875H559.1A25 25 0 0 0 584.1 850ZM583.2 772.7H415.9V806.8H584.1ZM693.2 468.2A190 190 0 0 0 500 284.1 190 190 0 0 0 305.9 468.2 247.7 247.7 0 0 0 359.5 620L366.4 629.5A205 205 0 0 1 414.5 738.6H585.5A205 205 0 0 1 633.6 629.5L640.5 620A247.7 247.7 0 0 0 694.1 468.2Z"
  }));
};
IconBulb.defaultProps = {
  title: 'bulb'
};
IconBulb.propTypes = {
  title: PropTypes.string
};

var IconBurger = function IconBurger(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-burger",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M76.8 256.8H923.2A29.5 29.5 0 0 0 954.5 227.3 30 30 0 0 0 925 197.7H76.8A29.1 29.1 0 0 0 55.9 247.7 30.9 30.9 0 0 0 76.8 256.8ZM923.2 470.5H76.8A29.1 29.1 0 0 0 55.9 520.5 30.9 30.9 0 0 0 76.8 529.1H923.2A29.5 29.5 0 0 0 954.5 500 30 30 0 0 0 923.2 470.5ZM923.2 743.2H76.8A29.1 29.1 0 0 0 55.9 793.2 30.9 30.9 0 0 0 76.8 801.8H923.2A29.5 29.5 0 0 0 954.5 772.7 30 30 0 0 0 923.2 743.2Z"
  }));
};
IconBurger.defaultProps = {
  title: 'burger'
};
IconBurger.propTypes = {
  title: PropTypes.string
};

var IconBusDoubleSolid = function IconBusDoubleSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-bus-double-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M763.2 379.5V321.4A1282.7 1282.7 0 0 1 500 346.8 1267.7 1267.7 0 0 1 238.6 321.4V380A1301.4 1301.4 0 0 0 500 405.5 1280.9 1280.9 0 0 0 763.2 379.5ZM763.2 284.5V242.3A153.2 153.2 0 0 0 614.1 85H386.8A153.6 153.6 0 0 0 238.6 242.3V285A1300 1300 0 0 0 500 310.5 1280.9 1280.9 0 0 0 763.2 284.5ZM800 413.6H775A1252.7 1252.7 0 0 1 500 442.3 1252.7 1252.7 0 0 1 227.3 413.6H200A40.9 40.9 0 0 0 160 455V522.7A40.9 40.9 0 0 0 200 563.6H237.7V590.9A1272.7 1272.7 0 0 0 500 616.8 1309.1 1309.1 0 0 0 762.3 590.9V563.2H800A40.5 40.5 0 0 0 840 522.3V454.5A41.4 41.4 0 0 0 800 413.6ZM237.3 628.6L237.3 872.7A40 40 0 0 0 276.8 913.6H331.8A40.5 40.5 0 0 0 371.8 872.7V836.8H624.5V873.6A40 40 0 0 0 664.1 914.5H720.9A40.5 40.5 0 0 0 760.9 873.6L760.9 628.6A1269.1 1269.1 0 0 1 499.1 654.1 1281.4 1281.4 0 0 1 237.3 628.6ZM367.7 757.7H335A17.7 17.7 0 0 1 335 722.7H367.7A17.7 17.7 0 0 1 367.7 757.7ZM626.4 722.7H659.5A17.7 17.7 0 0 1 659.5 757.7H626.4A17.7 17.7 0 0 1 626.4 722.7Z"
  }));
};
IconBusDoubleSolid.defaultProps = {
  title: 'bus double solid'
};
IconBusDoubleSolid.propTypes = {
  title: PropTypes.string
};

var IconBusDouble = function IconBusDouble(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-bus-double",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M801.4 416.8H765V247.3A155.9 155.9 0 0 0 719.5 134.5 147.3 147.3 0 0 0 615 89.1H387.7A154.1 154.1 0 0 0 235 247.3V416.8H198.6A40.9 40.9 0 0 0 157.7 457.7V523.6A40.9 40.9 0 0 0 198.6 564.5H235V868.2A40.9 40.9 0 0 0 276.4 909.1H333.6A40.9 40.9 0 0 0 374.5 868.2V834.1H625.9V868.2A40.9 40.9 0 0 0 666.8 909.1H724.1A40.9 40.9 0 0 0 765 868.2V830.5H765V564.5H801.4A40.9 40.9 0 0 0 842.3 523.6V457.7A40.9 40.9 0 0 0 801.4 416.8ZM235 527.7H198.6A5 5 0 0 1 193.6 522.3V457.3A5 5 0 0 1 198.6 454.5H235ZM338.6 868.2A5 5 0 0 1 333.6 873.2H276.4A5 5 0 0 1 272.7 868.2V834.1H338.6ZM729.1 868.2A5.5 5.5 0 0 1 724.1 873.2H666.8A5.9 5.9 0 0 1 661.8 868.2V834.1H727.3ZM729.1 798.2H270V628.6A1318.2 1318.2 0 0 0 501.4 648.6 1290.9 1290.9 0 0 0 728.6 629.1ZM729.1 593.2A1297.7 1297.7 0 0 1 269.5 590.9V430.5A1322.7 1322.7 0 0 0 500 450.5 1335 1335 0 0 0 727.3 430.9ZM729.1 395A1300.5 1300.5 0 0 1 267.7 395V333.2A1322.7 1322.7 0 0 0 500 353.2H515.5L551.4 353.2 575.5 353.2C604.5 353.2 633.6 349.5 662.3 346.4L688.2 342.7 729.1 337.3ZM729.1 297.7A1300.5 1300.5 0 0 1 267.7 297.7V247.3A117.7 117.7 0 0 1 385.9 128.2H613.2A117.7 117.7 0 0 1 730 247.3ZM805 525A5.9 5.9 0 0 1 800 530.5H763.6V454.5H800A5.9 5.9 0 0 1 805 460ZM387.7 737.7A17.7 17.7 0 0 1 370.5 755H337.7A16.8 16.8 0 0 1 320.5 737.7 17.7 17.7 0 0 1 337.7 720.9H370.5A17.7 17.7 0 0 1 387.7 737.7ZM615 737.7A17.7 17.7 0 0 1 632.3 720.9H665.5A17.3 17.3 0 0 1 665.5 755H631.8A17.3 17.3 0 0 1 614.5 737.7Z"
  }));
};
IconBusDouble.defaultProps = {
  title: 'bus double'
};
IconBusDouble.propTypes = {
  title: PropTypes.string
};

var IconBusNightSolid = function IconBusNightSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-bus-night-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M469.5 681.8A1810 1810 0 0 1 170 658.2L158.2 655.9V888.6A50 50 0 0 0 208.2 938.6H253.6A50 50 0 0 0 303.6 888.6V863.6H631.4V890A49.5 49.5 0 0 0 681.8 939.5H729.5A49.5 49.5 0 0 0 779.1 889.5V656.8L768.6 656.8A1814.5 1814.5 0 0 1 469.5 681.8ZM303.6 772.7H272.7A25 25 0 1 1 272.7 723.2H305.9A25 25 0 0 1 305.9 772.7ZM667.3 772.7H636.4A25 25 0 1 1 636.4 723.2H669.5A25 25 0 0 1 669.5 772.7ZM681.8 580A272.7 272.7 0 0 0 778.6 562.3V607.7L760 610.9A1765.5 1765.5 0 0 1 468.2 634.1 1760 1760 0 0 1 176.8 610.9L156.8 607.3V454.5H115.5A33.2 33.2 0 0 1 82.3 421.4V340.9A33.2 33.2 0 0 1 115.5 307.7H158.2A181.8 181.8 0 0 1 340 125.9H454.5A284.1 284.1 0 0 0 681.8 580.5ZM681.8 60.5A235 235 0 0 0 681.8 530 230.5 230.5 0 0 0 778.6 508.6 234.5 234.5 0 0 0 681.8 60.5ZM785.5 416.4A162.3 162.3 0 0 1 675.5 459.5 169.1 169.1 0 0 1 623.6 451.4 168.2 168.2 0 0 1 516.4 265.9 161.8 161.8 0 0 1 627.7 143.2 14.5 14.5 0 0 1 644.1 148.2 15 15 0 0 1 644.1 165 159.1 159.1 0 0 0 623.6 217.7H623.6A149.5 149.5 0 0 0 720.5 381.8 146.8 146.8 0 0 0 776.4 390.5 15 15 0 0 1 790.5 400 14.1 14.1 0 0 1 786.8 416.4ZM772.7 262.7L779.5 300.9 745 282.7 710.9 300.9 717.7 262.7 690 235.9 727.3 230.5 744.1 195.5 761.4 230.5 799.5 235.9Z"
  }));
};
IconBusNightSolid.defaultProps = {
  title: 'bus night solid'
};
IconBusNightSolid.propTypes = {
  title: PropTypes.string
};

var IconBusNight = function IconBusNight(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-bus-night",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M325.9 747.7A17.3 17.3 0 0 1 309.1 764.5H275.9A17.3 17.3 0 0 1 275.9 730.5H309.1A17.3 17.3 0 0 1 325.9 747.7ZM639.1 764.5H672.3A17.3 17.3 0 1 0 672.3 730.5H639.1A17.3 17.3 0 0 0 639.1 764.5ZM911.8 294.1A232.7 232.7 0 0 1 784.5 500V898.2A40 40 0 0 1 745 938.2H687.7A40 40 0 0 1 647.7 898.2V863.6H300.5V900.9A40 40 0 0 1 260.9 940.9H203.6A40 40 0 0 1 163.6 900.9V863.6H163.6V454.5H126.4A39.5 39.5 0 0 1 86.8 415V348.6A39.5 39.5 0 0 1 126.4 308.6H163.6V281.4A153.6 153.6 0 0 1 318.2 127.7H517.7A232.7 232.7 0 0 1 914.1 294.1ZM163.6 342.7H126.4A5.5 5.5 0 0 0 120.9 348.6V414.5A5.5 5.5 0 0 0 126.4 420H163.6ZM266.4 863.6H197.7V900.9A5.9 5.9 0 0 0 203.6 906.8H260.9A5.9 5.9 0 0 0 266.4 900.9ZM750.5 863.6H681.8V900.9A5.9 5.9 0 0 0 687.7 906.8H745A5.5 5.5 0 0 0 750.5 900.9ZM750.5 653.6A1736.8 1736.8 0 0 1 474.5 675 1748.2 1748.2 0 0 1 197.7 653.6V829.5H750.5ZM750.5 517.3A224.5 224.5 0 0 1 681.8 527.3 232.7 232.7 0 0 1 490 163.6H318.2A119.5 119.5 0 0 0 197.7 281.4V308.6H197.7V454.5H197.7V618.2A1788.6 1788.6 0 0 0 750.5 618.2ZM879.1 296.4A199.1 199.1 0 1 0 681.8 493.2 199.5 199.5 0 0 0 879.1 294.1ZM776.4 390.5A146.8 146.8 0 0 1 720.5 381.8 149.5 149.5 0 0 1 625.9 217.7H625.9A159.1 159.1 0 0 1 646.4 165 15 15 0 0 0 646.4 148.2 14.5 14.5 0 0 0 630 143.2 161.8 161.8 0 0 0 518.6 265.9 168.2 168.2 0 0 0 625.9 451.4 169.1 169.1 0 0 0 677.7 459.5 162.3 162.3 0 0 0 787.7 416.4 14.1 14.1 0 0 0 791.4 400 15 15 0 0 0 776.4 390.5ZM745 195.5L727.3 230.5 689.1 235.9 716.8 262.7 710 300.9 744.1 282.7 778.6 300.9 772.7 262.7 800.5 235.9 762.3 230.5Z"
  }));
};
IconBusNight.defaultProps = {
  title: 'bus night'
};
IconBusNight.propTypes = {
  title: PropTypes.string
};

var IconBusServiceSolid = function IconBusServiceSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-bus-service-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M686.8 56.4A235 235 0 1 0 921.8 291.4 235.9 235.9 0 0 0 686.8 56.4ZM807.3 318.2H711.8V411.8A25.5 25.5 0 1 1 661.4 411.8V318.2H565.9A25.5 25.5 0 0 1 540.9 292.7 25 25 0 0 1 565.9 267.7H661.4V170.9A25.5 25.5 0 1 1 711.8 170.9V266.4H807.3A25 25 0 0 1 832.7 291.4 25.5 25.5 0 0 1 807.3 318.2ZM686.8 577.3A283.2 283.2 0 0 0 781.4 560.5V609.5L769.1 611.8A1818.2 1818.2 0 0 1 468.6 635.9 1803.6 1803.6 0 0 1 169.5 611.8L155.9 609.5V450H107.7A30 30 0 0 1 78.2 420.5V338.2A30 30 0 0 1 107.7 308.6H155.9V305.9A181.8 181.8 0 0 1 337.7 124.1H454.5A285 285 0 0 0 685.9 578.6ZM468.6 686.4A1853.6 1853.6 0 0 1 161.4 661.8L155.9 661.8V898.2A45.5 45.5 0 0 0 201.4 943.6H250.9A45.5 45.5 0 0 0 296.4 898.2V875.5H639.1V898.2A45.5 45.5 0 0 0 684.5 943.6H733.2A45.5 45.5 0 0 0 778.6 898.2V661.8L774.5 661.8A1866.4 1866.4 0 0 1 468.6 686.4ZM300 777.3H265.9A25.5 25.5 0 0 1 265.9 726.4H300A25.5 25.5 0 0 1 300 777.3ZM671.4 777.3H636.4A25.5 25.5 0 0 1 636.4 727.3H670.5A25.5 25.5 0 0 1 670.5 778.2Z"
  }));
};
IconBusServiceSolid.defaultProps = {
  title: 'bus service solid'
};
IconBusServiceSolid.propTypes = {
  title: PropTypes.string
};

var IconBusService = function IconBusService(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-bus-service",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M815.5 294.1A17.3 17.3 0 0 1 798.2 310.9H694.5V414.5A17.3 17.3 0 0 1 677.3 431.8 16.8 16.8 0 0 1 660.5 414.5V310.9H556.4A17.3 17.3 0 0 1 556.4 276.8H660.5V173.2A16.8 16.8 0 0 1 677.3 155.9 17.3 17.3 0 0 1 694.5 173.2V276.8H798.2A17.3 17.3 0 0 1 815.5 294.1ZM910.5 294.1A231.8 231.8 0 0 1 787.3 500V901.4A40 40 0 0 1 747.7 941.4H690.5A40.5 40.5 0 0 1 650.5 901.4V863.6H303.2V900.9A40 40 0 0 1 263.6 940.9H206.4A40 40 0 0 1 166.4 900.9V863.6H166.4V454.5H129.1A39.5 39.5 0 0 1 90.9 414.5V348.6A39.5 39.5 0 0 1 130.5 308.6H167.7V281.4A153.6 153.6 0 0 1 318.2 127.7H512.3A232.7 232.7 0 0 1 909.1 294.1ZM166.4 342.7H129.1A5.5 5.5 0 0 0 123.6 348.6V414.5A5.5 5.5 0 0 0 129.1 420H166.4ZM269.1 863.6H200.5V900.9A5.9 5.9 0 0 0 206.4 906.8H263.6A5.5 5.5 0 0 0 269.1 900.9ZM753.2 863.6H684.5V900.9A5.9 5.9 0 0 0 690.5 906.8H747.7A5.5 5.5 0 0 0 753.2 900.9ZM753.2 653.6A1736.8 1736.8 0 0 1 477.3 675 1748.2 1748.2 0 0 1 200.5 653.6V829.5H753.2ZM753.2 514.5A220.5 220.5 0 0 1 677.3 528.6 232.7 232.7 0 0 1 485.5 165H318.2A119.5 119.5 0 0 0 200.5 281.4V308.6H200.5V454.5H200.5V618.2A1788.6 1788.6 0 0 0 753.2 618.2ZM876.4 295.5A198.6 198.6 0 0 0 539.5 151.8 15.5 15.5 0 0 1 530.5 161.8 197.3 197.3 0 0 0 478.2 295.5 199.1 199.1 0 0 0 876.4 295.5ZM311.8 730.5H278.6A17.3 17.3 0 0 0 278.6 764.5H311.8A17.3 17.3 0 0 0 311.8 730.5ZM641.8 764.5H675A17.3 17.3 0 1 0 675 730.5H641.8A17.3 17.3 0 0 0 641.8 764.5Z"
  }));
};
IconBusService.defaultProps = {
  title: 'bus service'
};
IconBusService.propTypes = {
  title: PropTypes.string
};

var IconBusSolid = function IconBusSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-bus-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 649.5A1803.6 1803.6 0 0 1 200.9 625.5L189.1 625.5V858.2A49.5 49.5 0 0 0 238.6 907.7H284.1A49.5 49.5 0 0 0 334.1 858.2V831.8H661.8V858.2A49.5 49.5 0 0 0 711.4 907.7H759.1A49.5 49.5 0 0 0 808.6 858.2V623.6L798.2 623.6A1818.2 1818.2 0 0 1 500 649.5ZM334.5 740.5H301.4A25 25 0 0 1 301.4 690.5H334.5A25 25 0 0 1 334.5 740.5ZM698.2 740.5H665.5A25 25 0 1 1 665.5 690.5H698.2A25 25 0 0 1 698.2 740.5ZM886.8 307.7V388.6A33.2 33.2 0 0 1 853.6 421.8H810.5V529.1H810.5V574.5L791.8 577.7A1772.7 1772.7 0 0 1 499.5 600.9C474.1 600.9 449.1 600.9 424.1 600.9A1643.6 1643.6 0 0 1 207.3 579.1L188.6 575.9V530.5H188.6V421.8H143.2A33.2 33.2 0 0 1 110 388.6V307.7A33.2 33.2 0 0 1 145.9 272.7H191.4A181.8 181.8 0 0 1 373.2 90.9H630.5A181.8 181.8 0 0 1 812.3 272.7H855.5A33.2 33.2 0 0 1 887.3 307.7Z"
  }));
};
IconBusSolid.defaultProps = {
  title: 'bus solid'
};
IconBusSolid.propTypes = {
  title: PropTypes.string
};

var IconBusStopSolid = function IconBusStopSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-bus-stop-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M281.4 420.9A129.1 129.1 0 0 1 173.6 548.2V795.9H215.9A21.4 21.4 0 0 1 215.9 838.6H88.2A21.4 21.4 0 1 1 88.2 795.9H130.5V548.2A129.1 129.1 0 1 1 281.4 420.9ZM945 312.3H912.7V300.9A139.1 139.1 0 0 0 772.7 161.4H540.5A139.5 139.5 0 0 0 400.9 300.9V312.3H368.6A31.8 31.8 0 0 0 336.8 344.5V395A31.8 31.8 0 0 0 368.6 426.8H400.9V552.7L404.5 552.7A1587.3 1587.3 0 0 0 910.5 552.7H910.5V426.8H942.7A31.8 31.8 0 0 0 975 395V344.5A32.3 32.3 0 0 0 945 312.3ZM657.3 627.3A1594.1 1594.1 0 0 0 912.7 607.3V800A31.8 31.8 0 0 1 880.9 832.3H837.7A32.3 32.3 0 0 1 805.5 800V768.2H508.2V800A32.3 32.3 0 0 1 475.9 832.3H433.2A32.3 32.3 0 0 1 400.9 800V607.3A1601.4 1601.4 0 0 0 657.3 627.3ZM545.5 685.5A26.8 26.8 0 0 0 518.6 658.6H490.9A26.4 26.4 0 0 0 464.1 685.5 26.8 26.8 0 0 0 490.9 712.3H518.6A27.3 27.3 0 0 0 545.5 685.5ZM767.7 685.5A26.8 26.8 0 0 0 794.5 712.3H822.3A27.3 27.3 0 0 0 849.1 685.5 26.8 26.8 0 0 0 822.3 658.6H794.5A26.4 26.4 0 0 0 768.2 685.5Z"
  }));
};
IconBusStopSolid.defaultProps = {
  title: 'bus stop solid'
};
IconBusStopSolid.propTypes = {
  title: PropTypes.string
};

var IconBusStop = function IconBusStop(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-bus-stop",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M534.5 676.8A15.9 15.9 0 0 1 518.6 692.7H491.4A15.9 15.9 0 0 1 491.4 660.9H518.6A15.9 15.9 0 0 1 534.5 676.8ZM791.8 692.7H818.2A15.9 15.9 0 0 0 818.2 660.9H790.9A15.9 15.9 0 0 0 790.9 692.7ZM289.1 425A133.2 133.2 0 0 1 171.8 556.8V800.9H217.3A15.9 15.9 0 0 1 233.2 816.8 15.9 15.9 0 0 1 217.3 832.7H90.9A15.9 15.9 0 0 1 76.8 818.2 15.9 15.9 0 0 1 90.9 800.9H136.4V556.8A133.2 133.2 0 1 1 285.5 425ZM257.3 425A101.4 101.4 0 1 0 155.9 526.4 101.4 101.4 0 0 0 257.3 425ZM977.3 349.5V399.1A37.3 37.3 0 0 1 940 436.4H913.6V800A37.3 37.3 0 0 1 876.4 837.3H834.1A37.3 37.3 0 0 1 796.8 800V772.7H513.6V799.1A37.3 37.3 0 0 1 476.4 836.4H434.1A37.3 37.3 0 0 1 396.8 799.1V435.5H370.5A37.3 37.3 0 0 1 333.2 398.2V349.5A37.3 37.3 0 0 1 370.5 312.3H396.8V305.9A143.6 143.6 0 0 1 540 162.7H772.7A143.6 143.6 0 0 1 913.6 305.9V312.3H940A37.3 37.3 0 0 1 977.3 349.5ZM396.8 344.1H370.5A5.5 5.5 0 0 0 363.6 349.5V399.1A5.5 5.5 0 0 0 369.1 404.5H395.5ZM481.8 772.7H428.6V799.1A5.5 5.5 0 0 0 434.1 804.5H476.4A5.5 5.5 0 0 0 481.8 799.1ZM881.8 772.7H828.6V799.1A5.5 5.5 0 0 0 834.1 804.5H876.4A5.5 5.5 0 0 0 881.8 799.1ZM881.8 599.1A1450.5 1450.5 0 0 1 654.5 616.8 1451.8 1451.8 0 0 1 427.3 599.1V740.9H881.8ZM881.8 305A111.4 111.4 0 0 0 772.7 194.5H540A111.4 111.4 0 0 0 428.6 305.9V568.2A1485.5 1485.5 0 0 0 883.2 568.2V305.9ZM945.5 350.5A5.5 5.5 0 0 0 940 345H913.6V404.5H940A5.5 5.5 0 0 0 945.5 399.1Z"
  }));
};
IconBusStop.defaultProps = {
  title: 'bus stop'
};
IconBusStop.propTypes = {
  title: PropTypes.string
};

var IconBusTimeSolid = function IconBusTimeSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-bus-time-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M681.8 580A272.7 272.7 0 0 0 778.6 562.3V607.7L760 610.5A1716.8 1716.8 0 0 1 468.2 634.1 1760 1760 0 0 1 176.8 610.9L156.8 607.3V454.5H115.5A33.2 33.2 0 0 1 82.3 421.4V340.9A33.2 33.2 0 0 1 115.5 307.7H158.2A181.8 181.8 0 0 1 340 125.9H454.5A284.1 284.1 0 0 0 681.8 580.5ZM917.7 295.5A234.1 234.1 0 0 1 781.4 508.6 230.5 230.5 0 0 1 684.5 530 235 235 0 1 1 917.7 295.5ZM800.5 376.4L709.5 285.5V127.7A25 25 0 0 0 659.5 127.7V294.1A26.8 26.8 0 0 0 666.8 311.8L766.8 411.4A24.5 24.5 0 0 0 784.5 418.6 23.2 23.2 0 0 0 801.8 411.4 24.1 24.1 0 0 0 800.5 376.4ZM769.5 658.6L780 658.6V891.4A50 50 0 0 1 730.5 941.4H681.8A50 50 0 0 1 632.3 891.4V863.6H305.5V890A50 50 0 0 1 255.5 940H210A50 50 0 0 1 160 890V656.8L171.8 659.1A1810 1810 0 0 0 471.4 682.7 1814.5 1814.5 0 0 0 769.5 658.6ZM328.6 749.5A25 25 0 0 0 303.6 725H272.7A25 25 0 1 0 272.7 772.7H305.9A25 25 0 0 0 328.6 748.6ZM692.3 749.5A24.5 24.5 0 0 0 667.7 725H636.4A25 25 0 1 0 636.4 772.7H669.5A24.5 24.5 0 0 0 692.7 748.6Z"
  }));
};
IconBusTimeSolid.defaultProps = {
  title: 'bus time solid'
};
IconBusTimeSolid.propTypes = {
  title: PropTypes.string
};

var IconBusTime = function IconBusTime(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-bus-time",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M681.8 60.5A232.7 232.7 0 0 0 518.6 127.7H318.2A153.6 153.6 0 0 0 163.6 281.4V308.6H126.4A39.5 39.5 0 0 0 86.8 348.6V414.5A39.5 39.5 0 0 0 126.4 454.1H163.6V863.2H163.6V900.5A40 40 0 0 0 203.6 940.5H260.9A40 40 0 0 0 300.5 900.5V863.6H647.7V900.9A40 40 0 0 0 687.7 940.9H745A40 40 0 0 0 784.5 900.9V500A232.7 232.7 0 0 0 681.8 60.5ZM163.6 420H126.4A5.5 5.5 0 0 1 120.9 414.5V348.6A5.5 5.5 0 0 1 126.4 342.7H163.6ZM266.4 899.5A5.9 5.9 0 0 1 260.9 905.5H203.6A5.9 5.9 0 0 1 197.7 899.5V863.6H266.4ZM750.5 899.5A5.5 5.5 0 0 1 745 905.5H687.7A5.9 5.9 0 0 1 681.8 899.5V863.6H750.5ZM750.5 828.2H197.7V652.3A1748.2 1748.2 0 0 0 474.5 673.6 1736.8 1736.8 0 0 0 750.5 652.3ZM750.5 617.7A1788.6 1788.6 0 0 1 197.7 617.7V454.5H197.7V308.6H197.7V281.4A119.5 119.5 0 0 1 318.2 161.8H489.1A232.7 232.7 0 0 0 680.9 525.5 224.5 224.5 0 0 0 751.4 513.2ZM681.8 493.2A199.5 199.5 0 1 1 880.9 294.1 199.5 199.5 0 0 1 681.8 493.2ZM792.7 379.5A17.3 17.3 0 0 1 792.7 403.6 18.2 18.2 0 0 1 780.5 408.6 16.4 16.4 0 0 1 768.6 403.6L668.2 304.5A16.4 16.4 0 0 1 663.2 292.7V127.7A17.3 17.3 0 0 1 697.3 127.7V285.5ZM325.9 747.7A17.3 17.3 0 0 1 309.1 764.5H275.9A17.3 17.3 0 0 1 275.9 730.5H309.1A17.3 17.3 0 0 1 325.9 747.7ZM622.3 747.7A17.3 17.3 0 0 1 639.1 730.5H672.3A17.3 17.3 0 1 1 672.3 764.5H639.1A17.3 17.3 0 0 1 622.3 747.7Z"
  }));
};
IconBusTime.defaultProps = {
  title: 'bus time'
};
IconBusTime.propTypes = {
  title: PropTypes.string
};

var IconBus = function IconBus(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-bus",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M648.2 714.1A16.8 16.8 0 0 1 665 696.8H698.2A16.8 16.8 0 0 1 715 714.1 16.4 16.4 0 0 1 698.2 730.9H665A16.4 16.4 0 0 1 648.2 714.1ZM887.7 315V380.9A40 40 0 0 1 847.7 420.5H810.5V829.5H810.5V866.8A40 40 0 0 1 770.5 906.8H713.2A40 40 0 0 1 673.6 866.8V829.5H326.4V866.8A40 40 0 0 1 286.4 906.8H227.3A40 40 0 0 1 187.7 866.8V829.5H187.7V420.5H152.3A40 40 0 0 1 112.3 380.9V315A40.5 40.5 0 0 1 152.3 275H189.5V247.7A153.6 153.6 0 0 1 342.7 94.1H657.3A153.6 153.6 0 0 1 810.5 247.7V275H847.7A40.5 40.5 0 0 1 887.7 315ZM189.5 309.1H152.3A5.9 5.9 0 0 0 146.4 315V380.9A5.5 5.5 0 0 0 152.3 386.4H189.5ZM292.3 828.6H223.6V865.9A5.5 5.5 0 0 0 229.1 871.8H286.4A5.9 5.9 0 0 0 292.3 865.9ZM776.4 828.6H707.7V865.9A5.5 5.5 0 0 0 713.2 871.8H772.7A5.9 5.9 0 0 0 778.6 865.9ZM776.4 618.6A1738.2 1738.2 0 0 1 500 640 1742.7 1742.7 0 0 1 223.6 618.6V794.5H776.4ZM776.4 247.7A119.5 119.5 0 0 0 657.3 128.2H342.7A119.5 119.5 0 0 0 223.6 247.7V275H223.6V420.5H223.6V584.1A1772.7 1772.7 0 0 0 776.4 584.1V483.2H776.4V420.5H776.4V275H776.4ZM853.6 315A5.9 5.9 0 0 0 847.7 309.1H810.5V386.4H847.7A5.5 5.5 0 0 0 853.6 380.9ZM335 696.8H301.8A17.3 17.3 0 0 0 284.5 714.1 16.8 16.8 0 0 0 301.8 730.9H335A16.8 16.8 0 0 0 351.8 714.1 17.3 17.3 0 0 0 335 696.8Z"
  }));
};
IconBus.defaultProps = {
  title: 'bus'
};
IconBus.propTypes = {
  title: PropTypes.string
};

var IconBuses = function IconBuses(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-buses",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1132 1132"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M566.4 648.6L556.8 648.6C511.4 652.3 465.9 654.1 420.5 654.5H397.7A1872.3 1872.3 0 0 1 84.5 629.5L79.5 629.5V851.8A62.3 62.3 0 0 0 142.3 914.1H167.7A62.3 62.3 0 0 0 227.3 852.3V837.3H561.8V852.3A64.1 64.1 0 0 0 565 870.9 62.3 62.3 0 0 0 624.5 916.4H650A62.3 62.3 0 0 0 712.3 854.1V630L708.6 630Q640 642.7 566.4 648.6ZM227.3 748.6H192.3A28.6 28.6 0 0 1 192.3 691.8H227.3A28.6 28.6 0 0 1 227.3 748.6ZM568.2 748.6H534.1A28.6 28.6 0 0 1 534.1 691.8H568.2A28.6 28.6 0 0 1 568.2 748.6ZM1131.8 309.1V380.5A39.5 39.5 0 0 1 1092.3 420H1054.1V572.7L1041.4 572.7A1842.3 1842.3 0 0 1 768.6 596.8V475A95.9 95.9 0 0 0 846.4 380.5V309.1A95.9 95.9 0 0 0 768.6 214.5 181.8 181.8 0 0 0 715.5 85.5H922.3A130.5 130.5 0 0 1 1052.7 215.9V269.5H1090.9A39.5 39.5 0 0 1 1131.8 309.1ZM768.2 655.5V837.3H901.8V852.3A62.3 62.3 0 0 0 964.5 914.5H990A62.3 62.3 0 0 0 1052.3 852.3V630L1048.6 630A1899.1 1899.1 0 0 1 770 655.5ZM937.7 746.4H904.1A28.6 28.6 0 1 1 904.1 689.5H937.7A28.6 28.6 0 1 1 937.7 746.4ZM751.4 420H713.2V572.7L704.1 572.7H700.5C655 580.5 612.3 585.9 566.4 589.5 542.3 591.8 517.7 593.6 492.7 594.5S428.6 597.3 395.9 597.3A1855.5 1855.5 0 0 1 90.9 575L76.4 572.3V420H40A39.5 39.5 0 0 1 0 380.5V309.1A39.5 39.5 0 0 1 40 269.5H77.7V215.9A130.5 130.5 0 0 1 208.6 85.5H582.7A130.5 130.5 0 0 1 713.2 215.9V269.5H751.4A39.5 39.5 0 0 1 790.9 309.1V380.5A39.5 39.5 0 0 1 751.4 420Z"
  }));
};
IconBuses.defaultProps = {
  title: 'buses'
};
IconBuses.propTypes = {
  title: PropTypes.string
};

var IconCalendarSolid = function IconCalendarSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-calendar-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M45.5 792.7A102.3 102.3 0 0 0 147.7 895H850.9A102.3 102.3 0 0 0 954.5 792.7V395.9L45.5 398.6ZM727.3 469.1A40.9 40.9 0 1 1 686.4 510 40.9 40.9 0 0 1 729.5 469.1ZM727.3 602.7A40.9 40.9 0 1 1 727.3 684.5 40.9 40.9 0 0 1 727.3 602.7ZM569.1 469.1A40.9 40.9 0 1 1 569.1 550.9 40.9 40.9 0 1 1 569.1 469.1ZM569.1 602.7A40.9 40.9 0 1 1 528.2 643.6 40.9 40.9 0 0 1 571.4 602.7ZM411.4 469.1A40.9 40.9 0 1 1 411.4 550.9 40.9 40.9 0 1 1 411.4 469.1ZM411.4 602.7A40.9 40.9 0 1 1 370.5 643.6 40.9 40.9 0 0 1 411.4 602.7ZM411.4 736.4A40.9 40.9 0 1 1 370.5 777.3 40.9 40.9 0 0 1 411.4 736.4ZM251.4 602.7A40.9 40.9 0 1 1 210.5 643.6 40.9 40.9 0 0 1 251.4 602.7ZM251.4 736.4A40.9 40.9 0 1 1 210.5 777.3 40.9 40.9 0 0 1 251.4 736.4ZM954.5 280.5V339.1L45.5 341.8V280.5A102.3 102.3 0 0 1 149.1 178.2H223.2V245.5A28.6 28.6 0 1 0 280 245.5V178.2H708.6V245.5A28.6 28.6 0 1 0 765.5 245.5V178.2H850.9A102.3 102.3 0 0 1 954.5 280.5ZM280 178.2H223.2V132.7A28.6 28.6 0 1 1 280 132.7ZM765.5 178.2H708.6V132.7A28.6 28.6 0 1 1 765.5 132.7Z"
  }));
};
IconCalendarSolid.defaultProps = {
  title: 'calendar solid'
};
IconCalendarSolid.propTypes = {
  title: PropTypes.string
};

var IconCalendar = function IconCalendar(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-calendar",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M850.9 158.2H760V125A22.7 22.7 0 0 0 737.3 102.3 22.7 22.7 0 0 0 714.5 125V158.2H272.7V125A22.7 22.7 0 0 0 250 102.3 22.7 22.7 0 0 0 227.3 125V158.2H149.1A113.6 113.6 0 0 0 35.5 272.7V784.1A113.6 113.6 0 0 0 149.1 897.7H850.9A113.6 113.6 0 0 0 964.5 784.1V272.7A113.6 113.6 0 0 0 850.9 158.2ZM919.1 784.1A68.2 68.2 0 0 1 850.9 852.3H149.1A68.2 68.2 0 0 1 80.9 784.1V384.5L919.1 381.8ZM919.1 336.4L80.9 339.1V272.7A68.2 68.2 0 0 1 149.1 204.5H227.3V238.2A23.2 23.2 0 0 0 250 260.9 22.7 22.7 0 0 0 272.7 238.2V203.6H713.2V237.3A22.7 22.7 0 0 0 735.9 260 23.2 23.2 0 0 0 758.6 237.3V203.6H849.5A68.2 68.2 0 0 1 919.1 272.7ZM380 484.5A31.8 31.8 0 1 1 443.2 484.5 31.8 31.8 0 1 1 380 484.5ZM540 484.5A31.8 31.8 0 1 1 603.2 484.5 31.8 31.8 0 1 1 540 484.5ZM697.7 484.5A31.8 31.8 0 0 1 761.4 484.5 31.8 31.8 0 0 1 697.7 484.5ZM379.5 618.2A31.8 31.8 0 1 1 410.9 650 31.4 31.4 0 0 1 380 618.2ZM219.5 618.2A31.8 31.8 0 1 1 250.9 650 31.4 31.4 0 0 1 220 618.2ZM379.5 754.5A31.8 31.8 0 1 1 410.9 785.9 31.4 31.4 0 0 1 380 752.3ZM219.5 754.5A31.8 31.8 0 1 1 250.9 785.9 31.4 31.4 0 0 1 220 752.3ZM537.7 618.2A31.8 31.8 0 1 1 569.1 650 31.4 31.4 0 0 1 540 618.2ZM695.5 618.2A31.8 31.8 0 0 1 759.1 618.2 31.8 31.8 0 0 1 695.5 618.2Z"
  }));
};
IconCalendar.defaultProps = {
  title: 'calendar'
};
IconCalendar.propTypes = {
  title: PropTypes.string
};

var IconCallSolid = function IconCallSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-call-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M902.7 716.8A73.2 73.2 0 0 0 853.2 675.5L633.2 620.9A57.7 57.7 0 0 0 615.5 618.6 75 75 0 0 0 570 634.1 74.1 74.1 0 0 0 541.8 694.1V697.3L549.1 772.7A560.5 560.5 0 0 1 227.3 450.9L306.8 457.3H310.9A80.5 80.5 0 0 0 330 454.5 73.6 73.6 0 0 0 369.5 427.3 72.3 72.3 0 0 0 381.8 363.6L323.2 145.9A74.5 74.5 0 0 0 280.5 96.8 76.4 76.4 0 0 0 252.3 90.9H252.3A80.9 80.9 0 0 0 214.5 100.9L214.5 100.9 214.5 100.9 130.5 159.1A71.8 71.8 0 0 0 90.9 215.9V253.6A656.8 656.8 0 0 0 744.1 909.1L791.8 909.1H794.5A49.1 49.1 0 0 0 830.9 887.7L898.2 786.8 898.2 786.8 898.2 784.1A96.8 96.8 0 0 0 904.5 767.3 73.2 73.2 0 0 0 902.7 716.8Z"
  }));
};
IconCallSolid.defaultProps = {
  title: 'call solid'
};
IconCallSolid.propTypes = {
  title: PropTypes.string
};

var IconCall = function IconCall(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-call",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M902.7 716.8A73.2 73.2 0 0 0 853.2 675.5L633.2 620.9A57.7 57.7 0 0 0 615.5 618.6 75 75 0 0 0 570 634.1 74.1 74.1 0 0 0 541.8 694.1V697.3L549.1 772.7A560.5 560.5 0 0 1 227.3 450.9L306.8 457.3H310.9A80.5 80.5 0 0 0 330 454.5 73.6 73.6 0 0 0 369.5 427.3 72.3 72.3 0 0 0 381.8 363.6L323.2 145.9A74.5 74.5 0 0 0 280.5 96.8 76.4 76.4 0 0 0 252.3 90.9H252.3A80.9 80.9 0 0 0 214.5 100.9L214.5 100.9 214.5 100.9 130.5 159.1A71.8 71.8 0 0 0 90.9 215.9V253.6A656.8 656.8 0 0 0 744.1 909.1L791.8 909.1H794.5A49.1 49.1 0 0 0 830.9 887.7L898.2 786.8 898.2 786.8 898.2 784.1A96.8 96.8 0 0 0 904.5 767.3 73.2 73.2 0 0 0 902.7 716.8ZM873.6 756.4A39.1 39.1 0 0 1 870.5 765.9L870.5 765.9 803.6 866.8A15.5 15.5 0 0 1 791.8 873.2L746.4 873.2A621.4 621.4 0 0 1 125 253.6V215C125 203.2 149.1 187.3 149.1 187.3L230.9 130.9A45.5 45.5 0 0 1 252.3 125 45.5 45.5 0 0 1 267.3 128.2 40 40 0 0 1 290 154.5L349.1 373.2A40 40 0 0 1 320.9 421.8 34.5 34.5 0 0 1 311.4 421.8H311.4L204.1 415 179.1 415A590.9 590.9 0 0 0 588.2 824.1L584.1 780.9 575.9 696.8A39.1 39.1 0 0 1 615.5 655.5L625 655.5 845 710.5A39.5 39.5 0 0 1 873.6 758.2Z"
  }));
};
IconCall.defaultProps = {
  title: 'call'
};
IconCall.propTypes = {
  title: PropTypes.string
};

var IconCarSeatSolid = function IconCarSeatSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-car-seat-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M192.3 215C192.3 208.2 192.3 151.8 195.5 124.1A40 40 0 0 1 235.9 85.9 324.1 324.1 0 0 1 287.3 90.9 40.5 40.5 0 0 1 318.2 144.5C315 160.9 308.6 223.6 305 235.5A36.8 36.8 0 0 1 271.4 263.6 296.8 296.8 0 0 1 225.9 260.9C200.5 258.6 191.8 237.3 192.3 215ZM424.5 557.3A357.7 357.7 0 0 0 409.1 470 443.2 443.2 0 0 0 341.4 318.2 77.7 77.7 0 0 0 272.7 283.6 148.6 148.6 0 0 0 227.3 295 48.2 48.2 0 0 0 198.2 360C213.2 403.2 289.1 640 316.4 714.1 323.2 734.5 345.9 725.9 359.1 709.1A330.9 330.9 0 0 0 410.5 618.2 164.5 164.5 0 0 0 424.5 557.3ZM804.5 687.7A124.1 124.1 0 0 0 721.4 602.7 203.6 203.6 0 0 0 643.2 588.2 454.5 454.5 0 0 0 556.8 599.5C522.3 607.7 515.9 610.5 481.4 619.5A111.4 111.4 0 0 0 406.4 671.8 326.4 326.4 0 0 0 388.2 710.9 215.9 215.9 0 0 0 369.1 766.4 35.5 35.5 0 0 0 402.7 800.9C484.5 800.9 712.3 797.7 754.1 797.3A38.6 38.6 0 0 0 785 782.3 112.3 112.3 0 0 0 804.5 687.7ZM709.5 833.2H404.1A22.7 22.7 0 0 0 381.4 855.9V889.1A22.7 22.7 0 0 0 404.1 911.8H709.5A22.7 22.7 0 0 0 732.3 889.1V855.9A22.7 22.7 0 0 0 709.5 833.2Z"
  }));
};
IconCarSeatSolid.defaultProps = {
  title: 'car seat solid'
};
IconCarSeatSolid.propTypes = {
  title: PropTypes.string
};

var IconCarSeat = function IconCarSeat(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-car-seat",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M243.2 122.3A260.9 260.9 0 0 1 277.7 122.3L282.7 122.3H282.7A24.1 24.1 0 0 1 282.7 134.5C282.7 141.8 279.5 157.7 277.3 175S272.7 222.7 269.5 227.3 269.5 230 264.5 230A327.7 327.7 0 0 1 229.1 230S227.3 224.5 227.3 215.5 227.3 195.5 227.3 176.8 227.3 140 227.3 127.7C227.3 124.1 230.5 122.3 234.5 122.3H240.9M275.5 318.2A45.5 45.5 0 0 1 313.6 339.5 409.1 409.1 0 0 1 375.9 479.1 329.5 329.5 0 0 1 390.5 559.1 129.1 129.1 0 0 1 378.6 600L376.4 605.5A318.2 318.2 0 0 1 337.7 678.6C321.8 633.2 297.3 558.6 275.5 492.3S235 368.2 227.3 348.6A15.5 15.5 0 0 1 236.4 326.8 120.9 120.9 0 0 1 272.7 318.2H276.4M644.1 622.7H644.1A175 175 0 0 1 709.5 634.5 90.9 90.9 0 0 1 772.7 695.9 78.2 78.2 0 0 1 758.6 762.3S758.6 762.3 755 762.3C727.7 762.3 487.7 765.9 405.9 766.4 405.9 766.4 405.9 766.4 405.9 766.4A128.6 128.6 0 0 1 415.9 738.6C415.9 733.6 420 728.6 422.3 723.2A379.5 379.5 0 0 1 438.6 687.7 76.8 76.8 0 0 1 492.7 652.7L520.9 644.5C535 640.9 545 637.7 566.4 632.7A409.1 409.1 0 0 1 644.5 622.3M699.5 867.3V877.7H415.5V867.3H698.2M243.2 88.2H235.9A40 40 0 0 0 195.5 126.4C195.5 151.8 192.3 208.2 192.3 217.3 192.3 239.5 200.5 262.7 222.3 262.7A309.5 309.5 0 0 0 264.5 265.5H269.1A36.8 36.8 0 0 0 302.7 237.3C306.4 223.6 312.7 160.9 315.9 146.4A40.5 40.5 0 0 0 287.3 90.9 263.6 263.6 0 0 0 241.8 88.2ZM275.5 283.6H272.7A148.6 148.6 0 0 0 227.3 295 48.2 48.2 0 0 0 198.2 360C213.2 403.2 289.1 640 316.4 714.1A15 15 0 0 0 331.4 725.9 39.1 39.1 0 0 0 359.1 709.1 330.9 330.9 0 0 0 410.5 618.2 164.5 164.5 0 0 0 426.8 558.2 357.7 357.7 0 0 0 409.1 470 443.2 443.2 0 0 0 341.4 318.2 78.6 78.6 0 0 0 275.5 282.7ZM643.2 588.2H643.2A454.5 454.5 0 0 0 556.8 599.5C522.3 607.7 515.9 610.5 481.8 619.5A110.9 110.9 0 0 0 406.4 671.8 326.4 326.4 0 0 0 388.2 710.9 215.9 215.9 0 0 0 369.1 766.4 35.5 35.5 0 0 0 402.7 800.9C484.5 800.9 712.3 797.7 754.1 797.3A38.6 38.6 0 0 0 785 782.3 112.3 112.3 0 0 0 804.5 687.7 124.1 124.1 0 0 0 721.4 602.7 203.6 203.6 0 0 0 643.2 588.2ZM709.5 833.2H404.1A22.7 22.7 0 0 0 381.4 855.9V889.1A22.7 22.7 0 0 0 404.1 911.8H709.5A22.7 22.7 0 0 0 732.3 889.1V855.9A22.7 22.7 0 0 0 709.5 833.2Z"
  }));
};
IconCarSeat.defaultProps = {
  title: 'car seat'
};
IconCarSeat.propTypes = {
  title: PropTypes.string
};

var IconCarSolid = function IconCarSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-car-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M859.5 371.8A25.9 25.9 0 0 0 843.2 354.5 39.5 39.5 0 0 0 820 354.5L781.4 363.6 768.2 310A126.4 126.4 0 0 0 645 213.6H355A126.4 126.4 0 0 0 231.8 310L218.2 363.6 181.8 354.1A36.4 36.4 0 0 0 158.6 354.1 25.9 25.9 0 0 0 142.3 371.4L128.6 420.9A25.5 25.5 0 0 0 134.5 443.6 35.9 35.9 0 0 0 154.5 454.5L190.5 463.6H193.2A2185.9 2185.9 0 0 0 804.5 463.6H806.8L809.1 463.6 845.5 454.5A39.5 39.5 0 0 0 863.6 442.7 25.5 25.5 0 0 0 869.5 420ZM195 512.7V730.5A56.4 56.4 0 0 0 250.9 786.4H275.9A55.9 55.9 0 0 0 331.8 730.5V710.9H668.2V730.5A55.9 55.9 0 0 0 724.1 786.4H748.6A55.9 55.9 0 0 0 804.5 730.5V512.7A2121.4 2121.4 0 0 1 500 534.1 2200.5 2200.5 0 0 1 195 512.7ZM335 625H301.8A23.2 23.2 0 0 1 301.8 579.5H335A23.2 23.2 0 0 1 335 625ZM665 579.5H698.2A23.2 23.2 0 0 1 698.2 625H665A23.2 23.2 0 0 1 665 579.5Z"
  }));
};
IconCarSolid.defaultProps = {
  title: 'car solid'
};
IconCarSolid.propTypes = {
  title: PropTypes.string
};

var IconCar = function IconCar(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-car",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M338.6 582.7H305.9A17.3 17.3 0 0 0 305.9 616.8H338.6A17.3 17.3 0 0 0 338.6 582.7ZM694.1 582.7H661.8A17.3 17.3 0 0 0 661.8 616.8H694.1A17.3 17.3 0 1 0 694.1 582.7ZM868.2 401.8A30.5 30.5 0 0 0 849.1 380.9 45.5 45.5 0 0 0 822.7 380.9L787.7 389.5 768.6 313.6A130 130 0 0 0 642.3 213.6H358.2A130.5 130.5 0 0 0 231.4 312.3L212.7 388.6 177.3 380A45.5 45.5 0 0 0 150.9 380 32.3 32.3 0 0 0 131.8 400.9L120 446.4A36.4 36.4 0 0 0 150 487.7L195.5 499.1V727.3A60 60 0 0 0 256.4 786.4H280.5A60 60 0 0 0 340.9 727.3V713.6H659.1V727.3A60.5 60.5 0 0 0 719.5 787.7H744.1A60.5 60.5 0 0 0 804.5 727.3V500L850 488.6A41.8 41.8 0 0 0 872.7 475 30.5 30.5 0 0 0 880 447.7ZM264.5 320.9A96.4 96.4 0 0 1 358.2 247.7H642.3A96.8 96.8 0 0 1 735.9 320.9L772.7 471.8A1745 1745 0 0 1 227.3 471.8ZM154.1 454.5S154.1 454.5 154.1 454.5L164.1 409.1A9.5 9.5 0 0 1 169.5 409.1L204.1 417.7 193.2 463.2 158.6 454.5ZM306.8 727.3A26.4 26.4 0 0 1 280.5 753.6H256.4A26.4 26.4 0 0 1 230 727.3V713.6H306.8ZM772.7 727.3A26.4 26.4 0 0 1 746.4 753.6H721.8A26.4 26.4 0 0 1 695.5 727.3V713.6H772.7ZM659.1 678.2H230V506.8A1721.8 1721.8 0 0 0 502.7 527.7 1720 1720 0 0 0 772.7 506.8V678.2ZM840.9 457.3L806.4 465.5 795.5 420 830 411.4S834.1 411.4 834.5 411.4L845.9 454.1A7.7 7.7 0 0 1 841.8 457.3Z"
  }));
};
IconCar.defaultProps = {
  title: 'car'
};
IconCar.propTypes = {
  title: PropTypes.string
};

var IconCartSolid = function IconCartSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-cart-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M446.4 837.7A59.1 59.1 0 1 1 387.7 778.6 59.1 59.1 0 0 1 446.4 837.7ZM815.5 778.6A59.1 59.1 0 1 0 874.5 837.7 59.5 59.5 0 0 0 815.5 778.6ZM903.6 283.2A45.5 45.5 0 0 0 867.3 265.9H309.5L284.1 152.7A62.7 62.7 0 0 0 222.3 103.2H109.1A22.7 22.7 0 0 0 86.4 125.9 22.7 22.7 0 0 0 109.1 148.6H222.3A17.7 17.7 0 0 1 239.5 162.7L354.1 671.4A62.7 62.7 0 0 0 415.9 720.9H813.6A22.7 22.7 0 0 0 813.6 675.5H415.9A17.7 17.7 0 0 1 398.6 661.4L379.1 575H811.8A45.5 45.5 0 0 0 857.3 539.5L912.3 322.7A45.5 45.5 0 0 0 903.6 283.2Z"
  }));
};
IconCartSolid.defaultProps = {
  title: 'cart solid'
};
IconCartSolid.propTypes = {
  title: PropTypes.string
};

var IconCart = function IconCart(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-cart",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M379.1 759.1A70.5 70.5 0 1 0 449.5 829.5 70 70 0 0 0 379.1 759.1ZM379.1 865.5A35.9 35.9 0 0 1 342.7 829.5 36.4 36.4 0 0 1 415.5 829.5 35.9 35.9 0 0 1 379.1 863.6ZM806.8 759.1A70.5 70.5 0 1 0 877.3 829.5 70 70 0 0 0 806.8 759.1ZM806.8 865.5A35.9 35.9 0 0 1 770.9 829.5 35.9 35.9 0 0 1 806.8 793.2 36.4 36.4 0 0 1 843.2 829.5 35.9 35.9 0 0 1 806.8 863.6ZM904.1 267.7A59.1 59.1 0 0 0 858.6 245.9H292.7L270 145.5A56.8 56.8 0 0 0 213.6 100H100.5A16.8 16.8 0 0 0 83.6 116.8 17.3 17.3 0 0 0 100.5 136.4H213.6A24.1 24.1 0 0 1 236.8 154.5L351.4 663.6A57.3 57.3 0 0 0 407.3 709.1H805A17.3 17.3 0 1 0 805 675H409.1A23.2 23.2 0 0 1 386.4 656.4L369.1 580H805A58.2 58.2 0 0 0 861.4 534.5L915 318.2A57.7 57.7 0 0 0 904.1 267.7ZM826.4 525.9A24.1 24.1 0 0 1 803.2 544.1H368.2A16.8 16.8 0 0 0 360 544.1L300.5 280H858.6A23.6 23.6 0 0 1 881.8 308.6Z"
  }));
};
IconCart.defaultProps = {
  title: 'cart'
};
IconCart.propTypes = {
  title: PropTypes.string
};

var IconCash = function IconCash(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-cash",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M895 344.5L758.6 162.7A90.9 90.9 0 0 0 631.4 144.5L250.9 431.8H250.9V431.8L122.7 528.2H122.7L122.7 528.2V454.5A56.8 56.8 0 0 1 181.8 397.7H295.9L340.9 363.6H181.8A90.9 90.9 0 0 0 90.9 454.5V574.1H90.9A90.9 90.9 0 0 0 90.9 627.3V681.8A90.9 90.9 0 0 0 181.8 772.7H193.2L241.8 836.8A90.9 90.9 0 0 0 369.1 855L478.2 772.7H818.2A90.9 90.9 0 0 0 909.1 681.8V454.5A83.6 83.6 0 0 0 906.4 433.2 90.9 90.9 0 0 0 895 344.5ZM104.5 545.5L104.5 548.6ZM125 681.8L105 655A65.5 65.5 0 0 1 96.4 640.9 90.9 90.9 0 0 0 105 655L165 735A57.3 57.3 0 0 1 125 681.8ZM348.6 827.3A57.3 57.3 0 0 1 269.1 818.2L132.7 636.4A56.4 56.4 0 0 1 143.6 556.8L651.4 172.3A57.3 57.3 0 0 1 730.9 181.8L867.3 363.6A56.4 56.4 0 0 1 856.4 443.2ZM784.1 541.8A126.4 126.4 0 0 0 806.8 551.4V583.6A125 125 0 0 0 720.5 670H614.1L610.9 672.3ZM875 681.4A56.8 56.8 0 0 1 818.2 738.6H523.2L568.6 704.5H750.5A90.9 90.9 0 0 1 841.4 613.6V522.7A93.2 93.2 0 0 1 815.9 518.6L788.2 539.1 879.1 472.3 879.1 472.3ZM893.6 454.1A19.5 19.5 0 0 0 893.6 450.9 19.5 19.5 0 0 1 893.6 454.5ZM617.7 240.5L218.2 541.4A90.9 90.9 0 0 1 200.5 668.6L255 741.4A90.9 90.9 0 0 1 382.3 759.1L781.8 458.2A90.9 90.9 0 0 1 799.5 330.9L745 258.2A90.9 90.9 0 0 1 617.7 240.5ZM737.7 448.6L385.5 714.1A125.5 125.5 0 0 0 264.5 697.3L245.5 671.4A125.9 125.9 0 0 0 262.3 550.9L614.5 285.5A126.8 126.8 0 0 0 735.5 302.3L754.5 327.7A126.8 126.8 0 0 0 737.7 448.6ZM555.9 459.1A68.2 68.2 0 1 1 460.5 445.5 68.2 68.2 0 0 1 554.5 459.1Z"
  }));
};
IconCash.defaultProps = {
  title: 'cash'
};
IconCash.propTypes = {
  title: PropTypes.string
};

var IconChatSolid = function IconChatSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-chat-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M858.2 90.9H141.8A98.6 98.6 0 0 0 42.3 188.6V659.1A99.1 99.1 0 0 0 141.8 756.8H209.1A17.7 17.7 0 0 1 227.3 772.7V867.7A40 40 0 0 0 250.5 903.6 41.8 41.8 0 0 0 268.2 907.7 39.1 39.1 0 0 0 294.1 898.2L463.6 759.5A17.7 17.7 0 0 1 475.5 755.5H858.6A99.1 99.1 0 0 0 958.2 657.7V188.6A98.6 98.6 0 0 0 858.2 90.9ZM295.5 548.6A45.5 45.5 0 1 1 340.9 503.2 45.5 45.5 0 0 1 295.5 548.6ZM500 548.6A45.5 45.5 0 1 1 545.5 503.2 45.5 45.5 0 0 1 500 548.6ZM704.5 548.6A45.5 45.5 0 1 1 750 503.2 45.5 45.5 0 0 1 704.5 548.6Z"
  }));
};
IconChatSolid.defaultProps = {
  title: 'chat solid'
};
IconChatSolid.propTypes = {
  title: PropTypes.string
};

var IconChat = function IconChat(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-chat",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M363.6 503.2A34.1 34.1 0 0 1 295.5 503.2 34.1 34.1 0 0 1 363.6 503.2ZM500 469.1A34.1 34.1 0 1 0 534.1 503.2 34.1 34.1 0 0 0 500 469.1ZM669.5 469.1A34.1 34.1 0 1 0 703.6 503.2 34.1 34.1 0 0 0 669.5 469.1ZM963.2 188.6V659.1A104.5 104.5 0 0 1 858.2 762.3H475A12.7 12.7 0 0 0 466.8 765L297.3 904.1A45.5 45.5 0 0 1 267.7 914.5 45.5 45.5 0 0 1 222.3 869.1V772.7A12.3 12.3 0 0 0 210 760.9H141.8A104.5 104.5 0 0 1 36.8 659.1V188.6A104.5 104.5 0 0 1 141.8 85.5H858.2A104.5 104.5 0 0 1 963.2 188.6ZM929.1 188.6A70.5 70.5 0 0 0 858.2 119.1H141.8A70.5 70.5 0 0 0 70.9 188.6V659.1A70 70 0 0 0 141.8 727.3H209.1A45.5 45.5 0 0 1 254.5 772.7V867.7A11.4 11.4 0 0 0 261.4 878.2 13.2 13.2 0 0 0 275 878.2L444.1 739.1A45.5 45.5 0 0 1 474.1 728.6H857.3A70 70 0 0 0 928.2 659.5Z"
  }));
};
IconChat.defaultProps = {
  title: 'chat'
};
IconChat.propTypes = {
  title: PropTypes.string
};

var IconCheckSolid = function IconCheckSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-check-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M886.4 223.6L457.7 832.7A103.6 103.6 0 0 1 388.2 878.2L372.3 878.2A103.6 103.6 0 0 1 310 857.3 110.5 110.5 0 0 1 285 830L114.5 568.2A77.3 77.3 0 0 1 136.4 463.2 72.3 72.3 0 0 1 224.5 467.7L363.6 588.2 791.8 141.4A60 60 0 0 1 837.3 122.3H837.3A60.9 60.9 0 0 1 882.7 140.9H882.7A65.5 65.5 0 0 1 886.4 223.6Z"
  }));
};
IconCheckSolid.defaultProps = {
  title: 'check solid'
};
IconCheckSolid.propTypes = {
  title: PropTypes.string
};

var IconCheck = function IconCheck(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-check",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M887.7 133.2H887.7A70.5 70.5 0 0 0 835.9 110.9H835.9A70.9 70.9 0 0 0 784.1 133.6L363.6 572.7 229.5 459.1A82.7 82.7 0 0 0 127.7 454.5 90.9 90.9 0 0 0 105 575L275.5 836.4A125.5 125.5 0 0 0 303.2 866.4 115 115 0 0 0 466.8 840L895.5 230A75.5 75.5 0 0 0 887.7 133.2ZM858.2 204.1L429.5 813.2A68.6 68.6 0 0 1 384.1 842.7 67.7 67.7 0 0 1 331.8 829.5 85 85 0 0 1 314.5 810.9L142.7 549.5A42.7 42.7 0 0 1 153.6 491.4 35.9 35.9 0 0 1 175.5 484.1 38.2 38.2 0 0 1 200.5 493.6L365.9 636.4 818.2 165A26.8 26.8 0 0 1 837.7 156.4H837.7A29.1 29.1 0 0 1 857.3 164.5 31.4 31.4 0 0 1 858.2 204.1Z"
  }));
};
IconCheck.defaultProps = {
  title: 'check'
};
IconCheck.propTypes = {
  title: PropTypes.string
};

var IconCheckmarkStrongSolid = function IconCheckmarkStrongSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-checkmark-strong-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 90.9A409.1 409.1 0 1 0 909.1 500 409.1 409.1 0 0 0 500 90.9ZM757.3 367.3L460 664.5A23.6 23.6 0 0 1 444.1 670.9 22.7 22.7 0 0 1 428.2 664.5L242.7 479.1A22.3 22.3 0 0 1 242.7 447.7 21.8 21.8 0 0 1 274.5 447.7L444.1 616.8 727.3 335.5A22.3 22.3 0 1 1 759.1 367.3Z"
  }));
};
IconCheckmarkStrongSolid.defaultProps = {
  title: 'checkmark strong solid'
};
IconCheckmarkStrongSolid.propTypes = {
  title: PropTypes.string
};

var IconCheckmarkStrong = function IconCheckmarkStrong(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-checkmark-strong",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M909.1 500A409.1 409.1 0 1 1 500 90.9 409.1 409.1 0 0 1 909.1 500ZM863.6 500A363.6 363.6 0 1 0 500 863.6 363.6 363.6 0 0 0 863.6 500ZM757.3 367.3L460 664.5A23.6 23.6 0 0 1 444.1 670.9 22.7 22.7 0 0 1 428.2 664.5L242.7 479.1A22.3 22.3 0 0 1 242.7 447.7 21.8 21.8 0 0 1 274.5 447.7L444.1 616.8 727.3 335.5A22.3 22.3 0 1 1 759.1 367.3Z"
  }));
};
IconCheckmarkStrong.defaultProps = {
  title: 'checkmark strong'
};
IconCheckmarkStrong.propTypes = {
  title: PropTypes.string
};

var IconCheckmark = function IconCheckmark(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-checkmark",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M950 172.3A29.5 29.5 0 0 0 908.6 172.3L330.9 750.5 106.4 526.4A29.1 29.1 0 0 0 65 567.7H65L310.5 812.3A45.5 45.5 0 0 0 318.2 818.2 42.3 42.3 0 0 0 329.1 818.2H329.1A37.3 37.3 0 0 0 340.5 818.2L349.5 811.8 950 213.6A29.5 29.5 0 0 0 950 172.3Z"
  }));
};
IconCheckmark.defaultProps = {
  title: 'checkmark'
};
IconCheckmark.propTypes = {
  title: PropTypes.string
};

var IconChildSolid = function IconChildSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-child-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 300A121.8 121.8 0 1 0 376.8 178.2 121.8 121.8 0 0 0 500 300ZM792.7 211.8A62.3 62.3 0 0 0 705 211.8L600.5 315H399.5L296.4 211.8A62.3 62.3 0 0 0 208.6 211.8 63.2 63.2 0 0 0 190.5 257.3 62.3 62.3 0 0 0 208.6 302.7L345 439.1V883.6A61.8 61.8 0 1 0 468.6 883.6V685H528.6V880.9A61.8 61.8 0 0 0 652.3 880.9V436.4L788.6 300A60.5 60.5 0 0 0 806.8 254.5 63.2 63.2 0 0 0 791.4 211.8Z"
  }));
};
IconChildSolid.defaultProps = {
  title: 'child solid'
};
IconChildSolid.propTypes = {
  title: PropTypes.string
};

var IconChild = function IconChild(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-child",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 297.3A123.2 123.2 0 1 0 375.5 174.1 123.2 123.2 0 0 0 500 297.3ZM500 85.5A90.9 90.9 0 1 1 409.1 176.4 90.9 90.9 0 0 1 500 85.5ZM796.4 208.2A63.2 63.2 0 0 0 707.7 208.2L603.2 312.3H398.2L293.6 208.2A63.2 63.2 0 0 0 205 208.2 63.2 63.2 0 0 0 205 299.1L344.5 435.9V885.9A62.7 62.7 0 1 0 469.5 885.9V687.7H530.5V885.9A62.7 62.7 0 1 0 655.5 885.9V435.9L795 296.8A62.7 62.7 0 0 0 813.2 251.4 61.4 61.4 0 0 0 795 208.2ZM772.7 272.7L621.4 421.8V885.9A28.6 28.6 0 1 1 564.5 885.9V653.6H435.5V885.9A28.6 28.6 0 1 1 378.6 885.9V421.8L227.3 272.7A26.8 26.8 0 0 1 219.1 252.7 28.2 28.2 0 0 1 227.3 232.3 29.1 29.1 0 0 1 267.7 232.3L384.1 346.4H615.9L730.5 232.3A29.1 29.1 0 0 1 770.9 232.3H770.9A28.2 28.2 0 0 1 779.1 252.3 26.8 26.8 0 0 1 772.7 272.7Z"
  }));
};
IconChild.defaultProps = {
  title: 'child'
};
IconChild.propTypes = {
  title: PropTypes.string
};

var IconCitySolid = function IconCitySolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-city-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1070 1070"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M1070 926.4A22.7 22.7 0 0 1 1047.3 949.1H22.7A22.7 22.7 0 0 1 0 926.4 22.7 22.7 0 0 1 22.7 903.6H68.2V188.6A22.3 22.3 0 0 1 86.4 166.4L354.5 115.9A22.3 22.3 0 0 1 379.5 136.4V187.3H356.8A68.6 68.6 0 0 0 288.6 255.5V329.1A68.2 68.2 0 0 0 248.2 391.4V903.6H293.6V391.4A22.7 22.7 0 0 1 316.4 368.6H334.1V255.5A23.2 23.2 0 0 1 356.8 232.7H493.2A23.2 23.2 0 0 1 515.9 255.5V368.6H533.6A22.7 22.7 0 0 1 556.4 391.4V903.6H601.8V391.4A68.2 68.2 0 0 0 561.4 329.1V255.5A68.2 68.2 0 0 0 493.2 187.3H419.5V73.6A22.7 22.7 0 0 1 442.3 50.9H669.5A22.7 22.7 0 0 1 692.3 73.6V903.6H737.7V177.3L985.9 230.9A22.3 22.3 0 0 1 1003.6 253.2V903.6H1049.1A22.7 22.7 0 0 1 1070 926.4Z"
  }));
};
IconCitySolid.defaultProps = {
  title: 'city solid'
};
IconCitySolid.propTypes = {
  title: PropTypes.string
};

var IconCity = function IconCity(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-city",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1070 1070"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M1045.5 903.6H1000V253.2A22.3 22.3 0 0 0 982.3 230.9L688.6 167.3V73.6A22.7 22.7 0 0 0 665.9 50.9H438.6A22.7 22.7 0 0 0 415.9 73.6V232.7H379.5V136.4A22.3 22.3 0 0 0 352.7 114.1L84.5 166.4A22.3 22.3 0 0 0 66.4 188.6V903.6H22.7A22.7 22.7 0 0 0 0 926.4 22.7 22.7 0 0 0 22.7 949.1H1045.5A22.7 22.7 0 0 0 1068.2 926.4 23.2 23.2 0 0 0 1045.5 903.6ZM334.1 255.5V368.6H318.2A22.7 22.7 0 0 0 295.5 391.4V903.6H113.6V207.3L335.9 165.5V246.8S335.9 249.5 335.9 251.4 334.1 254.1 334.1 255.5ZM512.3 903.6H339.1V414.1H356.8A22.7 22.7 0 0 0 379.5 391.4V278.2H470.5V391.4A22.7 22.7 0 0 0 493.2 414.1H510.9ZM648.6 185.9V903.6H557.7V391.4A22.7 22.7 0 0 0 535 368.6H517.3V255.5A23.2 23.2 0 0 0 494.5 232.7H465V96.4H646.8ZM960 903.6H692.3V214.1L958.2 272.7Z"
  }));
};
IconCity.defaultProps = {
  title: 'city'
};
IconCity.propTypes = {
  title: PropTypes.string
};

var IconClose = function IconClose(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-close",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M846.4 799.1L535.9 488.6 846.4 177.7A29.1 29.1 0 0 0 805 136.4L494.1 446.8 181.8 136.4A29.5 29.5 0 0 0 140.5 136.4 27.3 27.3 0 0 0 131.8 156.8 28.2 28.2 0 0 0 140.5 177.7L454.5 488.6 142.3 799.5A29.5 29.5 0 0 0 163.2 849.5 29.1 29.1 0 0 0 181.8 840.9L492.3 530.5 803.2 840.9A29.1 29.1 0 0 0 844.5 840.9 28.6 28.6 0 0 0 846.4 799.1Z"
  }));
};
IconClose.defaultProps = {
  title: 'close'
};
IconClose.propTypes = {
  title: PropTypes.string
};

var IconCollaborationSolid = function IconCollaborationSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-collaboration-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M247.3 250.5A75.5 75.5 0 0 0 318.2 170.9 75.9 75.9 0 0 0 247.3 90.9 75.9 75.9 0 0 0 176.8 170.9 75.5 75.5 0 0 0 247.3 250.5ZM755 250.5A75.5 75.5 0 0 0 825.9 170.9 75.9 75.9 0 0 0 755 90.9 75.9 75.9 0 0 0 684.5 170.9 75.5 75.5 0 0 0 755 250.5ZM826.4 272.7A36.8 36.8 0 0 0 790.9 278.2 57.3 57.3 0 0 1 717.3 278.2 36.8 36.8 0 0 0 681.8 272.7 106.8 106.8 0 0 0 657.3 285.9 262.3 262.3 0 0 0 500 232.7 266.4 266.4 0 0 0 342.7 284.5H342.7A110.5 110.5 0 0 0 318.2 272.7 35.9 35.9 0 0 0 283.2 278.2 57.7 57.7 0 0 1 209.1 278.2 36.8 36.8 0 0 0 174.1 272.7 131.4 131.4 0 0 0 90.9 393.6V434.5A35 35 0 0 0 125.9 469.5H235A223.2 223.2 0 0 0 235 500 267.7 267.7 0 0 0 386.4 740.5 130.5 130.5 0 0 0 346.8 831.4V872.3A35 35 0 0 0 381.8 907.3H623.2A34.5 34.5 0 0 0 657.7 872.7V831.4A131.4 131.4 0 0 0 618.6 740.5 267.3 267.3 0 0 0 767.3 500 223.2 223.2 0 0 0 765 469.5H874.5A34.5 34.5 0 0 0 909.1 435V393.6A130 130 0 0 0 826.4 272.7ZM732.7 500A232.7 232.7 0 0 1 583.6 716.8L572.3 711.8A34.1 34.1 0 0 0 537.3 717.3 58.2 58.2 0 0 1 463.2 717.3 36.4 36.4 0 0 0 428.2 711.4L416.8 716.8A232.7 232.7 0 0 1 267.3 500 223.2 223.2 0 0 1 270 469.5H366.8A34.5 34.5 0 0 0 401.4 435V393.6A130 130 0 0 0 369.1 307.3H369.1A230.9 230.9 0 0 1 500 267.3 233.6 233.6 0 0 1 631.4 307.7H631.4A130 130 0 0 0 598.6 393.6V434.5A35 35 0 0 0 633.2 469.5H730A223.2 223.2 0 0 1 732.7 500ZM500 530.5A75.5 75.5 0 0 0 429.5 610.5 75.5 75.5 0 0 0 500 690.5 75.9 75.9 0 0 0 570.5 610.5 75.9 75.9 0 0 0 500 530.5Z"
  }));
};
IconCollaborationSolid.defaultProps = {
  title: 'collaboration solid'
};
IconCollaborationSolid.propTypes = {
  title: PropTypes.string
};

var IconCollaboration = function IconCollaboration(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-collaboration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M247.3 250.5A75.5 75.5 0 0 0 318.2 170.9 75.9 75.9 0 0 0 247.3 90.9 75.9 75.9 0 0 0 176.8 170.9 75.5 75.5 0 0 0 247.3 250.5ZM247.3 120.9A45.5 45.5 0 0 1 288.2 170.9 45.5 45.5 0 0 1 247.3 220.5 45.5 45.5 0 0 1 206.8 170.9 45.5 45.5 0 0 1 247.3 120.9ZM755 250.5A75.5 75.5 0 0 0 825.9 170.9 75.9 75.9 0 0 0 755 90.9 75.9 75.9 0 0 0 684.5 170.9 75.5 75.5 0 0 0 755 250.5ZM755 120.9A45.5 45.5 0 0 1 795.9 170.9 45.5 45.5 0 0 1 755 220.5 45.5 45.5 0 0 1 714.5 170.9 45.5 45.5 0 0 1 755 120.9ZM826.4 272.7A36.8 36.8 0 0 0 790.9 278.2 57.3 57.3 0 0 1 717.3 278.2 36.8 36.8 0 0 0 681.8 272.7 106.8 106.8 0 0 0 657.3 285.9 262.3 262.3 0 0 0 500 232.7 266.4 266.4 0 0 0 342.7 284.5H342.7A110.5 110.5 0 0 0 318.2 272.7 35.9 35.9 0 0 0 283.2 278.2 57.7 57.7 0 0 1 209.1 278.2 36.8 36.8 0 0 0 174.1 272.7 131.4 131.4 0 0 0 90.9 393.6V434.5A35 35 0 0 0 125.9 469.5H235A223.2 223.2 0 0 0 235 500 267.7 267.7 0 0 0 386.4 740.5 130.5 130.5 0 0 0 346.8 831.4V872.3A35 35 0 0 0 381.8 907.3H623.2A34.5 34.5 0 0 0 657.7 872.7V831.4A131.4 131.4 0 0 0 618.6 740.5 267.3 267.3 0 0 0 767.3 500 223.2 223.2 0 0 0 765 469.5H874.5A34.5 34.5 0 0 0 909.1 435V393.6A130 130 0 0 0 826.4 272.7ZM123.6 434.5V393.6A95.9 95.9 0 0 1 189.1 302.7 90.9 90.9 0 0 0 306.8 302.7 96.8 96.8 0 0 1 368.6 393.6V435L368.6 435ZM623.6 833.2V874.5L623.6 874.5 377.3 874.1V833.2A95 95 0 0 1 442.7 742.3 90.9 90.9 0 0 0 420 754.1 258.6 258.6 0 0 0 500 766.8 272.7 272.7 0 0 0 581.8 753.6 97.7 97.7 0 0 1 622.7 833.2ZM732.7 500A232.7 232.7 0 0 1 583.6 716.8L572.3 711.8A34.1 34.1 0 0 0 537.3 717.3 58.2 58.2 0 0 1 463.2 717.3 36.4 36.4 0 0 0 428.2 711.4L416.8 716.8A232.7 232.7 0 0 1 267.3 500 223.2 223.2 0 0 1 270 469.5H366.8A34.5 34.5 0 0 0 401.4 435V393.6A130 130 0 0 0 369.1 307.3H369.1A230.9 230.9 0 0 1 500 267.3 233.6 233.6 0 0 1 631.4 307.7H631.4A130 130 0 0 0 598.6 393.6V434.5A35 35 0 0 0 633.2 469.5H730A223.2 223.2 0 0 1 732.7 500ZM876.4 435L876.4 435 633.2 435V394.1A95.9 95.9 0 0 1 698.6 303.2 90.9 90.9 0 0 0 816.4 303.2 96.8 96.8 0 0 1 878.2 394.1ZM500 530.5A75.5 75.5 0 0 0 429.5 610.5 75.5 75.5 0 0 0 500 690.5 75.9 75.9 0 0 0 570.5 610.5 75.9 75.9 0 0 0 500 530.5ZM500 660.5A45.5 45.5 0 0 1 459.5 610.5 45.5 45.5 0 0 1 500 560.5 45.5 45.5 0 0 1 540.5 610.5 45.5 45.5 0 0 1 500 660.5Z"
  }));
};
IconCollaboration.defaultProps = {
  title: 'collaboration'
};
IconCollaboration.propTypes = {
  title: PropTypes.string
};

var IconCollapse = function IconCollapse(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-collapse",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M723.2 161.4L506.8 377.7A8.2 8.2 0 0 1 493.2 377.7L276.8 161.4A28.6 28.6 0 1 0 236.4 201.8L454.5 418.2A66.4 66.4 0 0 0 500 437.7H500A66.4 66.4 0 0 0 545.5 418.2L763.6 201.8A28.6 28.6 0 0 0 723.2 161.4ZM276.8 838.6L493.2 622.3A8.2 8.2 0 0 1 506.8 622.3L723.2 838.6A28.6 28.6 0 0 0 763.6 798.2L545.5 581.8A66.4 66.4 0 0 0 500 562.3H500A66.4 66.4 0 0 0 454.5 581.8L236.4 798.2A28.6 28.6 0 1 0 276.8 838.6Z"
  }));
};
IconCollapse.defaultProps = {
  title: 'collapse'
};
IconCollapse.propTypes = {
  title: PropTypes.string
};

var IconConnectionTransfer = function IconConnectionTransfer(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-connection-transfer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 688 688"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M328.1 312.5V409.4A93.8 93.8 0 1 0 359.4 409.4V312.5A156.3 156.3 0 1 0 328.1 312.5ZM406.3 500A62.5 62.5 0 1 1 343.8 437.5 62.5 62.5 0 0 1 406.3 500ZM343.8 31.3A125 125 0 1 1 218.8 156.3 125 125 0 0 1 343.8 31.3ZM500 843.8A156.3 156.3 0 1 1 328.1 689.1V593.8A78.8 78.8 0 0 0 359.4 593.8V690.6A156.3 156.3 0 0 1 500 843.8Z"
  }));
};
IconConnectionTransfer.defaultProps = {
  title: 'connection transfer'
};
IconConnectionTransfer.propTypes = {
  title: PropTypes.string
};

var IconConnection = function IconConnection(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-connection",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 688 688"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M359.4 689.1V312.5A156.3 156.3 0 1 0 328.1 312.5V690.6A156.3 156.3 0 1 0 359.4 690.6ZM218.8 156.3A125 125 0 1 1 343.8 281.3 125 125 0 0 1 218.8 156.3Z"
  }));
};
IconConnection.defaultProps = {
  title: 'connection'
};
IconConnection.propTypes = {
  title: PropTypes.string
};

var IconCopySolid = function IconCopySolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-copy-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M545.5 354.1H185.9A100.9 100.9 0 0 0 85.5 454.5V813.6A100.5 100.5 0 0 0 185.9 914.5H545.5A100.9 100.9 0 0 0 646.4 813.6V454.5A101.4 101.4 0 0 0 545.5 354.1ZM590.9 813.6A45.5 45.5 0 0 1 545.5 859.1H185.9A45.5 45.5 0 0 1 140.5 813.6V454.5A45.5 45.5 0 0 1 185.9 409.1H545.5A45.5 45.5 0 0 1 590.9 454.5ZM814.1 85H454.5A101.4 101.4 0 0 0 354.1 185.9V269.1A28.6 28.6 0 1 0 409.1 269.1V185.9A45.5 45.5 0 0 1 454.5 140.5H813.6A45.5 45.5 0 0 1 859.1 185.9V545.5A45.5 45.5 0 0 1 813.6 590.9H730A28.6 28.6 0 0 0 730 647.7H814.1A101.4 101.4 0 0 0 915 545.5V185.9A101.4 101.4 0 0 0 814.1 85Z"
  }));
};
IconCopySolid.defaultProps = {
  title: 'copy solid'
};
IconCopySolid.propTypes = {
  title: PropTypes.string
};

var IconCopy = function IconCopy(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-copy",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M545.5 363.6H181.8A90.9 90.9 0 0 0 90.9 454.5V818.2A90.9 90.9 0 0 0 181.8 909.1H545.5A90.9 90.9 0 0 0 636.4 818.2V454.5A90.9 90.9 0 0 0 545.5 363.6ZM602.3 818.2A56.8 56.8 0 0 1 545.5 875H181.8A56.8 56.8 0 0 1 125 818.2V454.5A56.8 56.8 0 0 1 181.8 397.7H545.5A56.8 56.8 0 0 1 602.3 454.5ZM818.2 90.9H454.5A90.9 90.9 0 0 0 363.6 181.8V312.3A17.3 17.3 0 1 0 397.7 312.3V181.8A56.8 56.8 0 0 1 454.5 125H818.2A56.8 56.8 0 0 1 875 181.8V545.5A56.8 56.8 0 0 1 818.2 602.3H687.7A17.3 17.3 0 1 0 687.7 636.4H818.2A90.9 90.9 0 0 0 909.1 545.5V181.8A90.9 90.9 0 0 0 818.2 90.9Z"
  }));
};
IconCopy.defaultProps = {
  title: 'copy'
};
IconCopy.propTypes = {
  title: PropTypes.string
};

var IconCreditCardSolid = function IconCreditCardSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-credit-card-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M943.2 296.4V350H56.8V296.4A102.3 102.3 0 0 1 159.1 194.1H840.9A102.3 102.3 0 0 1 943.2 296.4ZM56.8 440.9H943.2V703.6A102.3 102.3 0 0 1 840.9 805.9H159.1A102.3 102.3 0 0 1 56.8 703.6ZM406.4 565.5A28.2 28.2 0 0 0 434.5 593.6H545.5A28.6 28.6 0 0 0 545.5 536.8H434.5A28.6 28.6 0 0 0 406.4 565.5ZM126.8 565.5A28.6 28.6 0 0 0 155.5 593.6H351.8A28.6 28.6 0 0 0 351.8 536.8H155.5A28.6 28.6 0 0 0 126.8 565.5ZM126.8 652.7A28.6 28.6 0 0 0 155.5 680.9H288.6A28.6 28.6 0 0 0 288.6 624.1H155.5A28.6 28.6 0 0 0 126.8 652.7Z"
  }));
};
IconCreditCardSolid.defaultProps = {
  title: 'credit card solid'
};
IconCreditCardSolid.propTypes = {
  title: PropTypes.string
};

var IconCreditCard = function IconCreditCard(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-credit-card",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M840.9 188.6H159.1A108.2 108.2 0 0 0 50.9 296.4V705.5A108.2 108.2 0 0 0 159.1 811.4H840.9A108.2 108.2 0 0 0 949.1 703.6V294.5A108.2 108.2 0 0 0 840.9 188.6ZM85.5 370.5H914.5V415.9H85.5ZM914.5 705.5A73.6 73.6 0 0 1 840.9 777.3H159.1A73.6 73.6 0 0 1 85.5 703.6V447.3H914.5ZM85.5 334.5V296.4A73.6 73.6 0 0 1 159.1 222.7H840.9A73.6 73.6 0 0 1 914.5 296.4V334.5ZM136.4 565.5A17.3 17.3 0 0 1 153.6 548.2H351.8A17.3 17.3 0 0 1 368.6 565.5 16.8 16.8 0 0 1 351.8 582.3H155.5A16.8 16.8 0 0 1 136.4 565.5ZM415.9 565.5A16.8 16.8 0 0 1 432.7 548.2H545.5A16.8 16.8 0 0 1 562.3 565.5 16.4 16.4 0 0 1 545.5 582.3H434.5A16.4 16.4 0 0 1 417.7 565.5ZM136.4 652.7A17.3 17.3 0 0 1 155.5 636.4H288.6A17.3 17.3 0 0 1 305.5 653.6 16.8 16.8 0 0 1 288.6 670.5H155.5A16.8 16.8 0 0 1 136.4 652.7Z"
  }));
};
IconCreditCard.defaultProps = {
  title: 'credit card'
};
IconCreditCard.propTypes = {
  title: PropTypes.string
};

var IconCustomerSolid = function IconCustomerSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-customer-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M874.5 171.4A272.7 272.7 0 0 0 500 162.7 272.7 272.7 0 0 0 125 553.2L465.5 895A48.2 48.2 0 0 0 500 909.1H500A45.5 45.5 0 0 0 534.1 895L875.5 553.2A272.7 272.7 0 0 0 874.5 171.4ZM500 242.7A86.8 86.8 0 0 1 580.5 333.6 86.8 86.8 0 0 1 500 427.3 86.8 86.8 0 0 1 419.5 336.4 86.8 86.8 0 0 1 500 242.7ZM666.8 636.4A31.4 31.4 0 0 1 635.9 667.3H363.6A30.9 30.9 0 0 1 333.6 636.4V590.9A139.1 139.1 0 0 1 422.3 459.1 31.4 31.4 0 0 1 453.6 464.1 72.7 72.7 0 0 0 544.5 464.1 32.3 32.3 0 0 1 576.4 459.1 136.4 136.4 0 0 1 666.8 590.9Z"
  }));
};
IconCustomerSolid.defaultProps = {
  title: 'customer solid'
};
IconCustomerSolid.propTypes = {
  title: PropTypes.string
};

var IconCustomer = function IconCustomer(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-customer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M878.6 167.3ZM878.6 557.3L537.3 899.1A53.6 53.6 0 0 1 499.1 914.5H499.1A54.5 54.5 0 0 1 460.9 899.1L121.4 557.3A276.4 276.4 0 0 1 500 155 276.4 276.4 0 0 1 879.1 557.3ZM853.6 193.6H853.6A242.7 242.7 0 0 0 511.8 193.6L500 202.3 488.2 190.5A242.3 242.3 0 0 0 145.5 533.2L485.5 875A19.5 19.5 0 0 0 499.5 880.5H499.5A19.5 19.5 0 0 0 513.6 875L855 533.2A243.2 243.2 0 0 0 854.5 191.4ZM421.4 354.1A86.4 86.4 0 0 1 501.4 263.2 86.4 86.4 0 0 1 581.4 354.1 86.4 86.4 0 0 1 501.4 445 86.4 86.4 0 0 1 421.4 354.1ZM455.5 354.1A52.3 52.3 0 0 0 500 409.1 52.3 52.3 0 0 0 545.5 352.3 52.3 52.3 0 0 0 500 295.5 52.3 52.3 0 0 0 454.5 354.1ZM658.6 585V627.3A34.5 34.5 0 0 1 623.6 661.8H376.8A35 35 0 0 1 341.4 626.8V585A136.4 136.4 0 0 1 426.4 460.9 35.5 35.5 0 0 1 461.8 466.4 59.5 59.5 0 0 0 538.6 466.4 36.8 36.8 0 0 1 574.1 460.9 132.3 132.3 0 0 1 658.6 585ZM624.5 585A97.7 97.7 0 0 0 561.8 494.1 96.4 96.4 0 0 1 440.9 494.1 97.3 97.3 0 0 0 375.5 585V626.8L623.6 626.8H623.6Z"
  }));
};
IconCustomer.defaultProps = {
  title: 'customer'
};
IconCustomer.propTypes = {
  title: PropTypes.string
};

var IconDeleteSolid = function IconDeleteSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-delete-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M880.9 201.4H677.3A181.8 181.8 0 0 0 322.7 201.4H119.1A24.1 24.1 0 0 0 100.5 210 30 30 0 0 0 93.6 227.3 26.8 26.8 0 0 0 119.1 255.5H880.9A26.8 26.8 0 0 0 906.4 227.3 26.4 26.4 0 0 0 880.9 201.4ZM380.9 201.4A126.4 126.4 0 0 1 616.4 201.4ZM849.1 296.4V796.4A142.3 142.3 0 0 1 706.8 938.2H293.2A142.3 142.3 0 0 1 150.9 796.4V296.4A28.6 28.6 0 0 1 207.7 296.4V796.4A85.5 85.5 0 0 0 293.2 881.4H706.8A85.5 85.5 0 0 0 792.3 796.4V296.4A28.6 28.6 0 0 1 849.1 296.4ZM500 793.2A28.2 28.2 0 0 1 480.9 786.4 23.2 23.2 0 0 1 471.8 767.7V369.5A28.2 28.2 0 0 1 528.2 369.5V767.7A26.8 26.8 0 0 1 500 793.2ZM345 793.2A30 30 0 0 1 325.9 786.4 24.1 24.1 0 0 1 318.2 767.7V369.5A26.4 26.4 0 0 1 345.9 344.1 26.8 26.8 0 0 1 374.1 369.5V767.7A26.8 26.8 0 0 1 345 793.2ZM655 793.2A28.2 28.2 0 0 1 636.4 786.4 23.2 23.2 0 0 1 627.3 767.7V369.5A26.8 26.8 0 0 1 655.5 344.1 26.4 26.4 0 0 1 683.2 369.5V767.7A26.4 26.4 0 0 1 655 793.2Z"
  }));
};
IconDeleteSolid.defaultProps = {
  title: 'delete solid'
};
IconDeleteSolid.propTypes = {
  title: PropTypes.string
};

var IconDelete = function IconDelete(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-delete",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M837.7 296.4V796.4A130.9 130.9 0 0 1 706.8 926.8H293.2A130.9 130.9 0 0 1 162.3 796.4V296.4A16.8 16.8 0 0 1 181.8 279.5 16.4 16.4 0 0 1 198.6 296.4V796.4A96.8 96.8 0 0 0 295.5 892.7H709.1A96.8 96.8 0 0 0 805.9 796.4V296.4A16.4 16.4 0 0 1 822.7 279.5 16.8 16.8 0 0 1 837.7 296.4ZM516.8 767.7V369.5A17.3 17.3 0 0 0 483.2 369.5V767.7A12.7 12.7 0 0 0 488.2 777.7 17.7 17.7 0 0 0 500 781.8 15.9 15.9 0 0 0 516.8 767.7ZM363.6 767.7V369.5A16.8 16.8 0 0 0 330.5 369.5V767.7A13.6 13.6 0 0 0 335 777.7 17.7 17.7 0 0 0 346.8 781.8 15.5 15.5 0 0 0 363.6 767.7ZM673.2 767.7V369.5A16.8 16.8 0 0 0 640 369.5V767.7A12.7 12.7 0 0 0 645 777.7 16.4 16.4 0 0 0 656.8 781.8 15.5 15.5 0 0 0 671.4 767.7ZM895 227.3A15.5 15.5 0 0 1 880.9 244.1H119.1A15.5 15.5 0 0 1 105 227.3 17.7 17.7 0 0 1 109.1 215.5 13.6 13.6 0 0 1 119.1 210.9H331.8A171.4 171.4 0 0 1 668.2 210.9H880.9A15.5 15.5 0 0 1 895 227.3ZM633.2 210A136.4 136.4 0 0 0 366.8 210Z"
  }));
};
IconDelete.defaultProps = {
  title: 'delete'
};
IconDelete.propTypes = {
  title: PropTypes.string
};

var IconDesktop = function IconDesktop(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-desktop",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M891.8 829.5H616.8V750.9H753.2A142.7 142.7 0 0 0 900.9 614.5V272.7A142.7 142.7 0 0 0 753.2 136.4H238.6A142.7 142.7 0 0 0 90.9 272.7V615A142.7 142.7 0 0 0 238.6 751.4H391.4V830H108.6A16.8 16.8 0 1 0 108.6 863.6H891.8A17.3 17.3 0 0 0 909.1 846.8 17.7 17.7 0 0 0 891.8 829.5ZM238.6 717.3A108.6 108.6 0 0 1 125 615V272.7A108.6 108.6 0 0 1 238.6 170.5H754.1A108.6 108.6 0 0 1 867.7 272.7V615A108.6 108.6 0 0 1 754.1 717.3ZM583.2 818.2H425.5V751.4H583.2Z"
  }));
};
IconDesktop.defaultProps = {
  title: 'desktop'
};
IconDesktop.propTypes = {
  title: PropTypes.string
};

var IconDirectionsSolid = function IconDirectionsSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-directions-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 90.9A409.1 409.1 0 1 0 909.1 500 409.1 409.1 0 0 0 500 90.9ZM708.2 401.4A53.2 53.2 0 0 1 692.7 439.1L565.5 566.4A23.2 23.2 0 0 1 533.2 566.4 22.7 22.7 0 0 1 533.2 534.1L645 421.8H382.3V747.7A22.7 22.7 0 0 1 336.8 747.7V399.5A22.7 22.7 0 0 1 343.2 383.6 23.6 23.6 0 0 1 359.1 377.3H640.9L533.2 268.6A22.7 22.7 0 0 1 533.2 236.4 23.2 23.2 0 0 1 565.5 236.4L692.7 363.6A53.2 53.2 0 0 1 708.2 401.4Z"
  }));
};
IconDirectionsSolid.defaultProps = {
  title: 'directions solid'
};
IconDirectionsSolid.propTypes = {
  title: PropTypes.string
};

var IconDirections = function IconDirections(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-directions",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 90.9A409.1 409.1 0 1 0 909.1 500 409.1 409.1 0 0 0 500 90.9ZM500 863.6A363.6 363.6 0 1 1 863.6 500 363.6 363.6 0 0 1 500 863.6ZM692.7 363.6A53.2 53.2 0 0 1 708.2 401.4H708.2A53.2 53.2 0 0 1 692.7 439.1L565.5 566.4A23.2 23.2 0 0 1 533.2 566.4 22.7 22.7 0 0 1 533.2 534.1L645 421.8H382.3V747.7A22.7 22.7 0 0 1 336.8 747.7V399.5A22.7 22.7 0 0 1 343.2 383.6 23.6 23.6 0 0 1 359.1 377.3H640.9L533.2 268.6A22.7 22.7 0 0 1 533.2 236.4 23.2 23.2 0 0 1 565.5 236.4Z"
  }));
};
IconDirections.defaultProps = {
  title: 'directions'
};
IconDirections.propTypes = {
  title: PropTypes.string
};

var IconDiscountSolid = function IconDiscountSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-discount-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M720 607.7A58.2 58.2 0 1 1 661.8 550 58.2 58.2 0 0 1 720 607.7ZM909.1 500A409.1 409.1 0 1 1 500 90.9 409.1 409.1 0 0 1 909.1 500ZM338.2 505A115 115 0 1 0 223.6 390.5 114.5 114.5 0 0 0 338.2 505ZM641.8 311.4A29.1 29.1 0 0 0 631.4 272.7 28.2 28.2 0 0 0 592.7 283.2L358.2 688.6A28.2 28.2 0 0 0 368.6 727.3 27.7 27.7 0 0 0 409.1 717.3ZM778.2 607.7A115 115 0 1 0 663.2 722.7 115 115 0 0 0 776.8 607.7ZM338.2 332.3A58.2 58.2 0 1 0 396.4 390.5 57.7 57.7 0 0 0 338.2 332.3Z"
  }));
};
IconDiscountSolid.defaultProps = {
  title: 'discount solid'
};
IconDiscountSolid.propTypes = {
  title: PropTypes.string
};

var IconDiscount = function IconDiscount(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-discount",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M630.9 305.5L396.8 711.4A17.7 17.7 0 0 1 381.8 720 20.5 20.5 0 0 1 373.2 717.7 16.4 16.4 0 0 1 367.3 694.5L601.4 288.6A16.8 16.8 0 1 1 630.9 305.5ZM382.7 493.6A103.6 103.6 0 1 1 486.4 390.5 103.6 103.6 0 0 1 382.7 493.6ZM382.7 459.5A69.5 69.5 0 1 0 313.2 390.5 69.5 69.5 0 0 0 382.7 459.5ZM720.5 607.7A103.6 103.6 0 1 1 617.3 504.5 103.6 103.6 0 0 1 720.5 607.7ZM686.4 607.7A69.5 69.5 0 0 0 550 607.7 69.5 69.5 0 1 0 686.4 607.7ZM913.6 500A414.5 414.5 0 1 1 500 85.5 415 415 0 0 1 914.5 500ZM880 500A380.9 380.9 0 1 0 500 880.9 381.4 381.4 0 0 0 880.9 500Z"
  }));
};
IconDiscount.defaultProps = {
  title: 'discount'
};
IconDiscount.propTypes = {
  title: PropTypes.string
};

var IconDocumentSolid = function IconDocumentSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-document-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M824.1 227.3L619.1 50.9H265.9A90.9 90.9 0 0 0 175 141.8V859.1A90.9 90.9 0 0 0 265.9 950H734.1A90.9 90.9 0 0 0 825 859.1V227.3ZM347.7 665H288.6A28.6 28.6 0 0 1 288.6 608.2H347.7A28.6 28.6 0 0 1 347.7 665ZM347.7 528.6H288.6A28.6 28.6 0 0 1 288.6 471.8H347.7A28.6 28.6 0 0 1 347.7 528.6ZM347.7 392.3H288.6A28.6 28.6 0 0 1 288.6 335.5H347.7A28.6 28.6 0 0 1 347.7 392.3ZM711.4 665H425A28.6 28.6 0 0 1 425 608.2H711.4A28.6 28.6 0 0 1 711.4 665ZM711.4 528.6H425A28.6 28.6 0 0 1 425 471.8H711.4A28.6 28.6 0 0 1 711.4 528.6ZM711.4 392.3H425A28.6 28.6 0 0 1 425 335.5H711.4A28.6 28.6 0 0 1 711.4 392.3ZM674.5 227.3A55.9 55.9 0 0 1 619.1 171.4V96.4L772.7 227.3Z"
  }));
};
IconDocumentSolid.defaultProps = {
  title: 'document solid'
};
IconDocumentSolid.propTypes = {
  title: PropTypes.string
};

var IconDocument = function IconDocument(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-document",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M727.3 500A17.3 17.3 0 0 1 710.5 517.3H425A17.3 17.3 0 0 1 425 482.7H711.4A17.3 17.3 0 0 1 727.3 500ZM710.5 619.1H425A17.3 17.3 0 0 0 425 653.6H711.4A17.3 17.3 0 0 0 711.4 619.1ZM409.1 363.6A17.3 17.3 0 0 0 425.9 380.9H712.3A17.3 17.3 0 0 0 712.3 346.4H425A17.3 17.3 0 0 0 409.1 363.6ZM347.7 482.7H288.6A17.3 17.3 0 0 0 288.6 517.3H347.7A17.3 17.3 0 0 0 347.7 482.7ZM347.7 619.1H288.6A17.3 17.3 0 0 0 288.6 653.6H347.7A17.3 17.3 0 0 0 347.7 619.1ZM347.7 346.4H288.6A17.3 17.3 0 0 0 288.6 380.9H347.7A17.3 17.3 0 0 0 347.7 346.4ZM824.1 227.3V859.1A90.9 90.9 0 0 1 733.2 950H265.9A90.9 90.9 0 0 1 175 859.1V140.9A90.9 90.9 0 0 1 265.9 50H619.1L824.1 227.3ZM619.1 173.2A55.5 55.5 0 0 0 674.5 227.3H772.7L619.1 96.4ZM790 264.1H674.5A90.9 90.9 0 0 1 583.6 173.2V85H265.5A55.9 55.9 0 0 0 210 140.9V859.1A55.9 55.9 0 0 0 265.9 914.5H734.1A55.9 55.9 0 0 0 790 859.1Z"
  }));
};
IconDocument.defaultProps = {
  title: 'document'
};
IconDocument.propTypes = {
  title: PropTypes.string
};

var IconDownload = function IconDownload(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-download",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M454.5 755A68.2 68.2 0 0 0 500 772.7H500A68.2 68.2 0 0 0 545.5 753.2L761.8 536.8A28.6 28.6 0 1 0 721.4 495.9L527.7 689.5V120.5A29.1 29.1 0 0 0 477.7 99.5 30 30 0 0 0 469.1 120.5V691.8L276.8 500A28.6 28.6 0 1 0 236.4 540.9ZM880.9 852.3H119.1A28.6 28.6 0 0 0 119.1 909.1H880.9A28.6 28.6 0 0 0 880.9 852.3Z"
  }));
};
IconDownload.defaultProps = {
  title: 'download'
};
IconDownload.propTypes = {
  title: PropTypes.string
};

var IconDrinksSolid = function IconDrinksSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-drinks-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M329.1 626.4V867.3H370.9A28.6 28.6 0 1 1 370.9 924.1H230A28.6 28.6 0 1 1 230 867.3H272.7V626.4L191.4 535.5H409.1ZM507.3 392.7H93.6A11.4 11.4 0 0 0 83.6 399.5 10.9 10.9 0 0 0 83.6 411.8L140 476.4H458.2L514.5 411.8A12.3 12.3 0 0 0 514.5 399.5 11.4 11.4 0 0 0 507.3 392.7ZM555.5 876.4A45.5 45.5 0 0 0 600.9 921.8H796.8A45.5 45.5 0 0 0 842.3 876.4V416.8H555.5ZM899.1 121.4L779.1 75.9A28.6 28.6 0 0 0 740.9 100.5L727.3 243.2H566.8A11.4 11.4 0 0 0 555.5 254.5V360H842.3V254.5A11.4 11.4 0 0 0 830.9 243.2H785.5L794.1 144.1 879.1 175A28.6 28.6 0 0 0 898.6 121.4Z"
  }));
};
IconDrinksSolid.defaultProps = {
  title: 'drinks solid'
};
IconDrinksSolid.propTypes = {
  title: PropTypes.string
};

var IconDrinks = function IconDrinks(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-drinks",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M515.9 372.7H102.3A17.3 17.3 0 0 0 86.8 382.7 17.3 17.3 0 0 0 90.9 401.4L291.8 636.4V881.8H238.2A16.8 16.8 0 0 0 221.4 898.6 17.3 17.3 0 0 0 238.2 915.9H379.5A17.3 17.3 0 0 0 396.8 898.6 16.8 16.8 0 0 0 379.5 881.8H325.9V636.4L528.6 403.6A17.3 17.3 0 0 0 531.4 385 17.7 17.7 0 0 0 515.9 372.7ZM309.1 600L227.3 507.7H390.9ZM420.5 472.3H197.7L139.5 409.1H478.2ZM903.6 131.4L783.6 85.9A16.4 16.4 0 0 0 760.9 100.5L750.5 221.4H575.5A16.8 16.8 0 0 0 558.6 238.6V357.3H558.6V391.4H558.6V863.6A51.4 51.4 0 0 0 609.5 915H805.5A51.4 51.4 0 0 0 856.4 863.6V391.4H856.4V357.3H856.4V240.5A16.8 16.8 0 0 0 839.5 223.2H784.5L792.7 127.3 891.8 163.2A17.3 17.3 0 0 0 913.6 153.2 16.8 16.8 0 0 0 903.6 131.4ZM590.9 257.3H745.5L736.8 357.3H590.9ZM822.3 863.6A16.8 16.8 0 0 1 805.5 880.9H609.5A16.8 16.8 0 0 1 590.9 863.6V391.4H733.6L706.8 698.6A17.3 17.3 0 0 0 722.3 717.3H722.3A17.3 17.3 0 0 0 739.5 701.8L766.8 391.4H819.1ZM822.3 258.6V358.6H772.7L781.4 258.6Z"
  }));
};
IconDrinks.defaultProps = {
  title: 'drinks'
};
IconDrinks.propTypes = {
  title: PropTypes.string
};

var IconDriverSolid = function IconDriverSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-driver-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M341.4 247.3C341.4 142.3 413.6 56.8 503.2 56.8S665 142.3 665 247.3 590.9 437.7 503.2 437.7 341.4 352.3 341.4 247.3ZM766.4 538.6L630 706.8A253.6 253.6 0 0 1 758.2 927.3V943.2H842.7A41.8 41.8 0 0 0 884.5 901.4V784.1A311.8 311.8 0 0 0 766.4 538.6ZM503.2 675A265.5 265.5 0 0 1 574.5 685L718.2 509.5A278.6 278.6 0 0 0 685 493.6H685A45.5 45.5 0 0 0 639.5 500.9 220.5 220.5 0 0 1 360 500.9 45.5 45.5 0 0 0 314.5 493.6 315.5 315.5 0 0 0 114.5 785.9V902.3A42.7 42.7 0 0 0 157.3 945H248.2V927.3A254.5 254.5 0 0 1 503.2 673.2ZM503.2 731.8A197.7 197.7 0 0 0 305.5 927.3V943.2H700.5V927.3A197.7 197.7 0 0 0 503.2 730Z"
  }));
};
IconDriverSolid.defaultProps = {
  title: 'driver solid'
};
IconDriverSolid.propTypes = {
  title: PropTypes.string
};

var IconDriver = function IconDriver(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-driver",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M503.2 443.6C594.1 443.6 670.5 355.5 670.5 247.3S595.5 50.9 503.2 50.9 335.5 139.1 335.5 247.3 409.1 443.6 503.2 443.6ZM503.2 85.5C576.8 85.5 636.4 158.2 636.4 247.3S576.8 409.1 503.2 409.1 369.5 336.8 369.5 247.3 429.5 85.5 503.2 85.5ZM685 486.4A52.3 52.3 0 0 0 634.5 494.5 214.1 214.1 0 0 1 361.8 494.5 51.4 51.4 0 0 0 311.8 486.4 321.8 321.8 0 0 0 107.7 784.1V900.5A48.6 48.6 0 0 0 159.1 949.1H840.9A45.5 45.5 0 0 0 888.6 901.4V784.1A318.2 318.2 0 0 0 687.3 486.4ZM159.1 914.5A14.1 14.1 0 0 1 144.5 900.5V784.1A286.8 286.8 0 0 1 326.4 518.2L331.8 518.2A17.3 17.3 0 0 1 342.7 522.3 249.1 249.1 0 0 0 657.7 522.3 17.7 17.7 0 0 1 674.5 519.1 318.2 318.2 0 0 1 710 536.4L577.7 698.2A240 240 0 0 0 259.5 915.5ZM295.5 914.5A208.2 208.2 0 0 1 710.9 914.5ZM855.5 901.4A13.2 13.2 0 0 1 841.8 914.5H745A241.8 241.8 0 0 0 608.6 710.9L736.8 554.1A282.3 282.3 0 0 1 853.2 784.1Z"
  }));
};
IconDriver.defaultProps = {
  title: 'driver'
};
IconDriver.propTypes = {
  title: PropTypes.string
};

var IconEbusSolid = function IconEbusSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-ebus-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M469.5 681.8A1810 1810 0 0 1 170 658.2L158.2 655.9V888.6A50 50 0 0 0 208.2 938.6H253.6A50 50 0 0 0 303.6 888.6V863.6H631.4V890A49.5 49.5 0 0 0 681.8 939.5H729.5A49.5 49.5 0 0 0 779.1 889.5V656.8L768.6 656.8A1814.5 1814.5 0 0 1 469.5 681.8ZM303.6 772.7H272.7A25 25 0 1 1 272.7 723.2H305.9A25 25 0 0 1 305.9 772.7ZM667.3 772.7H636.4A25 25 0 1 1 636.4 723.2H669.5A25 25 0 0 1 669.5 772.7ZM607.7 371.8A73.2 73.2 0 0 1 607.7 267.7L642.3 235.5 743.6 336.4V339.1L710.9 371.8A73.2 73.2 0 0 1 607.7 371.8ZM681.8 580A272.7 272.7 0 0 0 778.6 562.3V607.7L760 610.9A1765.5 1765.5 0 0 1 468.2 634.1 1760 1760 0 0 1 176.8 610.9L156.8 607.3V454.5H115.5A33.2 33.2 0 0 1 82.3 421.4V340.9A33.2 33.2 0 0 1 115.5 307.7H158.2A181.8 181.8 0 0 1 340 125.9H454.5A284.1 284.1 0 0 0 681.8 580.5ZM917.7 295.5A234.1 234.1 0 0 1 781.4 508.6 230 230 0 0 1 532.3 472.3L596.4 409.1A110.5 110.5 0 0 0 735.9 398.2L768.2 363.6A36.8 36.8 0 0 0 768.2 311.4L763.2 306.4 808.6 260.9A17.7 17.7 0 0 0 808.6 235.9H808.6A17.7 17.7 0 0 0 783.6 235.9L738.2 281.4 696.4 239.5 741.8 194.1A17.3 17.3 0 0 0 741.8 169.5 17.7 17.7 0 0 0 729.5 164.5H729.5A17.7 17.7 0 0 0 716.8 169.5L671.4 215 666.4 209.5A37.7 37.7 0 0 0 614.1 209.5L581.8 241.8A109.1 109.1 0 0 0 570.5 381.8L505.9 447.7A231.8 231.8 0 0 1 448.6 295.5 234.5 234.5 0 1 1 917.7 295.5Z"
  }));
};
IconEbusSolid.defaultProps = {
  title: 'ebus solid'
};
IconEbusSolid.propTypes = {
  title: PropTypes.string
};

var IconEbus = function IconEbus(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-ebus",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M681.8 60.5A232.7 232.7 0 0 0 518.6 127.7H318.2A153.6 153.6 0 0 0 163.6 281.4V308.6H126.4A39.5 39.5 0 0 0 86.8 348.6V414.5A39.5 39.5 0 0 0 126.4 454.1H163.6V863.2H163.6V900.5A40 40 0 0 0 203.6 940.5H260.9A40 40 0 0 0 300.5 900.5V863.6H647.7V900.9A40 40 0 0 0 687.7 940.9H745A40 40 0 0 0 784.5 900.9V500A232.7 232.7 0 0 0 681.8 60.5ZM163.6 420H126.4A5.5 5.5 0 0 1 120.9 414.5V348.6A5.5 5.5 0 0 1 126.4 342.7H163.6ZM266.4 899.5A5.9 5.9 0 0 1 260.9 905.5H203.6A5.9 5.9 0 0 1 197.7 899.5V863.6H266.4ZM750.5 899.5A5.5 5.5 0 0 1 745 905.5H687.7A5.9 5.9 0 0 1 681.8 899.5V863.6H750.5ZM750.5 828.2H197.7V652.3A1748.2 1748.2 0 0 0 474.5 673.6 1736.8 1736.8 0 0 0 750.5 652.3ZM750.5 617.7A1788.6 1788.6 0 0 1 197.7 617.7V454.5H197.7V308.6H197.7V281.4A119.5 119.5 0 0 1 318.2 161.8H489.1A232.7 232.7 0 0 0 680.9 525.5 224.5 224.5 0 0 0 751.4 513.2ZM681.8 493.2A197.7 197.7 0 0 1 554.5 447.7L595 407.3A109.5 109.5 0 0 0 734.5 396.4L765.5 363.6A36.8 36.8 0 0 0 765.5 311.8L760.5 306.8 805.9 261.4A17.3 17.3 0 0 0 805.9 236.8H805.9A17.3 17.3 0 0 0 781.4 236.8L735.9 282.3 694.5 240.9 740 195.5A17.3 17.3 0 0 0 740 170.9 17.7 17.7 0 0 0 727.3 162.7H727.3A17.7 17.7 0 0 0 715 167.7L669.5 213.2 664.5 208.2A37.7 37.7 0 0 0 612.3 208.2L580.5 240.5A109.1 109.1 0 0 0 569.1 380.5L528.6 420.9A198.2 198.2 0 1 1 681.8 493.2ZM606.4 265.9L640.9 233.6 742.3 335V337.7L709.5 370.5A73.6 73.6 0 0 1 606.4 370.5 74.5 74.5 0 0 1 604.5 265.9ZM624.1 747.7A17.3 17.3 0 0 1 640.9 730.5H674.1A17.3 17.3 0 1 1 674.1 764.5H640.9A17.3 17.3 0 0 1 622.3 747.7ZM327.7 747.7A17.3 17.3 0 0 1 310.9 764.5H275.9A17.3 17.3 0 0 1 275.9 730.5H309.1A17.3 17.3 0 0 1 325.9 747.7Z"
  }));
};
IconEbus.defaultProps = {
  title: 'ebus'
};
IconEbus.propTypes = {
  title: PropTypes.string
};

var IconEditSolid = function IconEditSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-edit-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M914.5 90.9L911.4 90.9A159.1 159.1 0 0 0 686.8 90.9L126.8 647.7 42.3 957.7 351.4 871.8 911.4 312.7A158.2 158.2 0 0 0 914.5 90.9ZM123.2 876.4L168.6 711.4 287.7 830.5ZM340.5 802.7L196.4 658.6 622.7 232.7 766.8 376.8ZM871.4 272.7L806.8 336.8 663.2 192.7 727.3 128.6A105 105 0 0 1 871.4 128.6H871.4A101.4 101.4 0 0 1 900.9 200.5 102.7 102.7 0 0 1 871.4 272.7Z"
  }));
};
IconEditSolid.defaultProps = {
  title: 'edit solid'
};
IconEditSolid.propTypes = {
  title: PropTypes.string
};

var IconEdit = function IconEdit(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-edit",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M900.9 99.1H900.9A147.7 147.7 0 0 0 692.7 99.1L136.4 656.4 55.9 944.1 343.2 863.6 900.9 307.3A147.3 147.3 0 0 0 900.9 99.1ZM104.5 895L160.5 691.8 307.3 838.6ZM337.7 821.4L177.7 661.4 620.5 219.1 780.5 379.1ZM876.8 283.2L804.5 355 644.5 195 716.8 123.2A113.2 113.2 0 0 1 876.8 123.2H876.8A113.2 113.2 0 0 1 876.8 283.2Z"
  }));
};
IconEdit.defaultProps = {
  title: 'edit'
};
IconEdit.propTypes = {
  title: PropTypes.string
};

var IconEntertainmentSolid = function IconEntertainmentSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-entertainment-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M136.4 786.8H863.6V181.8H136.4ZM391.8 377.7A41.8 41.8 0 0 1 409.1 343.2 45.5 45.5 0 0 1 430 337.7 41.8 41.8 0 0 1 449.5 342.7L636.4 446.4A41.4 41.4 0 0 1 657.3 482.3 40.9 40.9 0 0 1 636.4 517.7L450.9 621.4A40.5 40.5 0 0 1 410.5 621.4 40.5 40.5 0 0 1 390.5 586.4ZM136.4 895.5A99.1 99.1 0 0 0 235 994.5H766.4A99.1 99.1 0 0 0 863.6 895.5V845H136.4ZM500 866.8A45.5 45.5 0 1 1 454.5 912.3 45.5 45.5 0 0 1 500 866.8ZM766.4 5.5H233.6A99.1 99.1 0 0 0 136.4 104.5V121.4H863.6V104.5A99.1 99.1 0 0 0 766.4 5.5Z"
  }));
};
IconEntertainmentSolid.defaultProps = {
  title: 'entertainment solid'
};
IconEntertainmentSolid.propTypes = {
  title: PropTypes.string
};

var IconEntertainment = function IconEntertainment(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-entertainment",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M760 5.5H240A108.6 108.6 0 0 0 131.8 113.6V886.4A108.6 108.6 0 0 0 240 994.5H760A108.6 108.6 0 0 0 868.2 886.4V113.6A108.6 108.6 0 0 0 760 5.5ZM834.1 886.4A73.6 73.6 0 0 1 760 960H240A73.6 73.6 0 0 1 165.9 886.4V834.5H834.1ZM834.1 800.5H165.9V175.5H834.1ZM834.1 141.4H165.9V113.6A73.6 73.6 0 0 1 240 40H760A73.6 73.6 0 0 1 834.1 113.6ZM465.9 895A34.1 34.1 0 1 1 500 929.1 34.1 34.1 0 0 1 465.9 895ZM400.9 636.4A62.3 62.3 0 0 0 432.7 645 65.9 65.9 0 0 0 463.2 637.3L645 535.9A62.7 62.7 0 0 0 645 426.4L463.2 325A63.2 63.2 0 0 0 400.9 325 62.7 62.7 0 0 0 370.5 379.1V581.8A61.8 61.8 0 0 0 400.9 636.4ZM404.5 381.4A27.7 27.7 0 0 1 418.2 356.8 28.2 28.2 0 0 1 432.7 352.7 30.9 30.9 0 0 1 446.8 356.4L628.6 457.7A27.7 27.7 0 0 1 643.6 482.7 27.3 27.3 0 0 1 628.6 507.3L446.8 608.6A26.4 26.4 0 0 1 419.1 608.6 26.8 26.8 0 0 1 405 584.5Z"
  }));
};
IconEntertainment.defaultProps = {
  title: 'entertainment'
};
IconEntertainment.propTypes = {
  title: PropTypes.string
};

var IconExpand = function IconExpand(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-expand",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M276.8 429.5L493.2 213.2A8.2 8.2 0 0 1 506.8 213.2L723.2 429.5A28.6 28.6 0 0 0 763.6 389.1L545.5 172.7A66.4 66.4 0 0 0 500 153.2H500A66.4 66.4 0 0 0 454.5 172.7L236.4 389.1A28.6 28.6 0 0 0 276.8 429.5ZM723.2 570.5L506.8 786.8A8.2 8.2 0 0 1 493.2 786.8L276.8 570.5A28.6 28.6 0 0 0 236.4 610.9L454.5 827.3A66.4 66.4 0 0 0 500 846.8H500A66.4 66.4 0 0 0 545.5 827.3L761.8 610.9A28.6 28.6 0 0 0 721.4 570.5Z"
  }));
};
IconExpand.defaultProps = {
  title: 'expand'
};
IconExpand.propTypes = {
  title: PropTypes.string
};

var IconEyeNoSolid = function IconEyeNoSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-eye-no-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M767.7 136.4A28.6 28.6 0 0 0 729.5 145.9L221.8 827.7A29.1 29.1 0 0 0 232.3 866.8 30.9 30.9 0 0 0 246.4 870.5 28.6 28.6 0 0 0 272.7 854.5L778.2 175A28.6 28.6 0 0 0 767.7 136.4ZM363.6 545.5A150.5 150.5 0 0 1 354.5 500 145.5 145.5 0 0 1 500 354.5H502.3L581.8 248.2A373.2 373.2 0 0 0 500 238.6C307.7 238.6 146.8 388.6 86.4 453.6A68.6 68.6 0 0 0 86.4 544.5 825 825 0 0 0 255.5 683.2ZM913.6 454.5A825 825 0 0 0 744.5 315.9L638.6 457.7A150.5 150.5 0 0 1 645.5 500.9 145.5 145.5 0 0 1 500 645.5H500L417.7 751.8A380.5 380.5 0 0 0 500 761.4C692.3 761.4 853.2 611.4 913.6 546.4A68.6 68.6 0 0 0 913.6 454.5Z"
  }));
};
IconEyeNoSolid.defaultProps = {
  title: 'eye no solid'
};
IconEyeNoSolid.propTypes = {
  title: PropTypes.string
};

var IconEyeNo = function IconEyeNo(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-eye-no",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M913.6 454.5A772.7 772.7 0 0 0 681.8 282.3L768.2 169.1A16.8 16.8 0 0 0 761.8 145.9 17.3 17.3 0 0 0 738.6 152.3L651.8 268.6A422.3 422.3 0 0 0 500 238.6C307.7 238.6 146.8 388.6 86.4 453.6A68.6 68.6 0 0 0 86.4 544.5 772.7 772.7 0 0 0 318.2 717.7L231.8 830.9A16.8 16.8 0 0 0 238.2 854.1 16.8 16.8 0 0 0 246.4 856.4 17.7 17.7 0 0 0 261.4 847.7L348.2 731.4A422.3 422.3 0 0 0 500 761.4C692.3 761.4 853.2 611.4 913.6 546.4A68.6 68.6 0 0 0 913.6 454.5ZM111.4 523.2A33.6 33.6 0 0 1 111.4 477.7C168.6 415.5 321.4 272.7 500 272.7A379.5 379.5 0 0 1 630.5 296.8L572.7 374.5A147.7 147.7 0 0 0 500 354.5 145.5 145.5 0 0 0 400 605.5L336.8 690A742.7 742.7 0 0 1 111.4 523.2ZM420.5 577.7A111.4 111.4 0 0 1 500 388.6 105 105 0 0 1 551.8 402.3ZM579.5 421.8A111.4 111.4 0 0 1 500 611.4 105 105 0 0 1 448.2 597.7ZM888.6 523.2C831.4 584.5 678.6 727.3 500 727.3A379.5 379.5 0 0 1 369.5 703.2L427.3 625.5A147.7 147.7 0 0 0 500 645.5 145.5 145.5 0 0 0 600 394.5L663.2 310A742.7 742.7 0 0 1 890.5 476.8 33.6 33.6 0 0 1 888.6 523.2Z"
  }));
};
IconEyeNo.defaultProps = {
  title: 'eye no'
};
IconEyeNo.propTypes = {
  title: PropTypes.string
};

var IconEyeSolid = function IconEyeSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-eye-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M913.6 454.5C853.2 388.6 692.3 238.6 500 238.6S146.8 388.6 86.4 454.5A68.6 68.6 0 0 0 86.4 545.5C146.8 610.5 307.7 760.5 500 760.5S853.2 610.5 913.6 545.5A68.6 68.6 0 0 0 913.6 454.5ZM500 645.5A145.5 145.5 0 1 1 645.5 500 145.5 145.5 0 0 1 500 645.5Z"
  }));
};
IconEyeSolid.defaultProps = {
  title: 'eye solid'
};
IconEyeSolid.propTypes = {
  title: PropTypes.string
};

var IconEye = function IconEye(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-eye",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M913.6 454.5C853.2 388.6 692.3 238.6 500 238.6S146.8 388.6 86.4 454.5A68.6 68.6 0 0 0 86.4 545.5C146.8 610.5 307.7 760.5 500 760.5S853.2 610.5 913.6 545.5A68.6 68.6 0 0 0 913.6 454.5ZM888.6 524.1C831.4 584.5 678.6 727.3 500 727.3S168.6 584.5 111.4 523.2A33.6 33.6 0 0 1 111.4 477.7C168.6 415.5 321.4 272.7 500 272.7S831.4 415.5 888.6 476.8A33.6 33.6 0 0 1 888.6 523.2ZM500 354.5A145.5 145.5 0 1 0 645.5 500 145.5 145.5 0 0 0 500 354.5ZM500 611.4A111.4 111.4 0 1 1 611.4 500 111.4 111.4 0 0 1 500 611.4Z"
  }));
};
IconEye.defaultProps = {
  title: 'eye'
};
IconEye.propTypes = {
  title: PropTypes.string
};

var IconFerrySolid = function IconFerrySolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-ferry-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M940.5 753.2L913.2 778.6A35.5 35.5 0 0 0 858.6 778.6 67.3 67.3 0 0 1 762.7 784.1L757.3 778.6A32.3 32.3 0 0 0 711.8 771.4S706.4 775 704.5 778.6A69.5 69.5 0 0 1 606.8 784.1L601.4 778.6A34.1 34.1 0 0 0 555.9 771.4S550.5 775 548.6 778.6A67.7 67.7 0 0 1 452.3 784.1L446.8 778.6A37.7 37.7 0 0 0 420 765.9 38.6 38.6 0 0 0 392.7 778.6 67.3 67.3 0 0 1 296.8 784.1L291.4 778.6A32.3 32.3 0 0 0 245.9 771.4S240.5 775 238.6 778.6A67.3 67.3 0 0 1 142.7 784.1L136.4 778.6A32.3 32.3 0 0 0 90.9 772.7S85.5 776.4 83.6 780L60 754.5A67.3 67.3 0 0 1 156.4 749.1L161.4 754.5A32.3 32.3 0 0 0 206.8 761.8S212.3 758.2 214.1 754.5A55.5 55.5 0 0 1 227.3 742.3L145.5 525.9A87.3 87.3 0 0 1 151.8 442.7L151.8 442.7H846.8L846.8 442.7A87.3 87.3 0 0 1 853.2 525.9L772.7 743.2A45.5 45.5 0 0 1 780.5 747.7L785.9 753.2A35.5 35.5 0 0 0 813.2 765.9 38.6 38.6 0 0 0 840.5 753.2 66.4 66.4 0 0 1 936.4 747.7ZM500 280.9A38.6 38.6 0 1 0 538.2 319.5 38.6 38.6 0 0 0 500 280.9ZM741.8 409.1H258.2V287.7A90.9 90.9 0 0 1 349.1 196.8H482.7V126.4A17.3 17.3 0 0 1 500 109.1 16.8 16.8 0 0 1 516.8 126.4V196.8H653.2A90.9 90.9 0 0 1 744.1 287.7ZM572.3 318.2A72.3 72.3 0 1 0 500 391.8 72.7 72.7 0 0 0 572.3 318.2ZM838.6 822.7A59.1 59.1 0 0 0 795.5 843.6 30.9 30.9 0 0 1 773.6 854.1 29.1 29.1 0 0 1 751.4 843.6L746.8 838.6A65.9 65.9 0 0 0 704.1 822.3H700.5A60.5 60.5 0 0 0 657.3 843.2 29.1 29.1 0 0 1 611.8 843.2L606.8 838.2A58.6 58.6 0 0 0 561.4 822.3 60.5 60.5 0 0 0 515.9 843.2V843.2A15.5 15.5 0 0 1 511.8 846.8L511.8 846.8A27.7 27.7 0 0 1 474.1 840.9L469.5 835.9A60.5 60.5 0 0 0 424.1 820 59.1 59.1 0 0 0 378.6 840.9V840.9A10.9 10.9 0 0 1 374.5 844.5L374.5 844.5A28.2 28.2 0 0 1 336.4 838.6L331.8 833.6A62.3 62.3 0 0 0 243.6 838.6V838.6A13.6 13.6 0 0 1 240 842.3L240 842.3A25.5 25.5 0 0 1 203.6 836.4L198.6 831.4A58.6 58.6 0 0 0 153.2 815.5 59.1 59.1 0 0 0 107.7 836.4L107.7 836.4 132.7 863.6 132.7 860A15.5 15.5 0 0 1 140.5 863.6L140.5 863.6A25.9 25.9 0 0 1 176.8 869.5L181.4 874.5A61.8 61.8 0 0 0 226.8 890.9 60.9 60.9 0 0 0 272.3 869.5H272.7A15.5 15.5 0 0 1 275.5 863.6S275.5 863.6 275.5 863.6A25.9 25.9 0 0 1 311.8 869.5L316.8 874.5A60.5 60.5 0 0 0 404.5 869.5 29.1 29.1 0 0 1 450 869.5L454.5 874.5A61.8 61.8 0 0 0 496.4 890.9H500A60.9 60.9 0 0 0 543.2 869.5H543.2A11.8 11.8 0 0 1 547.3 865.5L547.3 865.5A27.7 27.7 0 0 1 585 871.4L589.5 876.4A66.8 66.8 0 0 0 635 892.7 62.7 62.7 0 0 0 680.5 871.4H680.5S682.7 868.6 684.1 867.3L684.1 867.3A25.5 25.5 0 0 1 720 873.2L725 878.2A60.5 60.5 0 0 0 770.5 894.5 62.7 62.7 0 0 0 815.9 873.2 28.2 28.2 0 0 1 861.4 873.2L889.1 847.3 884.5 842.3A60.5 60.5 0 0 0 838.6 822.7Z"
  }));
};
IconFerrySolid.defaultProps = {
  title: 'ferry solid'
};
IconFerrySolid.propTypes = {
  title: PropTypes.string
};

var IconFerry = function IconFerry(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-ferry",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M935 747.7A66.4 66.4 0 0 0 839.1 753.2 38.6 38.6 0 0 1 811.8 765.9 35.5 35.5 0 0 1 784.5 753.2L779.1 747.7A45.5 45.5 0 0 0 771.4 743.2L854.5 525.9A82.7 82.7 0 0 0 772.7 409.1H741.8V287.7A90.9 90.9 0 0 0 650.9 196.8H514.5V126.4A16.8 16.8 0 0 0 500 109.1 17.3 17.3 0 0 0 482.7 126.4V196.8H349.1A90.9 90.9 0 0 0 258.2 287.7V409.1H227.3A87.3 87.3 0 0 0 151.8 444.5 87.3 87.3 0 0 0 145.5 527.7L227.3 742.3A55.5 55.5 0 0 0 212.7 753.2C212.7 756.8 207.3 758.6 205.5 760.5A32.3 32.3 0 0 1 160 753.2L155 747.7A67.3 67.3 0 0 0 58.6 753.2L82.3 778.6C82.3 775 87.7 773.2 89.5 771.4A32.3 32.3 0 0 1 135 778.6L140.5 784.1A67.3 67.3 0 0 0 236.4 778.6C236.4 775 241.8 773.2 243.6 771.4A32.3 32.3 0 0 1 289.1 778.6L294.1 784.1A67.7 67.7 0 0 0 390.5 778.6 38.6 38.6 0 0 1 417.7 765.9 37.7 37.7 0 0 1 444.5 778.6L450 784.1A67.7 67.7 0 0 0 545.5 778.6C545.5 775 550.9 773.2 552.7 771.4A34.1 34.1 0 0 1 598.2 778.6L603.6 784.1A69.5 69.5 0 0 0 701.4 778.6C701.4 775 706.8 773.2 708.6 771.4A32.3 32.3 0 0 1 754.1 778.6L759.5 784.1A67.3 67.3 0 0 0 855.5 778.6 35.5 35.5 0 0 1 910 778.6L937.3 753.2ZM292.3 395.9V287.7A57.3 57.3 0 0 1 349.1 230.9H650.9A57.3 57.3 0 0 1 707.7 287.7V409.1H292.3ZM739.5 731.4A65.5 65.5 0 0 0 681.4 753.2 35.5 35.5 0 0 1 626.8 753.2L621.4 747.7A66.8 66.8 0 0 0 525.5 753.2C525.5 756.8 520 758.6 518.2 760.5A34.5 34.5 0 0 1 472.7 753.2L467.3 747.7A66.8 66.8 0 0 0 371.4 753.2C371.4 756.8 365.9 758.6 364.1 760.5A34.5 34.5 0 0 1 318.6 753.2L313.2 747.7A65.9 65.9 0 0 0 263.6 730L177.3 514.1A54.1 54.1 0 0 1 181.8 462.3 54.1 54.1 0 0 1 227.3 441.4H772.7A54.1 54.1 0 0 1 818.2 462.3 55 55 0 0 1 820.9 514.1ZM838.6 822.7A59.1 59.1 0 0 0 795.5 843.6 30.9 30.9 0 0 1 773.6 854.1 29.1 29.1 0 0 1 751.4 843.6L746.8 838.6A65.9 65.9 0 0 0 704.1 822.3H700.5A60.5 60.5 0 0 0 657.3 843.2 29.1 29.1 0 0 1 611.8 843.2L606.8 838.2A58.6 58.6 0 0 0 561.4 822.3 60.5 60.5 0 0 0 515.9 843.2V843.2A15.5 15.5 0 0 1 511.8 846.8L511.8 846.8A27.7 27.7 0 0 1 474.1 840.9L469.5 835.9A60.5 60.5 0 0 0 424.1 820 59.1 59.1 0 0 0 378.6 840.9V840.9A10.9 10.9 0 0 1 374.5 844.5L374.5 844.5A28.2 28.2 0 0 1 336.4 838.6L331.8 833.6A62.3 62.3 0 0 0 243.6 838.6V838.6A13.6 13.6 0 0 1 240 842.3L240 842.3A25.5 25.5 0 0 1 203.6 836.4L199.1 831.4A60.5 60.5 0 0 0 153.6 815.5 59.1 59.1 0 0 0 108.2 836.4L108.2 836.4 133.2 863.6 133.2 860A15.5 15.5 0 0 1 140.5 863.6L140.5 863.6A25.9 25.9 0 0 1 176.8 869.5L181.4 874.5A61.8 61.8 0 0 0 226.8 890.9 60.9 60.9 0 0 0 272.3 869.5H272.7A15.5 15.5 0 0 1 275.5 863.6S275.5 863.6 275.5 863.6A25.9 25.9 0 0 1 311.8 869.5L316.8 874.5A60.5 60.5 0 0 0 404.5 869.5 29.1 29.1 0 0 1 450 869.5L454.5 874.5A61.8 61.8 0 0 0 496.4 890.9H500A60.9 60.9 0 0 0 543.2 869.5H543.2A11.8 11.8 0 0 1 547.3 865.5L547.3 865.5A27.7 27.7 0 0 1 585 871.4L589.5 876.4A67.7 67.7 0 0 0 635 892.7 62.7 62.7 0 0 0 680.5 871.4H680.5S682.7 868.6 684.1 867.3L684.1 867.3A25.5 25.5 0 0 1 720 873.2L725 878.2A60.5 60.5 0 0 0 770.5 894.5 62.7 62.7 0 0 0 815.9 873.2 28.2 28.2 0 0 1 861.4 873.2L889.1 847.3 884.5 842.3A60.5 60.5 0 0 0 838.6 822.7ZM500 246.8A72.7 72.7 0 1 0 572.3 318.2 72.7 72.7 0 0 0 500 246.8ZM500 357.7A38.6 38.6 0 1 1 538.2 318.2 38.6 38.6 0 0 1 500 357.7Z"
  }));
};
IconFerry.defaultProps = {
  title: 'ferry'
};
IconFerry.propTypes = {
  title: PropTypes.string
};

var IconFilter = function IconFilter(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-filter",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M76.8 256.8H198.2V309.5A29.1 29.1 0 0 0 248.2 330.5 30.9 30.9 0 0 0 256.8 309.5V256.8H923.2A29.5 29.5 0 0 0 954.5 227.3 30 30 0 0 0 925 197.7H256.4V145A29.5 29.5 0 0 0 227.3 115.5 30 30 0 0 0 197.7 145V198.2H76.8A29.1 29.1 0 0 0 55.9 248.2 30.9 30.9 0 0 0 76.8 256.8ZM923.2 470.5H801.8V417.7A29.5 29.5 0 0 0 772.7 388.2 30 30 0 0 0 743.2 417.7V470.5H76.8A29.1 29.1 0 0 0 55.9 520.5 30.9 30.9 0 0 0 76.8 529.1H743.6V582.3A29.1 29.1 0 0 0 793.6 603.2 30.9 30.9 0 0 0 802.3 582.3V529.1H923.2A29.5 29.5 0 0 0 954.5 500 30 30 0 0 0 923.2 470.5ZM923.2 743.2H529.1V690.5A29.5 29.5 0 0 0 500 660.9 30 30 0 0 0 470.5 690.5V743.6H76.8A29.1 29.1 0 0 0 55.9 793.6 30.9 30.9 0 0 0 76.8 802.3H470.9V855A29.1 29.1 0 0 0 520.9 875.9 30.9 30.9 0 0 0 529.5 855V801.8H923.2A29.5 29.5 0 0 0 954.5 772.7 30 30 0 0 0 923.2 743.2Z"
  }));
};
IconFilter.defaultProps = {
  title: 'filter'
};
IconFilter.propTypes = {
  title: PropTypes.string
};

var IconFlixtechSolid = function IconFlixtechSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-flixtech-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 90.9A409.1 409.1 0 1 0 909.1 500 409.1 409.1 0 0 0 500 90.9ZM669.1 459.5H547.7V702.3A47.7 47.7 0 0 1 452.3 702.3V459.5H330.9A47.7 47.7 0 0 1 330.9 364.1H669.1A47.7 47.7 0 0 1 669.1 459.5ZM669.1 345.5H454.5A95.5 95.5 0 0 1 550 250H671.4A47.7 47.7 0 0 1 671.4 345.5Z"
  }));
};
IconFlixtechSolid.defaultProps = {
  title: 'flixtech solid'
};
IconFlixtechSolid.propTypes = {
  title: PropTypes.string
};

var IconFlixtech = function IconFlixtech(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-flixtech",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M643.2 345.5H669.1A47.7 47.7 0 0 0 669.1 250H547.7A95.5 95.5 0 0 0 454.5 345.5H645.5ZM669.1 363.6H330.9A47.7 47.7 0 0 0 330.9 459.1H454.5V701.8A47.7 47.7 0 0 0 550 701.8V459.5H671.4A47.7 47.7 0 0 0 671.4 364.1M500 90.9A409.1 409.1 0 1 0 909.1 500 409.1 409.1 0 0 0 500 90.9M500 875A375 375 0 1 1 875 500 375.5 375.5 0 0 1 500 875"
  }));
};
IconFlixtech.defaultProps = {
  title: 'flixtech'
};
IconFlixtech.propTypes = {
  title: PropTypes.string
};

var IconForbidden = function IconForbidden(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-forbidden",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 79.5A420.5 420.5 0 1 0 920.5 500 420.9 420.9 0 0 0 500 79.5ZM125 500A375.5 375.5 0 0 1 500 125 371.4 371.4 0 0 1 706.8 187.7L256.8 785A374.5 374.5 0 0 1 125 500ZM500 875A371.4 371.4 0 0 1 293.2 812.3L743.2 215A374.5 374.5 0 0 1 500 875Z"
  }));
};
IconForbidden.defaultProps = {
  title: 'forbidden'
};
IconForbidden.propTypes = {
  title: PropTypes.string
};

var IconFullScreen = function IconFullScreen(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-full-screen",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M681.8 250A68.6 68.6 0 0 1 750 318.2V681.8A68.2 68.2 0 0 1 681.8 750H318.2A68.2 68.2 0 0 1 250 681.8V318.2A68.6 68.6 0 0 1 318.2 250ZM102.7 401.4A36.8 36.8 0 0 0 140 363.6V150C140 140.9 143.6 137.7 152.3 137.7H366.8A37.3 37.3 0 0 0 366.8 63.2H152.3A85.9 85.9 0 0 0 90.9 90.9H90.9A85.9 85.9 0 0 0 65.9 150V363.6A36.4 36.4 0 0 0 102.7 401.4ZM633.2 136.4H847.7C856.4 136.4 860 140 860 148.6V363.6A36.8 36.8 0 0 0 897.3 400.5 36.4 36.4 0 0 0 934.1 363.6V150A85.9 85.9 0 0 0 909.1 90.9H909.1A85.9 85.9 0 0 0 848.2 65.5H633.2A37.3 37.3 0 0 0 633.2 140ZM897.3 597.3A36.8 36.8 0 0 0 860 634.1V850C860 859.1 856.4 862.3 847.7 862.3H633.2A37.3 37.3 0 0 0 633.2 936.8H847.7A85.9 85.9 0 0 0 909.1 911.4H909.1A85.9 85.9 0 0 0 934.1 850V636.4A36.4 36.4 0 0 0 897.3 598.6ZM372.7 863.6H158.6C149.5 863.6 146.4 860 146.4 851.4V636.4A37.3 37.3 0 0 0 71.8 636.4V850A86.4 86.4 0 0 0 97.3 911.4H97.3A86.4 86.4 0 0 0 158.6 936.8H372.7A37.3 37.3 0 0 0 372.7 863.6Z"
  }));
};
IconFullScreen.defaultProps = {
  title: 'full screen'
};
IconFullScreen.propTypes = {
  title: PropTypes.string
};

var IconGamesSolid = function IconGamesSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-games-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M731.8 136.4H268.2A231.4 231.4 0 0 0 36.8 367.3V730.9A132.3 132.3 0 0 0 283.2 798.2L400.9 598.6H599.1L716.8 798.2A132.3 132.3 0 0 0 963.2 730.9V367.3A231.4 231.4 0 0 0 731.8 136.4ZM344.1 389.1H290V443.2A21.8 21.8 0 0 1 244.5 443.2V389.1H192.7A21.8 21.8 0 0 1 171.4 367.3 21.4 21.4 0 0 1 192.7 345.9H246.8V291.8A21.8 21.8 0 1 1 292.3 291.8V345.9H344.1A21.4 21.4 0 0 1 363.6 367.3 21.8 21.8 0 0 1 344.1 389.1ZM640.9 405.9A38.6 38.6 0 1 1 681.8 367.3 38.6 38.6 0 0 1 640.9 405.9ZM731.8 496.8A38.6 38.6 0 1 1 770.5 458.2 38.6 38.6 0 0 1 731.8 496.8ZM731.8 315A38.6 38.6 0 1 1 772.7 276.4 38.6 38.6 0 0 1 731.8 315ZM822.7 405.9A38.6 38.6 0 1 1 863.6 367.3 38.6 38.6 0 0 1 822.7 405.9Z"
  }));
};
IconGamesSolid.defaultProps = {
  title: 'games solid'
};
IconGamesSolid.propTypes = {
  title: PropTypes.string
};

var IconGames = function IconGames(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-games",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M360.9 367.3A17.3 17.3 0 0 1 344.1 384.5H285.5V443.2A17.3 17.3 0 0 1 251.4 443.2V384.5H192.7A17.3 17.3 0 1 1 192.7 350.5H251.4V291.8A17.3 17.3 0 1 1 285.5 291.8V350.5H344.1A17.3 17.3 0 0 1 360.9 367.3ZM731.8 424.1A34.1 34.1 0 1 0 765.9 458.2 34.1 34.1 0 0 0 731.8 424.1ZM640.9 333.2A34.1 34.1 0 1 0 675 367.3 34.1 34.1 0 0 0 640.9 333.2ZM731.8 242.3A34.1 34.1 0 1 0 765.9 276.4 34.1 34.1 0 0 0 731.8 242.3ZM963.2 367.3V730.9A132.3 132.3 0 0 1 716.8 798.2L599.1 598.6H400.9L283.2 798.6A132.3 132.3 0 0 1 36.8 731.4V367.7A231.4 231.4 0 0 1 268.2 136.4H731.8A231.4 231.4 0 0 1 963.2 367.3ZM929.1 367.3A197.7 197.7 0 0 0 731.8 170H268.2A197.7 197.7 0 0 0 70.9 367.3V730.9A98.2 98.2 0 0 0 252.7 780.9L371.4 581.8 381.4 565H618.6L628.6 581.8 746.4 781.4A98.2 98.2 0 0 0 928.2 731.4ZM822.7 333.2A34.1 34.1 0 1 0 856.8 367.3 34.1 34.1 0 0 0 822.7 333.2Z"
  }));
};
IconGames.defaultProps = {
  title: 'games'
};
IconGames.propTypes = {
  title: PropTypes.string
};

var IconGroupSolid = function IconGroupSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-group-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M77.7 237.3A87.7 87.7 0 1 1 165.5 325 87.7 87.7 0 0 1 77.7 237.3ZM224.5 404.1A61.4 61.4 0 0 0 165.5 363.6H165.5A61.4 61.4 0 0 0 106.4 406.4L37.3 608.6A62.3 62.3 0 0 0 45.5 665 61.4 61.4 0 0 0 95.9 690.9H95.9V827.3A24.1 24.1 0 0 0 120 851.4H208.6A23.6 23.6 0 0 0 232.7 827.3V690.9H232.7A61.8 61.8 0 0 0 283.2 665 60.9 60.9 0 0 0 291.4 608.6ZM834.5 325A87.7 87.7 0 1 0 746.8 237.3 87.7 87.7 0 0 0 834.5 325ZM962.7 608.6L893.6 404.1A62.3 62.3 0 0 0 775.5 404.1L706.8 608.6A60.9 60.9 0 0 0 715 665 61.8 61.8 0 0 0 765.5 690.9H765.5V827.3A23.6 23.6 0 0 0 789.5 851.4H876.4A24.1 24.1 0 0 0 900.5 827.3V690.9H900.5A61.4 61.4 0 0 0 954.5 665 62.3 62.3 0 0 0 962.7 608.6ZM569.1 363.6H432.7A61.4 61.4 0 0 0 382.3 389.5 62.3 62.3 0 0 0 373.6 445.9L433.2 621.8V827.7A24.1 24.1 0 0 0 457.3 851.8H544.1A24.1 24.1 0 0 0 568.2 827.7V626.8L630 445A62.3 62.3 0 0 0 621.4 388.6 61.4 61.4 0 0 0 569.1 363.6ZM500 325A87.7 87.7 0 1 0 411.4 237.3 87.3 87.3 0 0 0 500 325Z"
  }));
};
IconGroupSolid.defaultProps = {
  title: 'group solid'
};
IconGroupSolid.propTypes = {
  title: PropTypes.string
};

var IconGroup = function IconGroup(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-group",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M165.5 330.9A93.6 93.6 0 1 0 74.5 237.3 93.2 93.2 0 0 0 165.5 330.9ZM165.5 178.2A59.5 59.5 0 1 1 106.4 237.3 59.1 59.1 0 0 1 165.5 178.2ZM229.5 402.3A66.4 66.4 0 0 0 165.5 356.8H165.5A67.3 67.3 0 0 0 100.9 402.3L31.8 606.8A68.2 68.2 0 0 0 92.3 697.7V827.3A29.5 29.5 0 0 0 121.8 857.3H208.6A30 30 0 0 0 238.6 827.3V696.4A67.7 67.7 0 0 0 289.5 668.2 65.9 65.9 0 0 0 298.6 606.8ZM261.8 648.2A32.7 32.7 0 0 1 234.5 662.3H221.4A17.3 17.3 0 0 0 204.5 681.8V824.1H126.4V681.8A17.3 17.3 0 0 0 109.1 664.5H96.4A32.7 32.7 0 0 1 69.1 650.5 33.2 33.2 0 0 1 64.1 620L133.2 415.5A33.2 33.2 0 0 1 165.5 392.3H165.5A32.3 32.3 0 0 1 197.3 415H197.3L266.4 619.5A33.2 33.2 0 0 1 261.8 648.2ZM834.5 330A93.6 93.6 0 1 0 741.4 236.4 93.2 93.2 0 0 0 834.5 330.9ZM834.5 177.3A59.5 59.5 0 1 1 775.5 236.4 59.1 59.1 0 0 1 834.5 178.2ZM968.2 605.9L899.1 401.4A67.3 67.3 0 0 0 834.5 355.9 66.4 66.4 0 0 0 770.5 401.4L701.4 605.9A65.9 65.9 0 0 0 710.5 667.3 67.7 67.7 0 0 0 761.4 695.5V825A29.5 29.5 0 0 0 791.4 855H878.2A29.5 29.5 0 0 0 907.7 825V696.4A68.2 68.2 0 0 0 968.2 605.5ZM930.9 647.3A32.7 32.7 0 0 1 903.6 661.4H890.9A17.3 17.3 0 0 0 873.6 678.6V820.9H795.5V681.8A17.3 17.3 0 0 0 778.6 664.5H765.5A33.6 33.6 0 0 1 733.6 619.1L802.7 414.5A32.3 32.3 0 0 1 834.5 391.4 33.2 33.2 0 0 1 866.8 414.5L935.9 619.1A33.2 33.2 0 0 1 930.9 648.2ZM567.3 355.5H430.9A67.7 67.7 0 0 0 366.8 446.4L425.9 621.4V826.4A29.5 29.5 0 0 0 455.5 856.4H542.3A30 30 0 0 0 572.3 826.4V627.7L633.2 445.9A67.7 67.7 0 0 0 569.1 355ZM599.1 434.1L537.3 615.9A12.3 12.3 0 0 0 537.3 621.8V818.6H460V618.2A22.7 22.7 0 0 0 460 612.7L399.1 435A33.6 33.6 0 0 1 430.9 389.5H567.3A33.6 33.6 0 0 1 599.1 435ZM500 330.9A93.6 93.6 0 1 0 405.5 237.3 93.2 93.2 0 0 0 500 330.9ZM500 178.2A59.5 59.5 0 1 1 440.5 237.3 59.5 59.5 0 0 1 500 178.2Z"
  }));
};
IconGroup.defaultProps = {
  title: 'group'
};
IconGroup.propTypes = {
  title: PropTypes.string
};

var IconHeadphonesSolid = function IconHeadphonesSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-headphones-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 90.9A460.9 460.9 0 0 0 40 549.5V837.3A28.6 28.6 0 0 0 58.6 864.1L181.8 909.1 184.5 909.1A53.6 53.6 0 0 0 230 899.1 54.5 54.5 0 0 0 250.9 853.6V609.1A54.1 54.1 0 0 0 230 566.4 55.5 55.5 0 0 0 181.8 556.8L95.5 587.7V549.5A403.6 403.6 0 1 1 902.3 549.5V587.7L811.4 556.4A54.5 54.5 0 0 0 743.6 609.1V855.9A55 55 0 0 0 800.9 909.1 61.4 61.4 0 0 0 814.1 909.1L941.4 863.6A29.1 29.1 0 0 0 960.5 836.8V549.5A461.4 461.4 0 0 0 500 90.9Z"
  }));
};
IconHeadphonesSolid.defaultProps = {
  title: 'headphones solid'
};
IconHeadphonesSolid.propTypes = {
  title: PropTypes.string
};

var IconHeadphones = function IconHeadphones(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-headphones",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 100.5A449.5 449.5 0 0 0 51.4 549.5V837.3A18.2 18.2 0 0 0 62.3 853.6L186.8 899.1H186.8A38.6 38.6 0 0 0 197.3 899.1 40.9 40.9 0 0 0 227.3 890 41.8 41.8 0 0 0 244.1 855.9V609.5A45.5 45.5 0 0 0 188.6 567.7L87.3 603.6V549.5A415 415 0 1 1 916.8 549.5V603.6L813.2 567.3A45.5 45.5 0 0 0 759.5 609.5V855.9A41.8 41.8 0 0 0 776.4 890 40.9 40.9 0 0 0 802.7 899.5 38.6 38.6 0 0 0 813.2 899.5H813.2L937.7 854.1A17.7 17.7 0 0 0 949.1 837.7V549.5A449.5 449.5 0 0 0 500 100.5ZM196.8 600.5A10 10 0 0 1 204.5 600.5 10.5 10.5 0 0 1 208.2 608.2V854.5A8.6 8.6 0 0 1 204.5 863.6 7.3 7.3 0 0 1 197.3 863.6L85.5 824.1V640ZM915 825.5L802.7 863.6A7.3 7.3 0 0 1 795.5 863.6 8.6 8.6 0 0 1 791.8 856.4V609.5A10.5 10.5 0 0 1 795.5 601.8 8.6 8.6 0 0 1 800.9 601.8H800.9L914.1 641.8Z"
  }));
};
IconHeadphones.defaultProps = {
  title: 'headphones'
};
IconHeadphones.propTypes = {
  title: PropTypes.string
};

var IconHomeSolid = function IconHomeSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-home-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M905 494.1A17.3 17.3 0 0 1 889.1 504.5H831.4A23.2 23.2 0 0 0 808.6 527.3V875.5A27.7 27.7 0 0 1 780.9 903.6H599.1A27.7 27.7 0 0 1 571.4 875.5V722.7A22.7 22.7 0 0 0 548.6 700H450A22.7 22.7 0 0 0 427.3 722.7V875.5A27.7 27.7 0 0 1 399.5 903.6H217.7A27.7 27.7 0 0 1 190 875.5V527.3A23.2 23.2 0 0 0 167.3 504.5H110.9A17.3 17.3 0 0 1 95 494.1 16.8 16.8 0 0 1 99.1 475.5L480.5 104.5A27.7 27.7 0 0 1 519.5 104.5L900.9 475.5A16.8 16.8 0 0 1 905 494.1Z"
  }));
};
IconHomeSolid.defaultProps = {
  title: 'home solid'
};
IconHomeSolid.propTypes = {
  title: PropTypes.string
};

var IconHome = function IconHome(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-home",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M900.9 475.5L519.5 104.5A27.7 27.7 0 0 0 480.5 104.5L99.1 475.5A16.8 16.8 0 0 0 95 494.1 17.3 17.3 0 0 0 110.9 504.5H191.4V875.5A27.7 27.7 0 0 0 219.1 903.6H400.9A27.7 27.7 0 0 0 428.6 875.5V700H574.1V875.5A27.7 27.7 0 0 0 601.8 903.6H783.6A27.7 27.7 0 0 0 811.4 875.5V504.5H891.8A17.3 17.3 0 0 0 907.7 494.1 16.8 16.8 0 0 0 900.9 475.5ZM791.8 470.5A17.3 17.3 0 0 0 774.5 487.7V869.5H606.8V693.6A27.7 27.7 0 0 0 578.6 665.9H421.4A27.7 27.7 0 0 0 393.2 693.6V869.5H227.3V487.7A17.3 17.3 0 0 0 210 470.5H152.7L500 133.2 847.3 470.5Z"
  }));
};
IconHome.defaultProps = {
  title: 'home'
};
IconHome.propTypes = {
  title: PropTypes.string
};

var IconInfoSolid = function IconInfoSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-info-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 90.9A409.1 409.1 0 1 0 909.1 500 409.1 409.1 0 0 0 500 90.9ZM528.2 735.5A28.2 28.2 0 1 1 471.8 735.5V490.5A28.2 28.2 0 1 1 528.2 490.5ZM500 348.6A45.5 45.5 0 1 1 545.5 303.2 45.5 45.5 0 0 1 500 348.6Z"
  }));
};
IconInfoSolid.defaultProps = {
  title: 'info solid'
};
IconInfoSolid.propTypes = {
  title: PropTypes.string
};

var IconInfo = function IconInfo(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-info",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M522.7 454.5V699.5A22.7 22.7 0 1 1 477.3 699.5V454.5A22.7 22.7 0 0 1 522.7 454.5ZM920.5 500A420.5 420.5 0 1 1 500 79.5 420.9 420.9 0 0 1 920.5 500ZM875 500A375 375 0 1 0 500 875 375.5 375.5 0 0 0 875 500ZM500 265.9A37.7 37.7 0 1 0 537.3 303.6 37.7 37.7 0 0 0 500 265.9Z"
  }));
};
IconInfo.defaultProps = {
  title: 'info'
};
IconInfo.propTypes = {
  title: PropTypes.string
};

var IconInterconnectionSolid = function IconInterconnectionSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-interconnection-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M965 27.3A33.2 33.2 0 0 0 919.5 39.5L681.8 454.5A132.7 132.7 0 0 0 580 697.7 136.4 136.4 0 0 0 646.4 715.5 133.6 133.6 0 0 0 772.7 545.5 136.4 136.4 0 0 0 737.3 485.9L977.3 73.2A34.1 34.1 0 0 0 965 27.3ZM421.8 303.2A132.7 132.7 0 0 0 261.8 512.7L22.7 926.8A34.1 34.1 0 0 0 35 972.3 33.6 33.6 0 0 0 51.8 976.8 32.7 32.7 0 0 0 80.9 960L318.2 545.5A130.5 130.5 0 0 0 353.2 550.5 129.1 129.1 0 0 0 387.7 545.9 131.4 131.4 0 0 0 468.6 483.6 133.2 133.2 0 0 0 421.8 303.2Z"
  }));
};
IconInterconnectionSolid.defaultProps = {
  title: 'interconnection solid'
};
IconInterconnectionSolid.propTypes = {
  title: PropTypes.string
};

var IconInterconnection = function IconInterconnection(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-interconnection",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M970.5 25.9A23.2 23.2 0 0 0 939.1 34.1L695.5 454.5A136.4 136.4 0 0 0 613.2 450.5 136.4 136.4 0 1 0 735 477.7L978.6 55.5A22.3 22.3 0 0 0 970.5 25.9ZM727.3 628.6A90.9 90.9 0 0 1 603.6 662.3 90.9 90.9 0 0 1 570.5 538.2 90.9 90.9 0 0 1 625.5 495.9 82.3 82.3 0 0 1 649.1 492.7 90.9 90.9 0 0 1 727.3 629.1ZM419.5 298.6A136.4 136.4 0 0 0 265 520.9L21.4 943.2A22.3 22.3 0 0 0 29.5 974.1 21.4 21.4 0 0 0 40.9 977.3 23.2 23.2 0 0 0 60.9 965.9L304.5 545.5A130.5 130.5 0 0 0 350 555 136.4 136.4 0 0 0 418.2 300.9ZM430 461.8A90.9 90.9 0 0 1 306.4 495 90.9 90.9 0 0 1 351.8 325.9 90.9 90.9 0 0 1 430 462.3Z"
  }));
};
IconInterconnection.defaultProps = {
  title: 'interconnection'
};
IconInterconnection.propTypes = {
  title: PropTypes.string
};

var IconInvoice = function IconInvoice(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-invoice",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M693.6 743.6V827.7A51.8 51.8 0 0 1 641.4 879.5H148.2A51.8 51.8 0 0 1 96.4 827.7V172.3A51.8 51.8 0 0 1 148.2 120.5H641.4A51.8 51.8 0 0 1 693.6 172.3V497.3A17.7 17.7 0 0 1 658.6 497.3V172.3A17.3 17.3 0 0 0 641.4 155.5H148.2A17.3 17.3 0 0 0 130.9 172.3V827.7A17.3 17.3 0 0 0 148.2 844.5H641.4A17.3 17.3 0 0 0 658.6 827.7V743.6A17.7 17.7 0 0 1 693.6 743.6ZM202.7 263.2H412.7A17.7 17.7 0 0 0 412.7 228.2H202.7A17.7 17.7 0 0 0 202.7 263.2ZM202.7 332.3H412.7A17.7 17.7 0 0 0 412.7 297.3H202.7A17.7 17.7 0 0 0 202.7 332.3ZM569.5 580V429.5H500V698.6A17.3 17.3 0 0 1 482.3 715.9H202.7A17.3 17.3 0 0 1 185.5 698.6V411.8A17.3 17.3 0 0 1 202.7 394.5H587.3A17.3 17.3 0 0 1 604.5 411.8V580A17.3 17.3 0 0 1 587.3 597.3 17.7 17.7 0 0 1 569.5 580ZM464.1 429.5H220.5V681.8H464.1ZM895.5 478.6L590.9 782.7A30 30 0 0 1 577.7 790.5L532.3 801.4A17.7 17.7 0 0 1 525.5 801.4 27.3 27.3 0 0 1 505 792.7 28.6 28.6 0 0 1 497.3 765.5L508.2 720A31.4 31.4 0 0 1 515.9 706.4L818.2 401.8A30.5 30.5 0 0 1 859.5 401.8L895 437.3A29.5 29.5 0 0 1 895.5 478.6ZM830.9 493.6L804.1 466.4 539.5 730.9 531.8 765.5 569.1 756.4ZM866.4 458.2L839.5 430.9 828.6 441.4 855.9 468.6Z"
  }));
};
IconInvoice.defaultProps = {
  title: 'invoice'
};
IconInvoice.propTypes = {
  title: PropTypes.string
};

var IconKebab = function IconKebab(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-kebab",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M443.2 227.3A56.8 56.8 0 1 1 500 284.1 56.8 56.8 0 0 1 443.2 227.3ZM500 443.2A56.8 56.8 0 1 0 556.8 500 56.8 56.8 0 0 0 500 443.2ZM500 715.9A56.8 56.8 0 1 0 556.8 772.7 56.8 56.8 0 0 0 500 715.9Z"
  }));
};
IconKebab.defaultProps = {
  title: 'kebab'
};
IconKebab.propTypes = {
  title: PropTypes.string
};

var IconLabelAttentionSolid = function IconLabelAttentionSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-label-attention-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M898.6 166.8A69.1 69.1 0 0 0 833.2 101.4L573.6 90.9A69.5 69.5 0 0 0 522.7 110.9L110.9 523.2A67.3 67.3 0 0 0 110.9 619.1L380.9 889.1A66.4 66.4 0 0 0 429.1 909.1H429.1A66.8 66.8 0 0 0 477.3 889.1L889.1 477.3A67.7 67.7 0 0 0 909.1 426.4ZM471.4 313.2A28.6 28.6 0 0 1 528.2 313.2V545.5A28.6 28.6 0 0 1 471.4 545.5ZM500 699.5A45.5 45.5 0 1 1 545.5 654.1 45.5 45.5 0 0 1 500 699.5ZM818.2 260.5A57.3 57.3 0 0 1 738.2 260.5 57.3 57.3 0 0 1 721.4 220 55.5 55.5 0 0 1 740 181.8 56.4 56.4 0 0 1 818.2 181.8 55.5 55.5 0 0 1 835 221.8 57.3 57.3 0 0 1 818.2 260.5Z"
  }));
};
IconLabelAttentionSolid.defaultProps = {
  title: 'label attention solid'
};
IconLabelAttentionSolid.propTypes = {
  title: PropTypes.string
};

var IconLabelAttention = function IconLabelAttention(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-label-attention",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M482.7 564.5V331.8A16.8 16.8 0 0 1 500 315 16.4 16.4 0 0 1 516.8 331.8V564.5A16.8 16.8 0 0 1 500 581.4 17.3 17.3 0 0 1 482.7 564.5ZM500 612.7A34.1 34.1 0 1 0 534.1 646.8 34.5 34.5 0 0 0 500 612.7ZM914.5 425.9A72.7 72.7 0 0 1 893.2 480.9L480.9 893.2A71.4 71.4 0 0 1 429.1 914.5H429.1A72.3 72.3 0 0 1 376.8 893.2L106.8 623.2A73.6 73.6 0 0 1 106.8 519.1L519.1 106.8A74.1 74.1 0 0 1 574.1 85.5L833.6 95.9A74.1 74.1 0 0 1 904.1 166.4ZM880.5 425.9L870 166.4A39.5 39.5 0 0 0 832.3 128.6L572.7 119.5H572.7A39.5 39.5 0 0 0 545 131.4L130.9 545.5A39.5 39.5 0 0 0 130.9 601.4L400.9 871.4A39.1 39.1 0 0 0 429.1 882.7 35.9 35.9 0 0 0 456.8 871.4L869.1 459.1A39.1 39.1 0 0 0 880.5 427.3ZM824.1 175.9A62.7 62.7 0 1 1 735.9 175.9 61.4 61.4 0 0 1 824.1 175.9ZM808.2 221.4A27.3 27.3 0 0 0 800 201.4 28.6 28.6 0 0 0 760 201.4 28.2 28.2 0 0 0 800 241.4 27.3 27.3 0 0 0 808.2 220Z"
  }));
};
IconLabelAttention.defaultProps = {
  title: 'label attention'
};
IconLabelAttention.propTypes = {
  title: PropTypes.string
};

var IconLabelSolid = function IconLabelSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-label-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M898.6 166.8A69.1 69.1 0 0 0 833.2 101.4L573.6 90.9A69.5 69.5 0 0 0 522.7 110.9L110.9 523.2A67.3 67.3 0 0 0 110.9 619.1L380.9 889.1A66.4 66.4 0 0 0 429.1 909.1H429.1A66.8 66.8 0 0 0 477.3 889.1L889.1 477.3A67.7 67.7 0 0 0 909.1 426.4ZM818.2 260.5A57.3 57.3 0 0 1 738.2 260.5 57.3 57.3 0 0 1 721.4 220 55.5 55.5 0 0 1 740 181.8 56.4 56.4 0 0 1 818.2 181.8 55.5 55.5 0 0 1 835 221.8 57.3 57.3 0 0 1 818.2 260.5Z"
  }));
};
IconLabelSolid.defaultProps = {
  title: 'label solid'
};
IconLabelSolid.propTypes = {
  title: PropTypes.string
};

var IconLabel = function IconLabel(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-label",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M914.5 425.9A72.7 72.7 0 0 1 893.2 480.9L480.9 893.2A71.4 71.4 0 0 1 429.1 914.5H429.1A72.3 72.3 0 0 1 376.8 893.2L106.8 623.2A73.6 73.6 0 0 1 106.8 519.1L519.1 106.8A74.1 74.1 0 0 1 574.1 85.5L833.6 95.9A74.1 74.1 0 0 1 904.1 166.4ZM880.5 425.9L870 166.4A39.5 39.5 0 0 0 832.3 128.6L572.7 119.5H572.7A39.5 39.5 0 0 0 545 131.4L130.9 545.5A39.5 39.5 0 0 0 130.9 601.4L400.9 871.4A39.1 39.1 0 0 0 429.1 882.7 35.9 35.9 0 0 0 456.8 871.4L869.1 459.1A39.1 39.1 0 0 0 880.5 427.3ZM824.1 175.9A62.7 62.7 0 1 1 735.9 175.9 61.4 61.4 0 0 1 824.1 175.9ZM808.2 221.4A27.3 27.3 0 0 0 800 201.4 28.6 28.6 0 0 0 760 201.4 28.2 28.2 0 0 0 800 241.4 27.3 27.3 0 0 0 808.2 220Z"
  }));
};
IconLabel.defaultProps = {
  title: 'label'
};
IconLabel.propTypes = {
  title: PropTypes.string
};

var IconLeafSolid = function IconLeafSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-leaf-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M917.3 126.4C905 217.3 852.3 527.3 693.2 685.9A381.8 381.8 0 0 1 413.6 790.9 694.1 694.1 0 0 1 219.5 761.4 90.9 90.9 0 0 1 204.5 754.5 826.4 826.4 0 0 1 581.8 402.7 28.6 28.6 0 0 0 596.4 363.6 29.1 29.1 0 0 0 558.6 349.1 882.3 882.3 0 0 0 162.7 712.7 71.4 71.4 0 0 1 155.9 698.2C130.9 618.2 90.9 415.9 237.3 267.3 398.2 106.4 767.7 85.5 877.3 81.8H877.3A40.5 40.5 0 0 1 906.4 95 39.5 39.5 0 0 1 917.3 126.4ZM162.7 712.7A986.8 986.8 0 0 0 84.1 880 28.2 28.2 0 0 0 101.4 916.4 23.6 23.6 0 0 0 110.9 916.4 29.1 29.1 0 0 0 136.4 899.1 949.1 949.1 0 0 1 204.5 754.5 90.9 90.9 0 0 1 162.7 712.7Z"
  }));
};
IconLeafSolid.defaultProps = {
  title: 'leaf solid'
};
IconLeafSolid.propTypes = {
  title: PropTypes.string
};

var IconLeaf = function IconLeaf(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-leaf",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M903.2 99.5A45.5 45.5 0 0 0 868.6 84.5C758.6 87.7 387.3 109.1 224.5 272.7 73.6 422.7 116.8 627.7 142.3 708.6A101.8 101.8 0 0 0 157.7 738.2 950.9 950.9 0 0 0 86.4 892.3 16.8 16.8 0 0 0 96.4 914.1L102.3 914.1A17.3 17.3 0 0 0 118.2 902.7 950 950 0 0 1 181.8 762.7 112.7 112.7 0 0 0 207.7 775 690 690 0 0 0 403.6 805 389.5 389.5 0 0 0 687.3 698.6C848.6 538.2 901.8 227.3 914.5 136.4A45.5 45.5 0 0 0 903.2 99.5ZM664.5 674.5C524.5 814.5 306.4 768.6 219.1 742.3A64.5 64.5 0 0 1 200.5 733.2 834.5 834.5 0 0 1 568.6 400.5 16.8 16.8 0 1 0 555 369.5 863.6 863.6 0 0 0 177.7 705.5L174.5 698.6C150.9 623.2 110.9 433.6 248.6 295.9 402.3 142.3 762.7 121.4 869.5 118.6H869.5A9.5 9.5 0 0 1 877.3 122.3 10 10 0 0 1 880 131.4C868.6 220 818.2 521.8 664.5 674.5Z"
  }));
};
IconLeaf.defaultProps = {
  title: 'leaf'
};
IconLeaf.propTypes = {
  title: PropTypes.string
};

var IconLinkSolid = function IconLinkSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-link-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 710.5A33.6 33.6 0 0 1 500 758.6L409.1 849.5A159.1 159.1 0 0 1 181.8 849.5L149.1 818.2A159.5 159.5 0 0 1 149.1 590.9L333.6 409.1A159.5 159.5 0 0 1 560.9 409.1L577.7 425.9A34.1 34.1 0 0 1 577.7 474.1 34.1 34.1 0 0 1 529.5 474.1L510.9 454.5A90.9 90.9 0 0 0 381.8 454.5L197.3 640A90.9 90.9 0 0 0 197.3 769.1L230.9 802.7A90.9 90.9 0 0 0 360 802.7L450.9 711.8A34.1 34.1 0 0 1 500 710.5ZM850.9 181.8L818.2 149.1A159.5 159.5 0 0 0 590.9 149.1L500 240A33.6 33.6 0 0 0 500 288.2 34.1 34.1 0 0 0 548.2 288.2L639.1 197.3A90.9 90.9 0 0 1 768.2 197.3L801.8 230.9A90.9 90.9 0 0 1 801.8 360L618.2 545.5A90.9 90.9 0 0 1 489.1 545.5L472.3 528.6A34.1 34.1 0 0 0 424.1 576.8L440.9 590.9A159.1 159.1 0 0 0 668.2 590.9L850.9 409.1A159.5 159.5 0 0 0 850.9 181.8Z"
  }));
};
IconLinkSolid.defaultProps = {
  title: 'link solid'
};
IconLinkSolid.propTypes = {
  title: PropTypes.string
};

var IconLink = function IconLink(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-link",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M488.6 722.7A17.7 17.7 0 0 1 488.6 746.8L397.7 837.7A143.2 143.2 0 0 1 196.4 837.7L162.3 803.6A142.7 142.7 0 0 1 162.3 602.3L345.5 419.1A142.7 142.7 0 0 1 546.8 419.1L564.1 435.9A17.3 17.3 0 0 1 539.5 460.5L522.7 443.2A110.9 110.9 0 0 0 369.5 443.2L185 628.2A106.4 106.4 0 0 0 153.2 704.5 107.7 107.7 0 0 0 185 780.9L219.1 815A110.5 110.5 0 0 0 371.8 815L462.7 724.1A16.8 16.8 0 0 1 488.6 722.7ZM839.1 195L805 160.9A142.7 142.7 0 0 0 603.6 160.9L512.7 251.8A17.7 17.7 0 0 0 512.7 275.9 16.8 16.8 0 0 0 536.8 275.9L627.7 185A110.9 110.9 0 0 1 780.9 185L815 219.1A109.1 109.1 0 0 1 815 372.3L630 556.8A110.5 110.5 0 0 1 477.3 556.8L460 539.5A17.7 17.7 0 0 0 435.9 539.5 18.2 18.2 0 0 0 435.9 564.1L453.2 580.9A140.9 140.9 0 0 0 553.6 622.7 142.7 142.7 0 0 0 654.5 580.9L839.1 396.4A143.2 143.2 0 0 0 839.1 195Z"
  }));
};
IconLink.defaultProps = {
  title: 'link'
};
IconLink.propTypes = {
  title: PropTypes.string
};

var IconListSolid = function IconListSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-list-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M170.5 784.1A45.5 45.5 0 1 1 125 738.6 45.5 45.5 0 0 1 170.5 784.1ZM125 549.1A45.5 45.5 0 1 0 170.5 594.5 45.5 45.5 0 0 0 125 549.1ZM266.8 244.5H892.3A28.6 28.6 0 0 0 920.5 215.9 28.2 28.2 0 0 0 892.3 187.7H266.8A28.2 28.2 0 0 0 238.6 215.9 28.6 28.6 0 0 0 266.8 244.5ZM125 360A45.5 45.5 0 1 0 170.5 405.5 45.5 45.5 0 0 0 125 360ZM125 170.5A45.5 45.5 0 1 0 170.5 215.9 45.5 45.5 0 0 0 125 170.5ZM892.3 376.8H266.8A28.6 28.6 0 0 0 266.8 433.6H892.3A28.6 28.6 0 0 0 892.3 376.8ZM892.3 566.4H266.8A28.6 28.6 0 0 0 266.8 623.2H892.3A28.6 28.6 0 0 0 892.3 566.4ZM892.3 755.9H266.8A28.2 28.2 0 0 0 238.6 784.1 28.6 28.6 0 0 0 266.8 812.7H892.3A28.6 28.6 0 0 0 920.5 784.1 28.2 28.2 0 0 0 892.3 755.9Z"
  }));
};
IconListSolid.defaultProps = {
  title: 'list solid'
};
IconListSolid.propTypes = {
  title: PropTypes.string
};

var IconList = function IconList(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-list",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M159.1 784.1A34.1 34.1 0 1 1 125 750 34.5 34.5 0 0 1 159.1 784.1ZM125 371.4A34.1 34.1 0 1 0 159.1 405.5 34.1 34.1 0 0 0 125 371.4ZM266.8 235H891.8A16.8 16.8 0 0 0 909.1 215.9 17.3 17.3 0 0 0 891.8 198.6H266.8A16.8 16.8 0 0 0 250 215.9 16.4 16.4 0 0 0 266.8 232.7ZM125 560.5A34.1 34.1 0 1 0 159.1 594.5 34.5 34.5 0 0 0 125 560.5ZM891.8 577.7H266.8A17.3 17.3 0 0 0 266.8 611.8H891.8A17.3 17.3 0 1 0 891.8 577.7ZM125 181.8A34.1 34.1 0 1 0 159.1 215.9 34.5 34.5 0 0 0 125 181.8ZM891.8 388.2H266.8A17.3 17.3 0 0 0 266.8 422.3H891.8A17.3 17.3 0 1 0 891.8 388.2ZM891.8 766.8H266.8A16.8 16.8 0 0 0 250 784.1 16.4 16.4 0 0 0 266.8 800.9H891.8A16.8 16.8 0 0 0 909.1 784.1 17.3 17.3 0 0 0 891.8 766.8Z"
  }));
};
IconList.defaultProps = {
  title: 'list'
};
IconList.propTypes = {
  title: PropTypes.string
};

var IconLocationSolid = function IconLocationSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-location-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 959 959"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M485.8 481.9A644.4 644.4 0 0 0 647.1 612.6L652.3 612.6 657.1 612.6C667.5 607 911.5 481.9 911.5 261A261.4 261.4 0 1 0 392.2 261.4 286.3 286.3 0 0 0 403.9 342 379.1 379.1 0 0 0 485.8 481.9ZM653.6 170.8A91.1 91.1 0 1 1 561.7 261.4 90.6 90.6 0 0 1 653.6 170.8ZM87.1 335.1L282.8 261.4V925.9L114.6 990.4A49.7 49.7 0 0 1 96.7 993.5 47.1 47.1 0 0 1 68.8 984.7 49.7 49.7 0 0 1 47.1 943.8V394.3A63.6 63.6 0 0 1 87.1 335.1ZM676.3 650.1A650.5 650.5 0 0 0 798.7 563V864.5A63.2 63.2 0 0 1 757.7 923.7L566.4 999.1V610A570.4 570.4 0 0 0 628.8 649.2 56.6 56.6 0 0 0 654 655.3 54.5 54.5 0 0 0 677.1 650.1ZM485 545.5Q502.4 562.5 520.3 576.9V1002.2L326.4 925.5V261.4L348.6 268.8A405.7 405.7 0 0 0 485.8 545.5Z"
  }));
};
IconLocationSolid.defaultProps = {
  title: 'location solid'
};
IconLocationSolid.propTypes = {
  title: PropTypes.string
};

var IconLocation = function IconLocation(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-location",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 942 942"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M635.5 0A266 266 0 0 0 370.4 266C370.4 273.2 370.4 280.5 370.4 287.8L302.4 261.2H299.8L294.6 261.2 289.5 261.2H286.9L81.4 340A62.1 62.1 0 0 0 42.8 398.3V938.3A48.4 48.4 0 0 0 63.8 978.6 46.7 46.7 0 0 0 91.6 987.2 50.5 50.5 0 0 0 107.5 985H107.5L294.6 913.5 519.5 999.1A20.1 20.1 0 0 0 526.8 999.1H526.8A22.7 22.7 0 0 0 534.5 999.1L740.5 920.3A62.5 62.5 0 0 0 780.7 862.1V521.2A361 361 0 0 0 901.1 264.2 266 266 0 0 0 635.5 0ZM273.2 874.9L92.1 942.2A4.7 4.7 0 0 1 85.7 942.2 5.6 5.6 0 0 1 85.7 938.3V398.3A20.1 20.1 0 0 1 98.1 379.9L273.2 312.2ZM316.1 312.2L379.4 336.6A412.4 412.4 0 0 0 505.4 533.6V947.3L316.1 874.9ZM737.9 861.2A19.7 19.7 0 0 1 725.1 879.7L548.2 947.3V570A674.5 674.5 0 0 0 625.7 621 29.1 29.1 0 0 0 635.5 623.1 19.7 19.7 0 0 0 645.4 621 596.6 596.6 0 0 0 737.9 559.3ZM636 577.3C593.1 551.2 413.3 435.5 413.3 266A222.7 222.7 0 1 1 856.5 266C856.5 438.5 680.1 551.6 636 577.3ZM636 146.5A121.6 121.6 0 1 0 757.6 267.7 121.2 121.2 0 0 0 635.5 146.5ZM636 346.5A78.8 78.8 0 1 1 714.8 267.7 78.4 78.4 0 0 1 635.5 346.5Z"
  }));
};
IconLocation.defaultProps = {
  title: 'location'
};
IconLocation.propTypes = {
  title: PropTypes.string
};

var IconLockSolid = function IconLockSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-lock-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M749.5 409.1V334.5A249.5 249.5 0 1 0 249.5 334.5V409.1A120 120 0 0 0 139.5 528.6V797.3A119.5 119.5 0 0 0 259.1 916.8H740A119.5 119.5 0 0 0 859.5 797.3V526.4A120 120 0 0 0 749.5 409.1ZM500 772.7A29.1 29.1 0 0 1 470.9 743.6V580.5A29.1 29.1 0 0 1 479.5 560 27.3 27.3 0 0 1 500.5 551.4 29.1 29.1 0 0 1 529.5 580.5V745A29.5 29.5 0 0 1 500 772.7ZM692.7 404.1H307.3V334.5A192.7 192.7 0 0 1 692.7 334.5Z"
  }));
};
IconLockSolid.defaultProps = {
  title: 'lock solid'
};
IconLockSolid.propTypes = {
  title: PropTypes.string
};

var IconLock = function IconLock(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-lock",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M743.2 416.8H743.2V332.3A241.4 241.4 0 1 0 260.5 332.3V416.8H260.5A110 110 0 0 0 150.5 526.8V799.5A110 110 0 0 0 256.8 909.1H743.2A110 110 0 0 0 853.2 799.1V526.4A110 110 0 0 0 743.2 416.8ZM293.2 332.3A206.8 206.8 0 0 1 706.8 332.3V416.4H293.2ZM818.2 799.1A73.2 73.2 0 0 1 745 872.3H256.8A73.2 73.2 0 0 1 181.8 799.1V526.4A73.2 73.2 0 0 1 256.8 454.5H743.2A73.2 73.2 0 0 1 818.2 526.8ZM522.7 596.8V727.3A22.7 22.7 0 0 1 477.3 727.3V596.8A22.7 22.7 0 0 1 522.7 596.8Z"
  }));
};
IconLock.defaultProps = {
  title: 'lock'
};
IconLock.propTypes = {
  title: PropTypes.string
};

var IconLogoutSolid = function IconLogoutSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-logout-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M818.2 79.5H181.8A102.3 102.3 0 0 0 79.5 181.8V818.2A102.3 102.3 0 0 0 181.8 920.5H818.2A102.3 102.3 0 0 0 920.5 818.2V181.8A102.3 102.3 0 0 0 818.2 79.5ZM863.6 818.2A45.5 45.5 0 0 1 818.2 863.6H181.8A45.5 45.5 0 0 1 136.4 818.2V181.8A45.5 45.5 0 0 1 181.8 136.4H818.2A45.5 45.5 0 0 1 863.6 181.8ZM791.8 463.6A51.4 51.4 0 0 1 791.8 536.4L662.3 665.9A28.2 28.2 0 0 1 642.3 674.1 28.6 28.6 0 0 1 621.8 665.9 28.2 28.2 0 0 1 613.6 645.9 28.6 28.6 0 0 1 621.8 625.5L718.6 528.6H404.1A29.1 29.1 0 1 1 404.1 470.9H718.2L621.8 374.5A28.6 28.6 0 0 1 613.6 354.1 28.2 28.2 0 0 1 621.8 334.1 29.1 29.1 0 0 1 662.3 334.1Z"
  }));
};
IconLogoutSolid.defaultProps = {
  title: 'logout solid'
};
IconLogoutSolid.propTypes = {
  title: PropTypes.string
};

var IconLogout = function IconLogout(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-logout",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M818.2 90.9H181.8A90.9 90.9 0 0 0 90.9 181.8V818.2A90.9 90.9 0 0 0 181.8 909.1H818.2A90.9 90.9 0 0 0 909.1 818.2V181.8A90.9 90.9 0 0 0 818.2 90.9ZM875 818.2A56.8 56.8 0 0 1 818.2 875H181.8A56.8 56.8 0 0 1 125 818.2V181.8A56.8 56.8 0 0 1 181.8 125H818.2A56.8 56.8 0 0 1 875 181.8ZM784.1 471.8A38.2 38.2 0 0 1 795.9 500H795.9A38.2 38.2 0 0 1 784.1 528.2L654.5 657.7A16.8 16.8 0 0 1 630.5 633.6L746.4 517.3H404.1A17.3 17.3 0 0 1 391.4 511.8 16.8 16.8 0 0 1 386.4 500 17.3 17.3 0 0 1 404.1 482.7H745.9L630 366.4A16.8 16.8 0 1 1 654.1 342.3Z"
  }));
};
IconLogout.defaultProps = {
  title: 'logout'
};
IconLogout.propTypes = {
  title: PropTypes.string
};

var IconLostSolid = function IconLostSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-lost-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M510.9 412.3L479.1 295A11.4 11.4 0 0 1 483.2 283.2 11.8 11.8 0 0 1 495.9 283.2 157.7 157.7 0 0 0 641.8 286.4V156.4A30.5 30.5 0 0 0 580.9 156.4V188.6A23.2 23.2 0 0 1 558.2 211.4 22.7 22.7 0 0 1 535.5 188.6V156.4A75.9 75.9 0 0 1 687.3 156.4V283.2A158.6 158.6 0 0 0 833.6 283.2 11.8 11.8 0 0 1 846.4 283.2 10.9 10.9 0 0 1 850 295L818.2 412.3H510.9ZM119.5 306.8A45.5 45.5 0 0 1 141.8 246.4L296.4 174.5A45.5 45.5 0 0 1 356.8 196.4L457.3 412.3H169.1ZM172.3 306.8A34.1 34.1 0 1 0 206.4 272.7 34.1 34.1 0 0 0 172.3 307.3ZM886.4 514.5V727.3A193.6 193.6 0 0 1 693.2 920.5H306.8A193.6 193.6 0 0 1 113.6 727.3V514.5A57.3 57.3 0 0 1 170.5 457.7H829.5A57.3 57.3 0 0 1 886.4 514.5ZM554.5 835A40 40 0 0 0 475 835 40 40 0 1 0 554.5 835ZM614.5 600.5A93.6 93.6 0 0 0 519.5 504.5 98.2 98.2 0 0 0 428.6 567.3C428.6 572.7 425.5 577.7 424.1 583.2A25.5 25.5 0 0 0 427.7 600.5 24.1 24.1 0 0 0 442.7 610 23.6 23.6 0 0 0 468.2 590.9 55 55 0 0 1 468.2 582.7 52.3 52.3 0 0 1 517.3 549.5 48.2 48.2 0 0 1 566.8 600C566.8 620 539.5 645.5 529.1 654.5L523.2 660A97.3 97.3 0 0 0 490 728.2V744.1A22.7 22.7 0 0 0 512.7 766.8 22.7 22.7 0 0 0 535.5 744.1V727.3A53.2 53.2 0 0 1 555.5 691.4L560 686.8A136.4 136.4 0 0 0 614.5 600.5Z"
  }));
};
IconLostSolid.defaultProps = {
  title: 'lost solid'
};
IconLostSolid.propTypes = {
  title: PropTypes.string
};

var IconLost = function IconLost(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-lost",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M829.5 446.4H814.1L855.5 290.9A16.8 16.8 0 0 0 849.5 272.7 16.4 16.4 0 0 0 830.9 272.7 152.7 152.7 0 0 1 681.8 267.7V150.9A70.5 70.5 0 0 0 540.9 150.9V181.8A17.3 17.3 0 1 0 575 181.8V150A36.4 36.4 0 1 1 647.7 150V270A151.4 151.4 0 0 1 500 272.7 17.3 17.3 0 0 0 481.4 272.7 17.7 17.7 0 0 0 475 290.9L516.8 446.4H483.6L363.6 188.2A51.4 51.4 0 0 0 295.5 163.6L139.5 235.5A52.7 52.7 0 0 0 112.7 264.5 50.9 50.9 0 0 0 112.7 303.6L181.8 446.4H170.5A62.3 62.3 0 0 0 108.2 509.1V720.5A199.1 199.1 0 0 0 306.8 919.5H693.2A199.1 199.1 0 0 0 891.8 720.5V509.1A62.3 62.3 0 0 0 829.5 446.4ZM681.8 305.5A181.8 181.8 0 0 0 813.6 315.5L779.5 443.6S779.5 443.6 779.5 446.4H681.8ZM647.7 305.5V446.4H550A12.7 12.7 0 0 0 550 442.3L515.9 318.2A185.9 185.9 0 0 0 647.7 307.7ZM147.7 286.8A15.5 15.5 0 0 1 147.7 274.1 17.3 17.3 0 0 1 156.4 264.1L310.9 192.3A16.8 16.8 0 0 1 333.6 200.5L447.3 444.1H220ZM860.5 718.2A165.5 165.5 0 0 1 695.5 883.2H306.8A165.5 165.5 0 0 1 141.8 718.2V509.1A28.6 28.6 0 0 1 170.5 480.5H829.5A28.6 28.6 0 0 1 858.2 509.1ZM206.4 329.1A27.7 27.7 0 0 1 178.6 301.4 27.7 27.7 0 0 1 206.4 272.7 28.2 28.2 0 0 1 234.1 300.5 27.7 27.7 0 0 1 206.4 329.1ZM542.3 818.2A27.7 27.7 0 1 1 515 790.5 27.3 27.3 0 0 1 542.3 818.2ZM608.6 595A128.2 128.2 0 0 1 558.6 678.2L553.6 682.7A58.2 58.2 0 0 0 532.3 722.7V739.1A17.3 17.3 0 0 1 498.2 739.1V722.7A90.9 90.9 0 0 1 529.5 658.6L535.5 653.2C547.3 642.3 574.5 616.8 574.5 595A53.2 53.2 0 0 0 519.5 538.6 58.2 58.2 0 0 0 465 575.5L462.3 585A16.8 16.8 0 1 1 429.1 578.6 90.9 90.9 0 0 1 520 504.5 87.7 87.7 0 0 1 608.6 595Z"
  }));
};
IconLost.defaultProps = {
  title: 'lost'
};
IconLost.propTypes = {
  title: PropTypes.string
};

var IconLuggageAdditionalSolid = function IconLuggageAdditionalSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-luggage-additional-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M401.8 209.1H345A120.9 120.9 0 0 1 465.9 90.9H534.1A120.9 120.9 0 0 1 655 209.1H598.2A64.1 64.1 0 0 0 534.1 145.5H465.9A64.1 64.1 0 0 0 401.8 209.1ZM943.2 372.3V786.4A125 125 0 0 1 818.2 911.4H181.8A125 125 0 0 1 56.8 786.4V372.3A125 125 0 0 1 181.8 247.3H818.2A125 125 0 0 1 943.2 372.3ZM695 575A28.6 28.6 0 0 0 666.4 546.4H530V409.1A28.2 28.2 0 0 0 473.6 409.1V545.5H337.3A28.6 28.6 0 1 0 337.3 602.3H473.6V738.6A28.2 28.2 0 1 0 530 738.6V602.3H666.4A28.6 28.6 0 0 0 695 575Z"
  }));
};
IconLuggageAdditionalSolid.defaultProps = {
  title: 'luggage additional solid'
};
IconLuggageAdditionalSolid.propTypes = {
  title: PropTypes.string
};

var IconLuggageAdditional = function IconLuggageAdditional(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-luggage-additional",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M818.2 233.2H181.8A130.9 130.9 0 0 0 50.9 363.6V777.3A130.5 130.5 0 0 0 181.8 909.1H818.2A130.5 130.5 0 0 0 949.1 778.6V363.6A130.9 130.9 0 0 0 818.2 233.2ZM914.5 778.6A96.4 96.4 0 0 1 818.2 874.1H181.8A96.4 96.4 0 0 1 85.5 777.7V363.6A96.8 96.8 0 0 1 181.8 267.3H818.2A96.8 96.8 0 0 1 914.5 363.6ZM390.5 200.9H356.4A109.1 109.1 0 0 1 465.9 90.9H534.1A109.1 109.1 0 0 1 643.6 200H609.5A75.5 75.5 0 0 0 534.1 125H465.9A75.5 75.5 0 0 0 390.5 200.9ZM683.6 564.5A17.3 17.3 0 0 1 666.4 581.8H517.3V730.9A17.3 17.3 0 1 1 482.7 730.9V583.6H333.6A17.3 17.3 0 0 1 318.2 566.4 16.8 16.8 0 0 1 335.5 549.5H484.5V400A17.3 17.3 0 0 1 519.1 400V549.5H668.2A16.8 16.8 0 0 1 681.8 566.4Z"
  }));
};
IconLuggageAdditional.defaultProps = {
  title: 'luggage additional'
};
IconLuggageAdditional.propTypes = {
  title: PropTypes.string
};

var IconLuggageBulkySolid = function IconLuggageBulkySolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-luggage-bulky-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M405.5 206.8H348.6A118.2 118.2 0 0 1 466.8 90.9H533.2A118.2 118.2 0 0 1 651.4 209.1H594.5A61.4 61.4 0 0 0 533.2 145.5H466.8A61.4 61.4 0 0 0 405.5 206.8ZM943.2 372.7V786.4A125 125 0 0 1 818.2 911.4H181.8A125 125 0 0 1 56.8 786.4V372.7A125 125 0 0 1 181.8 247.7H818.2A125 125 0 0 1 943.2 372.7ZM526.8 700.5A27.3 27.3 0 0 0 522.3 679.1L447.3 571.8 513.6 478.6A27.3 27.3 0 0 0 518.6 457.3 28.6 28.6 0 0 0 467.3 446.8L411.4 529.1 354.5 446.8A26.4 26.4 0 0 0 336.4 435 28.2 28.2 0 0 0 314.5 440.5 28.6 28.6 0 0 0 302.7 458.6 28.2 28.2 0 0 0 307.7 479.5L373.2 570.5 298.2 681.8A29.5 29.5 0 0 0 293.6 703.2 31.4 31.4 0 0 0 305.9 721.4 28.6 28.6 0 0 0 321.4 725.9 28.2 28.2 0 0 0 345 713.6L409.1 615.9 473.6 712.3A28.6 28.6 0 0 0 514.5 718.6 27.7 27.7 0 0 0 526.8 700.5ZM743.6 704.1A26.8 26.8 0 0 0 716.8 677.3H615.5V454.5A27.3 27.3 0 0 0 590.9 427.7H588.2A27.3 27.3 0 0 0 561.4 454.5V703.2A27.7 27.7 0 0 0 589.5 730.9H719.1A26.4 26.4 0 0 0 743.6 704.1Z"
  }));
};
IconLuggageBulkySolid.defaultProps = {
  title: 'luggage bulky solid'
};
IconLuggageBulkySolid.propTypes = {
  title: PropTypes.string
};

var IconLuggageBulky = function IconLuggageBulky(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-luggage-bulky",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M818.2 233.6H181.8A130.9 130.9 0 0 0 50.9 363.6V777.3A130.9 130.9 0 0 0 181.8 909.1H818.2A130.9 130.9 0 0 0 949.1 778.2V363.6A130.9 130.9 0 0 0 818.2 233.6ZM914.5 779.1A96.8 96.8 0 0 1 818.2 874.5H181.8A96.8 96.8 0 0 1 85.5 777.7V363.6A96.4 96.4 0 0 1 181.8 267.7H818.2A96.4 96.4 0 0 1 914.5 363.6ZM394.1 198.2H360A106.8 106.8 0 0 1 466.8 90.9H533.2A106.8 106.8 0 0 1 640 197.7H605.9A72.7 72.7 0 0 0 533.2 125H466.8A72.7 72.7 0 0 0 394.1 198.2ZM513.2 677.3A16.8 16.8 0 0 1 508.6 700.9L508.6 700.9A16.8 16.8 0 0 1 485.5 696.4L409.1 586.8 335.5 697.3A16.4 16.4 0 0 1 312.3 701.8H312.3A16.8 16.8 0 0 1 307.7 678.2L387.3 563.6 318.2 464.5A16.8 16.8 0 0 1 322.3 441.4L322.3 441.4A16.8 16.8 0 0 1 345.9 445.5L411.8 541.4 477.3 445.5A16.8 16.8 0 0 1 500.5 440.9 16.8 16.8 0 0 1 505 464.5L433.6 563.6ZM732.3 695.9A15.5 15.5 0 0 1 716.8 711.4H587.3A17.3 17.3 0 0 1 570.5 694.5V446.4A15.5 15.5 0 0 1 585.9 430.9H590.9A15.5 15.5 0 0 1 606.4 446.4V681.8H719.1A15.5 15.5 0 0 1 732.3 695.9Z"
  }));
};
IconLuggageBulky.defaultProps = {
  title: 'luggage bulky'
};
IconLuggageBulky.propTypes = {
  title: PropTypes.string
};

var IconLuggageHandSolid = function IconLuggageHandSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-luggage-hand-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M459.1 222.7H402.3V198.2A77.7 77.7 0 0 1 483.6 124.5H516.4A77.7 77.7 0 0 1 597.7 198.2V222.7H540.9V198.2C540.9 190 530.9 181.4 516.4 181.4H483.6C470.5 181.4 459.1 189.1 459.1 198.2ZM326.8 517.3A27.7 27.7 0 0 1 353.6 496.4 28.6 28.6 0 0 1 381.8 525V554.5A261.8 261.8 0 0 0 618.2 554.5V525A28.6 28.6 0 0 1 646.4 496.4 27.7 27.7 0 0 1 673.2 517.3 255.9 255.9 0 0 0 745.9 411.8L753.2 391.4 746.4 345.9A110 110 0 0 0 636.4 251.8H363.6A110 110 0 0 0 253.6 345.9L246.8 391.4 254.1 411.8A255.9 255.9 0 0 0 326.8 517.3ZM808.2 748.2L768.6 491.8A321.8 321.8 0 0 1 675 586.8V641.4A28.6 28.6 0 0 1 618.2 641.4V615.9A322.3 322.3 0 0 1 500 639.5 322.3 322.3 0 0 1 381.8 615.9V641.4A28.6 28.6 0 0 1 325 641.4V586.8A321.8 321.8 0 0 1 231.4 491.8L191.8 748.2A110 110 0 0 0 301.4 875.5H698.6A110 110 0 0 0 808.2 748.2Z"
  }));
};
IconLuggageHandSolid.defaultProps = {
  title: 'luggage hand solid'
};
IconLuggageHandSolid.propTypes = {
  title: PropTypes.string
};

var IconLuggageHand = function IconLuggageHand(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-luggage-hand",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M813.6 738.6L764.1 414.1H764.1L759.5 385 752.3 339.5H752.3V339.5A115.5 115.5 0 0 0 636.4 237.7H363.6A115.5 115.5 0 0 0 248.2 336.4V336.4H248.2L240.9 381.8 236.4 410.9H236.4L186.4 738.6A116.8 116.8 0 0 0 213.2 832.3 115.5 115.5 0 0 0 301.4 872.7H698.6A115.5 115.5 0 0 0 786.8 832.3 116.8 116.8 0 0 0 813.6 738.6ZM281.8 341.4A81.4 81.4 0 0 1 363.6 272.7H636.4A81.4 81.4 0 0 1 718.2 341.4L727.3 411.4A272.7 272.7 0 0 1 661.8 516.4 17.3 17.3 0 1 0 627.7 516.4V545.5A223.6 223.6 0 0 1 368.6 545.5V517.7A17.3 17.3 0 1 0 334.5 517.7 272.7 272.7 0 0 1 272.7 411.4ZM760.9 810A81.4 81.4 0 0 1 698.6 838.6H301.4A82.3 82.3 0 0 1 220 744.1L259.5 485.9 259.5 472.3A300 300 0 0 0 334.5 563.2V634.1A17.3 17.3 0 0 0 368.6 634.1V584.5A257.3 257.3 0 0 0 627.7 584.5V632.7A17.3 17.3 0 0 0 661.8 632.7V561.8A294.5 294.5 0 0 0 736.8 470.9L736.8 477.7 777.3 742.7A81.4 81.4 0 0 1 760.9 810ZM457.7 214.1H423.6V189.5A62.3 62.3 0 0 1 485.9 127.3H514.1A62.7 62.7 0 0 1 576.4 189.5V214.1H542.3V189.5A28.2 28.2 0 0 0 514.1 161.4H485.9A28.2 28.2 0 0 0 457.7 189.5Z"
  }));
};
IconLuggageHand.defaultProps = {
  title: 'luggage hand'
};
IconLuggageHand.propTypes = {
  title: PropTypes.string
};

var IconLuggageSolid = function IconLuggageSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-luggage-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 979 979"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M819.3 866.5A89 89 0 0 1 730.3 959.5H725.4V972A28 28 0 1 1 669.8 972V959.5H311.5V972A28 28 0 1 1 255.9 972V959.5H250.1A89 89 0 0 1 161.1 866.5L176.7 498 178.9 498A887 887 0 0 0 321.3 530.9V560.7A28 28 0 0 0 376.9 560.7V538.1C413.4 541.6 450.8 543.4 489.5 543.4S567 543.4 604.8 538.1V560.7A28 28 0 0 0 660.4 560.7V534A979.1 979.1 0 0 0 805.1 504.7H805.1ZM194.5 445L178 440.6 186 253.2A159.3 159.3 0 0 1 343.6 102.8H368.9A127.7 127.7 0 0 1 494.9 0 117 117 0 0 1 610.1 102.8H635.5A157.5 157.5 0 0 1 793.5 253.2L801.1 445 787.7 448.6A1125.9 1125.9 0 0 1 489.5 489.5 951.5 951.5 0 0 1 194.5 445ZM426.3 102.8H553.6A61 61 0 0 0 494.9 55.6 73.4 73.4 0 0 0 426.3 102.8ZM292.8 225.2A28 28 0 0 0 320.9 253.2H529.6V275A28 28 0 1 0 585.2 275V253.2H657.3A28 28 0 1 0 657.3 197.6H321.8A28 28 0 0 0 293.7 225.2Z"
  }));
};
IconLuggageSolid.defaultProps = {
  title: 'luggage solid'
};
IconLuggageSolid.propTypes = {
  title: PropTypes.string
};

var IconLuggage = function IconLuggage(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-luggage",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 990 990"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M540.1 244.8H325.4A22.5 22.5 0 0 1 325.4 199.8H664.7A22.5 22.5 0 0 1 664.7 244.8H585.1V272.7A23 23 0 0 1 562.6 295.2 22.5 22.5 0 0 1 540.1 272.7ZM827.2 870.4A90 90 0 0 1 802 936.5 90 90 0 0 1 735.8 964.4H725V977.5A22.5 22.5 0 0 1 702.5 1000 23 23 0 0 1 680 977.5V964.4H308.7V977.5A23 23 0 0 1 286.2 1000 22.5 22.5 0 0 1 263.7 977.5V964.4H252.9A90 90 0 0 1 186.8 936.5 90 90 0 0 1 161.6 870.4L187.7 250.2A160.7 160.7 0 0 1 347.4 98.6H378.5A124.7 124.7 0 0 1 500.5 0 113.4 113.4 0 0 1 611.6 98.6H642.7A158.9 158.9 0 0 1 802.4 250.2ZM422.1 98.6H562.6A67.1 67.1 0 0 0 500.5 45 80.1 80.1 0 0 0 425.3 98.6ZM225 455A922.6 922.6 0 0 0 495 495 1080.1 1080.1 0 0 0 765.1 461.7L757.4 252A113.9 113.9 0 0 0 642.7 143.6H347.4A115.2 115.2 0 0 0 232.7 252ZM784.4 872.2L769.1 505.4A957.2 957.2 0 0 1 661.1 526.1S661.1 528.4 661.1 529.3V562.1A22.5 22.5 0 0 1 638.6 584.6 22.5 22.5 0 0 1 616.1 562.1V531.5A1208.8 1208.8 0 0 1 495 540.1 1135.9 1135.9 0 0 1 375.8 533.8V564.4A22.5 22.5 0 0 1 353.3 586.9 22.5 22.5 0 0 1 330.8 564.4V531.5S330.8 528.8 330.8 527.5A873.5 873.5 0 0 1 223.2 503.6L207.5 874.4A45 45 0 0 0 220.1 907.7 45 45 0 0 0 253.8 921.7H737.2A45 45 0 0 0 770.9 907.3 45 45 0 0 0 783.5 872.2Z"
  }));
};
IconLuggage.defaultProps = {
  title: 'luggage'
};
IconLuggage.propTypes = {
  title: PropTypes.string
};

var IconMagnifierSolid = function IconMagnifierSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-magnifier-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M909.1 848.2L719.5 670A357.7 357.7 0 0 0 174.1 205.5 358.2 358.2 0 0 0 437.3 809.1H448.6A358.2 358.2 0 0 0 675.9 720.5L863.6 898.2A34.5 34.5 0 0 0 886.8 907.3 35.5 35.5 0 0 0 911.8 896.8 35 35 0 0 0 909.1 848.2ZM446.4 740.5A290 290 0 0 1 428.6 160.9H437.7A290 290 0 0 1 446.4 740.5Z"
  }));
};
IconMagnifierSolid.defaultProps = {
  title: 'magnifier solid'
};
IconMagnifierSolid.propTypes = {
  title: PropTypes.string
};

var IconMagnifier = function IconMagnifier(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-magnifier",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M902.3 856.8L704.5 670.9A346.4 346.4 0 0 0 185 213.2 343.6 343.6 0 0 0 90.9 461.4 347.3 347.3 0 0 0 437.3 797.7H448.2A345.5 345.5 0 0 0 675.5 706.8L872.7 892.7A22.7 22.7 0 0 0 888.2 898.6 22.3 22.3 0 0 0 905 891.4 22.3 22.3 0 0 0 902.3 856.8ZM447.7 751.8A301.4 301.4 0 0 1 428.2 149.5H437.7A301.4 301.4 0 0 1 446.8 751.8Z"
  }));
};
IconMagnifier.defaultProps = {
  title: 'magnifier'
};
IconMagnifier.propTypes = {
  title: PropTypes.string
};

var IconMapSolid = function IconMapSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-map-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M395.9 100.9L604.1 181.8V899.1L395.9 818.2ZM90.9 235.9V852.3A45.5 45.5 0 0 0 109.5 887.7 41.8 41.8 0 0 0 133.6 895 45.5 45.5 0 0 0 149.1 892.3L339.1 818.2V100.9L128.6 181.8A58.6 58.6 0 0 0 90.9 235.9ZM890.5 112.3A45.5 45.5 0 0 0 850.9 107.7L660.9 181.8V899.1L871.4 818.2A58.6 58.6 0 0 0 909.1 763.6V147.7A45.5 45.5 0 0 0 890.5 112.3Z"
  }));
};
IconMapSolid.defaultProps = {
  title: 'map solid'
};
IconMapSolid.propTypes = {
  title: PropTypes.string
};

var IconMap = function IconMap(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-map",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M893.6 107.7A45.5 45.5 0 0 0 848.2 102.3L632.7 185 373.6 85.9H363.6L128.6 176.8A63.6 63.6 0 0 0 87.7 236.4V852.3A48.6 48.6 0 0 0 108.6 892.3 49.1 49.1 0 0 0 135.9 900.5 45.5 45.5 0 0 0 153.2 897.3L369.5 814.5 628.6 913.6A15.9 15.9 0 0 0 635 913.6H635A14.1 14.1 0 0 0 640.9 913.6L875.9 822.7A64.5 64.5 0 0 0 916.8 762.7V147.3A45.5 45.5 0 0 0 893.6 107.7ZM350.5 784.5L138.6 863.6A13.6 13.6 0 0 1 125.5 863.6 14.1 14.1 0 0 1 119.1 851.8V235.5A30 30 0 0 1 138.6 207.7L350.5 126.8ZM615.5 873.2L384.5 784.5V126.8L615.5 215ZM880.9 764.1A30 30 0 0 1 861.4 791.8L649.5 873.2V215L863.6 136.4A13.6 13.6 0 0 1 876.8 136.4 14.1 14.1 0 0 1 883.2 148.2Z"
  }));
};
IconMap.defaultProps = {
  title: 'map'
};
IconMap.propTypes = {
  title: PropTypes.string
};

var IconMeatball = function IconMeatball(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-meatball",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M829.5 500A56.8 56.8 0 1 1 772.7 443.2 56.8 56.8 0 0 1 829.5 500ZM500 443.2A56.8 56.8 0 1 0 556.8 500 56.8 56.8 0 0 0 500 443.2ZM227.3 443.2A56.8 56.8 0 1 0 284.1 500 56.8 56.8 0 0 0 227.3 443.2Z"
  }));
};
IconMeatball.defaultProps = {
  title: 'meatball'
};
IconMeatball.propTypes = {
  title: PropTypes.string
};

var IconMenWomenSolid = function IconMenWomenSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-men-women-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M156.4 174.1A106.4 106.4 0 1 1 262.3 280.5 106.4 106.4 0 0 1 156.4 174.1ZM333.2 381.8A74.5 74.5 0 0 0 191.8 381.8L106.4 636.4A74.1 74.1 0 0 0 176.8 734.5H181.8V904.5A27.3 27.3 0 0 0 209.1 931.8H318.2A27.3 27.3 0 0 0 345.5 904.5V734.1H350A74.1 74.1 0 0 0 418.6 636.4ZM883.6 363.6A74.1 74.1 0 0 0 823.2 332.7H651.8A74.1 74.1 0 0 0 581.4 430.9L655 650V904.5A27.3 27.3 0 0 0 682.3 931.8H790A27.3 27.3 0 0 0 817.3 904.5V656.8L893.6 429.5A74.1 74.1 0 0 0 883.6 363.6ZM736.4 280.5A106.4 106.4 0 1 0 630 174.1 106.4 106.4 0 0 0 736.4 280.5ZM500 124.1A22.7 22.7 0 0 0 477.3 146.8V853.2A22.7 22.7 0 0 0 522.7 853.2V146.8A22.7 22.7 0 0 0 500 124.1Z"
  }));
};
IconMenWomenSolid.defaultProps = {
  title: 'men women solid'
};
IconMenWomenSolid.propTypes = {
  title: PropTypes.string
};

var IconMenWomen = function IconMenWomen(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-men-women",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M262.3 285.9A111.8 111.8 0 1 0 150.9 174.1 111.8 111.8 0 0 0 262.3 285.9ZM262.3 96.8A77.7 77.7 0 1 1 185 174.1 77.7 77.7 0 0 1 262.3 96.8ZM338.2 380A80 80 0 0 0 186.4 380L100.9 636.4A77.7 77.7 0 0 0 111.8 708.6 79.5 79.5 0 0 0 175.9 742.3V904.5A32.7 32.7 0 0 0 208.6 937.3H318.2A32.7 32.7 0 0 0 350.9 904.5V740A79.5 79.5 0 0 0 415 706.4 80.5 80.5 0 0 0 424.1 636.4ZM383.6 686.4A45.5 45.5 0 0 1 346.4 705.9H332.3A16.8 16.8 0 0 0 315 722.7L315 904.5 208.6 904.5V722.7A16.8 16.8 0 0 0 191.4 705.9H176.8A45.5 45.5 0 0 1 139.5 686.4 45.5 45.5 0 0 1 133.2 645L218.6 390.9A45.5 45.5 0 0 1 305.9 390.9L391.8 645A45.5 45.5 0 0 1 385.5 686.4ZM888.2 359.1A78.2 78.2 0 0 0 823.2 325.5H651.8A80.5 80.5 0 0 0 575.9 431.4L649.5 649.5V904.5A32.7 32.7 0 0 0 682.3 937.3H790A32.7 32.7 0 0 0 822.7 904.5V657.7L899.1 430.5A77.7 77.7 0 0 0 888.2 359.1ZM866.8 420.5L789.5 647.7A22.7 22.7 0 0 0 789.5 653.2L789.5 901.4 681.8 904.5V646.8A22.7 22.7 0 0 0 681.8 641.4L608.2 420.5A45.5 45.5 0 0 1 614.5 378.6 45.5 45.5 0 0 1 651.8 359.5H823.2A45.5 45.5 0 0 1 860.5 378.6 45.5 45.5 0 0 1 866.8 420.5ZM736.4 284.1A111.8 111.8 0 1 0 624.5 172.3 111.8 111.8 0 0 0 736.4 285.9ZM736.4 95A77.7 77.7 0 0 1 736.4 250 77.7 77.7 0 1 1 736.4 95ZM517.3 145V853.2A17.3 17.3 0 1 1 482.7 853.2V146.8A17.3 17.3 0 0 1 517.3 146.8Z"
  }));
};
IconMenWomen.defaultProps = {
  title: 'men women'
};
IconMenWomen.propTypes = {
  title: PropTypes.string
};

var IconMinus = function IconMinus(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-minus",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M923.2 470.5H76.8A29.1 29.1 0 0 0 55.9 520.5 30.9 30.9 0 0 0 76.8 529.1H923.2A29.5 29.5 0 0 0 954.5 500 30 30 0 0 0 923.2 470.5Z"
  }));
};
IconMinus.defaultProps = {
  title: 'minus'
};
IconMinus.propTypes = {
  title: PropTypes.string
};

var IconMountainsSolid = function IconMountainsSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-mountains-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1140 1140"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M186.8 818.2A90.9 90.9 0 0 0 181.8 897.3H34.1A33.6 33.6 0 0 1 4.5 880 35 35 0 0 1 4.5 845.9L272.7 380.5A35.5 35.5 0 0 1 331.8 380.5L385.5 471.4ZM1136.4 845.9L842.7 339.5 786.4 385A28.2 28.2 0 0 1 756.8 389.5L720.5 373.2 654.1 451.8A29.1 29.1 0 0 1 633.2 461.4H633.2A27.3 27.3 0 0 1 612.3 452.3L521.4 353.2 418.6 530 236.8 848.2A35 35 0 0 0 236.8 882.3 33.6 33.6 0 0 0 266.4 899.5H1105.5A33.6 33.6 0 0 0 1135 882.3 35 35 0 0 0 1136.4 845.9ZM691.4 321.8A27.7 27.7 0 0 1 724.1 314.5L763.6 331.8 813.6 289.5 715 118.6A35 35 0 0 0 702.3 106.8 24.1 24.1 0 0 0 696.8 106.8 32.3 32.3 0 0 0 685.5 104.1H685.5A32.3 32.3 0 0 0 674.1 106.8 24.1 24.1 0 0 0 668.6 106.8 35 35 0 0 0 655.9 118.6L550.5 300.5 631.8 391.4Z"
  }));
};
IconMountainsSolid.defaultProps = {
  title: 'mountains solid'
};
IconMountainsSolid.propTypes = {
  title: PropTypes.string
};

var IconMountains = function IconMountains(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-mountains",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1151 1151"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M1145.5 843.2L727.3 115.9A40.9 40.9 0 0 0 658.6 115.9L424.5 518.2 343.2 377.7A41.4 41.4 0 0 0 272.7 377.7L5.5 843.2A38.6 38.6 0 0 0 5.5 882.7 39.1 39.1 0 0 0 40 902.7H1110.9A39.1 39.1 0 0 0 1145.5 882.7 38.6 38.6 0 0 0 1145.5 843.2ZM686.4 132.7A5.9 5.9 0 0 1 691.4 130 5.5 5.5 0 0 1 695.9 132.7L803.2 318.2 772.7 345 727.3 325A17.3 17.3 0 0 0 707.3 329.1L636.4 409.1 570 334.1ZM231.8 868.6H40A5.5 5.5 0 0 1 35 865.9 6.4 6.4 0 0 1 35 860L303.6 394.5C306.8 390 310.5 390 313.6 394.5L404.5 552.3 236.8 843.2A38.2 38.2 0 0 0 232.3 868.6ZM1115.5 865.9A5.5 5.5 0 0 1 1110.5 868.6H272.7A5.9 5.9 0 0 1 267.7 865.9 6.4 6.4 0 0 1 267.7 860L552.3 363.6 625.5 443.2A17.7 17.7 0 0 0 636.4 450H636.4A16.8 16.8 0 0 0 648.6 444.1L720.9 360.9 766.4 380.5A16.8 16.8 0 0 0 784.1 380.5L819.5 350.5 1115 862.3A5.5 5.5 0 0 1 1115.9 865.9Z"
  }));
};
IconMountains.defaultProps = {
  title: 'mountains'
};
IconMountains.propTypes = {
  title: PropTypes.string
};

var IconNewTabSolid = function IconNewTabSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-new-tab-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M818.2 79.5H181.8A102.3 102.3 0 0 0 79.5 181.8V818.2A102.3 102.3 0 0 0 181.8 920.5H818.2A102.3 102.3 0 0 0 920.5 818.2V181.8A102.3 102.3 0 0 0 818.2 79.5ZM863.6 818.2A45.5 45.5 0 0 1 818.2 863.6H181.8A45.5 45.5 0 0 1 136.4 818.2V181.8A45.5 45.5 0 0 1 181.8 136.4H818.2A45.5 45.5 0 0 1 863.6 181.8ZM791.8 208.2A52.3 52.3 0 0 1 806.8 244.5V426.4A28.6 28.6 0 0 1 778.2 455 28.6 28.6 0 0 1 749.5 426.4V290L527.3 513.6A28.6 28.6 0 0 1 486.4 513.6 29.5 29.5 0 0 1 486.4 472.7L708.6 250.5H572.3A28.6 28.6 0 1 1 572.3 193.2H754.1A52.3 52.3 0 0 1 790.5 208.2L782.3 216.4Z"
  }));
};
IconNewTabSolid.defaultProps = {
  title: 'new tab solid'
};
IconNewTabSolid.propTypes = {
  title: PropTypes.string
};

var IconNewTab = function IconNewTab(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-new-tab",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M818.2 90.9H181.8A90.9 90.9 0 0 0 90.9 181.8V818.2A90.9 90.9 0 0 0 181.8 909.1H818.2A90.9 90.9 0 0 0 909.1 818.2V181.8A90.9 90.9 0 0 0 818.2 90.9ZM875 818.2A56.8 56.8 0 0 1 818.2 875H181.8A56.8 56.8 0 0 1 125 818.2V181.8A56.8 56.8 0 0 1 181.8 125H818.2A56.8 56.8 0 0 1 875 181.8ZM783.6 216.4H783.6A39.5 39.5 0 0 0 755.5 204.5H573.6A17.3 17.3 0 0 0 573.6 239.1H736.4L494.5 480.9A17.3 17.3 0 0 0 494.5 505.5 16.4 16.4 0 0 0 519.1 505.5L760.9 263.6V427.7A17.3 17.3 0 0 0 795.5 427.7V245.9A39.5 39.5 0 0 0 783.6 216.4Z"
  }));
};
IconNewTab.defaultProps = {
  title: 'new tab'
};
IconNewTab.propTypes = {
  title: PropTypes.string
};

var IconNewsletterSolid = function IconNewsletterSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-newsletter-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M863.6 193.2H136.4A69.5 69.5 0 0 0 68.2 262.7V737.3A69.5 69.5 0 0 0 136.4 806.8H863.6A69.5 69.5 0 0 0 933.2 737.3V262.7A69.5 69.5 0 0 0 863.6 193.2ZM625 490L766.8 623.2A19.5 19.5 0 0 1 766.8 650.5 20 20 0 0 1 752.3 656.4 18.6 18.6 0 0 1 739.1 651.4L594.5 515 565.9 540A101.4 101.4 0 0 1 500.5 563.6 102.7 102.7 0 0 1 434.5 540L403.6 512.7 256.8 649.1A20 20 0 0 1 243.6 654.1 19.1 19.1 0 0 1 227.3 650.5 20 20 0 0 1 227.3 622.7L370.9 486.4 108.2 256.4A39.1 39.1 0 0 1 132.7 230.5L457.7 513.6A67.3 67.3 0 0 0 542.3 513.6Q704.5 371.8 867.3 230.5A39.1 39.1 0 0 1 891.8 255.9Z"
  }));
};
IconNewsletterSolid.defaultProps = {
  title: 'newsletter solid'
};
IconNewsletterSolid.propTypes = {
  title: PropTypes.string
};

var IconNewsletter = function IconNewsletter(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-newsletter",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M863.6 193.2H136.4A69.5 69.5 0 0 0 68.2 262.7V737.3A69.5 69.5 0 0 0 136.4 806.8H863.6A69.5 69.5 0 0 0 933.2 737.3V262.7A69.5 69.5 0 0 0 863.6 193.2ZM146.8 227.3H853.2A37.7 37.7 0 0 1 867.7 230L542.3 513.6A66.4 66.4 0 0 1 458.2 513.6L132.7 230.5A36.8 36.8 0 0 1 146.8 227.3ZM894.1 731.4A40.9 40.9 0 0 1 853.2 772.3H146.8A40.9 40.9 0 0 1 105.9 731.4V268.6A34.5 34.5 0 0 1 105.9 256.4L371.8 488.2 228.2 624.5A19.1 19.1 0 0 0 228.2 651.8 18.6 18.6 0 0 0 242.3 658.2 19.1 19.1 0 0 0 255.5 652.7L402.3 516.4 433.2 543.6A101.8 101.8 0 0 0 499.1 567.3 99.5 99.5 0 0 0 564.5 543.2L593.2 518.6 737.7 655A20.9 20.9 0 0 0 750.9 660 18.2 18.2 0 0 0 765 654.1 19.1 19.1 0 0 0 765 626.8L623.6 493.6 891.8 260A45.5 45.5 0 0 1 891.8 271.8Z"
  }));
};
IconNewsletter.defaultProps = {
  title: 'newsletter'
};
IconNewsletter.propTypes = {
  title: PropTypes.string
};

var IconNightSolid = function IconNightSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-night-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M898.2 842.3A481.8 481.8 0 0 1 417.3 945.9 500 500 0 0 1 99.1 395 481.8 481.8 0 0 1 429.1 31.4 35 35 0 0 1 468.6 83.2 464.5 464.5 0 0 0 409.1 245.9 459.1 459.1 0 0 0 875.5 782.3H875.5A34.1 34.1 0 0 1 907.3 803.6 35 35 0 0 1 898.2 842.3Z"
  }));
};
IconNightSolid.defaultProps = {
  title: 'night solid'
};
IconNightSolid.propTypes = {
  title: PropTypes.string
};

var IconNight = function IconNight(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-night",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M911.8 801.4A42.3 42.3 0 0 0 872.7 776.4 450 450 0 0 1 702.3 749.1 454.5 454.5 0 0 1 412.3 249.1H412.3A454.5 454.5 0 0 1 474.1 87.7 41.4 41.4 0 0 0 474.1 42.3 40.9 40.9 0 0 0 428.6 28.6 487.3 487.3 0 0 0 93.6 394.1 505.5 505.5 0 0 0 415.5 951.4 493.6 493.6 0 0 0 570.5 976.4 486.4 486.4 0 0 0 901.8 846.4 40.5 40.5 0 0 0 911.8 801.4ZM878.6 821.4A454.5 454.5 0 0 1 426.4 919.1 469.5 469.5 0 0 1 127.3 400.9 454.5 454.5 0 0 1 437.7 57.7H437.7A6.4 6.4 0 0 1 442.3 60 6.8 6.8 0 0 1 442.3 67.3 483.6 483.6 0 0 0 378.6 240.9 490.5 490.5 0 0 0 690.9 780.9 478.2 478.2 0 0 0 872.7 810.5C878.2 810.5 878.2 812.7 878.6 814.5A5.5 5.5 0 0 1 878.6 821.4Z"
  }));
};
IconNight.defaultProps = {
  title: 'night'
};
IconNight.propTypes = {
  title: PropTypes.string
};

var IconNotificationSolid = function IconNotificationSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-notification-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M710.5 387.3A210.5 210.5 0 0 0 289.5 387.3V670H710.5ZM551.4 136.4A51.4 51.4 0 0 0 448.6 136.4V142.3H551.4ZM796.8 727.3H203.2A61.4 61.4 0 0 0 198.6 750 79.1 79.1 0 0 0 281.8 823.2H403.6A96.4 96.4 0 0 0 596.4 823.2H718.6A79.1 79.1 0 0 0 801.4 749.5 61.4 61.4 0 0 0 796.8 727.3Z"
  }));
};
IconNotificationSolid.defaultProps = {
  title: 'notification solid'
};
IconNotificationSolid.propTypes = {
  title: PropTypes.string
};

var IconNotification = function IconNotification(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-notification",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M718.6 681.8H704.5V387.3A204.5 204.5 0 1 0 295.5 387.3V681.8H281.4A73.2 73.2 0 0 0 204.1 750 73.6 73.6 0 0 0 281.4 818.2H409.1A90.9 90.9 0 0 0 590.9 818.2H718.6A73.6 73.6 0 0 0 795.9 750 73.2 73.2 0 0 0 718.6 681.8ZM329.5 387.3A170.5 170.5 0 1 1 670.5 387.3V681.8H329.5ZM718.6 783.6H281.4A40.5 40.5 0 0 1 235.9 749.5 40 40 0 0 1 281.4 715.5H718.6A40 40 0 0 1 764.1 749.5 40.5 40.5 0 0 1 718.6 783.6ZM500 90.9A45.5 45.5 0 0 0 454.5 136.4H545.5A45.5 45.5 0 0 0 500 90.9Z"
  }));
};
IconNotification.defaultProps = {
  title: 'notification'
};
IconNotification.propTypes = {
  title: PropTypes.string
};

var IconOfferSolid = function IconOfferSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-offer-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 90.9A409.1 409.1 0 1 0 909.1 500 409.1 409.1 0 0 0 500 90.9ZM695.9 529.1H529.5V695.5A29.5 29.5 0 1 1 470.9 695.5V529.5H304.1A30.9 30.9 0 0 1 283.2 520.9 29.1 29.1 0 0 1 304.1 470.9H470.5V304.1A30.9 30.9 0 0 1 479.1 283.2 29.1 29.1 0 0 1 500 272.7 30 30 0 0 1 529.1 302.3V468.6H695.5A30 30 0 0 1 727.3 500 29.5 29.5 0 0 1 695.9 529.1Z"
  }));
};
IconOfferSolid.defaultProps = {
  title: 'offer solid'
};
IconOfferSolid.propTypes = {
  title: PropTypes.string
};

var IconOffer = function IconOffer(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-offer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 79.5A420.5 420.5 0 1 0 920.5 500 420.9 420.9 0 0 0 500 79.5ZM500 875A375 375 0 1 1 875 500 375.5 375.5 0 0 1 500 875ZM702.7 477.3H520.9V295.5A22.7 22.7 0 1 0 475.5 295.5V477.3H293.6A22.7 22.7 0 1 0 293.6 522.7H475.5V704.5A22.7 22.7 0 0 0 520.9 704.5V522.7H702.7A22.7 22.7 0 0 0 702.7 477.3Z"
  }));
};
IconOffer.defaultProps = {
  title: 'offer'
};
IconOffer.propTypes = {
  title: PropTypes.string
};

var IconPartnerSolid = function IconPartnerSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-partner-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M784.5 235A80.5 80.5 0 0 0 859.5 150.5 80 80 0 0 0 784.5 65.9 80 80 0 0 0 710 150.5 80.5 80.5 0 0 0 784.5 235ZM860 257.3A39.5 39.5 0 0 0 822.7 263.2 60.5 60.5 0 0 1 744.5 263.2 39.5 39.5 0 0 0 707.3 257.3 139.1 139.1 0 0 0 619.1 386.4V429.5A37.3 37.3 0 0 0 655.9 466.8H911.4A36.4 36.4 0 0 0 947.7 430V384.5A136.4 136.4 0 0 0 860 257.3ZM446.4 445.5C540 445.5 616.4 354.5 616.4 247.3S540 48.6 446.4 48.6 276.4 136.4 276.4 247.3 352.7 445.5 446.4 445.5ZM630 480.5H630A55.9 55.9 0 0 0 576.4 489.1 208.2 208.2 0 0 1 444.5 537.7 210.9 210.9 0 0 1 311.4 489.1 55.9 55.9 0 0 0 257.7 480.5 322.7 322.7 0 0 0 53.2 779.1V894.5A51.8 51.8 0 0 0 105 946.4H782.3A50.9 50.9 0 0 0 833.2 895.5V779.1A318.2 318.2 0 0 0 630 480.5Z"
  }));
};
IconPartnerSolid.defaultProps = {
  title: 'partner solid'
};
IconPartnerSolid.propTypes = {
  title: PropTypes.string
};

var IconPartner = function IconPartner(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-partner",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M784.5 235A80.5 80.5 0 0 0 859.5 150.5 80 80 0 0 0 784.5 65.9 80 80 0 0 0 710 150.5 80.5 80.5 0 0 0 784.5 235ZM784.5 98.6A48.6 48.6 0 0 1 827.7 151.4 48.6 48.6 0 0 1 784.5 204.1 48.6 48.6 0 0 1 741.8 151.4 48.6 48.6 0 0 1 784.5 97.7ZM860 257.3A39.5 39.5 0 0 0 822.7 263.2 60.5 60.5 0 0 1 744.5 263.2 39.5 39.5 0 0 0 707.3 257.3 139.1 139.1 0 0 0 619.1 386.4V429.5A37.3 37.3 0 0 0 655.9 466.8H911.4A36.4 36.4 0 0 0 947.7 430V384.5A136.4 136.4 0 0 0 860 257.3ZM913.2 430L913.2 430 655.5 427.7V386.4A100.5 100.5 0 0 1 722.7 290.5 99.1 99.1 0 0 0 847.7 290.5 102.7 102.7 0 0 1 913.2 386.4ZM446.4 445.5C540 445.5 616.4 354.5 616.4 247.3S540 48.6 446.4 48.6 276.4 136.4 276.4 247.3 352.7 445.5 446.4 445.5ZM446.4 90.9C516.8 90.9 574.5 160.9 574.5 247.7S516.8 404.1 446.4 404.1 318.2 333.6 318.2 247.3 375.5 90.9 446.4 90.9ZM630 480.5H630A55.9 55.9 0 0 0 576.4 489.1 208.2 208.2 0 0 1 444.5 537.7 210.9 210.9 0 0 1 311.4 489.1 55.9 55.9 0 0 0 257.7 480.5 322.7 322.7 0 0 0 53.2 779.1V894.5A51.8 51.8 0 0 0 105 946.4H782.3A50.9 50.9 0 0 0 833.2 895.5V779.1A318.2 318.2 0 0 0 630 480.5ZM791.8 895.5A10 10 0 0 1 782.3 905H105A10.5 10.5 0 0 1 94.5 894.5V779.1A280 280 0 0 1 272.7 519.5 6.8 6.8 0 0 1 276.8 519.5 12.7 12.7 0 0 1 285.5 522.7 248.2 248.2 0 0 0 603.6 522.7 11.4 11.4 0 0 1 615.9 520.5 275.9 275.9 0 0 1 792.7 780Z"
  }));
};
IconPartner.defaultProps = {
  title: 'partner'
};
IconPartner.propTypes = {
  title: PropTypes.string
};

var IconPassportSolid = function IconPassportSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-passport-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 601.4C507.7 601.4 527.3 572.7 533.2 517.3H466.8C472.7 572.7 492.3 601.4 500 601.4ZM727.3 205H394.1L666.8 109.5A15 15 0 0 1 670.5 117.7V157.7A23.6 23.6 0 0 0 694.5 181.8 24.1 24.1 0 0 0 718.6 157.7V117.7A61.8 61.8 0 0 0 694.1 69.1 45.5 45.5 0 0 0 654.5 62.7L275.9 195A87.7 87.7 0 0 0 247.3 214.1 45.5 45.5 0 0 0 227.3 253.6V890A48.6 48.6 0 0 0 275.9 938.6H727.3A48.6 48.6 0 0 0 772.7 890.9V254.5A48.6 48.6 0 0 0 727.3 205ZM500 318.2A165.9 165.9 0 1 1 334.1 484.1 166.4 166.4 0 0 1 500 318.2ZM590.9 828.6H409.1A24.5 24.5 0 0 1 409.1 781.8H590.9A24.5 24.5 0 0 1 590.9 830.5ZM658.2 752.7H340A24.5 24.5 0 0 1 340 704.1H658.2A24.5 24.5 0 0 1 658.2 752.7ZM387.3 517.3A119.1 119.1 0 0 0 432.7 580.9 297.7 297.7 0 0 1 420 517.3ZM615.9 469.1A117.3 117.3 0 0 0 570.5 390.9 302.3 302.3 0 0 1 584.1 469.1ZM430.9 390.9A117.3 117.3 0 0 0 385.5 469.1H418.6A302.3 302.3 0 0 1 430.9 390.9ZM500 370.5C491.8 370.5 469.5 404.5 465.9 469.1H534.1C530.5 404.5 508.2 370.5 500 370.5ZM612.7 517.3H581.8A297.7 297.7 0 0 1 569.1 580.9 119.1 119.1 0 0 0 612.7 517.3Z"
  }));
};
IconPassportSolid.defaultProps = {
  title: 'passport solid'
};
IconPassportSolid.propTypes = {
  title: PropTypes.string
};

var IconPassport = function IconPassport(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-passport",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M735.9 186.8H356.8L685.9 78.6A22.7 22.7 0 0 1 694.1 95V136.4A17.3 17.3 0 0 0 727.3 136.4V95A55.9 55.9 0 0 0 704.5 49.5 35.5 35.5 0 0 0 672.3 45.5L257.3 184.1A56.8 56.8 0 0 0 244.5 190.9H244.5L235.5 196.8A45.5 45.5 0 0 0 225.9 205.9L223.2 209.5A45.5 45.5 0 0 0 217.3 219.5 45.5 45.5 0 0 0 213.6 237.3H213.6V905.5A50.9 50.9 0 0 0 264.1 954.5H735.9A50.9 50.9 0 0 0 786.8 903.6V237.3A50.9 50.9 0 0 0 735.9 186.8ZM752.7 905.5A16.4 16.4 0 0 1 735.9 922.3H264.1A16.4 16.4 0 0 1 247.3 905.5V236.4A20.9 20.9 0 0 1 257.7 221.8 14.5 14.5 0 0 1 264.1 221.8H735.9A16.8 16.8 0 0 1 752.7 238.6ZM500 646.8A165.9 165.9 0 1 0 334.5 480.9 165.9 165.9 0 0 0 500 646.8ZM500 612.7C480.5 612.7 454.5 572.7 449.1 505.5H550.9C545.5 572.7 519.5 612.7 500 612.7ZM630.9 471.8H585.5A253.6 253.6 0 0 0 562.7 365.9 131.4 131.4 0 0 1 630.9 471.8ZM585.5 505.5H630.9A130.5 130.5 0 0 1 564.5 596.4 254.1 254.1 0 0 0 585 505.5ZM500 349.5C520.9 349.5 549.5 395 551.8 471.8H448.2C450.5 395.9 479.1 349.5 500 349.5ZM437.3 365.9A253.6 253.6 0 0 0 414.5 471.8H369.1A131.4 131.4 0 0 1 437.3 365.9ZM415 505.5A254.1 254.1 0 0 0 437.3 596.4 130.5 130.5 0 0 1 370.9 505.5ZM684.1 736.8A17.3 17.3 0 0 1 666.8 754.1H333.2A17.3 17.3 0 1 1 333.2 720H666.8A17.3 17.3 0 0 1 684.1 736.8ZM613.6 818.2A17.3 17.3 0 0 1 596.8 835H403.2A17.3 17.3 0 0 1 386.4 818.2 16.8 16.8 0 0 1 403.2 801.4H596.8A16.8 16.8 0 0 1 613.6 818.2Z"
  }));
};
IconPassport.defaultProps = {
  title: 'passport'
};
IconPassport.propTypes = {
  title: PropTypes.string
};

var IconPauseSolid = function IconPauseSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-pause-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 90.9A409.1 409.1 0 1 0 909.1 500 409.1 409.1 0 0 0 500 90.9ZM409.1 727.3A29.5 29.5 0 0 1 380 697.7V304.1A30 30 0 0 1 388.6 283.2 29.1 29.1 0 0 1 438.6 304.1V695.9A30 30 0 0 1 409.1 727.3ZM590.9 727.3A29.5 29.5 0 0 1 561.8 697.7V304.1A30 30 0 0 1 570.5 283.2 29.1 29.1 0 0 1 620.5 304.1V695.9A30 30 0 0 1 590.9 727.3Z"
  }));
};
IconPauseSolid.defaultProps = {
  title: 'pause solid'
};
IconPauseSolid.propTypes = {
  title: PropTypes.string
};

var IconPause = function IconPause(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-pause",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 79.5A420.5 420.5 0 1 0 920.5 500 420.9 420.9 0 0 0 500 79.5ZM500 875A375 375 0 1 1 875 500 375.5 375.5 0 0 1 500 875ZM613.6 297.3V702.7A22.7 22.7 0 0 1 568.2 702.7V297.3A22.7 22.7 0 1 1 613.6 297.3ZM431.8 297.3V702.7A22.7 22.7 0 0 1 386.4 702.7V297.3A22.7 22.7 0 1 1 431.8 297.3Z"
  }));
};
IconPause.defaultProps = {
  title: 'pause'
};
IconPause.propTypes = {
  title: PropTypes.string
};

var IconPersonSolid = function IconPersonSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-person-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M341.4 247.3C341.4 142.3 413.6 56.8 503.2 56.8S665 142.3 665 247.3 590.9 437.7 503.2 437.7 341.4 352.3 341.4 247.3ZM685 491.8H685A45.5 45.5 0 0 0 639.5 499.1 220.5 220.5 0 0 1 360 499.1 45.5 45.5 0 0 0 314.5 491.8 315.5 315.5 0 0 0 114.5 784.1V900.5A42.7 42.7 0 0 0 157.3 943.2H839.1A41.8 41.8 0 0 0 880.9 901.4V784.1A310.5 310.5 0 0 0 685 491.8Z"
  }));
};
IconPersonSolid.defaultProps = {
  title: 'person solid'
};
IconPersonSolid.propTypes = {
  title: PropTypes.string
};

var IconPerson = function IconPerson(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-person",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M503.2 443.6C412.3 443.6 335.5 355.5 335.5 247.3S409.1 50.9 503.2 50.9 670.5 139.1 670.5 247.3 595.5 443.6 503.2 443.6ZM503.2 85.5C429.5 85.5 369.5 158.2 369.5 247.3S429.5 409.1 503.2 409.1 636.4 336.8 636.4 247.3 576.8 85.5 503.2 85.5ZM841.8 949.1H159.1A48.6 48.6 0 0 1 110.5 900.5V784.1A320.9 320.9 0 0 1 314.5 486.4 51.4 51.4 0 0 1 364.5 494.5 214.1 214.1 0 0 0 637.3 494.5 52.3 52.3 0 0 1 687.7 486.4H687.7A318.2 318.2 0 0 1 890 784.1V901.4A45.5 45.5 0 0 1 841.8 949.1ZM332.3 517.3L326.8 517.3A286.8 286.8 0 0 0 145 783.2V899.5A14.1 14.1 0 0 0 159.5 913.6H841.4A13.2 13.2 0 0 0 855 900.5V784.1A282.7 282.7 0 0 0 673.2 518.2 17.7 17.7 0 0 0 656.4 521.4 249.1 249.1 0 0 1 341.4 521.4 16.4 16.4 0 0 0 332.3 517.3Z"
  }));
};
IconPerson.defaultProps = {
  title: 'person'
};
IconPerson.propTypes = {
  title: PropTypes.string
};

var IconPhoneSolid = function IconPhoneSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-phone-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M229.5 890.9A102.3 102.3 0 0 0 331.8 993.2H668.2A102.3 102.3 0 0 0 772.7 890.9V848.6H229.5ZM502.3 870A45.5 45.5 0 1 1 456.8 915.5 45.5 45.5 0 0 1 500 870ZM772.7 109.1V127.3H229.5V109.1A102.3 102.3 0 0 1 331.8 6.8H668.2A102.3 102.3 0 0 1 772.7 109.1ZM229.5 184.1H772.7V791.8H229.5Z"
  }));
};
IconPhoneSolid.defaultProps = {
  title: 'phone solid'
};
IconPhoneSolid.propTypes = {
  title: PropTypes.string
};

var IconPhoneTabletSolid = function IconPhoneTabletSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-phone-tablet-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M601.8 244.5A108.2 108.2 0 0 0 494.1 352.7V699.1H105V215H686.8V244.5ZM686.8 153.6A85.5 85.5 0 0 0 601.4 68.2H192.3A85.5 85.5 0 0 0 105 153.2V158.2H686.8ZM105 755.9H494.1V863.6H190A85 85 0 0 1 105 778.6ZM357.3 809.1A38.6 38.6 0 1 0 395.9 772.7 38.6 38.6 0 0 0 357.3 809.1ZM844.1 301.4H601.8A51.4 51.4 0 0 0 550.9 352.7V367.3H895V352.7A51.4 51.4 0 0 0 844.1 301.4ZM550.9 767.3H895V424.1H550.9ZM550.9 824.1H895V880.9A51.4 51.4 0 0 1 844.1 932.3H601.8A51.4 51.4 0 0 1 550.9 880.9V824.1ZM681.8 878.2A40.9 40.9 0 1 0 722.7 837.3 40.9 40.9 0 0 0 681.8 878.2Z"
  }));
};
IconPhoneTabletSolid.defaultProps = {
  title: 'phone tablet solid'
};
IconPhoneTabletSolid.propTypes = {
  title: PropTypes.string
};

var IconPhoneTablet = function IconPhoneTablet(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-phone-tablet",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M367.3 805.9A34.1 34.1 0 1 1 401.4 840 34.1 34.1 0 0 1 367.3 805.9ZM912.7 358.2V886.8A62.3 62.3 0 0 1 850 949.1H607.7A62.3 62.3 0 0 1 545.5 891.4H195.9A108.6 108.6 0 0 1 87.7 783.2V158.6A108.2 108.2 0 0 1 195.9 50.9H607.3A107.7 107.7 0 0 1 715 158.6V295H851.4A62.3 62.3 0 0 1 912.3 358.2ZM125.5 136.4H677.7A74.5 74.5 0 0 0 607.3 84.1H198.2A74.1 74.1 0 0 0 125.5 136.4ZM545.5 759.1H121.8V783.2A74.1 74.1 0 0 0 195.9 857.3H545.5ZM607.7 295.9H681.8V171.4H121.8V727.3H545.5V358.2A62.3 62.3 0 0 1 607.7 295.9ZM880.5 827.3H579.1V886.8A28.6 28.6 0 0 0 607.7 915H849.5A28.6 28.6 0 0 0 878.2 886.8ZM880.5 418.2H579.1V793.2H878.2ZM880.5 358.2A28.6 28.6 0 0 0 851.8 330H607.7A28.6 28.6 0 0 0 579.1 358.2V384.1H878.2ZM727.3 905.9A34.1 34.1 0 0 0 727.3 837.7 34.1 34.1 0 0 0 727.3 905.9Z"
  }));
};
IconPhoneTablet.defaultProps = {
  title: 'phone tablet'
};
IconPhoneTablet.propTypes = {
  title: PropTypes.string
};

var IconPhone = function IconPhone(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-phone",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M668.2 0H331.8A108.2 108.2 0 0 0 224.1 109.1V890.9A108.2 108.2 0 0 0 331.8 1000H668.2A108.2 108.2 0 0 0 775.9 891.8V109.1A108.2 108.2 0 0 0 668.2 0ZM331.8 35H668.2A74.1 74.1 0 0 1 741.8 109.1V138.6H258.2V109.1A74.1 74.1 0 0 1 331.8 35ZM740.9 171.4V814.1H258.2V172.7ZM668.2 965H331.8A74.1 74.1 0 0 1 258.2 890.9V848.2H741.8V890.9A74.1 74.1 0 0 1 668.2 965ZM534.1 909.1A34.1 34.1 0 1 1 500 872.7 34.5 34.5 0 0 1 534.1 909.1Z"
  }));
};
IconPhone.defaultProps = {
  title: 'phone'
};
IconPhone.propTypes = {
  title: PropTypes.string
};

var IconPinSolid = function IconPinSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-pin-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 15.9A409.1 409.1 0 0 0 90.9 425C90.9 566.8 160.9 708.6 293.2 834.1A1009.1 1009.1 0 0 0 494.5 982.7 11.4 11.4 0 0 0 500 982.7 9.1 9.1 0 0 0 505 982.7 960.9 960.9 0 0 0 706.8 836.4C839.1 711.8 909.1 569.5 909.1 427.3A409.1 409.1 0 0 0 500 15.9ZM500 576.4A151.8 151.8 0 1 1 651.4 424.5 151.8 151.8 0 0 1 500 576.4Z"
  }));
};
IconPinSolid.defaultProps = {
  title: 'pin solid'
};
IconPinSolid.propTypes = {
  title: PropTypes.string
};

var IconPin = function IconPin(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-pin",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 10A415.5 415.5 0 0 0 85.5 425.5C85.5 770.9 475.5 979.5 494.5 988.2A17.3 17.3 0 0 0 510 988.2C526.8 979.5 919.1 777.3 919.1 425.5A415.5 415.5 0 0 0 500 10ZM500 954.5C445 923.2 119.1 727.3 119.1 426.4A380.9 380.9 0 1 1 880.9 426.4C880.9 729.5 555 923.2 500 954.5ZM500 245A181.8 181.8 0 1 0 681.8 426.8 181.8 181.8 0 0 0 500 245ZM500 570.5A145.9 145.9 0 1 1 645.9 424.5 145.9 145.9 0 0 1 500 570.5Z"
  }));
};
IconPin.defaultProps = {
  title: 'pin'
};
IconPin.propTypes = {
  title: PropTypes.string
};

var IconPlaneSolid = function IconPlaneSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-plane-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M709.1 422.7L748.2 764.1A36.4 36.4 0 0 1 739.1 791.8L707.3 823.2A24.1 24.1 0 0 1 668.2 818.2L605 691.8H605A28.6 28.6 0 0 1 570.9 691.8L561.8 682.3A23.6 23.6 0 0 1 555 665 25 25 0 0 1 561.4 647.7L574.5 633.2 545.5 571.4C500 610 450.9 647.7 409.1 678.6L365.9 713.2V822.3A32.3 32.3 0 0 1 356.4 847.7L347.3 857.3A21.8 21.8 0 0 1 331.8 863.6 22.7 22.7 0 0 1 311.4 850.5L253.6 745.5 147.7 686.8A22.3 22.3 0 0 1 141.4 651.4L155.5 639.1A42.3 42.3 0 0 1 176.4 632.7H285.9L318.2 590.9C349.5 551.4 387.3 503.2 425.5 454.5L367.3 425 352.3 440A25 25 0 0 1 334.5 446.8 26.4 26.4 0 0 1 318.2 440.5L309.1 430.9A24.1 24.1 0 0 1 302.3 413.2 22.7 22.7 0 0 1 309.1 395.9H309.1L181.8 333.2A25.5 25.5 0 0 1 168.2 315.5 24.1 24.1 0 0 1 175.5 295L212.3 259.5A45.5 45.5 0 0 1 233.6 252.7L577.3 291.8C659.1 214.1 748.6 136.4 809.1 136.4A55 55 0 0 1 849.1 152.3C902.7 205.9 810.5 314.5 709.1 422.7Z"
  }));
};
IconPlaneSolid.defaultProps = {
  title: 'plane solid'
};
IconPlaneSolid.propTypes = {
  title: PropTypes.string
};

var IconPlane = function IconPlane(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-plane",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M341.4 830.9ZM578.2 670H578.2ZM714.5 431.8L750.9 750A48.6 48.6 0 0 1 737.3 789.5L707.3 820A34.5 34.5 0 0 1 676.4 831.8 39.5 39.5 0 0 1 643.6 810.5L590.9 703.6 582.3 703.6A40.5 40.5 0 0 1 553.6 692.7L545.5 685A39.1 39.1 0 0 1 534.5 656.8 40 40 0 0 1 545.5 628.6L550 623.6 535 593.6C495.5 626.4 455.9 657.3 422.3 684.5L387.3 712.3V808.6A47.7 47.7 0 0 1 373.2 845L364.5 853.6A37.3 37.3 0 0 1 304.5 843.2L252.7 746.4 155.5 692.7A37.3 37.3 0 0 1 135.9 665.5 37.7 37.7 0 0 1 145.9 633.2L163.6 618.2A57.3 57.3 0 0 1 190.9 610.5H287.7L314.1 576.8C341.4 541.8 372.7 501.8 405 462.7L376.4 448.2 370.5 454.5A40.5 40.5 0 0 1 342.3 465.5 40 40 0 0 1 314.1 454.5L305 445.5A40.9 40.9 0 0 1 294.1 417.3 61.8 61.8 0 0 1 294.1 407.7L190.5 355A37.7 37.7 0 0 1 181.8 292.7L221.4 255.5A60.9 60.9 0 0 1 249.1 247.7L571.4 284.1C652.3 206.8 735 136.4 798.6 136.4A69.1 69.1 0 0 1 848.6 156.4C905.9 217.3 818.2 325.5 716.8 431.8ZM681.8 420.5L687.3 415C780.9 318.2 863.6 219.1 821.8 179.1A35.5 35.5 0 0 0 795 169.1C742.3 169.1 655.9 245.9 586.4 312.7L580.9 318.2 245 280A25 25 0 0 0 236.4 283.6L202.7 318.2A5.9 5.9 0 0 0 202.7 323.2 6.4 6.4 0 0 0 207.3 328.2L343.6 395.5 328.6 411.4A9.1 9.1 0 0 0 328.6 417.3C328.6 420 328.6 421.8 328.6 422.3L337.7 431.4A6.8 6.8 0 0 0 347.7 431.4L370.5 408.6 456.8 451.8 443.6 467.7C406.8 513.2 370.9 558.6 341.4 595L303.6 642.7H190.9A21.4 21.4 0 0 0 183.6 642.7L181.8 646.8 170.9 656.8A5.5 5.5 0 0 0 170.9 660S170.9 662.3 170.9 662.7L170.9 662.7 277.3 721.4 328.6 812.3 335 826.4C335 829.1 338.6 830.5 340.5 830H340.5L340.5 830 349.5 820.9 354.5 818.2H354.5A19.1 19.1 0 0 0 354.5 809.1V695.5L402.3 658.2C440 628.6 485.9 592.3 530 555.9L545.9 542.7 591.4 629.1 573.6 648.6S569.1 653.6 569.5 656.8 569.5 660.9 569.5 661.8L577.7 670H577.7A13.6 13.6 0 0 0 586.4 670L590 670 603.6 657.3 613.6 676.4 674.1 797.3A7.7 7.7 0 0 0 680 800.9L680 800.9 684.1 800.9 714.5 770.9A18.6 18.6 0 0 0 718.6 756.4Z"
  }));
};
IconPlane.defaultProps = {
  title: 'plane'
};
IconPlane.propTypes = {
  title: PropTypes.string
};

var IconPlaySolid = function IconPlaySolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-play-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 90.9A409.1 409.1 0 1 0 909.1 500 409.1 409.1 0 0 0 500 90.9ZM651.4 564.5L469.5 665.9A70.9 70.9 0 0 1 433.6 675.5 72.3 72.3 0 0 1 396.4 665 73.6 73.6 0 0 1 360 601.4V398.6A73.6 73.6 0 0 1 469.5 334.1L651.4 435.5A73.6 73.6 0 0 1 651.4 564.5Z"
  }));
};
IconPlaySolid.defaultProps = {
  title: 'play solid'
};
IconPlaySolid.propTypes = {
  title: PropTypes.string
};

var IconPlay = function IconPlay(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-play",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 79.5A420.5 420.5 0 1 0 920.5 500 420.9 420.9 0 0 0 500 79.5ZM500 875A375 375 0 1 1 875 500 375.5 375.5 0 0 1 500 875ZM648.6 440.5L466.8 339.1A68.2 68.2 0 0 0 363.6 398.6V601.4A68.6 68.6 0 0 0 431.8 669.5 65.9 65.9 0 0 0 465 660.9L646.8 559.5A68.2 68.2 0 0 0 646.8 440.5ZM626.4 520L444.5 621.4A21.8 21.8 0 0 1 422.3 621.4 21.8 21.8 0 0 1 409.1 601.4V398.6A21.8 21.8 0 0 1 420.5 379.1 20.5 20.5 0 0 1 431.8 375.9 21.8 21.8 0 0 1 442.7 378.6L624.5 480A22.7 22.7 0 0 1 624.5 520Z"
  }));
};
IconPlay.defaultProps = {
  title: 'play'
};
IconPlay.propTypes = {
  title: PropTypes.string
};

var IconPlus = function IconPlus(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-plus",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M529.5 923.2V529.5H923.2A29.5 29.5 0 0 0 954.5 500 30 30 0 0 0 925 470.5H529.5V76.8A30 30 0 0 0 500 45.5 29.1 29.1 0 0 0 479.1 54.1 30.9 30.9 0 0 0 470.5 75V468.6H76.8A29.1 29.1 0 0 0 55.9 518.6 30.9 30.9 0 0 0 76.8 527.3H470.5V920.9A29.5 29.5 0 1 0 529.1 920.9Z"
  }));
};
IconPlus.defaultProps = {
  title: 'plus'
};
IconPlus.propTypes = {
  title: PropTypes.string
};

var IconProfileSolid = function IconProfileSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-profile-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 85.5A415 415 0 1 0 914.5 500 414.5 414.5 0 0 0 500 85.5ZM503.2 198.6C591.4 198.6 662.7 283.2 662.7 386.8S590.9 575 503.2 575 343.2 490.5 343.2 386.8 415 198.6 503.2 198.6ZM500 858.2A357.7 357.7 0 0 1 207.7 705.9 300.9 300.9 0 0 1 321.4 626.4 45.5 45.5 0 0 1 364.5 633.6 214.1 214.1 0 0 0 637.3 633.6 45.5 45.5 0 0 1 682.7 626.4H682.7A291.4 291.4 0 0 1 795.5 704.5 358.2 358.2 0 0 1 500 858.2Z"
  }));
};
IconProfileSolid.defaultProps = {
  title: 'profile solid'
};
IconProfileSolid.propTypes = {
  title: PropTypes.string
};

var IconProfile = function IconProfile(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-profile",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M503.2 202.7C415.9 202.7 345.5 285.9 345.5 388.2S415.9 574.1 503.2 574.1 660.9 490.9 660.9 388.2 590.9 202.7 503.2 202.7ZM500 90.9A409.1 409.1 0 1 0 909.1 500 409.1 409.1 0 0 0 500 90.9ZM198.6 721.8C206.4 732.3 214.1 742.3 222.7 751.8 214.1 742.3 206.4 732.3 198.6 721.8ZM681.8 626.8H681.8A45.5 45.5 0 0 0 636.4 634.1 214.1 214.1 0 0 1 363.6 634.1 45.5 45.5 0 0 0 320.5 626.8 306.4 306.4 0 0 0 195.5 717.7 374.5 374.5 0 1 1 804.1 717.7 301.8 301.8 0 0 0 681.8 626.8Z"
  }));
};
IconProfile.defaultProps = {
  title: 'profile'
};
IconProfile.propTypes = {
  title: PropTypes.string
};

var IconPublicSolid = function IconPublicSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-public-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M239.5 528.2A538.6 538.6 0 0 0 330.5 821.8 363.6 363.6 0 0 1 136.4 528.2ZM330.5 178.2A363.6 363.6 0 0 0 136.4 471.8H239.5A538.6 538.6 0 0 1 331.8 178.2ZM863.6 471.8A363.6 363.6 0 0 0 668.2 178.2 535 535 0 0 1 759.1 471.8ZM705 471.8C695 288.6 603.2 136.4 500 136.4S305 288.6 296.4 471.8ZM295.9 528.2C305 711.4 396.8 863.6 500 863.6S695 711.4 703.6 528.2ZM920.5 500A420.5 420.5 0 1 1 500 79.5 420.9 420.9 0 0 1 920.5 500ZM897.7 500A397.7 397.7 0 1 0 500 897.7 398.2 398.2 0 0 0 897.7 500ZM668.2 821.8A363.6 363.6 0 0 0 863.6 528.2H760.5A535 535 0 0 1 668.2 821.8Z"
  }));
};
IconPublicSolid.defaultProps = {
  title: 'public solid'
};
IconPublicSolid.propTypes = {
  title: PropTypes.string
};

var IconPublic = function IconPublic(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-public",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 90.9A409.1 409.1 0 1 0 909.1 500 409.1 409.1 0 0 0 500 90.9ZM874.1 482.7H749.5A490.5 490.5 0 0 0 626.4 147.3 375.5 375.5 0 0 1 874.1 482.7ZM500 875C386.4 875 290 712.7 284.5 517.3H715.5C710 712.7 613.6 875 500 875ZM284.5 482.7C290 287.3 386.4 125 500 125S710 287.3 715.5 482.7ZM375.5 147.3A490.5 490.5 0 0 0 252.3 482.7H125.9A375.5 375.5 0 0 1 373.6 147.3ZM125.9 517.3H250.5A490.5 490.5 0 0 0 373.6 852.7 375.5 375.5 0 0 1 125.9 517.3ZM625.9 852.7A490.5 490.5 0 0 0 749.1 517.3H873.6A375.5 375.5 0 0 1 626.4 852.7Z"
  }));
};
IconPublic.defaultProps = {
  title: 'public'
};
IconPublic.propTypes = {
  title: PropTypes.string
};

var IconQAndASolid = function IconQAndASolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-q-and-a-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1019 1019"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M1018.6 342.3V710.5A80 80 0 0 1 937.7 789.5H885.5A11.8 11.8 0 0 0 873.6 800.9V875A34.1 34.1 0 0 1 854.1 905.9 32.3 32.3 0 0 1 839.5 909.1 35.9 35.9 0 0 1 817.3 901.4L685 792.3A12.3 12.3 0 0 0 677.3 789.5H376.8A80 80 0 0 1 297.7 722.7L357.3 674.1H641.4A136.4 136.4 0 0 0 777.7 537.7V265H936.8A80 80 0 0 1 1018.6 342.3ZM333.6 620L296.4 650.5 200.9 727.3A35.5 35.5 0 0 1 164.1 731.8 34.5 34.5 0 0 1 144.5 700.9V628.6A11.4 11.4 0 0 0 132.7 617.3H80.5A79.5 79.5 0 0 1 0 538.2V170A79.5 79.5 0 0 1 80.5 90.9H641.4A79.5 79.5 0 0 1 721.8 170V538.2A79.5 79.5 0 0 1 641.4 617.3H341.4A12.3 12.3 0 0 0 333.6 620ZM305.9 235A57.7 57.7 0 0 1 360.5 198.6 52.3 52.3 0 0 1 415 254.1C415 275.9 384.5 304.1 372.7 315L365.9 321.4A114.1 114.1 0 0 0 327.3 401.4V420A28.6 28.6 0 1 0 384.1 420V401.4A58.2 58.2 0 0 1 405.9 363.6L411.4 358.6A156.8 156.8 0 0 0 471.8 255.9 109.1 109.1 0 0 0 360.5 141.8 115 115 0 0 0 252.7 215.5 86.8 86.8 0 0 0 247.7 234.1 28.2 28.2 0 1 0 303.6 244.1 66.4 66.4 0 0 1 305.9 235ZM359.5 572.7A45.5 45.5 0 1 0 314.1 527.3 45.5 45.5 0 0 0 359.5 572.7Z"
  }));
};
IconQAndASolid.defaultProps = {
  title: 'q and a solid'
};
IconQAndASolid.propTypes = {
  title: PropTypes.string
};

var IconQAndA = function IconQAndA(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-q-and-a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1030 1030"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M363.6 550A34.1 34.1 0 1 1 363.6 481.8 34.1 34.1 0 0 1 363.6 550ZM432.3 263.2C432.3 289.5 400 319.5 386.8 332.3L380 338.6A102.3 102.3 0 0 0 344.1 409.1V427.7A17.3 17.3 0 1 0 378.2 427.7V409.1A69.1 69.1 0 0 1 403.6 363.6L409.1 357.3A145.5 145.5 0 0 0 466.4 263.2 98.2 98.2 0 0 0 365.9 162.3 103.2 103.2 0 0 0 269.1 227.3 96.4 96.4 0 0 0 264.5 243.6 17.3 17.3 0 0 0 298.2 250 42.7 42.7 0 0 1 300.9 239.1 69.1 69.1 0 0 1 365.9 193.6 64.5 64.5 0 0 1 432.3 263.2ZM943.6 257.7H790.5A16.8 16.8 0 0 0 772.7 272.7 17.3 17.3 0 0 0 790 290H943.2A50.9 50.9 0 0 1 995.5 342.3V710.5A51.4 51.4 0 0 1 943.6 761.4H891.4A40 40 0 0 0 850.9 800.9V875A5.9 5.9 0 0 1 847.7 880 6.4 6.4 0 0 1 840.9 880L708.6 772.7A40.9 40.9 0 0 0 682.7 763.6H382.7A51.8 51.8 0 0 1 330.5 712.7V712.7A15.9 15.9 0 0 0 313.6 696.8 18.2 18.2 0 0 0 296.4 714.5 85.9 85.9 0 0 0 382.7 799.5H681.8A5.5 5.5 0 0 1 685.9 799.5L818.2 905.5A38.6 38.6 0 0 0 863.6 909.1 39.5 39.5 0 0 0 886.4 873.2V800.9A5.9 5.9 0 0 1 892.7 795.5H945A85.5 85.5 0 0 0 1030.9 710.5V342.3A85.5 85.5 0 0 0 943.6 257.7ZM342.7 624.5L210.5 733.2A39.5 39.5 0 0 1 185 742.7 40.5 40.5 0 0 1 167.3 738.6 39.5 39.5 0 0 1 144.5 702.7V628.6A5.5 5.5 0 0 0 138.6 623.2H86.4A85.9 85.9 0 0 1 0 538.2V170A85.9 85.9 0 0 1 86.4 85H647.3A85.5 85.5 0 0 1 733.2 170V538.2A85.5 85.5 0 0 1 647.3 623.2H346.8ZM321.4 598.2A40.5 40.5 0 0 1 346.8 589.1H647.3A51.4 51.4 0 0 0 699.1 538.2V170A51.4 51.4 0 0 0 647.3 119.1H86.4A51.4 51.4 0 0 0 34.1 170V538.2A51.4 51.4 0 0 0 86.4 590.9H138.6A40 40 0 0 1 178.6 630.5V704.5A5.9 5.9 0 0 0 181.8 709.5 6.4 6.4 0 0 0 188.6 709.5Z"
  }));
};
IconQAndA.defaultProps = {
  title: 'q and a'
};
IconQAndA.propTypes = {
  title: PropTypes.string
};

var IconQuestionSolid = function IconQuestionSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-question-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M741.4 169.5A409.1 409.1 0 1 0 909.1 500 409.1 409.1 0 0 0 741.4 169.5ZM500 810.9A45.5 45.5 0 1 1 545.5 765.5 45.5 45.5 0 0 1 500 810.9ZM573.6 509.1L565.5 516.8A97.7 97.7 0 0 0 529.1 584.5V611.8A28.6 28.6 0 1 1 472.3 611.8V584.5A151.8 151.8 0 0 1 525.5 476.8L535 467.3C555 449.1 601.4 405.9 601.4 368.6A90.9 90.9 0 0 0 506.4 272.7 98.6 98.6 0 0 0 415.5 335 97.3 97.3 0 0 0 409.1 351.4 28.2 28.2 0 1 1 353.2 341.4 200.5 200.5 0 0 1 360.9 318.2 155.5 155.5 0 0 1 506.4 218.6 147.7 147.7 0 0 1 656.8 370.5C656.8 430.9 599.5 483.6 572.3 509.1Z"
  }));
};
IconQuestionSolid.defaultProps = {
  title: 'question solid'
};
IconQuestionSolid.propTypes = {
  title: PropTypes.string
};

var IconQuestion = function IconQuestion(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-question",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M748.2 160.5A420.5 420.5 0 1 0 920.5 500 418.6 418.6 0 0 0 748.2 160.5ZM500 875A375 375 0 1 1 875 500 375.5 375.5 0 0 1 500 875ZM535.9 745A37.3 37.3 0 1 1 498.6 707.7 37.3 37.3 0 0 1 535.9 745ZM651.4 368.6C651.4 428.2 595.5 480 568.2 505L560 512.7A104.5 104.5 0 0 0 522.3 584.5V611.8A22.7 22.7 0 0 1 499.5 634.5 22.7 22.7 0 0 1 476.8 611.8V584.5A146.8 146.8 0 0 1 527.7 480.9L537.3 471.8C557.7 452.7 605.9 408.2 605.9 368.6A96.8 96.8 0 0 0 506.4 267.7 103.2 103.2 0 0 0 409.1 334.1 73.2 73.2 0 0 0 404.5 350.5 22.7 22.7 0 1 1 359.1 342.3 209.5 209.5 0 0 1 366.4 318.2 149.5 149.5 0 0 1 506.4 222.3 142.3 142.3 0 0 1 651.4 368.6Z"
  }));
};
IconQuestion.defaultProps = {
  title: 'question'
};
IconQuestion.propTypes = {
  title: PropTypes.string
};

var IconRealTimeSolid = function IconRealTimeSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-real-time-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M206.8 820.9A28.6 28.6 0 1 1 150 820.9 671.8 671.8 0 0 1 821.4 150 28.6 28.6 0 0 1 850 178.2 29.5 29.5 0 0 1 821.4 206.8 615 615 0 0 0 206.8 820.9ZM821.4 333.6A488.2 488.2 0 0 0 333.6 820.9 28.6 28.6 0 0 0 362.3 849.5 28.6 28.6 0 0 0 390.5 820.9 430.5 430.5 0 0 1 821.4 390.5 29.5 29.5 0 0 0 850 363.6 28.6 28.6 0 0 0 821.4 333.6ZM652.3 651.8A108.6 108.6 0 1 0 806.4 651.8 109.1 109.1 0 0 0 652.3 652.7Z"
  }));
};
IconRealTimeSolid.defaultProps = {
  title: 'real time solid'
};
IconRealTimeSolid.propTypes = {
  title: PropTypes.string
};

var IconRealTime = function IconRealTime(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-real-time",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M195.9 821.4A17.7 17.7 0 0 1 190.9 833.6 18.6 18.6 0 0 1 178.6 838.6 17.3 17.3 0 0 1 161.8 821.4 660.9 660.9 0 0 1 820.9 160.9 17.3 17.3 0 1 1 820.9 195 626.4 626.4 0 0 0 195.9 821.4ZM832.3 373.6A16.8 16.8 0 0 0 838.2 363.6 17.3 17.3 0 0 0 821.4 346.8 476.8 476.8 0 0 0 345.5 821.4 17.3 17.3 0 0 0 379.5 821.4 442.3 442.3 0 0 1 821.4 378.6 16.4 16.4 0 0 0 833.2 373.6ZM805.5 806.4A108.6 108.6 0 1 1 805.5 652.7 108.2 108.2 0 0 1 806.4 806.4ZM781.4 676.8A74.5 74.5 0 1 0 781.4 782.3 74.5 74.5 0 0 0 782.3 676.8Z"
  }));
};
IconRealTime.defaultProps = {
  title: 'real time'
};
IconRealTime.propTypes = {
  title: PropTypes.string
};

var IconRebookSolid = function IconRebookSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-rebook-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M776.8 184.5L664.1 164.5A30 30 0 0 0 631.8 178.2 78.6 78.6 0 0 1 484.5 152.3 30.9 30.9 0 0 0 459.1 128.2L345.9 108.6A26.8 26.8 0 0 0 323.2 113.6 30 30 0 0 0 310.5 133.6L196.4 780A30.5 30.5 0 0 0 221.4 815.5L334.5 835.5A30.9 30.9 0 0 0 366.8 821.8 77.7 77.7 0 0 1 435.5 780.5 70.5 70.5 0 0 1 449.5 780.5 78.6 78.6 0 0 1 513.6 846.4 30.9 30.9 0 0 0 539.1 870.5L652.3 890.5A30.5 30.5 0 0 0 675.5 885 31.8 31.8 0 0 0 688.2 865.5L801.8 218.6A30.5 30.5 0 0 0 776.8 184.5ZM668.6 409.1H663.6L376.4 358.6A28.2 28.2 0 0 1 353.2 325.9 28.6 28.6 0 0 1 386.4 302.7L673.6 353.6A27.7 27.7 0 0 1 696.4 386.4 28.2 28.2 0 0 1 668.6 409.1ZM189.1 454.5V515.5S189.1 515.5 189.1 518.6A16.4 16.4 0 0 1 189.1 523.2 35.5 35.5 0 0 1 189.1 529.5S189.1 529.5 189.1 529.5L189.1 529.5A26.4 26.4 0 0 1 181.4 535.9L179.1 535.9A27.3 27.3 0 0 1 166.8 539.1H99.5A28.6 28.6 0 0 1 71.4 510.5 27.7 27.7 0 0 1 94.1 483.2 189.1 189.1 0 0 1 204.5 200 28.6 28.6 0 0 1 218.6 255.5 132.3 132.3 0 0 0 118.2 384.1 130 130 0 0 0 136.4 446.8 28.2 28.2 0 0 1 162.7 428.2 28.6 28.6 0 0 1 189.1 454.5ZM938.6 626.4A189.5 189.5 0 0 1 795.5 808.2L788.6 808.2A28.2 28.2 0 0 1 781.4 752.3 132.7 132.7 0 0 0 865.9 560.5 28.2 28.2 0 0 1 839.5 579.1 28.6 28.6 0 0 1 810.9 550.9V494.5A11.4 11.4 0 0 1 810.9 491.4 16.4 16.4 0 0 1 810.9 486.8 22.7 22.7 0 0 1 813.2 480.9L813.2 478.6S813.2 478.6 813.2 478.6L817.7 474.5A10.9 10.9 0 0 1 821.8 471.8L826.8 469.5 832.3 469.5H895.9A28.2 28.2 0 0 1 924.1 497.7 27.7 27.7 0 0 1 901.4 525 189.5 189.5 0 0 1 938.6 628.2Z"
  }));
};
IconRebookSolid.defaultProps = {
  title: 'rebook solid'
};
IconRebookSolid.propTypes = {
  title: PropTypes.string
};

var IconRebook = function IconRebook(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-rebook",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M778.2 178.6L665 159.1 657.7 159.1A34.1 34.1 0 0 0 626.8 176.4 73.6 73.6 0 0 1 562.7 214.5 57.7 57.7 0 0 1 550 214.5 72.7 72.7 0 0 1 490.5 153.2 36.4 36.4 0 0 0 460 124.5L346.8 102.7H340.5A36.4 36.4 0 0 0 304.5 132.7L190.9 779.1A36.4 36.4 0 0 0 220.5 821.4L333.2 840.9 340.5 840.9A35.5 35.5 0 0 0 371.8 823.6 72.3 72.3 0 0 1 435.9 785.5 62.3 62.3 0 0 1 448.6 785.5 73.2 73.2 0 0 1 508.2 846.8 35.5 35.5 0 0 0 538.2 875.5L651.4 895.5H657.7A36.4 36.4 0 0 0 693.6 865.5L807.7 220.9A37.3 37.3 0 0 0 778.2 178.6ZM660 860.5A2.3 2.3 0 0 1 657.3 860.5H657.3L545.5 843.6H543.2A107.3 107.3 0 0 0 455.9 752.7L437.3 752.7A105 105 0 0 0 346.4 807.7H339.5L227.3 787.7A3.2 3.2 0 0 1 225 785L338.2 136.4 338.2 136.4H338.2L454.5 156.4H454.5L454.5 156.4A106.8 106.8 0 0 0 541.8 247.3 124.1 124.1 0 0 0 560.5 247.3 105.9 105.9 0 0 0 651.4 192.3H654.5L772.7 212.3A3.6 3.6 0 0 1 772.7 215ZM685.5 383.2A17.3 17.3 0 0 1 668.6 397.3H665.5L378.2 347.7A17.3 17.3 0 0 1 363.6 327.7 16.4 16.4 0 0 1 383.2 314.1L671.4 363.6A17.3 17.3 0 0 1 685.5 384.5ZM177.7 454.5V515.5S177.7 515.5 177.7 515.5A5.9 5.9 0 0 0 177.7 518.2 9.1 9.1 0 0 1 177.7 521.8L177.7 521.8 177.7 521.8 173.2 525.9 173.2 525.9A19.1 19.1 0 0 1 165.9 525.9H99.5A16.8 16.8 0 0 1 82.7 508.6 16.4 16.4 0 0 1 99.5 500H115.9A181.8 181.8 0 0 1 72.7 383.6 177.3 177.3 0 0 1 209.1 211.4 16.8 16.8 0 0 1 227.3 223.6 17.3 17.3 0 0 1 214.5 244.1 144.1 144.1 0 0 0 142.7 480V454.5A16.4 16.4 0 0 1 159.5 437.7 16.8 16.8 0 0 1 177.7 454.5ZM927.3 628.2A178.2 178.2 0 0 1 790.9 800.9H786.8A17.3 17.3 0 0 1 770 788.2 17.3 17.3 0 0 1 782.3 767.3 144.1 144.1 0 0 0 854.5 531.4V555A16.4 16.4 0 0 1 837.7 571.8 16.8 16.8 0 0 1 820.5 555V494.5S820.5 494.5 820.5 494.5 820.5 494.5 820.5 491.8A9.1 9.1 0 0 1 820.5 488.2L820.5 488.2 820.5 488.2 823.2 485.5S823.2 485.5 825.5 485.5L828.6 485.5 832.3 485.5H894.5A16.8 16.8 0 0 1 911.4 502.3 17.3 17.3 0 0 1 894.5 519.5H878.2A178.6 178.6 0 0 1 927.3 628.2Z"
  }));
};
IconRebook.defaultProps = {
  title: 'rebook'
};
IconRebook.propTypes = {
  title: PropTypes.string
};

var IconRefresh = function IconRefresh(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-refresh",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M727.3 640.9A105 105 0 0 0 781.8 660 323.2 323.2 0 0 1 500 823.6C489.1 823.6 478.2 823.6 467.7 823.6L457.3 823.6 436.4 818.2 423.6 815.5 406.4 810.9 392.7 805.9A154.5 154.5 0 0 1 377.3 800.5L363.6 793.2 350.5 786.8 335.9 778.6 323.6 772.7 309.5 762.7 299.5 755.5 285.9 743.6 277.3 735.9 263.6 722.3 256.8 714.5C252.3 709.5 248.2 704.1 243.6 698.6L238.2 691.4C234.1 685.5 230 679.5 226.4 673.6L222.3 666.8A210.5 210.5 0 0 1 211.4 647.3L208.2 640.9C205 633.6 201.4 626.4 198.6 619.1S198.6 615.5 198.6 614.1A250.9 250.9 0 0 1 188.6 590.9S188.6 588.2 188.6 586.8A246.8 246.8 0 0 1 181.8 558.2L181.8 558.2A323.6 323.6 0 0 1 176.4 500C176.4 495.9 176.4 491.8 176.4 487.3L68.6 595.9A29.5 29.5 0 0 1 48.6 604.1H48.6A29.5 29.5 0 0 1 28.6 595.9 28.6 28.6 0 0 1 28.6 555.9L172.7 411.8A53.6 53.6 0 0 1 249.1 411.8L393.2 555.9A28.6 28.6 0 0 1 393.2 595.9 29.5 29.5 0 0 1 353.2 595.9L234.1 476.8C234.1 484.5 234.1 492.3 234.1 500S234.1 510.9 234.1 516.8A307.3 307.3 0 0 0 242.3 567.3H242.3A238.6 238.6 0 0 0 250 590.9H250C252.7 598.6 255.9 605.9 259.1 613.2L259.1 613.2A170.5 170.5 0 0 0 272.7 636.4L272.7 636.4C276.4 642.7 280.5 648.6 284.5 654.5L284.5 657.7C288.6 663.2 293.2 668.6 297.7 673.6A12.3 12.3 0 0 0 300.9 677.3 132.3 132.3 0 0 0 314.5 691.4L319.1 695.9 332.7 707.7 339.1 712.3 352.7 722.3 363.6 727.3 376.8 735 386.8 740 399.5 745.9 411.4 750 423.6 754.5 437.3 758.2 448.6 760.9 465.5 763.6 474.5 763.6A258.2 258.2 0 0 0 501.4 763.6 266.4 266.4 0 0 0 727.3 640.9ZM972.7 404.1A29.5 29.5 0 0 0 952.7 395.9H952.7A29.5 29.5 0 0 0 932.7 404.1L824.5 512.7C824.5 508.2 824.5 504.1 824.5 500A323.6 323.6 0 0 0 818.2 444.1L818.2 444.1A246.8 246.8 0 0 0 812.3 417.7S812.3 415 812.3 413.6A207.3 207.3 0 0 0 804.1 390 25.5 25.5 0 0 0 804.1 384.5 227.3 227.3 0 0 0 794.5 362.7L791.4 356.4A164.5 164.5 0 0 0 780.5 336.8L772.7 327.7C769.1 321.4 765 315.9 760.9 310A45.5 45.5 0 0 0 755 302.7C750.9 297.3 746.8 291.8 742.3 286.8L735.5 279.1 721.8 265.5 713.2 257.7 699.5 245.9 689.1 238.6 676.4 227.3 664.1 220 650.5 211.8 636.4 206.8 622.3 200.5A154.5 154.5 0 0 0 606.8 195L593.2 190 575.9 185.5 563.6 181.8 545.5 179.1 534.5 179.1C524.1 179.1 513.2 179.1 502.3 179.1A323.2 323.2 0 0 0 219.5 340 105 105 0 0 1 272.7 359.1 266.8 266.8 0 0 1 500 232.7C509.1 232.7 518.2 232.7 526.8 232.7A62.7 62.7 0 0 0 535.9 232.7L552.7 235.5 564.1 238.2 577.7 241.8 590 246.4 601.8 250.5 614.5 256.4 624.5 260.9 636.4 272.7 644.1 277.3 657.7 287.3 664.1 291.8 677.7 304.1 682.3 308.2A132.3 132.3 0 0 1 695.9 322.3 12.3 12.3 0 0 1 699.1 325.9 159.5 159.5 0 0 1 712.3 342.3L712.3 345 727.3 363.6 727.3 363.6A181.8 181.8 0 0 1 738.2 384.5V384.5A193.2 193.2 0 0 1 747.7 406.8H747.7A212.7 212.7 0 0 1 755.5 430.9H755.5A305 305 0 0 1 763.6 481.8H763.6C763.6 487.3 763.6 492.7 763.6 498.2A199.1 199.1 0 0 1 763.6 521.4L646.8 404.1A29.5 29.5 0 0 0 606.8 404.1 28.6 28.6 0 0 0 606.8 444.1L750.9 588.2A53.6 53.6 0 0 0 827.3 588.2L971.4 444.1A28.6 28.6 0 0 0 971.4 404.1Z"
  }));
};
IconRefresh.defaultProps = {
  title: 'refresh'
};
IconRefresh.propTypes = {
  title: PropTypes.string
};

var IconResetSolid = function IconResetSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-reset-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M914.5 500A347.3 347.3 0 0 1 236.8 606.8L231.8 590.9 250.9 590.9A75.9 75.9 0 0 0 278.6 586.8L288.6 584.1 292.3 594.1A291.4 291.4 0 1 0 279.1 457.7L370 366.8A27.7 27.7 0 0 1 415.5 386.4 29.1 29.1 0 0 1 409.1 405.5L286.8 528.6A50.9 50.9 0 0 1 216.8 528.6L93.2 405.5A28.6 28.6 0 0 1 85.5 385.9 27.3 27.3 0 0 1 93.2 366.4 28.2 28.2 0 0 1 132.3 366.4L223.2 457.3A347.3 347.3 0 0 1 914.5 500Z"
  }));
};
IconResetSolid.defaultProps = {
  title: 'reset solid'
};
IconResetSolid.propTypes = {
  title: PropTypes.string
};

var IconReset = function IconReset(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-reset",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M909.1 500A340.9 340.9 0 0 1 243.6 604.5H248.6A108.6 108.6 0 0 0 278.6 600 306.4 306.4 0 1 0 261.8 487.7L377.7 372.3A16.8 16.8 0 1 1 401.4 395.9L275.9 520.9A37.3 37.3 0 0 1 248.6 532.3H248.6A37.3 37.3 0 0 1 220.9 520.9L95.9 395.9A16.4 16.4 0 0 1 95.9 372.3 16.4 16.4 0 0 1 119.1 372.3L227.3 481.4A340.9 340.9 0 0 1 909.1 500Z"
  }));
};
IconReset.defaultProps = {
  title: 'reset'
};
IconReset.propTypes = {
  title: PropTypes.string
};

var IconRideShareSolid = function IconRideShareSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-ride-share-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M859.5 371.8A25.9 25.9 0 0 0 843.2 354.5 39.5 39.5 0 0 0 820 354.5L781.4 363.6 768.2 310A126.8 126.8 0 0 0 644.5 213.6H355A126.4 126.4 0 0 0 231.8 310L218.2 363.6 181.8 354.1A36.4 36.4 0 0 0 158.6 354.1 25.9 25.9 0 0 0 142.3 371.4L128.6 420.9A25.5 25.5 0 0 0 134.5 443.6 35.9 35.9 0 0 0 154.5 454.5L190.5 463.6H193.2L250.9 470.9A93.6 93.6 0 0 1 309.5 393.6 12.7 12.7 0 0 1 322.3 393.6 65 65 0 0 0 405.5 393.6 13.6 13.6 0 0 1 418.6 393.6H418.6A90.9 90.9 0 0 1 477.3 480V486.4H522.7V479.5A90.9 90.9 0 0 1 582.3 393.2 12.7 12.7 0 0 1 595 393.2 65 65 0 0 0 678.2 393.2 13.6 13.6 0 0 1 691.4 393.2H691.4A90.9 90.9 0 0 1 749.1 472.3C767.7 470 786.4 468.2 804.5 465.5H806.8L809.1 465.5 845.5 456.4A39.5 39.5 0 0 0 863.6 442.7 25.5 25.5 0 0 0 869.5 420ZM363.6 377.3A52.3 52.3 0 0 1 318.2 320.9 52.7 52.7 0 0 1 363.6 264.5 52.7 52.7 0 0 1 412.3 320.9 52.3 52.3 0 0 1 363.6 377.3ZM500 443.6A120 120 0 0 0 481.4 407.3 68.2 68.2 0 0 0 519.5 407.3 120 120 0 0 0 500 443.6ZM500 377.3A52.3 52.3 0 0 1 454.5 320.9 52.7 52.7 0 0 1 500 264.5 52.7 52.7 0 0 1 547.7 320.9 52.3 52.3 0 0 1 500 377.3ZM636.4 377.3A52.3 52.3 0 0 1 590.9 320.9 52.7 52.7 0 0 1 636.4 264.5 52.7 52.7 0 0 1 684.1 320.9 52.3 52.3 0 0 1 636.4 377.3ZM194.1 513.6V731.4A56.4 56.4 0 0 0 250.9 786.4H275.9A55.9 55.9 0 0 0 331.8 730.5V710.9H668.2V730.5A55.9 55.9 0 0 0 724.1 786.4H748.6A55.9 55.9 0 0 0 804.5 730.5V512.7A2188.6 2188.6 0 0 1 500 534.1 2200.5 2200.5 0 0 1 195 512.7ZM334.1 625.9H301.8A23.2 23.2 0 0 1 301.8 580.5H335A23.2 23.2 0 0 1 335 625.9ZM664.1 580.5H697.3A23.2 23.2 0 0 1 697.3 625.9H664.1A23.2 23.2 0 0 1 664.1 580.5Z"
  }));
};
IconRideShareSolid.defaultProps = {
  title: 'ride share solid'
};
IconRideShareSolid.propTypes = {
  title: PropTypes.string
};

var IconRideShare = function IconRideShare(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-ride-share",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 264.5A52.7 52.7 0 0 0 454.5 320.9 52.3 52.3 0 0 0 500 377.3 52.3 52.3 0 0 0 547.7 320.9 52.7 52.7 0 0 0 500 264.5ZM500 343.2C493.6 343.2 486.4 333.6 486.4 320.9S493.6 298.6 500 298.6 513.6 308.6 513.6 320.9 507.3 343.2 500 343.2ZM868.2 401.8A30.5 30.5 0 0 0 849.1 380.9 45.5 45.5 0 0 0 822.7 380.9L787.7 389.5 768.6 313.6A130 130 0 0 0 642.3 213.6H358.2A130.5 130.5 0 0 0 231.4 312.3L212.7 388.6 177.7 380A45.5 45.5 0 0 0 150.9 380 32.3 32.3 0 0 0 131.8 400.9L120 446.4A36.4 36.4 0 0 0 150 487.7L195.5 499.1V727.3A60 60 0 0 0 256.4 786.4H280.5A60 60 0 0 0 340.9 727.3V713.6H659.1V727.3A60.5 60.5 0 0 0 719.5 787.7H744.1A60.5 60.5 0 0 0 804.5 727.3V500L850 488.6A41.8 41.8 0 0 0 872.7 475 30.5 30.5 0 0 0 880 447.7ZM192.7 466.4L158.2 457.7 154.1 457.7S154.1 457.7 154.1 457.7L164.1 412.3A9.5 9.5 0 0 1 169.5 412.3L204.1 420.9ZM306.8 727.3A26.4 26.4 0 0 1 280.5 753.6H256.4A26.4 26.4 0 0 1 230 727.3V713.6H306.8ZM772.7 727.3A26.4 26.4 0 0 1 746.4 753.6H721.8A26.4 26.4 0 0 1 695.5 727.3V713.6H772.7ZM772.7 679.5H230V506.8A1721.8 1721.8 0 0 0 502.7 527.7H534.1A1681.8 1681.8 0 0 0 752.3 510H752.3L772.7 507.3ZM415.5 430A50 50 0 0 1 431.8 445.9 55.9 55.9 0 0 1 443.2 480V492.3C389.1 492.3 335.9 486.4 284.1 480H284.1A58.6 58.6 0 0 1 312.3 430 99.1 99.1 0 0 0 363.6 444.5 96.4 96.4 0 0 0 397.3 437.7H397.3A104.5 104.5 0 0 0 415.5 430ZM465.9 437.7A101.4 101.4 0 0 0 500.5 444.5 96.4 96.4 0 0 0 534.1 437.7 90.9 90.9 0 0 0 522.7 480V493.2H477.3V480A90.9 90.9 0 0 0 465.9 437.7ZM556.8 492.3V480A60 60 0 0 1 568.2 445.9 56.4 56.4 0 0 1 585 430 98.6 98.6 0 0 0 688.2 430 57.7 57.7 0 0 1 715.9 480H715.9C664.1 486.8 610.9 490.5 556.8 492.3ZM749.1 475.5A90.9 90.9 0 0 0 691.4 393.6H691.4A10 10 0 0 0 686.4 393.6 13.6 13.6 0 0 0 678.2 396.4 66.4 66.4 0 0 1 636.4 409.1 67.3 67.3 0 0 1 594.5 394.1 13.6 13.6 0 0 0 586.4 391.4 7.3 7.3 0 0 0 581.8 391.4 74.5 74.5 0 0 0 568.6 398.6 59.1 59.1 0 0 0 554.5 391.4H554.5A10 10 0 0 0 549.5 391.4 13.6 13.6 0 0 0 541.4 394.1 66.4 66.4 0 0 1 500 409.1 67.3 67.3 0 0 1 458.2 394.1 13.6 13.6 0 0 0 450 391.4 7.3 7.3 0 0 0 445.5 391.4 54.5 54.5 0 0 0 430.9 398.6 90.9 90.9 0 0 0 418.2 391.4H418.2A10 10 0 0 0 413.2 391.4 13.6 13.6 0 0 0 405 394.1 66.4 66.4 0 0 1 363.6 409.1 67.3 67.3 0 0 1 321.8 394.1 13.6 13.6 0 0 0 313.6 391.4 7.3 7.3 0 0 0 309.1 391.4 90.9 90.9 0 0 0 250.5 473.2L227.3 471.8 264.5 320.9A96.8 96.8 0 0 1 358.2 247.7H642.3A96.8 96.8 0 0 1 735.9 320.9L772.7 471.8ZM840 457.3L805.5 465.5 794.5 420 829.1 411.4S833.2 411.4 833.6 411.4L845 454.1A7.7 7.7 0 0 1 841.8 457.3ZM363.6 264.5A52.7 52.7 0 0 0 318.2 320.9 52.3 52.3 0 0 0 363.6 377.3 52.3 52.3 0 0 0 412.3 320.9 52.7 52.7 0 0 0 363.6 264.5ZM363.6 343.2C357.3 343.2 350 333.6 350 320.9S357.3 298.6 363.6 298.6 377.3 308.6 377.3 320.9 370.9 343.2 363.6 343.2ZM354.5 599.5A17.3 17.3 0 0 1 337.7 616.8H305.9A17.3 17.3 0 0 1 305.9 582.7H338.6A17.3 17.3 0 0 1 355.5 599.5ZM636.4 264.5A52.7 52.7 0 0 0 590.9 320.9 52.3 52.3 0 0 0 636.4 377.3 52.3 52.3 0 0 0 684.1 320.9 52.7 52.7 0 0 0 636.4 264.5ZM636.4 343.2C630 343.2 622.7 333.6 622.7 320.9S630 298.6 636.4 298.6 650 308.6 650 320.9 643.6 343.2 636.4 343.2ZM710.5 599.5A17.3 17.3 0 0 1 693.2 616.8H660.9A17.3 17.3 0 0 1 660.9 582.7H693.2A17.3 17.3 0 0 1 711.4 599.5Z"
  }));
};
IconRideShare.defaultProps = {
  title: 'ride share'
};
IconRideShare.propTypes = {
  title: PropTypes.string
};

var IconSaveSolid = function IconSaveSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-save-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M659.1 556.8H340.9A45.5 45.5 0 0 0 295.5 602.3V738.6A45.5 45.5 0 0 0 340.9 784.1H659.1A45.5 45.5 0 0 0 704.5 738.6V602.3A45.5 45.5 0 0 0 659.1 556.8ZM426.8 738.6H335.9V602.3H426.8ZM818.2 85.5H181.8A96.8 96.8 0 0 0 85 181.8V764.1L234.1 913.2 234.1 913.2H818.2A96.8 96.8 0 0 0 914.5 818.2V181.8A96.4 96.4 0 0 0 818.2 85.5ZM761.4 738.6A102.3 102.3 0 0 1 659.1 840.9H340.9A102.3 102.3 0 0 1 238.6 738.6V602.3A102.3 102.3 0 0 1 340.9 500H659.1A102.3 102.3 0 0 1 761.4 602.3ZM806.8 340.9A102.3 102.3 0 0 1 704.5 443.2H295.5A102.3 102.3 0 0 1 193.2 340.9V250A102.3 102.3 0 0 1 295.5 147.7H704.5A102.3 102.3 0 0 1 806.8 250Z"
  }));
};
IconSaveSolid.defaultProps = {
  title: 'save solid'
};
IconSaveSolid.propTypes = {
  title: PropTypes.string
};

var IconSave = function IconSave(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-save",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M704.5 159.1H295.5A90.9 90.9 0 0 0 204.5 250V340.9A90.9 90.9 0 0 0 295.5 431.8H704.5A90.9 90.9 0 0 0 795.5 340.9V250A90.9 90.9 0 0 0 704.5 159.1ZM761.4 340.9A56.8 56.8 0 0 1 704.5 397.7H295.5A56.8 56.8 0 0 1 238.6 340.9V250A56.8 56.8 0 0 1 295.5 193.2H704.5A56.8 56.8 0 0 1 761.4 250ZM659.1 511.4H340.9A90.9 90.9 0 0 0 250 602.3V738.6A90.9 90.9 0 0 0 340.9 829.5H659.1A90.9 90.9 0 0 0 750 738.6V602.3A90.9 90.9 0 0 0 659.1 511.4ZM715.9 738.6A56.8 56.8 0 0 1 659.1 795.5H340.9A56.8 56.8 0 0 1 284.1 738.6V602.3A56.8 56.8 0 0 1 340.9 545.5H659.1A56.8 56.8 0 0 1 715.9 602.3ZM818.2 90.9H181.8A90.9 90.9 0 0 0 90.9 181.8V761.8L238.2 909.1H818.2A90.9 90.9 0 0 0 909.1 818.2V181.8A90.9 90.9 0 0 0 818.2 90.9ZM875 818.2A56.8 56.8 0 0 1 818.2 875H252.3L125 747.7V181.8A56.8 56.8 0 0 1 181.8 125H818.2A56.8 56.8 0 0 1 875 181.8ZM335.9 602.3H426.8V738.6H335.9Z"
  }));
};
IconSave.defaultProps = {
  title: 'save'
};
IconSave.propTypes = {
  title: PropTypes.string
};

var IconSeatBeltSolid = function IconSeatBeltSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-seat-belt-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M557.7 694.1A21.8 21.8 0 0 1 557.7 725L473.6 809.1A38.6 38.6 0 0 1 454.5 818.2L369.5 829.5A28.2 28.2 0 0 0 354.5 837.3L294.1 896.8A21.8 21.8 0 0 1 278.6 903.2 22.3 22.3 0 0 1 263.2 896.8L103.2 736.4A20.5 20.5 0 0 1 96.4 720.9 20.9 20.9 0 0 1 103.2 705.5L160.9 647.7A27.7 27.7 0 0 0 168.6 632.3L181.8 547.7A40 40 0 0 1 192.7 525.9L272.7 442.3A23.2 23.2 0 0 1 304.1 442.3ZM903.6 278.6A20.5 20.5 0 0 1 896.8 294.1L839.1 352.3A26.8 26.8 0 0 0 831.4 367.3L818.2 451.8A40 40 0 0 1 807.3 473.6L727.3 557.7A23.6 23.6 0 0 1 711.4 564.1 22.3 22.3 0 0 1 695.9 557.7L665.5 526.8 601.4 590.9A50.5 50.5 0 0 1 565.5 605.9 51.8 51.8 0 0 1 529.1 590.9L409.1 470.9A52.3 52.3 0 0 1 394.1 434.5 50.5 50.5 0 0 1 409.1 398.6L473.2 336.4 442.3 305.5A21.8 21.8 0 0 1 442.3 274.5L526.4 190.9A37.3 37.3 0 0 1 548.2 181.8L632.7 170A24.5 24.5 0 0 0 647.7 162.7L705.9 104.5A22.7 22.7 0 0 1 736.8 104.5L896.8 265A20.5 20.5 0 0 1 903.6 278.6ZM585.5 513.2A25.9 25.9 0 0 0 577.7 494.5L505.5 422.7A26.4 26.4 0 0 0 467.3 422.7 26.8 26.8 0 0 0 467.3 460L539.1 531.8H539.1A28.6 28.6 0 0 0 557.7 539.5 29.5 29.5 0 0 0 577.3 530.9 26.4 26.4 0 0 0 585 513.2Z"
  }));
};
IconSeatBeltSolid.defaultProps = {
  title: 'seat belt solid'
};
IconSeatBeltSolid.propTypes = {
  title: PropTypes.string
};

var IconSeatBelt = function IconSeatBelt(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-seat-belt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M905 255L744.5 95A33.6 33.6 0 0 0 699.1 95L640 152.7A17.3 17.3 0 0 1 630.9 157.3L545.5 168.6A49.1 49.1 0 0 0 518.2 181.8L434.1 266.8A33.6 33.6 0 0 0 434.1 312.3L456.8 335 402.7 390.5A62.7 62.7 0 0 0 402.7 478.6L520.9 596.8A61.8 61.8 0 0 0 609.5 596.8L663.6 542.7 686.4 565.5A31.8 31.8 0 0 0 709.5 575.5 33.2 33.2 0 0 0 733.2 565.5L818.2 481.8A51.8 51.8 0 0 0 832.3 453.2L843.6 369.1A13.6 13.6 0 0 1 848.2 360L905.9 302.3A33.2 33.2 0 0 0 905 255ZM586.8 573.2A28.2 28.2 0 0 1 546.4 573.2L426.8 454.5A28.6 28.6 0 0 1 426.8 414.5L480.9 360.5 639.5 518.6ZM824.5 336.4H824.5A51.4 51.4 0 0 0 810.9 364.5L799.1 449.1A16.8 16.8 0 0 1 795 458.2L712.3 541.8 689.5 519.1H689.5L481.4 311.8 481.4 311.8 459.1 290 543.2 205.9A15.9 15.9 0 0 1 551.8 201.4L636.4 190.9A45.5 45.5 0 0 0 664.5 176.8L721.4 119.1 881.8 278.2ZM313.6 434.1A34.1 34.1 0 0 0 268.2 434.1L181.8 518.2A52.3 52.3 0 0 0 167.7 546.4L156.4 630.9A13.6 13.6 0 0 1 151.8 639.5L95 697.7A31.4 31.4 0 0 0 85.5 720.9 32.7 32.7 0 0 0 95 744.5L255.5 905A31.4 31.4 0 0 0 278.6 914.5 32.7 32.7 0 0 0 302.3 905L360 846.8A16.8 16.8 0 0 1 369.1 842.7L454.5 830.9A47.7 47.7 0 0 0 481.8 818.2L565.9 734.5A34.1 34.1 0 0 0 565.9 689.1ZM457.7 792.7A13.6 13.6 0 0 1 449.1 797.3L363.6 808.6A55 55 0 0 0 335 822.7L279.5 880.9 119.1 721.8 176.8 663.6A45.5 45.5 0 0 0 190.9 636.4L202.7 551.8A15.5 15.5 0 0 1 206.8 543.2L289.5 459.1 541.8 710ZM490 419.1L580.9 510A16.8 16.8 0 0 1 580.9 534.1 17.3 17.3 0 0 1 569.1 539.1 17.7 17.7 0 0 1 556.8 534.1L465.9 443.2A16.8 16.8 0 0 1 490 419.1Z"
  }));
};
IconSeatBelt.defaultProps = {
  title: 'seat belt'
};
IconSeatBelt.propTypes = {
  title: PropTypes.string
};

var IconSeatSolid = function IconSeatSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-seat-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M838.2 681.8V727.3A90.9 90.9 0 0 1 747.3 818.2H607.7V944.5H734.5A28.6 28.6 0 0 1 734.5 1001.4H424.1A28.6 28.6 0 1 1 424.1 944.5H550.9V814.1H419.5L411.4 814.1H409.1A81.8 81.8 0 0 1 325.5 760.5L325.5 754.5A95.5 95.5 0 0 1 313.2 727.3L169.1 330.5A94.1 94.1 0 0 1 164.5 309.5 73.2 73.2 0 0 1 161.8 289.5V85.5A82.7 82.7 0 1 1 326.8 85.5V281.4L385.5 443.2 388.6 443.2H692.3A28.6 28.6 0 1 1 692.3 500H405.9L440 594.1H749.5A90.9 90.9 0 0 1 838.2 681.8Z"
  }));
};
IconSeatSolid.defaultProps = {
  title: 'seat solid'
};
IconSeatSolid.propTypes = {
  title: PropTypes.string
};

var IconSeat = function IconSeat(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-seat",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M749.5 595.9H444.1L409.1 496.4H693.6A17.3 17.3 0 1 0 693.6 462.3H395.5L332.3 288.6V94.1A88.2 88.2 0 1 0 155.9 94.1V297.7A64.5 64.5 0 0 0 159.1 318.2 84.1 84.1 0 0 0 163.6 340.9L307.7 736.4A96.4 96.4 0 0 0 317.7 764.1L317.7 770A90.9 90.9 0 0 0 408.6 827.7H560.5V959.5H424.1A17.3 17.3 0 0 0 424.1 994.1H734.5A17.3 17.3 0 0 0 734.5 959.5H598.2V827.7H751.4A94.5 94.5 0 0 0 845.9 733.2V687.7A94.5 94.5 0 0 0 749.5 595.9ZM810 732.3A60.5 60.5 0 0 1 749.5 792.7H409.1A54.5 54.5 0 0 1 352.7 757.7L350 750A87.7 87.7 0 0 1 340.5 727.3L195.5 329.1A68.2 68.2 0 0 1 192.3 312.3 60 60 0 0 1 190 297.7V93.6A54.1 54.1 0 0 1 298.2 93.6V291.8A31.4 31.4 0 0 0 298.2 297.7L415 618.6A17.7 17.7 0 0 0 431.4 630H749.5A60.9 60.9 0 0 1 810 690.5Z"
  }));
};
IconSeat.defaultProps = {
  title: 'seat'
};
IconSeat.propTypes = {
  title: PropTypes.string
};

var IconSecurePaymentSolid = function IconSecurePaymentSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-secure-payment-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M906.4 278.2H20V196.8A76.4 76.4 0 0 1 96.8 120H829.5A76.8 76.8 0 0 1 906.4 196.8ZM633.6 609.5A108.6 108.6 0 0 0 580 703.2V731.4H96.8A76.8 76.8 0 0 1 20 654.5V369.1H906.4V466.8A177.3 177.3 0 0 0 808.6 436.8 175 175 0 0 0 633.6 609.5ZM387.3 513.2A28.2 28.2 0 0 0 359.1 485H118.2A28.6 28.6 0 0 0 118.2 541.8H359.1A28.6 28.6 0 0 0 387.3 513.2ZM978.2 703.2V828.2A51.8 51.8 0 0 1 926.4 880H689.1A52.3 52.3 0 0 1 636.4 828.2V703.2A52.7 52.7 0 0 1 688.6 650.9H688.6V611.8A117.7 117.7 0 0 1 905 545.5 115.5 115.5 0 0 1 926.8 612.7V651.8H926.8A52.3 52.3 0 0 1 980 703.2ZM879.5 612.3A72.7 72.7 0 1 0 734.1 612.3V651.4H879.5Z"
  }));
};
IconSecurePaymentSolid.defaultProps = {
  title: 'secure payment solid'
};
IconSecurePaymentSolid.propTypes = {
  title: PropTypes.string
};

var IconSecurePayment = function IconSecurePayment(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-secure-payment",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M928.2 654.1H928.2V614.5A112.3 112.3 0 0 0 703.6 614.5V654.1H703.6A50.9 50.9 0 0 0 652.7 705V831.8A51.4 51.4 0 0 0 703.6 883.2H930.9A51.8 51.8 0 0 0 982.3 831.8V705A51.4 51.4 0 0 0 928.2 654.1ZM736.8 614.5A78.2 78.2 0 0 1 893.2 614.5V654.1H736.8ZM945.5 831.8A17.3 17.3 0 0 1 928.2 849.1H700.9A17.3 17.3 0 0 1 684.1 831.8V705A16.8 16.8 0 0 1 700.9 688.2H928.2A16.8 16.8 0 0 1 945.5 705ZM590.9 705.9H103.2A48.6 48.6 0 0 1 54.5 657.3V375.9H884.1V470A17.3 17.3 0 0 0 901.4 486.8 16.8 16.8 0 0 0 918.2 470V199.5A82.7 82.7 0 0 0 835.9 116.8H103.2A83.2 83.2 0 0 0 20.5 199.5V657.3A82.7 82.7 0 0 0 103.2 740H590.9A17.3 17.3 0 1 0 590.9 705.9ZM54.5 341.8V296.4H884.1V341.8ZM54.5 199.5A48.6 48.6 0 0 1 103.2 150.9H835.9A48.2 48.2 0 0 1 884.1 199.5V263.2H54.5ZM363.6 500A17.3 17.3 0 0 1 363.6 534.1H125A17.3 17.3 0 1 1 125 500Z"
  }));
};
IconSecurePayment.defaultProps = {
  title: 'secure payment'
};
IconSecurePayment.propTypes = {
  title: PropTypes.string
};

var IconSecuritySolid = function IconSecuritySolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-security-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M859.1 109.5A12.3 12.3 0 0 0 848.6 109.5 363.6 363.6 0 0 1 732.7 128.6 360 360 0 0 1 505.5 50 10.9 10.9 0 0 0 490.9 50 359.1 359.1 0 0 1 263.6 128.6 363.6 363.6 0 0 1 147.7 109.5 12.3 12.3 0 0 0 137.3 109.5 12.7 12.7 0 0 0 132.7 119.1V594.5C136.4 768.2 397.7 909.1 478.2 948.6A45.5 45.5 0 0 0 523.6 948.6C602.3 909.1 863.6 768.2 863.6 594.5V119.1A12.7 12.7 0 0 0 859.1 109.5ZM669.5 522.7H522.7V669.5A22.7 22.7 0 0 1 477.3 669.5V522.7H330.5A22.7 22.7 0 0 1 330.5 477.3H477.3V330.5A22.7 22.7 0 0 1 522.7 330.5V477.3H669.5A22.7 22.7 0 0 1 669.5 522.7Z"
  }));
};
IconSecuritySolid.defaultProps = {
  title: 'security solid'
};
IconSecuritySolid.propTypes = {
  title: PropTypes.string
};

var IconSecurity = function IconSecurity(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-security",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M863.6 105A17.3 17.3 0 0 0 848.2 102.7 357.7 357.7 0 0 1 510.5 45.5 16.4 16.4 0 0 0 489.5 45.5 357.7 357.7 0 0 1 153.2 104.1 16.8 16.8 0 0 0 136.4 105 16.4 16.4 0 0 0 129.5 119.1V594.5C129.5 771.4 393.2 912.7 474.1 954.1A57.7 57.7 0 0 0 523.2 954.1C604.1 914.1 867.7 772.3 867.7 594.5V119.1A16.4 16.4 0 0 0 863.6 105ZM836.8 594.5C836.8 755.5 564.1 896.8 510.9 923.2A20.5 20.5 0 0 1 491.8 923.2C437.3 896.8 165.9 755.5 165.9 594.5V140A391.4 391.4 0 0 0 500 79.1 391.4 391.4 0 0 0 835.5 141.8ZM686.8 500A16.8 16.8 0 0 1 669.5 516.8H517.3V669.5A17.3 17.3 0 1 1 482.7 669.5V516.8H330.5A16.8 16.8 0 0 1 313.2 500 17.3 17.3 0 0 1 330.5 482.7H482.7V330.5A17.3 17.3 0 1 1 517.3 330.5V482.7H669.5A17.3 17.3 0 0 1 686.8 500Z"
  }));
};
IconSecurity.defaultProps = {
  title: 'security'
};
IconSecurity.propTypes = {
  title: PropTypes.string
};

var IconSettingsSolid = function IconSettingsSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-settings-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M863.6 400.5H823.2A336.8 336.8 0 0 0 792.7 330.9 315 315 0 0 0 747.3 270L767.3 235A45.5 45.5 0 0 0 750.9 172.7L657.7 118.6A45.5 45.5 0 0 0 623.2 114.1 45.5 45.5 0 0 0 595.9 135.5L575.5 170.5A338.2 338.2 0 0 0 424.5 170.5L404.1 136.4A45.5 45.5 0 0 0 376.8 115 47.7 47.7 0 0 0 342.3 119.5L248.6 172.7A45.5 45.5 0 0 0 232.3 235L252.3 270A335.9 335.9 0 0 0 176.8 400.5H136.4A45.5 45.5 0 0 0 90.9 445.9V554.1A45.5 45.5 0 0 0 136.4 599.5H176.8A336.8 336.8 0 0 0 207.3 669.1 329.5 329.5 0 0 0 252.7 730L232.7 765A45.5 45.5 0 0 0 228.2 799.5 45.5 45.5 0 0 0 249.1 827.3L342.7 881.4A45.5 45.5 0 0 0 365.5 887.3L377.3 887.3A45.5 45.5 0 0 0 404.5 865.9L425 830.9A338.2 338.2 0 0 0 575.9 830.9L596.4 865.9A45.5 45.5 0 0 0 658.2 882.7L751.8 828.6A45.5 45.5 0 0 0 768.2 766.4L748.2 731.4A339.1 339.1 0 0 0 823.6 600.9H863.6A45.5 45.5 0 0 0 909.1 555.5V445.9A45.5 45.5 0 0 0 863.6 400.5ZM566.4 615A132.7 132.7 0 0 1 433.6 385 129.5 129.5 0 0 1 500 367.3 132.7 132.7 0 0 1 566.8 615Z"
  }));
};
IconSettingsSolid.defaultProps = {
  title: 'settings solid'
};
IconSettingsSolid.propTypes = {
  title: PropTypes.string
};

var IconSettings = function IconSettings(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-settings",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M545.5 338.6A166.8 166.8 0 0 0 357.7 583.6 164.5 164.5 0 0 0 459.1 661.4 181.8 181.8 0 0 0 504.5 667.3 167.3 167.3 0 0 0 545.5 338.6ZM619.5 531.4A121.8 121.8 0 0 1 396.8 560.9 122.7 122.7 0 0 1 442.3 394.5 125.5 125.5 0 0 1 500 378.6 123.6 123.6 0 0 1 531.4 382.7 120.5 120.5 0 0 1 617.3 531.4ZM863.6 389.1H831.4A332.7 332.7 0 0 0 802.7 325.5 340.5 340.5 0 0 0 761.8 268.6L777.7 240.5A56.8 56.8 0 0 0 756.8 162.7L665.9 109.1A55.5 55.5 0 0 0 622.7 103.2 57.7 57.7 0 0 0 588.2 129.5L571.8 157.7A341.4 341.4 0 0 0 432.7 157.7L416.4 129.5A57.7 57.7 0 0 0 381.8 103.2 55.5 55.5 0 0 0 338.6 109.1L243.2 162.7A58.2 58.2 0 0 0 216.4 197.3 57.3 57.3 0 0 0 222.3 242.7L238.2 270.9A350.9 350.9 0 0 0 168.6 389.1H136.4A56.8 56.8 0 0 0 79.5 445.9V554.1A56.8 56.8 0 0 0 136.4 610.9H168.6A320.5 320.5 0 0 0 197.3 674.5 363.6 363.6 0 0 0 238.2 731.8L222.3 759.5A57.3 57.3 0 0 0 243.2 837.3L336.4 890.9A55.5 55.5 0 0 0 379.5 896.8 56.4 56.4 0 0 0 414.1 870.5L430.5 842.3A341.4 341.4 0 0 0 569.5 842.3L585.9 870.5A57.7 57.7 0 0 0 620.5 896.8 53.2 53.2 0 0 0 635 896.8 54.1 54.1 0 0 0 663.6 889.1L754.5 835.5A56.8 56.8 0 0 0 775.5 757.7L759.5 730A357.3 357.3 0 0 0 829.1 609.1H863.6A56.8 56.8 0 0 0 920.5 552.3V445.9A56.8 56.8 0 0 0 863.6 389.1ZM875 554.1A11.4 11.4 0 0 1 863.6 565.5H814.5A22.7 22.7 0 0 0 792.7 581.8 305.9 305.9 0 0 1 717.3 712.7 21.8 21.8 0 0 0 714.1 740L738.6 782.3A11.8 11.8 0 0 1 734.1 797.7L643.2 851.8A10 10 0 0 1 634.5 851.8 9.5 9.5 0 0 1 627.7 846.8L603.2 804.1A24.1 24.1 0 0 0 583.2 792.7L577.7 792.7A303.2 303.2 0 0 1 426.8 792.7 22.3 22.3 0 0 0 401.8 803.2L377.3 845.9A10.9 10.9 0 0 1 370 850.9 10 10 0 0 1 361.4 850.9L265.9 797.7A11.4 11.4 0 0 1 261.8 782.3L285.9 740A21.8 21.8 0 0 0 282.7 712.7 301.8 301.8 0 0 1 237.3 651.8 297.3 297.3 0 0 1 207.7 581.8 22.7 22.7 0 0 0 185.9 565.5H136.4A11.4 11.4 0 0 1 125 554.1V445.9A11.4 11.4 0 0 1 136.4 434.5H185.5A22.7 22.7 0 0 0 207.3 418.2 305.9 305.9 0 0 1 282.7 287.3 21.4 21.4 0 0 0 285.9 260.5L261.8 217.7A10.5 10.5 0 0 1 261.8 209.1 10.5 10.5 0 0 1 267.3 202.3L359.1 148.2A12.3 12.3 0 0 1 367.7 148.2 13.2 13.2 0 0 1 375 153.2L399.1 195.9A23.2 23.2 0 0 0 424.5 206.4 303.2 303.2 0 0 1 575.5 206.4 22.7 22.7 0 0 0 600.9 195.9L625.5 153.2A10.9 10.9 0 0 1 632.3 148.2 12.3 12.3 0 0 1 640.9 148.2L731.8 202.3A10.5 10.5 0 0 1 737.3 209.1 12.3 12.3 0 0 1 737.3 217.7L712.7 260A22.7 22.7 0 0 0 715.9 287.3 301.8 301.8 0 0 1 761.4 348.2 297.3 297.3 0 0 1 790.9 418.2 22.7 22.7 0 0 0 812.7 434.5H863.6A11.4 11.4 0 0 1 875 445.9Z"
  }));
};
IconSettings.defaultProps = {
  title: 'settings'
};
IconSettings.propTypes = {
  title: PropTypes.string
};

var IconShareFileSolid = function IconShareFileSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-share-file-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M352.3 578.6A22.7 22.7 0 0 1 306.8 578.6 22.7 22.7 0 0 1 352.3 578.6ZM670.5 772.7A22.7 22.7 0 1 0 647.7 750 22.7 22.7 0 0 0 670.5 772.7ZM909.1 340.9V818.2A90.9 90.9 0 0 1 818.2 909.1H181.8A90.9 90.9 0 0 1 90.9 818.2V181.8A90.9 90.9 0 0 1 181.8 90.9H409.1A90.9 90.9 0 0 1 500 181.8V250H818.2A90.9 90.9 0 0 1 909.1 340.9ZM418.6 562.7L606.4 471.8A90.9 90.9 0 0 0 670.5 499.1 90.9 90.9 0 1 0 579.5 408.2C579.5 412.3 579.5 416.8 579.5 421.4L390.9 512.3A90.9 90.9 0 0 0 328.6 486.8 90.9 90.9 0 1 0 386.4 649.5L580 744.5A22.3 22.3 0 0 0 580 750 90.9 90.9 0 1 0 601.4 691.4L419.5 600.5A76.4 76.4 0 0 0 422.7 577.7 65.9 65.9 0 0 0 418.6 562.7ZM670.5 430A22.7 22.7 0 0 0 693.2 407.3 22.7 22.7 0 0 0 647.7 407.3 22.7 22.7 0 0 0 670.5 430Z"
  }));
};
IconShareFileSolid.defaultProps = {
  title: 'share file solid'
};
IconShareFileSolid.propTypes = {
  title: PropTypes.string
};

var IconShareFile = function IconShareFile(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-share-file",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M670.5 486.8A79.5 79.5 0 1 0 590.9 409.1 64.5 64.5 0 0 0 593.6 428.2L389.5 526.8A79.5 79.5 0 1 0 384.5 636.4L590.9 737.7A56.4 56.4 0 0 0 590.9 750 79.5 79.5 0 1 0 670.5 670.5 78.6 78.6 0 0 0 604.5 705.9L403.6 607.3A86.4 86.4 0 0 0 409.1 578.6 68.6 68.6 0 0 0 405.5 556.8L609.1 456.8A78.2 78.2 0 0 0 670.5 486.8ZM670.5 373.2A34.1 34.1 0 1 1 636.4 409.1 34.5 34.5 0 0 1 670.5 373.2ZM670.5 715.9A34.1 34.1 0 1 1 636.4 750 34.5 34.5 0 0 1 670.5 715.9ZM329.5 612.7A34.1 34.1 0 1 1 363.6 578.6 34.5 34.5 0 0 1 329.5 612.7ZM818.2 250H500V181.8A90.9 90.9 0 0 0 409.1 90.9H181.8A90.9 90.9 0 0 0 90.9 181.8V818.2A90.9 90.9 0 0 0 181.8 909.1H818.2A90.9 90.9 0 0 0 909.1 818.2V340.9A90.9 90.9 0 0 0 818.2 250ZM875 818.2A56.8 56.8 0 0 1 818.2 875H181.8A56.8 56.8 0 0 1 125 818.2V181.8A56.8 56.8 0 0 1 181.8 125H409.1A56.8 56.8 0 0 1 465.9 181.8V284.1H818.2A56.8 56.8 0 0 1 875 340.9Z"
  }));
};
IconShareFile.defaultProps = {
  title: 'share file'
};
IconShareFile.propTypes = {
  title: PropTypes.string
};

var IconSitSolid = function IconSitSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-sit-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M865.9 854.1A65.9 65.9 0 0 1 775 854.1L675.9 755V895A65.9 65.9 0 1 1 544.5 895V689.1H387.3A78.6 78.6 0 0 1 309.1 623.2 79.1 79.1 0 0 1 305.5 604.1L281.8 345.9A90.9 90.9 0 0 1 305.9 275 94.5 94.5 0 0 1 374.5 244.5H420A93.6 93.6 0 0 1 488.6 275 90.9 90.9 0 0 1 512.7 345.9L495.9 530.5H606.8A60 60 0 0 1 630.9 535.5H630.9A71.4 71.4 0 0 1 651.4 549.5H651.4L862.7 761.4A65.9 65.9 0 0 1 865.9 854.1ZM398.2 215.5A88.2 88.2 0 1 0 310 127.3 88.2 88.2 0 0 0 398.2 215.5ZM381.4 730H245V451.8A65.9 65.9 0 1 0 113.6 451.8V795.9A65.9 65.9 0 0 0 181.8 863.6H381.4A65.9 65.9 0 0 0 381.4 731.8Z"
  }));
};
IconSitSolid.defaultProps = {
  title: 'sit solid'
};
IconSitSolid.propTypes = {
  title: PropTypes.string
};

var IconSit = function IconSit(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-sit",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M870 757.3L658.6 545.5A74.5 74.5 0 0 0 635.9 530H635.9L624.5 526.4H622.3A74.1 74.1 0 0 0 608.2 526.4H503.2L519.5 347.7A98.6 98.6 0 0 0 494.1 272.7 99.5 99.5 0 0 0 421.4 240.9H375.9A99.5 99.5 0 0 0 303.2 272.7 98.6 98.6 0 0 0 277.7 348.2L300 604.5A68.2 68.2 0 0 0 303.6 624.1 84.5 84.5 0 0 0 387.3 695H536.8V895A71.4 71.4 0 1 0 679.5 895V768.6L770.5 859.5A71.4 71.4 0 0 0 820.9 880.5 71.4 71.4 0 0 0 892.3 809.1 71.4 71.4 0 0 0 870 757.3ZM645.5 893.6A37.3 37.3 0 1 1 570.9 893.6V660.9H389.1A51.4 51.4 0 0 1 338.6 615.5 51.8 51.8 0 0 1 335.5 600.5L310.5 343.6A64.1 64.1 0 0 1 374.5 272.7H420A64.1 64.1 0 0 1 484.1 343.2L464.5 558.6H606.8A35.5 35.5 0 0 1 620.9 561.4 51.4 51.4 0 0 1 629.1 566.8 36.8 36.8 0 0 1 644.1 595.9ZM845.9 832.7A37.3 37.3 0 0 1 793.2 832.7L681.8 720.5V615L848.2 781.4A37.7 37.7 0 0 1 859.1 807.7 38.2 38.2 0 0 1 845.9 834.1ZM398.2 220.9A94.1 94.1 0 1 0 304.1 127.3 93.6 93.6 0 0 0 398.2 220.9ZM398.2 67.3A60 60 0 1 1 338.2 127.3 60 60 0 0 1 398.2 67.3ZM381.4 724.5H251.8V451.8A71.4 71.4 0 1 0 109.1 451.8V795.9A71.4 71.4 0 0 0 181.8 867.3H381.4A71.4 71.4 0 0 0 381.4 724.5ZM381.4 833.2H181.8A37.3 37.3 0 0 1 144.5 795.9V451.8A37.3 37.3 0 1 1 219.1 451.8V758.6H382.7A37.3 37.3 0 1 1 382.7 833.2Z"
  }));
};
IconSit.defaultProps = {
  title: 'sit'
};
IconSit.propTypes = {
  title: PropTypes.string
};

var IconSmokingNo = function IconSmokingNo(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-smoking-no",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M863.6 437.3H136.4A45.5 45.5 0 0 0 90.9 482.7V517.3A45.5 45.5 0 0 0 136.4 562.7H863.6A45.5 45.5 0 0 0 909.1 517.3V482.7A45.5 45.5 0 0 0 863.6 437.3ZM214.5 528.2H136.4A11.4 11.4 0 0 1 125 517.3V482.7A11.4 11.4 0 0 1 136.4 471.8H215ZM875 517.3A11.4 11.4 0 0 1 863.6 528.2H249.1V471.8H863.6A11.4 11.4 0 0 1 875 482.7ZM147.7 385.5A125.5 125.5 0 0 1 167.3 294.5 81.4 81.4 0 0 1 232.3 267.7C301.8 267.7 323.2 174.1 323.2 173.2H323.2A16.4 16.4 0 0 1 339.5 159.5 16.8 16.8 0 0 1 356.4 176.4 13.2 13.2 0 0 1 356.4 180.5H356.4C356.4 185.5 329.1 301.8 232.3 301.8A45.5 45.5 0 0 0 195 318.2 90.9 90.9 0 0 0 181.8 379.5H181.8S181.8 379.5 181.8 382.3A16.8 16.8 0 0 1 165 399.1 17.3 17.3 0 0 1 148.2 385.5ZM761.8 145.9A17.3 17.3 0 0 0 738.6 152.3L231.8 830.9A16.8 16.8 0 0 0 238.2 854.1 16.8 16.8 0 0 0 246.4 856.4 17.7 17.7 0 0 0 261.4 847.7L768.2 169.1A16.8 16.8 0 0 0 761.8 145.9Z"
  }));
};
IconSmokingNo.defaultProps = {
  title: 'smoking no'
};
IconSmokingNo.propTypes = {
  title: PropTypes.string
};

var IconSmoking = function IconSmoking(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-smoking",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M863.6 437.3H136.4A45.5 45.5 0 0 0 90.9 482.7V517.3A45.5 45.5 0 0 0 136.4 562.7H863.6A45.5 45.5 0 0 0 909.1 517.3V482.7A45.5 45.5 0 0 0 863.6 437.3ZM214.5 528.2H136.4A11.4 11.4 0 0 1 125 517.3V482.7A11.4 11.4 0 0 1 136.4 471.8H215ZM875 517.3A11.4 11.4 0 0 1 863.6 528.2H249.1V471.8H863.6A11.4 11.4 0 0 1 875 482.7ZM147.7 385.5A125.5 125.5 0 0 1 167.3 294.5 81.4 81.4 0 0 1 232.3 267.7C301.8 267.7 323.2 174.1 323.2 173.2H323.2A16.4 16.4 0 0 1 339.5 159.5 16.8 16.8 0 0 1 356.4 176.4 13.2 13.2 0 0 1 356.4 180.5H356.4C356.4 185.5 329.1 301.8 232.3 301.8A45.5 45.5 0 0 0 195 318.2 90.9 90.9 0 0 0 181.8 379.5H181.8S181.8 379.5 181.8 382.3A16.8 16.8 0 0 1 165 399.1 17.3 17.3 0 0 1 148.2 385.5Z"
  }));
};
IconSmoking.defaultProps = {
  title: 'smoking'
};
IconSmoking.propTypes = {
  title: PropTypes.string
};

var IconSnacksSolid = function IconSnacksSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-snacks-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M834.1 392.7L830.5 392.7A60.5 60.5 0 0 1 851.8 426.4V854.5A68.6 68.6 0 0 1 830.5 890.5L835.5 894.1C843.2 899.5 851.8 905.9 851.8 915.9V989.5A5.9 5.9 0 0 1 848.2 995 6.4 6.4 0 0 1 842.3 995L803.6 954.5 766.4 994.5A6.8 6.8 0 0 1 762.3 994.5H762.3A5 5 0 0 1 758.2 994.5L721.8 955 684.1 995A5.9 5.9 0 0 1 680 995H680A5.9 5.9 0 0 1 676.4 989.5V915C676.4 905 684.5 898.6 691.8 892.7L695 890.5A75 75 0 0 1 676.4 853.6V428.2A60 60 0 0 1 695.9 395L693.2 395C685 389.5 676.4 382.7 676.4 373.2V295.9A5.5 5.5 0 0 1 680 290.9 5 5 0 0 1 685.9 290.9L723.6 330 759.1 291.8A4.5 4.5 0 0 1 763.2 291.8L767.3 291.8 804.5 328.6 844.1 290.9A6.4 6.4 0 0 1 850.5 290.9 5.5 5.5 0 0 1 853.6 295.9V370.9C851.8 380.9 842.3 387.3 834.1 392.7ZM457.3 165.5H248.6L170.9 262.3A108.2 108.2 0 0 0 148.2 328.2V934.1A61.4 61.4 0 0 0 209.5 995.5H496.4A61.4 61.4 0 0 0 557.3 934.1V327.3A105 105 0 0 0 535 262.7ZM444.5 59.1A54.5 54.5 0 0 0 390 4.5H318.2A54.5 54.5 0 0 0 263.6 59.1V108.2H445.5Z"
  }));
};
IconSnacksSolid.defaultProps = {
  title: 'snacks solid'
};
IconSnacksSolid.propTypes = {
  title: PropTypes.string
};

var IconSnacks = function IconSnacks(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-snacks",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M444.5 118.2V68.2A62.7 62.7 0 0 0 381.8 5.5H323.6A62.7 62.7 0 0 0 260.9 68.2V118.2L162.3 243.2A116.8 116.8 0 0 0 136.4 318.2V921.8A72.7 72.7 0 0 0 209.1 994.1H495.9A72.3 72.3 0 0 0 568.2 921.8V315A112.7 112.7 0 0 0 545.5 243.6ZM295 68.2A28.6 28.6 0 0 1 323.6 39.5H381.8A28.6 28.6 0 0 1 409.1 68.2V106.8H295ZM534.5 921.8A38.6 38.6 0 0 1 496.4 960H209.5A38.6 38.6 0 0 1 170.9 921.8V318.2A85 85 0 0 1 188.6 266.4L286.4 140.9H419.1L517.3 264.5A81.8 81.8 0 0 1 534.5 315ZM863.6 358.6V283.6A16.8 16.8 0 0 0 853.2 268.2 16.4 16.4 0 0 0 835 271.4L803.2 301.4 772.7 272.7A19.5 19.5 0 0 0 760.5 268.2 16.4 16.4 0 0 0 748.2 273.6L720.9 302.7 692.3 272.7A16.4 16.4 0 0 0 673.6 269.1 16.4 16.4 0 0 0 663.2 284.5V358.6A34.5 34.5 0 0 0 677.3 384.1 50 50 0 0 0 663.2 415.9V841.4A65.5 65.5 0 0 0 677.3 875.9 36.4 36.4 0 0 0 663.2 902.7V977.3A17.3 17.3 0 0 0 674.1 993.2 13.6 13.6 0 0 0 680 993.2 19.5 19.5 0 0 0 692.7 988.2L721.4 957.3 749.5 987.7A16.4 16.4 0 0 0 762.3 993.2H762.3A17.7 17.7 0 0 0 774.5 988.2L804.1 956.8 834.1 988.2A16.8 16.8 0 0 0 852.7 992.3 17.3 17.3 0 0 0 863.6 977.3V903.6A34.1 34.1 0 0 0 847.7 876.4 59.5 59.5 0 0 0 863.6 842.3V415.9A51.4 51.4 0 0 0 848.2 384.5 33.2 33.2 0 0 0 863.6 358.6ZM810.5 890.5A63.2 63.2 0 0 0 822.7 900C825.5 902.3 829.1 905 829.5 903.6V935L816.4 921.4A16.4 16.4 0 0 0 804.1 915.9H804.1A16.4 16.4 0 0 0 791.8 921.4L762.7 952.3 734.5 921.4A13.6 13.6 0 0 0 722.3 915.9 16.4 16.4 0 0 0 709.5 921.4L697.3 934.5V905A35.9 35.9 0 0 1 704.5 898.2L713.6 890.5A16.8 16.8 0 0 0 713.6 866.4 73.6 73.6 0 0 1 697.7 841.4V416.8A72.3 72.3 0 0 1 715 394.1 17.7 17.7 0 0 0 715 370L704.5 363.6C701.8 363.6 697.3 358.6 697.3 360V326.4L709.5 339.1A16.8 16.8 0 0 0 721.8 344.1H721.8A16.4 16.4 0 0 0 734.1 338.6L761.8 309.1 790.9 337.3A16.8 16.8 0 0 0 814.5 337.3L829.1 323.2V355.5L821.4 363.6A61.4 61.4 0 0 0 810 371.8 17.7 17.7 0 0 0 810 396.4 119.1 119.1 0 0 1 829.1 417.7V843.2A78.6 78.6 0 0 1 810 868.2 16.4 16.4 0 0 0 805 880 17.7 17.7 0 0 0 810 890.5Z"
  }));
};
IconSnacks.defaultProps = {
  title: 'snacks'
};
IconSnacks.propTypes = {
  title: PropTypes.string
};

var IconSocketSolid = function IconSocketSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-socket-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M879.5 345L727.3 500 755.9 528.2A65.5 65.5 0 0 1 755.9 619.1L665 710A260 260 0 0 1 477.3 786.4 262.7 262.7 0 0 1 312.7 727.3L152.3 887.7 112.3 847.7 272.7 686.8A263.6 263.6 0 0 1 291.4 335.9L382.3 245A65.5 65.5 0 0 1 473.2 245L501.4 273.6 655.9 119.1A28.2 28.2 0 0 1 695.9 119.1 28.6 28.6 0 0 1 695.9 159.1L541.4 313.6 685.5 457.7 840 303.2A28.6 28.6 0 1 1 880 343.6Z"
  }));
};
IconSocketSolid.defaultProps = {
  title: 'socket solid'
};
IconSocketSolid.propTypes = {
  title: PropTypes.string
};

var IconSocket = function IconSocket(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-socket",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M873.2 310.9A16.8 16.8 0 0 0 849.1 310.9L698.6 461.4 538.6 301.4 689.1 150.9A17.7 17.7 0 0 0 689.1 126.8 16.8 16.8 0 0 0 665 126.8L514.5 277.3 478.2 240.9A70 70 0 0 0 378.6 240.9L287.7 331.8A269.1 269.1 0 0 0 276.4 699.5L121.8 854.1 145.9 878.2 301.8 722.3A266.8 266.8 0 0 0 668.6 712.3L759.5 621.4A70 70 0 0 0 759.5 521.8L723.2 485.5 873.6 335A16.8 16.8 0 0 0 873.2 310.9ZM736.8 545.9A36.4 36.4 0 0 1 736.8 597.3L645.9 688.2A235 235 0 0 1 313.2 354.5L404.1 263.6A36.4 36.4 0 0 1 430 252.7 35 35 0 0 1 455.5 263.6Z"
  }));
};
IconSocket.defaultProps = {
  title: 'socket'
};
IconSocket.propTypes = {
  title: PropTypes.string
};

var IconSort = function IconSort(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-sort",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M909.1 736.4H909.1A30.9 30.9 0 0 1 900.5 757.3L764.1 893.6A53.2 53.2 0 0 1 688.2 893.6L551.8 757.3A30.9 30.9 0 0 1 545.5 736.4H545.5A29.5 29.5 0 0 1 595.9 715.5L696.4 818.2V120.5A29.5 29.5 0 0 1 727.3 90.9 29.5 29.5 0 0 1 756.8 120.5V818.2L859.5 715.9A29.5 29.5 0 0 1 909.1 736.4ZM120 256.8H557.7A29.5 29.5 0 0 0 557.7 198.2H120A29.1 29.1 0 0 0 99.5 248.2 29.1 29.1 0 0 0 120 256.8ZM421.4 470.5H120A29.1 29.1 0 0 0 99.5 520.5 29.1 29.1 0 0 0 120 529.1H421.4A29.5 29.5 0 0 0 421.4 470.5ZM330.5 743.2H120A29.1 29.1 0 0 0 99.5 793.2 29.1 29.1 0 0 0 120 801.8H330.5A29.5 29.5 0 0 0 330.5 743.2Z"
  }));
};
IconSort.defaultProps = {
  title: 'sort'
};
IconSort.propTypes = {
  title: PropTypes.string
};

var IconStarSolid = function IconStarSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-star-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M898.2 446.4A40 40 0 0 0 913.2 404.1C910.9 396.4 902.7 382.7 876.4 379.1L691.8 352.3A113.2 113.2 0 0 1 617.7 298.6L535.5 131.4C523.6 107.7 508.2 104.1 500 104.1S476.4 107.7 464.5 131.4L382.3 298.6A113.2 113.2 0 0 1 308.2 352.3L123.6 379.1C97.3 382.7 89.1 396.4 86.8 404.1A40 40 0 0 0 101.8 446.4L235.5 576.4A113.2 113.2 0 0 1 263.6 663.6L231.8 845.5A45.5 45.5 0 0 0 239.5 884.1 30 30 0 0 0 263.6 894.5 55 55 0 0 0 289.5 887.3L454.5 802.3A110.5 110.5 0 0 1 545.5 802.3L710 888.6A53.6 53.6 0 0 0 735.9 895.9 30 30 0 0 0 760 885.5 45.5 45.5 0 0 0 767.7 846.8L735.9 665A113.2 113.2 0 0 1 764.1 577.7Z"
  }));
};
IconStarSolid.defaultProps = {
  title: 'star solid'
};
IconStarSolid.propTypes = {
  title: PropTypes.string
};

var IconStar = function IconStar(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-star",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M895.5 437.7C918.6 415.5 911.4 392.3 879.5 388.6L692.7 363.6A124.5 124.5 0 0 1 609.5 303.2L525.9 131.4C518.6 117.3 509.5 110 500 110S481.4 117.3 474.1 131.4L390.5 300.9A124.5 124.5 0 0 1 307.3 363.6L120.5 390.9C88.6 395.5 81.4 417.7 104.5 440L240.9 571.8A123.2 123.2 0 0 1 272.7 667.7L240.9 853.6C236.8 876.8 245.9 890 261.8 890A45.5 45.5 0 0 0 282.7 884.1L449.5 796.4A123.6 123.6 0 0 1 553.2 796.4L720 884.1A45.5 45.5 0 0 0 740.9 890C756.8 890 765.9 876.8 761.8 853.6L727.3 667.7A123.2 123.2 0 0 1 759.1 569.5ZM694.5 673.6L724.5 848.2 567.7 765.5A160.5 160.5 0 0 0 431.4 765.5L275.5 848.2 305.5 673.6A158.6 158.6 0 0 0 263.6 545.5L136.4 420.9 312.3 395.5A158.6 158.6 0 0 0 421.8 318.2L500 157.3 578.2 318.2A157.7 157.7 0 0 0 687.7 395.5L863.6 420.9 736.4 545.5A158.6 158.6 0 0 0 694.5 673.6Z"
  }));
};
IconStar.defaultProps = {
  title: 'star'
};
IconStar.propTypes = {
  title: PropTypes.string
};

var IconStationSolid = function IconStationSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-station-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M601.8 920.5H397.3A28.6 28.6 0 0 1 397.3 863.6H471.8V500A210.5 210.5 0 0 1 287.3 292.3 212.7 212.7 0 0 1 712.7 292.3 210.5 210.5 0 0 1 528.2 500V863.6H601.8A28.6 28.6 0 1 1 601.8 920.5Z"
  }));
};
IconStationSolid.defaultProps = {
  title: 'station solid'
};
IconStationSolid.propTypes = {
  title: PropTypes.string
};

var IconStation = function IconStation(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-station",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M701.4 292.3A201.4 201.4 0 1 0 482.7 491.8V875H397.3A17.3 17.3 0 0 0 397.3 909.1H601.8A17.3 17.3 0 1 0 601.8 875H517.3V491.8A201.4 201.4 0 0 0 701.4 292.3ZM332.7 292.3A167.3 167.3 0 1 1 500 459.5 167.3 167.3 0 0 1 332.7 292.3Z"
  }));
};
IconStation.defaultProps = {
  title: 'station'
};
IconStation.propTypes = {
  title: PropTypes.string
};

var IconStopwatchSolid = function IconStopwatchSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-stopwatch-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M688.6 264.1L734.1 185.9A21.8 21.8 0 0 0 727.3 155.5 22.3 22.3 0 0 0 697.3 163.6L651.8 242.3A329.5 329.5 0 0 0 523.6 207.7V155.9H543.6A22.3 22.3 0 0 0 565.5 133.6 21.8 21.8 0 0 0 543.6 111.8H458.2A21.8 21.8 0 0 0 435.9 133.6 22.3 22.3 0 0 0 458.2 155.9H478.2V207.7A340.9 340.9 0 1 0 688.6 264.1ZM660.5 705.9A23.2 23.2 0 0 1 645 712.3 23.6 23.6 0 0 1 629.1 705.9L484.5 560.9A21.8 21.8 0 0 1 478.2 545.5V304.5A21.8 21.8 0 0 1 500 282.3 22.3 22.3 0 0 1 522.3 304.5V536.4L658.6 672.7A22.3 22.3 0 0 1 660.5 705.9Z"
  }));
};
IconStopwatchSolid.defaultProps = {
  title: 'stopwatch solid'
};
IconStopwatchSolid.propTypes = {
  title: PropTypes.string
};

var IconStopwatch = function IconStopwatch(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-stopwatch",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M685 259.5L730.5 181.4A17.7 17.7 0 1 0 700 163.6L654.5 241.8A330.9 330.9 0 0 0 518.2 205.5V149.1H542.7A17.3 17.3 0 0 0 560 131.4 17.7 17.7 0 0 0 542.7 113.6H458.2A17.7 17.7 0 0 0 440.5 131.4 17.3 17.3 0 0 0 458.2 149.1H482.3V205.5A340.9 340.9 0 1 0 685 259.5ZM500 850.9A305.9 305.9 0 1 1 805.5 545.5 305.9 305.9 0 0 1 500 850.9ZM657.3 675.5A17.7 17.7 0 0 1 657.3 700.5 16.4 16.4 0 0 1 645 705.9 17.7 17.7 0 0 1 632.3 700.5L487.7 555.9A17.3 17.3 0 0 1 482.3 543.2V302.3A18.2 18.2 0 0 1 500 284.5 17.7 17.7 0 0 1 517.7 302.3V535.9Z"
  }));
};
IconStopwatch.defaultProps = {
  title: 'stopwatch'
};
IconStopwatch.propTypes = {
  title: PropTypes.string
};

var IconStrollerSolid = function IconStrollerSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-stroller-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M348.2 763.6A75 75 0 1 0 423.2 838.6 75 75 0 0 0 348.2 763.6ZM848.6 763.6A75 75 0 1 0 923.2 838.6 74.5 74.5 0 0 0 848.6 763.6ZM345.5 694.5A22.7 22.7 0 0 0 368.2 717.3H783.2A22.7 22.7 0 0 0 804.1 703.2 23.2 23.2 0 0 0 799.1 678.6L384.1 263.6 380.9 260.9 233.6 113.6H233.6A90.9 90.9 0 0 0 76.8 178.6 22.7 22.7 0 0 0 99.5 201.4 23.2 23.2 0 0 0 122.3 178.6 45.5 45.5 0 0 1 136.4 145.9 45.5 45.5 0 0 1 201.4 145.9H201.4L345.5 289.5Z"
  }));
};
IconStrollerSolid.defaultProps = {
  title: 'stroller solid'
};
IconStrollerSolid.propTypes = {
  title: PropTypes.string
};

var IconStroller = function IconStroller(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-stroller",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M340 743.6A85.9 85.9 0 1 0 425.9 829.5 86.4 86.4 0 0 0 340 743.6ZM340 880A51.8 51.8 0 1 1 391.8 828.2 52.3 52.3 0 0 1 340 881.4ZM840 743.6A85.9 85.9 0 1 0 926.4 829.5 85.9 85.9 0 0 0 840 743.6ZM840 880A51.8 51.8 0 1 1 891.8 828.2 51.8 51.8 0 0 1 840 881.4ZM342.3 278.6V687.7A17.3 17.3 0 0 0 359.5 704.5H772.7A16.4 16.4 0 0 0 788.2 694.1 16.8 16.8 0 0 0 784.5 675.5L371.4 258.6S371.4 258.6 368.6 256.4L221.4 109.1H221.4A90.9 90.9 0 0 0 99.5 109.1 85.5 85.5 0 0 0 74.1 170 17.3 17.3 0 0 0 108.6 170 50.9 50.9 0 0 1 123.6 133.2 52.7 52.7 0 0 1 197.3 133.2H197.3ZM376.4 311.8L733.2 668.6H376.4Z"
  }));
};
IconStroller.defaultProps = {
  title: 'stroller'
};
IconStroller.propTypes = {
  title: PropTypes.string
};

var IconSuitcaseSolid = function IconSuitcaseSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-suitcase-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M943.2 369.5V783.2A125 125 0 0 1 818.2 909.1H181.8A125 125 0 0 1 56.8 784.1V369.5A125 125 0 0 1 181.8 244.5H818.2A125 125 0 0 1 943.2 369.5ZM465.9 136.4H534.1A69.1 69.1 0 0 1 603.6 205.5H649.1A114.5 114.5 0 0 0 534.1 90.9H465.9A114.5 114.5 0 0 0 350.9 206.4H396.4A69.1 69.1 0 0 1 465.9 136.4Z"
  }));
};
IconSuitcaseSolid.defaultProps = {
  title: 'suitcase solid'
};
IconSuitcaseSolid.propTypes = {
  title: PropTypes.string
};

var IconSuitcase = function IconSuitcase(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-suitcase",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M818.2 233.2H181.8A130.9 130.9 0 0 0 50.9 363.6V777.3A130.5 130.5 0 0 0 181.8 909.1H818.2A130.5 130.5 0 0 0 949.1 778.6V363.6A130.9 130.9 0 0 0 818.2 233.2ZM914.5 778.6A96.4 96.4 0 0 1 818.2 874.1H181.8A96.4 96.4 0 0 1 85.5 777.7V363.6A96.8 96.8 0 0 1 181.8 267.3H818.2A96.8 96.8 0 0 1 914.5 363.6ZM390.5 200.9H356.4A109.1 109.1 0 0 1 465.9 90.9H534.1A109.1 109.1 0 0 1 643.6 200H609.5A75.5 75.5 0 0 0 534.1 125H465.9A75.5 75.5 0 0 0 390.5 200.9Z"
  }));
};
IconSuitcase.defaultProps = {
  title: 'suitcase'
};
IconSuitcase.propTypes = {
  title: PropTypes.string
};

var IconSwitchVertical = function IconSwitchVertical(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-switch-vertical",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M636.4 79.5V860L535 758.2A29.5 29.5 0 0 0 493.6 758.2 29.1 29.1 0 0 0 485 778.6H485A29.1 29.1 0 0 0 493.6 799.1L630 935.5A53.2 53.2 0 0 0 705 935.5L841.4 799.1A27.3 27.3 0 0 0 850 778.6H850A27.3 27.3 0 0 0 841.4 758.2 29.5 29.5 0 0 0 800 758.2L698.6 859.5V79.5A29.1 29.1 0 0 0 669.1 50.5 28.6 28.6 0 0 0 648.6 58.6 30.9 30.9 0 0 0 636.4 79.5ZM363.6 920.5V140L465 241.8A29.5 29.5 0 0 0 506.4 241.8 29.1 29.1 0 0 0 515 221.4H515A29.1 29.1 0 0 0 506.4 200.9L370 64.5A53.2 53.2 0 0 0 295 64.5L158.6 200.9A27.3 27.3 0 0 0 150 221.4H150A27.3 27.3 0 0 0 158.6 241.8 29.5 29.5 0 0 0 200 241.8L305.9 140.5V920.5A28.6 28.6 0 0 0 335.5 949.5 28.6 28.6 0 0 0 355.9 941.4 30.9 30.9 0 0 0 363.6 920.5Z"
  }));
};
IconSwitchVertical.defaultProps = {
  title: 'switch vertical'
};
IconSwitchVertical.propTypes = {
  title: PropTypes.string
};

var IconSwitch = function IconSwitch(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-switch",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M83.2 363.6H863.6L761.8 465A29.5 29.5 0 0 0 761.8 506.4 30 30 0 0 0 782.7 515H782.7A29.1 29.1 0 0 0 803.2 506.4L939.5 370A53.2 53.2 0 0 0 939.5 295L803.2 158.6A27.3 27.3 0 0 0 782.7 150H782.7A28.2 28.2 0 0 0 761.8 158.6 29.5 29.5 0 0 0 761.8 200L863.6 305.9H83.2A29.5 29.5 0 0 0 54.1 335.5 29.5 29.5 0 0 0 83.2 363.6ZM924.1 636.4H144.1L245.5 534.1A29.5 29.5 0 0 0 245.5 492.7 29.1 29.1 0 0 0 227.3 484.1H227.3A30 30 0 0 0 206.4 492.7L70 629.1A53.2 53.2 0 0 0 70 704.1L206.4 840.5A28.2 28.2 0 0 0 227.3 845.5H227.3A28.6 28.6 0 0 0 247.7 837.3 30 30 0 0 0 247.7 795.5L144.1 694.1H924.1A29.5 29.5 0 0 0 953.6 664.5 29.5 29.5 0 0 0 924.1 635.5Z"
  }));
};
IconSwitch.defaultProps = {
  title: 'switch'
};
IconSwitch.propTypes = {
  title: PropTypes.string
};

var IconTablet = function IconTablet(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-tablet",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M541.4 825.9A34.1 34.1 0 1 1 507.3 792.7 33.6 33.6 0 0 1 541.4 825.9ZM800 195V803.6A106.8 106.8 0 0 1 691.8 909.1H301.8A106.8 106.8 0 0 1 193.6 804.1V195A106.8 106.8 0 0 1 301.8 90.9H692.3A106.4 106.4 0 0 1 800 195ZM231.4 174.5H762.3A74.1 74.1 0 0 0 691.8 123.2H301.8A73.2 73.2 0 0 0 231.4 174.5ZM227.3 747.3H765.9V207.7H227.3ZM765.9 780.9H227.3V804.1A72.7 72.7 0 0 0 300.9 875.9H691.4A73.2 73.2 0 0 0 765 804.1H765Z"
  }));
};
IconTablet.defaultProps = {
  title: 'tablet'
};
IconTablet.propTypes = {
  title: PropTypes.string
};

var IconTicketSolid = function IconTicketSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-ticket-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M894.5 404.5L818.2 325.9A30 30 0 0 0 783.2 318.2 76.4 76.4 0 0 1 681.8 216.8 29.1 29.1 0 0 0 674.1 181.8L595.5 105.5A29.1 29.1 0 0 0 554.1 105.5L105.5 554.1A29.1 29.1 0 0 0 105.5 595.9L181.8 674.1A29.1 29.1 0 0 0 215 681.4 75.5 75.5 0 0 1 249.1 673.2 76.4 76.4 0 0 1 318.2 783.6 28.6 28.6 0 0 0 325 816.4L404.5 895A30.5 30.5 0 0 0 445.9 895L894.5 446.4A29.1 29.1 0 0 0 894.5 404.5ZM720 520.5A28.2 28.2 0 0 1 700 528.6 30 30 0 0 1 679.5 520.5L480.5 320.9A28.6 28.6 0 0 1 520.5 280.5L720 480A29.1 29.1 0 0 1 720 520.5Z"
  }));
};
IconTicketSolid.defaultProps = {
  title: 'ticket solid'
};
IconTicketSolid.propTypes = {
  title: PropTypes.string
};

var IconTicketSpecialSolid = function IconTicketSpecialSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-ticket-special-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M894.5 404.5L818.2 325.9A30 30 0 0 0 783.2 318.2 76.4 76.4 0 0 1 681.8 216.8 29.1 29.1 0 0 0 674.1 181.8L595.5 105.5A29.1 29.1 0 0 0 554.1 105.5L105.5 554.1A29.1 29.1 0 0 0 105.5 595.9L181.8 674.1A29.1 29.1 0 0 0 215 681.4 75.5 75.5 0 0 1 249.1 673.2 76.4 76.4 0 0 1 318.2 783.6 28.6 28.6 0 0 0 325 816.4L404.5 895A30.5 30.5 0 0 0 445.9 895L894.5 446.4A29.1 29.1 0 0 0 894.5 404.5ZM488.2 586.4L448.2 642.7 427.7 576.8 363.6 558.6 420 518.6 420 449.5 475.5 490.9 540.9 468.6 518.6 534.1 557.3 590.9ZM720 518.2A28.2 28.2 0 0 1 700 526.4 30 30 0 0 1 679.5 518.2L480.5 320.9A28.6 28.6 0 0 1 520.5 280.5L720 480A29.1 29.1 0 0 1 720 520.5Z"
  }));
};
IconTicketSpecialSolid.defaultProps = {
  title: 'ticket special solid'
};
IconTicketSpecialSolid.propTypes = {
  title: PropTypes.string
};

var IconTicketSpecial = function IconTicketSpecial(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-ticket-special",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M711.8 487.7A17.3 17.3 0 0 1 700 517.3 17.7 17.7 0 0 1 687.7 512.3L488.2 312.7A17.7 17.7 0 0 1 488.2 288.6 17.3 17.3 0 0 1 512.7 288.6ZM898.6 450L450 898.6A34.5 34.5 0 0 1 400.5 898.6L321.8 820.5A35 35 0 0 1 313.6 780.9 70.9 70.9 0 0 0 250.9 678.6 71.4 71.4 0 0 0 219.1 686.4 32.7 32.7 0 0 1 205.9 689.1 39.1 39.1 0 0 1 181.8 678.2L101.4 599.5A34.5 34.5 0 0 1 101.4 550L550 101.4A34.5 34.5 0 0 1 599.5 101.4L678.2 181.8A35 35 0 0 1 686.4 221.4 70 70 0 0 0 699.5 302.7 68.6 68.6 0 0 0 749.1 323.6 71.4 71.4 0 0 0 780.9 315.9 32.7 32.7 0 0 1 794.1 313.2 39.1 39.1 0 0 1 820.5 324.1L898.6 402.7A34.5 34.5 0 0 1 898.6 450ZM874.5 425.9L796.4 345.9 794.1 345.9A95.5 95.5 0 0 1 748.6 356.8 102.3 102.3 0 0 1 675 325.9 103.6 103.6 0 0 1 655 205.9H655L655 205.9 575.5 125.5H575.5L125.5 574.1 203.6 654.1 203.6 654.1A100.9 100.9 0 0 1 249.1 643.6 102.3 102.3 0 0 1 322.7 674.5 103.6 103.6 0 0 1 342.7 794.5H342.7L342.7 794.5 421.4 872.7ZM538.2 468.6L472.7 490.9 417.3 449.5 417.3 518.6 363.6 558.6 429.5 579.1 450 645 488.2 590.9 557.3 590.9 515.9 535.5Z"
  }));
};
IconTicketSpecial.defaultProps = {
  title: 'ticket special'
};
IconTicketSpecial.propTypes = {
  title: PropTypes.string
};

var IconTicket = function IconTicket(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-ticket",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M898.6 400.5L820.5 321.8A39.1 39.1 0 0 0 794.1 310.9 32.7 32.7 0 0 0 780.9 313.6 71.4 71.4 0 0 1 749.1 321.4 68.6 68.6 0 0 1 699.5 300.5 70 70 0 0 1 686.4 219.1 35 35 0 0 0 678.2 181.8L599.5 101.4A34.5 34.5 0 0 0 550 101.4L101.4 550A34.5 34.5 0 0 0 101.4 599.5L181.8 678.2A39.5 39.5 0 0 0 208.2 689.5 33.2 33.2 0 0 0 221.4 686.4 71.4 71.4 0 0 1 253.2 678.6 70.9 70.9 0 0 1 313.6 780.9 35 35 0 0 0 321.8 820.5L400.5 898.6A34.5 34.5 0 0 0 450 898.6L898.6 450A34.5 34.5 0 0 0 898.6 400.5ZM424.5 874.5L345.9 796.4 345.9 796.4H345.9A103.6 103.6 0 0 0 325.9 676.4 102.3 102.3 0 0 0 252.3 645.5 95.5 95.5 0 0 0 206.8 656.4L206.8 656.4 125.5 574.1 574.1 125.5H574.1L652.7 203.6 652.7 203.6H652.7A103.6 103.6 0 0 0 672.7 323.6 102.3 102.3 0 0 0 746.4 354.5 95.5 95.5 0 0 0 791.8 343.6L794.1 343.6 872.3 423.6ZM711.8 488.2A16.8 16.8 0 0 1 711.8 512.3 17.3 17.3 0 0 1 700 517.3 17.7 17.7 0 0 1 687.7 512.3L488.2 312.7A17.7 17.7 0 0 1 488.2 288.6 17.3 17.3 0 0 1 512.7 288.6Z"
  }));
};
IconTicket.defaultProps = {
  title: 'ticket'
};
IconTicket.propTypes = {
  title: PropTypes.string
};

var IconTimeSolid = function IconTimeSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-time-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 90.9A409.1 409.1 0 1 0 909.1 500 409.1 409.1 0 0 0 500 90.9ZM700 697.3A28.6 28.6 0 0 1 680 705.9 30.5 30.5 0 0 1 659.5 697.3L480 517.7A28.2 28.2 0 0 1 471.8 497.7V198.2A28.6 28.6 0 0 1 528.6 198.2V485.9L700 657.3A28.6 28.6 0 0 1 700 697.3Z"
  }));
};
IconTimeSolid.defaultProps = {
  title: 'time solid'
};
IconTimeSolid.propTypes = {
  title: PropTypes.string
};

var IconTime = function IconTime(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-time",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M690.5 656.8A22.3 22.3 0 0 1 690.5 688.2 21.8 21.8 0 0 1 659.5 688.2L484.5 513.2A21.8 21.8 0 0 1 478.2 497.7V206.4A21.4 21.4 0 0 1 500 184.5 21.8 21.8 0 0 1 522.3 206.4V488.6ZM909.1 500A409.1 409.1 0 1 1 500 90.9 409.1 409.1 0 0 1 909.1 500ZM863.6 500A363.6 363.6 0 1 0 500 863.6 363.6 363.6 0 0 0 863.6 500Z"
  }));
};
IconTime.defaultProps = {
  title: 'time'
};
IconTime.propTypes = {
  title: PropTypes.string
};

var IconToiletSolid = function IconToiletSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-toilet-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M85.5 590.9H870.9C853.6 762.3 714.5 933.6 513.2 933.6H141.4A55.9 55.9 0 0 1 85.5 877.3ZM839.1 420H436.4A75.9 75.9 0 0 0 360.5 495.9V532.7H905.9A71.8 71.8 0 0 0 915.9 495.9 75.5 75.5 0 0 0 839.1 420ZM318.2 152.7A85.5 85.5 0 0 0 230.9 67.7H170.5A85 85 0 0 0 85.5 152.7V532.7H318.2Z"
  }));
};
IconToiletSolid.defaultProps = {
  title: 'toilet solid'
};
IconToiletSolid.propTypes = {
  title: PropTypes.string
};

var IconToilet = function IconToilet(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-toilet",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M839.1 420H436.4A75.9 75.9 0 0 0 360.5 495.9V537.3H298.6A83.2 83.2 0 0 0 318.2 486.4V152.7A85.5 85.5 0 0 0 230.9 67.7H170.5A85 85 0 0 0 85.5 152.7V875.9A55.9 55.9 0 0 0 141.4 932.3H513.2C725 932.3 868.2 743.2 872.7 563.2A75.5 75.5 0 0 0 839.1 420ZM119.1 152.7A51.4 51.4 0 0 1 170.5 101.8H230.9A51.4 51.4 0 0 1 282.3 152.7V486.4A51.4 51.4 0 0 1 230.9 537.3H119.1ZM513.2 898.2H141.4A22.3 22.3 0 0 1 119.1 875.9V571.4H838.6C830 732.3 701.4 898.2 513.2 898.2ZM839.1 537.3H394.5V495.9A41.8 41.8 0 0 1 436.4 454.5H839.1A41.8 41.8 0 1 1 839.1 537.7Z"
  }));
};
IconToilet.defaultProps = {
  title: 'toilet'
};
IconToilet.propTypes = {
  title: PropTypes.string
};

var IconTrainNightSolid = function IconTrainNightSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-train-night-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M376.4 644.1A56.8 56.8 0 1 1 433.2 700.9 56.8 56.8 0 0 1 376.4 644.1ZM642.3 574.5A286.4 286.4 0 0 0 743.2 555.9V706.4A150.5 150.5 0 0 1 646.4 846.4L716.4 916.4A16.8 16.8 0 1 1 692.3 940.5L669.5 917.7H196.4L173.6 940.5A16.8 16.8 0 1 1 149.5 916.4L219.5 846.4A150.5 150.5 0 0 1 122.7 706.4V272.7A150.9 150.9 0 0 1 272.7 123.6H409.1A297.7 297.7 0 0 0 372.7 193.2H281.8A90.9 90.9 0 0 0 190.9 284.1V425.9A90.9 90.9 0 0 0 281.8 516.8H470.9A280.9 280.9 0 0 0 642.3 574.5ZM342.3 644.1A90.9 90.9 0 1 0 433.2 553.2 90.9 90.9 0 0 0 342.3 644.1ZM234.1 775H267.3A25 25 0 0 0 267.3 725H234.1A25 25 0 0 0 234.1 775ZM636.4 883.6L607.7 855C603.2 855 598.6 855 594.1 855H272.7C268.2 855 263.6 855 259.1 855L230.5 883.6ZM631.8 727.3H598.6A25 25 0 0 0 598.6 777.3H631.8A25 25 0 1 0 631.8 727.3ZM877.3 291.4A234.5 234.5 0 1 1 642.3 54.5 235.5 235.5 0 0 1 877.3 289.1ZM754.1 395.5A15 15 0 0 0 740 385.9 146.8 146.8 0 0 1 684.1 377.3 149.5 149.5 0 0 1 590.9 213.2H590.9A153.2 153.2 0 0 1 611.4 160.9 15.9 15.9 0 0 0 611.4 143.6 15 15 0 0 0 590.9 138.6 161.8 161.8 0 0 0 479.5 261.4 168.2 168.2 0 0 0 590.9 446.8 156.8 156.8 0 0 0 642.7 455.5 160.5 160.5 0 0 0 752.7 410 14.1 14.1 0 0 0 754.1 395.5ZM764.1 231.4L727.3 227.3 710 192.7 691.8 227.3 653.6 232.7 681.4 259.5 674.5 297.7 708.6 280 743.2 297.7 736.4 259.5Z"
  }));
};
IconTrainNightSolid.defaultProps = {
  title: 'train night solid'
};
IconTrainNightSolid.propTypes = {
  title: PropTypes.string
};

var IconTrainNight = function IconTrainNight(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-train-night",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M435.5 552.7A90.9 90.9 0 1 0 526.4 643.6 90.9 90.9 0 0 0 435.5 552.7ZM435.5 700.5A56.8 56.8 0 1 1 492.3 643.6 56.8 56.8 0 0 1 435.5 700.5ZM287.7 745.9A17.3 17.3 0 0 1 270.5 763.2H237.3A17.3 17.3 0 0 1 237.3 729.1H272.7A17.3 17.3 0 0 1 287.7 747.7ZM874.5 288.6A233.2 233.2 0 0 0 476.4 123.6H275.5A150.5 150.5 0 0 0 125.5 272.7V705.5A149.5 149.5 0 0 0 222.3 845.5L152.3 915.9A16.8 16.8 0 0 0 152.3 940 17.7 17.7 0 0 0 176.4 940L199.1 916.8H672.3L695 940A17.7 17.7 0 0 0 719.1 940 16.8 16.8 0 0 0 719.1 915.9L649.1 845.5A149.5 149.5 0 0 0 745.9 705.9V495.9H745.9A233.2 233.2 0 0 0 874.5 288.6ZM233.2 882.7L261.8 854.5 275.5 854.5H595.9L609.5 854.5 638.2 882.7ZM711.8 509.5V705.9A116.4 116.4 0 0 1 595.9 821.8H277.7A116.4 116.4 0 0 1 161.8 705.9V272.7A115.9 115.9 0 0 1 275.5 157.3H448.6L429.1 192.7H284.5A90.9 90.9 0 0 0 193.6 283.6V425.5A90.9 90.9 0 0 0 284.5 516.4H590.9L590.9 516.4A223.2 223.2 0 0 0 643.6 523.2 232.3 232.3 0 0 0 714.5 510.9ZM515.9 484.5L511.4 482.3H284.1A57.3 57.3 0 0 1 227.3 425.5V283.2A57.3 57.3 0 0 1 284.5 227.3H417.7A220.5 220.5 0 0 0 409.1 288.6 231.8 231.8 0 0 0 515.9 484.5ZM641.4 487.7A199.5 199.5 0 1 1 840.5 288.6 199.5 199.5 0 0 1 641.4 487.7ZM633.6 730.9A17.3 17.3 0 1 1 633.6 765H600.9A17.3 17.3 0 1 1 600.9 730.9ZM754.1 395.5A14.1 14.1 0 0 1 750.5 411.8 160.5 160.5 0 0 1 640.5 457.3 156.8 156.8 0 0 1 590.9 446.8 168.2 168.2 0 0 1 483.6 261.4 161.8 161.8 0 0 1 590.9 138.6 15 15 0 0 1 607.3 143.6 15.9 15.9 0 0 1 607.3 160.9 153.2 153.2 0 0 0 590.9 213.2H590.9A149.5 149.5 0 0 0 684.1 377.3 146.8 146.8 0 0 0 740 385.9 15 15 0 0 1 754.1 395.5ZM727.3 227.3L765.5 232.7 737.7 259.5 744.5 297.7 710 280 675.9 297.7 681.8 258.2 654.1 231.4 691.8 227.3 708.6 192.7Z"
  }));
};
IconTrainNight.defaultProps = {
  title: 'train night'
};
IconTrainNight.propTypes = {
  title: PropTypes.string
};

var IconTrainServiceSolid = function IconTrainServiceSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-train-service-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M376.4 644.1A56.8 56.8 0 1 1 433.2 700.9 56.8 56.8 0 0 1 376.4 644.1ZM642.3 574.5A286.4 286.4 0 0 0 743.2 555.9V706.4A150.5 150.5 0 0 1 646.4 846.4L716.4 916.4A16.8 16.8 0 1 1 692.3 940.5L669.5 917.7H196.4L173.6 940.5A16.8 16.8 0 1 1 149.5 916.4L219.5 846.4A150.5 150.5 0 0 1 122.7 706.4V272.7A150.9 150.9 0 0 1 272.7 123.6H409.1A297.7 297.7 0 0 0 372.7 193.2H281.8A90.9 90.9 0 0 0 190.9 284.1V425.9A90.9 90.9 0 0 0 281.8 516.8H470.9A280.9 280.9 0 0 0 642.3 574.5ZM342.3 644.1A90.9 90.9 0 1 0 433.2 553.2 90.9 90.9 0 0 0 342.3 644.1ZM234.1 775H267.3A25 25 0 0 0 267.3 725H234.1A25 25 0 0 0 234.1 775ZM636.4 883.6L607.7 855C603.2 855 598.6 855 594.1 855H272.7C268.2 855 263.6 855 259.1 855L230.5 883.6ZM631.8 727.3H598.6A25 25 0 0 0 598.6 777.3H631.8A25 25 0 1 0 631.8 727.3ZM877.3 291.4A234.5 234.5 0 1 1 642.3 54.5 235.5 235.5 0 0 1 877.3 289.1ZM791.8 291.4A28.6 28.6 0 0 0 763.2 263.2H672.3V172.3A28.6 28.6 0 0 0 615.5 172.3V263.2H524.5A28.6 28.6 0 0 0 524.5 320H615.5V409.1A28.6 28.6 0 1 0 672.3 409.1V318.2H763.2A28.6 28.6 0 0 0 791.8 289.1Z"
  }));
};
IconTrainServiceSolid.defaultProps = {
  title: 'train service solid'
};
IconTrainServiceSolid.propTypes = {
  title: PropTypes.string
};

var IconTrainService = function IconTrainService(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-train-service",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M287.7 747.7A17.3 17.3 0 0 1 270.5 765H237.3A17.3 17.3 0 0 1 237.3 730.9H272.7A17.3 17.3 0 0 1 287.7 747.7ZM526.4 643.6A90.9 90.9 0 1 1 435.5 552.7 90.9 90.9 0 0 1 526.4 643.6ZM492.3 643.6A56.8 56.8 0 1 0 435.5 700.5 56.8 56.8 0 0 0 492.3 643.6ZM600.9 730.9A17.3 17.3 0 1 0 600.9 765H633.6A17.3 17.3 0 1 0 633.6 730.9ZM745 496.4H745V706.4A149.5 149.5 0 0 1 648.2 845.9L718.2 916.4A16.8 16.8 0 0 1 718.2 940.5 17.7 17.7 0 0 1 694.1 940.5L671.4 917.3H199.1L176.4 940.5A17.7 17.7 0 0 1 152.3 940.5 16.8 16.8 0 0 1 152.3 916.4L222.3 845.5A149.5 149.5 0 0 1 125.5 705.9V272.7A150.5 150.5 0 0 1 275.5 122.7H476.4A232.7 232.7 0 1 1 745 495.5ZM636.4 882.7L607.7 854.5 594.1 854.5H275.9L262.3 854.5 233.6 882.7ZM710.5 509.5A232.3 232.3 0 0 1 639.5 521.8 223.2 223.2 0 0 1 590.9 515L590.9 515H284.5A90.9 90.9 0 0 1 193.6 424.1V283.2A90.9 90.9 0 0 1 284.5 192.3H429.1L448.6 156.8H275.5A115.9 115.9 0 0 0 159.5 272.7V705.5A116.4 116.4 0 0 0 275.5 821.4H595.9A116.4 116.4 0 0 0 711.8 705.5V509.5ZM409.1 288.6A220.5 220.5 0 0 1 417.7 227.3H284.5A57.3 57.3 0 0 0 227.3 283.2V425.5A57.3 57.3 0 0 0 284.1 482.3H511.4L515.9 484.5A231.8 231.8 0 0 1 409.1 288.6ZM841.4 288.6A199.1 199.1 0 1 0 642.3 487.7 199.5 199.5 0 0 0 840.5 288.6ZM762.3 272.7H658.2V167.7A17.3 17.3 0 1 0 624.1 167.7V272.7H520.5A17.3 17.3 0 1 0 520.5 306.8H624.1V409.1A17.3 17.3 0 0 0 658.2 409.1V305.5H762.3A17.3 17.3 0 0 0 762.3 271.4Z"
  }));
};
IconTrainService.defaultProps = {
  title: 'train service'
};
IconTrainService.propTypes = {
  title: PropTypes.string
};

var IconTrainSolid = function IconTrainSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-train-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M810 671.8V239.1A150.5 150.5 0 0 0 660 90.9H341.8A150.5 150.5 0 0 0 191.8 240.9V673.6A150.9 150.9 0 0 0 288.6 813.6L216.4 881.8A17.7 17.7 0 0 0 216.4 905.9 16.8 16.8 0 0 0 240.5 905.9L263.6 883.2H736.4L759.5 905.9A16.8 16.8 0 0 0 783.6 905.9 17.7 17.7 0 0 0 783.6 881.8L713.2 811.8A150.9 150.9 0 0 0 810 671.8ZM276.4 717.3A25 25 0 0 1 301.4 692.3H334.5A25 25 0 0 1 334.5 742.3H301.4A25 25 0 0 1 276.4 715.5ZM297.7 850.9L325.9 822.3A136.4 136.4 0 0 0 340 822.3H658.2A136.4 136.4 0 0 0 672.3 822.3L700.5 850.9ZM409.1 609.5A90.9 90.9 0 1 1 500 700.5 90.9 90.9 0 0 1 409.1 609.5ZM698.6 740.5H665.9A25 25 0 1 1 665.9 690.5H698.6A25 25 0 0 1 698.6 740.5ZM744.1 391.4A90.9 90.9 0 0 1 653.2 482.3H349.1A90.9 90.9 0 0 1 258.2 391.4V249.5A90.9 90.9 0 0 1 349.1 158.6H650.9A90.9 90.9 0 0 1 741.8 249.5ZM500 666.4A56.8 56.8 0 1 1 556.8 609.5 56.8 56.8 0 0 1 500 666.4Z"
  }));
};
IconTrainSolid.defaultProps = {
  title: 'train solid'
};
IconTrainSolid.propTypes = {
  title: PropTypes.string
};

var IconTrainStopSolid = function IconTrainStopSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-train-stop-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M371.8 175V265.9A15.9 15.9 0 0 1 355.9 281.8H119.5V827.3A15.9 15.9 0 0 1 103.6 843.2 15.9 15.9 0 0 1 87.7 827.3V175A15.9 15.9 0 0 1 103.6 159.5H355.9A15.9 15.9 0 0 1 371.8 175ZM701.8 590.9A45.5 45.5 0 1 0 656.4 636.4 45.5 45.5 0 0 0 701.8 590.9ZM831.4 758.2L889.5 818.2A14.1 14.1 0 1 1 869.5 838.2L850.9 818.2H458.2L439.5 836.8A14.1 14.1 0 0 1 419.5 836.8 13.6 13.6 0 0 1 419.5 816.8L477.7 758.6A124.1 124.1 0 0 1 397.3 642.7V283.6A124.5 124.5 0 0 1 521.8 159.1H787.3A124.5 124.5 0 0 1 911.8 283.6V642.3A124.1 124.1 0 0 1 831.4 758.2ZM489.5 699.1H517.3A20.5 20.5 0 0 0 537.7 678.6 20.9 20.9 0 0 0 517.3 657.7H489.5A20.9 20.9 0 0 0 469.1 678.6 20.5 20.5 0 0 0 489.5 699.1ZM822.3 790L798.6 766.8 787.3 766.8H521.8L510 766.8 486.8 790ZM654.5 667.3A75.5 75.5 0 1 0 579.1 590.9 75.5 75.5 0 0 0 654.5 666.4ZM840 679.5A20.9 20.9 0 0 0 819.5 658.6H791.8A20.9 20.9 0 0 0 771.4 679.5 20.5 20.5 0 0 0 791.8 700H818.2A20.5 20.5 0 0 0 840 678.6ZM855 293.2A75.5 75.5 0 0 0 779.5 217.7H529.1A75 75 0 0 0 454.5 292.3V409.1A75 75 0 0 0 529.5 484.5H780A75.5 75.5 0 0 0 855 409.1Z"
  }));
};
IconTrainStopSolid.defaultProps = {
  title: 'train stop solid'
};
IconTrainStopSolid.propTypes = {
  title: PropTypes.string
};

var IconTrainStop = function IconTrainStop(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-train-stop",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M533.6 676.8A15.5 15.5 0 0 1 518.2 692.3H490.9A15.5 15.5 0 0 1 490.9 661.4H518.2A15.5 15.5 0 0 1 533.6 676.8ZM371.8 176.8V267.7A15.9 15.9 0 0 1 355.9 283.6H119.5V829.1A15.9 15.9 0 0 1 103.6 845 15.9 15.9 0 0 1 87.7 829.1V175A15.9 15.9 0 0 1 103.6 159.5H355.9A15.9 15.9 0 0 1 371.8 175ZM340 193.2H119.5V249.5H340ZM818.2 661.4H790.9A15.5 15.5 0 0 0 790.9 692.3H818.2A15.5 15.5 0 0 0 818.2 661.4ZM729.5 590.9A75 75 0 1 1 654.5 515.9 75 75 0 0 1 729.5 590.9ZM701.4 590.9A45.5 45.5 0 1 0 655.9 636.4 45.5 45.5 0 0 0 701.4 590.9ZM833.2 758.2L889.5 814.5A15.5 15.5 0 0 1 889.5 836.8 15.5 15.5 0 0 1 867.7 836.8L849.1 818.2H460L441.4 836.8A15.9 15.9 0 0 1 419.1 836.8 16.4 16.4 0 0 1 419.1 814.5L475.9 758.2A126.4 126.4 0 0 1 396.8 642.3V284.5A125.9 125.9 0 0 1 522.3 159.1H786.8A125.9 125.9 0 0 1 912.3 284.5V641.8A126.4 126.4 0 0 1 833.2 757.7ZM818.2 787.3L797.7 766.8H511.4L490.9 787.3ZM880.9 642.3V284.5A94.1 94.1 0 0 0 786.8 190.5H522.3A94.1 94.1 0 0 0 428.2 284.5V641.8A94.5 94.5 0 0 0 522.3 736.4H786.8A94.5 94.5 0 0 0 880.9 641.8ZM855.9 293.6V409.1A76.8 76.8 0 0 1 779.1 485.5H530A76.8 76.8 0 0 1 454.5 409.1V293.2A76.8 76.8 0 0 1 531.4 216.4H780.5A76.8 76.8 0 0 1 855.9 293.2ZM824.5 293.6A45.5 45.5 0 0 0 779.1 248.2H530A45.5 45.5 0 0 0 484.5 293.6V409.1A45.5 45.5 0 0 0 530 454.5H779.1A45.5 45.5 0 0 0 824.5 409.1Z"
  }));
};
IconTrainStop.defaultProps = {
  title: 'train stop'
};
IconTrainStop.propTypes = {
  title: PropTypes.string
};

var IconTrainTimeSolid = function IconTrainTimeSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-train-time-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M642.3 54.5A234.5 234.5 0 1 0 877.3 289.1 233.2 233.2 0 0 0 642.3 54.5ZM760 405A25.5 25.5 0 0 1 724.5 405L625 305.5A23.2 23.2 0 0 1 617.7 287.7V121.8A25 25 0 0 1 642.3 96.8 25 25 0 0 1 667.3 121.8V277.7L758.2 368.6A25 25 0 0 1 760 405ZM376.4 644.1A56.8 56.8 0 1 1 433.2 700.9 56.8 56.8 0 0 1 376.4 644.1ZM470.9 516.8H281.8A90.9 90.9 0 0 1 190.9 425.9V284.1A90.9 90.9 0 0 1 281.8 193.2H372.7A297.7 297.7 0 0 1 409.1 123.6H272.7A150.9 150.9 0 0 0 122.7 272.7V705.5A150.5 150.5 0 0 0 219.5 845.5L149.5 916.4A16.8 16.8 0 1 0 173.6 940.5L196.4 917.7H669.5L692.3 940.5A16.8 16.8 0 1 0 716.4 916.4L646.4 846.4A150.5 150.5 0 0 0 743.2 706.4V555.9A286.4 286.4 0 0 1 642.3 574.5 280.9 280.9 0 0 1 470.9 516.8ZM433.2 553.2A90.9 90.9 0 1 1 342.3 644.1 90.9 90.9 0 0 1 433.2 553.2ZM209.5 750A25 25 0 0 1 234.1 727.3H267.3A25 25 0 0 1 267.3 777.3H234.1A25 25 0 0 1 209.5 750ZM230.5 883.6L259.1 855C263.6 855 268.2 855 272.7 855H593.2C597.7 855 602.3 855 606.8 855L635.5 883.6ZM656.8 750A25 25 0 0 1 631.8 775H598.6A25 25 0 0 1 598.6 725H631.8A25 25 0 0 1 656.8 750Z"
  }));
};
IconTrainTimeSolid.defaultProps = {
  title: 'train time solid'
};
IconTrainTimeSolid.propTypes = {
  title: PropTypes.string
};

var IconTrainTime = function IconTrainTime(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-train-time",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M874.5 288.6A233.2 233.2 0 0 0 476.4 123.6H275.5A150.5 150.5 0 0 0 125.5 272.7V705.5A149.5 149.5 0 0 0 222.3 845.5L152.3 915.9A16.8 16.8 0 0 0 152.3 940 17.7 17.7 0 0 0 176.4 940L199.1 916.8H672.3L695 940A17.7 17.7 0 0 0 719.1 940 16.8 16.8 0 0 0 719.1 915.9L649.1 845.5A149.5 149.5 0 0 0 745.9 705.9V495.9H745.9A233.2 233.2 0 0 0 874.5 288.6ZM233.2 882.7L261.8 854.5 275.5 854.5H595.9L609.5 854.5 638.2 882.7ZM429.1 192.7H284.5A90.9 90.9 0 0 0 193.6 283.6V425.5A90.9 90.9 0 0 0 284.5 516.4H590.9L590.9 516.4A223.2 223.2 0 0 0 643.6 523.2 232.3 232.3 0 0 0 714.5 510.9H714.5V707.3A116.4 116.4 0 0 1 598.6 823.2H280.5A116.4 116.4 0 0 1 164.5 707.3V272.7A115.9 115.9 0 0 1 275.5 157.3H448.6M417.7 227.3A220.5 220.5 0 0 0 409.1 288.6 234.1 234.1 0 0 0 550 502.7 272.7 272.7 0 0 1 512.3 482.3H285A57.3 57.3 0 0 1 227.3 425.5V283.2A57.3 57.3 0 0 1 284.5 227.3H417.7ZM641.4 489.1A199.5 199.5 0 1 1 840.5 290 199.5 199.5 0 0 1 641.4 487.7ZM752.3 375.5A16.8 16.8 0 0 1 752.3 399.5 17.7 17.7 0 0 1 740 404.5 17.3 17.3 0 0 1 727.3 398.2L629.1 299.1A16.4 16.4 0 0 1 624.1 287.3V122.3A17.3 17.3 0 0 1 658.2 122.3V280ZM434.1 554.1A90.9 90.9 0 1 0 525 645 90.9 90.9 0 0 0 435.5 552.7ZM434.1 701.8A56.8 56.8 0 1 1 490.9 645 56.8 56.8 0 0 1 435.5 700.5ZM632.3 732.3A17.3 17.3 0 1 1 632.3 766.4H599.5A17.3 17.3 0 1 1 599.5 732.3ZM286.4 749.1A17.3 17.3 0 0 1 269.1 766.4H237.3A17.3 17.3 0 0 1 237.3 732.3H272.7A17.3 17.3 0 0 1 287.7 747.7Z"
  }));
};
IconTrainTime.defaultProps = {
  title: 'train time'
};
IconTrainTime.propTypes = {
  title: PropTypes.string
};

var IconTrainWagonSolid = function IconTrainWagonSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-train-wagon-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M77.7 569.1H922.3A17.7 17.7 0 0 0 940 551.4V377.3A17.7 17.7 0 0 0 922.3 359.5 17.3 17.3 0 0 0 940 341.8V332.7A17.3 17.3 0 0 0 922.3 315H77.7A17.3 17.3 0 0 0 60 332.7V341.8A17.3 17.3 0 0 0 77.7 359.5 17.7 17.7 0 0 0 60 377.3V551.4A17.7 17.7 0 0 0 77.7 569.1ZM788.6 412.3A17.7 17.7 0 0 1 806.4 395H897.3A17.3 17.3 0 0 1 914.5 412.3V480.9A17.3 17.3 0 0 1 897.3 498.6H806.4A17.7 17.7 0 0 1 788.6 480.9ZM612.7 412.3A17.3 17.3 0 0 1 630 395H720.9A17.7 17.7 0 0 1 738.6 412.3V480.9A17.7 17.7 0 0 1 720.9 498.6H630A17.3 17.3 0 0 1 612.7 480.9ZM436.4 412.3A17.3 17.3 0 0 1 454.5 395H545.5A17.3 17.3 0 0 1 563.2 412.3V480.9A17.3 17.3 0 0 1 545.5 500H454.5A17.3 17.3 0 0 1 436.8 482.3ZM260 412.3A17.7 17.7 0 0 1 277.7 395H368.6A17.3 17.3 0 0 1 385.9 412.3V480.9A17.3 17.3 0 0 1 368.6 498.6H277.7A17.7 17.7 0 0 1 260 480.9ZM84.1 412.3A17.3 17.3 0 0 1 101.8 395H192.7A17.7 17.7 0 0 1 210.5 412.3V480.9A17.7 17.7 0 0 1 192.7 498.6H101.8A17.3 17.3 0 0 1 84.1 480.9ZM977.3 576.4V593.2H919.5V619.1H878.2A42.3 42.3 0 0 1 883.2 639.1 45.5 45.5 0 1 1 792.3 639.1 48.2 48.2 0 0 1 797.3 619.1H772.7A48.2 48.2 0 0 1 777.7 639.1 45.5 45.5 0 1 1 686.8 639.1 42.3 42.3 0 0 1 691.8 619.1H650.5V593.2H550.5V619.1H450.5V593.2H350.9V619.1H309.5A48.2 48.2 0 0 1 314.5 639.1 45.5 45.5 0 1 1 223.6 639.1 42.3 42.3 0 0 1 227.3 619.1H203.6A42.3 42.3 0 0 1 208.6 639.1 45.5 45.5 0 1 1 117.7 639.1 42.3 42.3 0 0 1 122.7 619.1H81.8V593.2H22.7V576.4Z"
  }));
};
IconTrainWagonSolid.defaultProps = {
  title: 'train wagon solid'
};
IconTrainWagonSolid.propTypes = {
  title: PropTypes.string
};

var IconTrain = function IconTrain(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-train",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M810 671.8V239.1A150.5 150.5 0 0 0 660 90.9H341.8A150.5 150.5 0 0 0 191.8 240.9V673.6A150.9 150.9 0 0 0 288.6 813.6L216.4 881.8A17.7 17.7 0 0 0 216.4 905.9 16.8 16.8 0 0 0 240.5 905.9L263.6 883.2H736.4L759.5 905.9A16.8 16.8 0 0 0 783.6 905.9 17.7 17.7 0 0 0 783.6 881.8L713.2 811.8A150.9 150.9 0 0 0 810 671.8ZM297.7 849.1L325.9 820.5A136.4 136.4 0 0 0 340 820.5H658.2A136.4 136.4 0 0 0 672.3 820.5L700.5 849.1ZM661.4 787.7H343.2A115.9 115.9 0 0 1 227.3 671.8V239.1A115.9 115.9 0 0 1 340 123.2H658.2A115.9 115.9 0 0 1 774.1 239.1V671.8A115.9 115.9 0 0 1 660 787.7ZM351.8 714.1A16.8 16.8 0 0 1 335 730.9H301.8A16.4 16.4 0 0 1 285 714.1 16.8 16.8 0 0 1 301.8 696.8H335A17.3 17.3 0 0 1 351.8 714.1ZM715.5 714.1A16.4 16.4 0 0 1 698.6 730.9H665.5A16.8 16.8 0 0 1 648.6 714.1 17.3 17.3 0 0 1 665.5 696.8H698.6A16.8 16.8 0 0 1 715 714.1ZM650.9 158.6H349.1A90.9 90.9 0 0 0 258.2 249.5V391.4A90.9 90.9 0 0 0 349.1 482.3H650.9A90.9 90.9 0 0 0 741.8 391.4V249.5A90.9 90.9 0 0 0 650.9 158.6ZM707.7 283.6V391.4A56.8 56.8 0 0 1 650.9 448.2H349.1A56.8 56.8 0 0 1 292.3 391.4V249.5A56.8 56.8 0 0 1 349.1 192.7H650.9A56.8 56.8 0 0 1 707.7 249.5ZM500 518.6A90.9 90.9 0 1 0 590.9 609.5 90.9 90.9 0 0 0 500 518.6ZM500 666.4A56.8 56.8 0 1 1 556.8 609.5 56.8 56.8 0 0 1 500 666.4Z"
  }));
};
IconTrain.defaultProps = {
  title: 'train'
};
IconTrain.propTypes = {
  title: PropTypes.string
};

var IconTransferSolid = function IconTransferSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-transfer-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M711.4 430.9L685.5 514.5 685.5 514.5 812.3 641.4A50.5 50.5 0 0 1 825.9 667.3L853.2 822.7A45.5 45.5 0 0 1 845 858.6 45.5 45.5 0 0 1 814.1 878.2L805.9 878.2A48.2 48.2 0 0 1 760.5 838.6L735.9 697.7 653.6 615.5 633.6 681.8A125.9 125.9 0 0 1 622.3 703.2L520.9 878.6A45.5 45.5 0 0 1 479.5 902.7 51.4 51.4 0 0 1 455.5 896.4 47.7 47.7 0 0 1 433.2 863.6 48.2 48.2 0 0 1 438.2 827.3L538.2 653.6V653.6L588.6 426.4 528.2 500 524.1 503.2A9.1 9.1 0 0 1 524.1 507.3L387.7 671.4V671.4L276.8 801.4H276.8A78.6 78.6 0 0 0 217.7 774.5 80.5 80.5 0 0 0 145 822.3L142.7 822.3 120 803.2A48.6 48.6 0 0 1 102.7 770.5 49.5 49.5 0 0 1 114.1 735.5L255.9 566.4A49.1 49.1 0 0 1 288.2 549.5 45.5 45.5 0 0 1 323.2 560.5L378.2 605.9 378.2 605.9 461.4 506.8S461.4 506.8 461.4 506.8A48.6 48.6 0 0 1 454.5 439.5L595.9 272.7C610.9 255.5 641.4 252.3 677.3 262.3L709.5 270.9A29.5 29.5 0 0 1 717.3 274.5V272.7A48.2 48.2 0 0 1 743.2 294.1L804.5 400.5S807.3 404.1 807.7 405L883.6 480.9A45.5 45.5 0 0 1 897.7 514.5 48.2 48.2 0 0 1 883.6 548.6 45.5 45.5 0 0 1 850 562.7H850A45.5 45.5 0 0 1 815.9 548.6L738.6 470.9A70.9 70.9 0 0 1 727.3 454.5ZM709.1 222.7A61.8 61.8 0 1 0 647.3 161.4 61.8 61.8 0 0 0 709.1 222.7ZM217.3 809.1A45.5 45.5 0 0 0 171.8 844.1 42.3 42.3 0 0 0 169.5 855 45.5 45.5 0 0 0 260.5 855 48.2 48.2 0 0 0 215 809.5Z"
  }));
};
IconTransferSolid.defaultProps = {
  title: 'transfer solid'
};
IconTransferSolid.propTypes = {
  title: PropTypes.string
};

var IconTransfer = function IconTransfer(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-transfer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M720.9 458.6A90.9 90.9 0 0 0 734.5 475L811.8 552.7A54.5 54.5 0 0 0 887.7 552.7 54.5 54.5 0 0 0 903.2 514.5 53.2 53.2 0 0 0 887.7 476.8L812.7 401.8 748.2 291.4A55.9 55.9 0 0 0 719.1 267.3L678.6 255.9C636.4 245 608.2 249.1 590.9 268.2L450.5 435.9A54.5 54.5 0 0 0 438.2 475.5 52.7 52.7 0 0 0 456.8 511.8 66.8 66.8 0 0 0 474.5 521.4L394.1 617.3A45.5 45.5 0 0 0 381.4 601.8L326.4 556.4A54.1 54.1 0 0 0 250.9 562.7L109.1 730.9A53.6 53.6 0 0 0 115.9 806.4L138.6 825.9A16.8 16.8 0 0 0 149.5 829.5 16.4 16.4 0 0 0 162.7 823.6 17.3 17.3 0 0 0 160.5 799.5L136.4 780.5A19.5 19.5 0 0 1 129.5 767.3 18.6 18.6 0 0 1 134.1 752.7L277.3 584.1A18.6 18.6 0 0 1 290.5 576.8 22.7 22.7 0 0 1 304.5 581.4L359.5 626.8A20 20 0 0 1 362.3 654.1L358.2 658.6H358.2L255 781.4A17.7 17.7 0 0 0 255 805.5 17.3 17.3 0 0 0 279.1 805.5L388.2 677.3H388.2L532.3 505.5 577.7 450.9 532.3 652.3 433.2 825.9A53.6 53.6 0 0 0 454.5 899.1 56.4 56.4 0 0 0 481.4 906.4 54.5 54.5 0 0 0 526.8 879.5L628.2 703.6A121.8 121.8 0 0 0 640 681.4L656.8 628.2 730.9 702.7 755.5 841.8A54.1 54.1 0 0 0 777.7 876.4 52.7 52.7 0 0 0 808.2 885.9H818.2A54.1 54.1 0 0 0 852.7 863.6 52.3 52.3 0 0 0 861.4 823.6L834.1 668.2A57.3 57.3 0 0 0 819.1 639.1L693.2 513.2 714.5 445.5ZM742.7 350.5L781.4 417.3A81.4 81.4 0 0 0 788.6 425.9L863.6 500A19.1 19.1 0 0 1 869.1 513.6 19.5 19.5 0 0 1 835.9 527.7L758.6 450A36.8 36.8 0 0 1 750.5 440.5L727.3 400.9ZM793.2 662.3A21.4 21.4 0 0 1 799.1 673.6L826.4 829.1A18.6 18.6 0 0 1 823.2 843.6 19.1 19.1 0 0 1 810.9 851.8 20 20 0 0 1 796.4 848.6 19.5 19.5 0 0 1 788.2 835.9L762.7 691.4A14.1 14.1 0 0 0 757.7 682.3L666.8 591.4 680 549.5ZM606.4 670.9A75 75 0 0 1 596.8 688.2L496.4 863.6A19.5 19.5 0 0 1 469.5 870.9 19.5 19.5 0 0 1 462.7 844.1L562.3 671.4 562.3 669.1A21.4 21.4 0 0 0 562.3 661.4L622.7 391.4A16.8 16.8 0 0 0 613.6 372.3 17.7 17.7 0 0 0 593.2 376.8L502.3 484.5A19.5 19.5 0 1 1 472.3 459.5L613.2 291.8C620 284.1 640 283.2 665.9 291.8L698.2 300.5A19.1 19.1 0 0 1 711.8 325ZM709.1 227.3A67.7 67.7 0 1 0 641.4 160 67.7 67.7 0 0 0 709.1 227.3ZM709.1 126.4A33.6 33.6 0 1 1 675.5 160 33.6 33.6 0 0 1 709.1 127.7ZM217.3 803.6A51.4 51.4 0 1 0 268.6 855 51.4 51.4 0 0 0 217.3 803.6ZM217.3 872.3A17.3 17.3 0 1 1 234.5 855 17.3 17.3 0 0 1 217.3 872.3Z"
  }));
};
IconTransfer.defaultProps = {
  title: 'transfer'
};
IconTransfer.propTypes = {
  title: PropTypes.string
};

var IconTripSolid = function IconTripSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-trip-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1194 1194"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M427.7 769.1A33.6 33.6 0 0 1 427.7 817.3 33.2 33.2 0 0 1 403.6 827.3 33.6 33.6 0 0 1 379.5 818.2 34.1 34.1 0 0 1 379.5 770H379.5A34.1 34.1 0 0 1 427.7 769.1ZM466.8 707.7A30 30 0 0 0 458.2 711.8 34.1 34.1 0 0 0 477.3 772.7 36.4 36.4 0 0 0 493.6 768.6 34.1 34.1 0 0 0 509.5 727.7 33.2 33.2 0 0 0 466.8 707.7ZM562.7 675A30.5 30.5 0 0 0 551.8 675 34.1 34.1 0 0 0 562.7 741.4H569.1A34.1 34.1 0 0 0 562.7 673.6ZM360.5 832.7A34.1 34.1 0 0 0 315 846.4 34.5 34.5 0 0 0 325.9 891.8 35.5 35.5 0 0 0 344.5 897.3 33.6 33.6 0 0 0 373.2 882.3L373.2 878.2A34.1 34.1 0 0 0 360.5 832.7ZM322.7 643.6C322.7 776.8 177.7 851.8 171.8 855A20.9 20.9 0 0 1 161.4 857.3 20.9 20.9 0 0 1 150.9 855C144.5 851.8 0 772.7 0 643.6A161.4 161.4 0 1 1 322.7 643.6ZM224.1 650A62.7 62.7 0 1 0 161.4 712.7 62.7 62.7 0 0 0 224.1 650ZM1193.6 264.1C1193.6 397.3 1048.6 472.3 1042.3 475.5A19.1 19.1 0 0 1 1032.3 475.5 20.9 20.9 0 0 1 1021.8 475.5C1015.5 472.3 870.9 395 870.9 264.1A161.4 161.4 0 0 1 1193.6 264.1ZM1094.5 272.7A62.7 62.7 0 1 0 1032.3 335.5 62.3 62.3 0 0 0 1094.5 272.7ZM890.5 623.2A34.1 34.1 0 0 0 909.1 681.8 32.7 32.7 0 0 0 928.2 675.9L933.6 671.8A35 35 0 0 0 933.6 623.2 34.1 34.1 0 0 0 890.5 620.9ZM950.9 560.9L946.4 566.4A33.6 33.6 0 0 0 955.9 611.8 32.3 32.3 0 0 0 974.5 617.7 33.6 33.6 0 0 0 1001.8 604.1 34.1 34.1 0 0 0 950.9 558.6ZM744.1 680.9H744.1A33.6 33.6 0 0 0 710 715 34.1 34.1 0 1 0 744.1 680.9ZM818.2 662.3A34.1 34.1 0 0 0 798.2 704.5 34.5 34.5 0 0 0 830.9 727.7 30 30 0 0 0 841.4 727.7L846.4 727.7A34.1 34.1 0 0 0 818.2 662.3ZM660 671.8L651.4 671.8A34.1 34.1 0 0 0 647.7 740H651.8A34.1 34.1 0 0 0 660 672.7Z"
  }));
};
IconTripSolid.defaultProps = {
  title: 'trip solid'
};
IconTripSolid.propTypes = {
  title: PropTypes.string
};

var IconTrip = function IconTrip(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-trip",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1194 1194"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M161.4 485A161.8 161.8 0 0 0 0 646.8C0 777.3 144.5 854.5 150.9 857.7A21.4 21.4 0 0 0 171.8 857.7C177.7 854.5 322.7 779.5 322.7 646.8A161.8 161.8 0 0 0 161.4 485ZM161.4 811.4C131.4 792.7 45.5 732.3 45.5 646.8A115.9 115.9 0 1 1 277.3 646.8C277.3 733.2 191.8 793.2 161.4 811.4ZM370.9 878.6L368.6 881.8A28.2 28.2 0 0 1 345 894.5 26.8 26.8 0 0 1 329.5 890 28.6 28.6 0 0 1 320.5 852.3 28.6 28.6 0 0 1 370.9 878.6ZM423.6 775.9A28.6 28.6 0 1 1 383.6 775.9H383.6A28.6 28.6 0 0 1 423.6 775.9ZM504.5 733.6A29.1 29.1 0 0 1 490.9 767.7 30.5 30.5 0 0 1 477.3 771.4 28.6 28.6 0 0 1 461.4 719.1 23.2 23.2 0 0 1 468.2 715.9 28.6 28.6 0 0 1 504.5 733.6ZM161.4 573.6A79.5 79.5 0 1 0 240.9 653.2 79.5 79.5 0 0 0 161.4 573.6ZM161.4 687.3A34.1 34.1 0 1 1 195.5 653.2 34.5 34.5 0 0 1 161.4 687.3ZM1032.3 105.5A161.8 161.8 0 0 0 870.9 267.3C870.9 397.7 1015.5 475 1021.8 478.2A20.9 20.9 0 0 0 1032.3 480.9 20.9 20.9 0 0 0 1042.3 478.2C1048.6 475 1193.6 400 1193.6 267.3A161.8 161.8 0 0 0 1032.3 105.5ZM1032.3 431.8C1001.8 413.2 916.4 352.7 916.4 267.3A115.9 115.9 0 1 1 1148.2 267.3C1148.2 353.6 1062.7 413.6 1032.3 431.8ZM681.8 714.5A28.2 28.2 0 0 1 654.5 736.4H651.4A27.7 27.7 0 0 1 625.9 708.2 29.1 29.1 0 0 1 661.4 680.9 27.7 27.7 0 0 1 681.8 714.5ZM932.3 630.9A28.6 28.6 0 0 1 932.3 670.9L927.7 674.5A29.1 29.1 0 0 1 911.8 679.1 28.2 28.2 0 0 1 888.2 666.8 29.1 29.1 0 0 1 894.5 628.2 28.6 28.6 0 0 1 931.4 630.9ZM995.9 565.9A28.6 28.6 0 0 1 975.5 614.5 27.3 27.3 0 0 1 960 609.5 28.6 28.6 0 0 1 951.8 570L955.5 565.9A28.2 28.2 0 0 1 995 565.9ZM859.5 683.6A28.6 28.6 0 0 1 846.8 721.8L842.7 721.8A28.6 28.6 0 0 1 806.8 703.6 28.6 28.6 0 0 1 858.2 681.8ZM590.9 711.8A28.6 28.6 0 0 1 567.7 740H562.3A28.6 28.6 0 0 1 535 720.5 28.2 28.2 0 0 1 553.2 684.5 29.1 29.1 0 0 1 562.3 684.5 28.6 28.6 0 0 1 590.9 711.8ZM1031.8 194.1A79.5 79.5 0 1 0 1111.8 272.7 79.5 79.5 0 0 0 1032.3 194.1ZM1031.8 307.7A34.1 34.1 0 1 1 1066.4 272.7 34.1 34.1 0 0 1 1032.3 307.7ZM771.8 716.8A28.6 28.6 0 1 1 743.2 688.2H743.2A28.6 28.6 0 0 1 772.7 715.5Z"
  }));
};
IconTrip.defaultProps = {
  title: 'trip'
};
IconTrip.propTypes = {
  title: PropTypes.string
};

var IconTunnel = function IconTunnel(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-tunnel",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M500 155.5A344.1 344.1 0 0 0 155.9 500V844.1L414.1 585.9V500A85.9 85.9 0 1 1 585.9 500V585.9L844.1 844.1V500A344.1 344.1 0 0 0 500 155.5ZM500 87.3A413.2 413.2 0 0 0 87.3 500V636.4H87.3V805.5A104.5 104.5 0 0 0 190.9 912.7H809.1A105 105 0 0 0 912.7 807.3V500A413.2 413.2 0 0 0 500 87.3ZM878.6 807.3A70.5 70.5 0 0 1 809.1 878.6H190.9A70 70 0 0 1 121.8 807.3V636.4H121.8V500A378.2 378.2 0 1 1 878.2 500V636.4H878.2Z"
  }));
};
IconTunnel.defaultProps = {
  title: 'tunnel'
};
IconTunnel.propTypes = {
  title: PropTypes.string
};

var IconUpload = function IconUpload(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-upload",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M545.5 110.9A66.8 66.8 0 0 0 500 90.9H500A66.8 66.8 0 0 0 454.5 110.9L236.4 326.8A28.6 28.6 0 1 0 276.8 367.7L470.5 174.1V745A29.1 29.1 0 0 0 520.5 765.9 30 30 0 0 0 529.1 745V173.6L723.2 367.7A28.6 28.6 0 1 0 763.6 326.8ZM880.9 852.3H119.1A28.6 28.6 0 0 0 119.1 909.1H880.9A28.6 28.6 0 0 0 880.9 852.3Z"
  }));
};
IconUpload.defaultProps = {
  title: 'upload'
};
IconUpload.propTypes = {
  title: PropTypes.string
};

var IconUserAddGroupSolid = function IconUserAddGroupSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-user-add-group-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M631.4 174.5A66.4 66.4 0 0 1 692.7 105 66.4 66.4 0 0 1 754.5 174.5 66.4 66.4 0 0 1 692.7 244.1 66.4 66.4 0 0 1 631.4 174.5ZM414.1 417.3A153.2 153.2 0 0 0 554.1 254.1 153.2 153.2 0 0 0 414.1 90.9 153.2 153.2 0 0 0 272.7 254.1 153.2 153.2 0 0 0 414.1 417.3ZM909.1 656.8A252.7 252.7 0 1 1 656.4 404.1 252.7 252.7 0 0 1 909.1 656.8ZM772.7 656.8A27.3 27.3 0 0 0 745.5 629.5H681.8V565.9A27.3 27.3 0 1 0 627.3 565.9V629.5H563.6A27.3 27.3 0 0 0 536.4 656.8 26.8 26.8 0 0 0 563.6 683.6H627.3V747.7A27.3 27.3 0 0 0 681.8 747.7V681.8H745.5A26.8 26.8 0 0 0 772.7 656.8ZM397.7 492.3A173.6 173.6 0 0 1 302.7 454.5 45.5 45.5 0 0 0 257.3 447.7 265.9 265.9 0 0 0 90.9 693.6V788.2A42.7 42.7 0 0 0 133.6 830.9L403.2 830.9A304.5 304.5 0 0 1 397.3 493.2ZM826.4 401.4V367.7A112.3 112.3 0 0 0 754.1 262.3 31.4 31.4 0 0 0 723.2 266.8 50 50 0 0 1 658.6 266.8 30 30 0 0 0 628.2 261.8 114.5 114.5 0 0 0 555.9 366.4 304.5 304.5 0 0 1 826.4 400.5Z"
  }));
};
IconUserAddGroupSolid.defaultProps = {
  title: 'user add group solid'
};
IconUserAddGroupSolid.propTypes = {
  title: PropTypes.string
};

var IconUserAddGroup = function IconUserAddGroup(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-user-add-group",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M692.7 244.1A66.4 66.4 0 0 0 754.5 174.5 66.4 66.4 0 0 0 692.7 105 66.4 66.4 0 0 0 631.4 174.5 66.4 66.4 0 0 0 692.7 244.1ZM692.7 130.9A40 40 0 0 1 728.2 176.4 40 40 0 0 1 692.7 221.8 40 40 0 0 1 657.7 176.4 40 40 0 0 1 692.7 130.9ZM766.4 656.4A15.9 15.9 0 0 1 750.5 672.3H675.5V747.3A15.9 15.9 0 1 1 643.6 747.3V672.3H568.6A15.9 15.9 0 0 1 568.6 640.5H643.6V565.5A15.9 15.9 0 0 1 675.5 565.5V640.5H750.5A15.9 15.9 0 0 1 766.4 656.4ZM777.7 435H797.3A30.5 30.5 0 0 0 827.3 405V368.6A113.2 113.2 0 0 0 755 262.7 30.9 30.9 0 0 0 724.1 267.7 50 50 0 0 1 660 267.7 30.9 30.9 0 0 0 629.1 262.7 114.1 114.1 0 0 0 556.4 368.6V404.5A30 30 0 0 0 562.7 422.3H562.7A247.3 247.3 0 0 0 475.9 480.5 168.6 168.6 0 0 1 412.7 493.2 175.5 175.5 0 0 1 303.2 454.5 45.5 45.5 0 0 0 257.7 447.3 265.5 265.5 0 0 0 90.9 692.3V787.3A42.7 42.7 0 0 0 133.6 829.5H473.2A250 250 0 0 0 655 909.1 252.7 252.7 0 0 0 777.7 435ZM585 368.6A83.6 83.6 0 0 1 641.8 289.5 80.9 80.9 0 0 0 744.5 289.5 85 85 0 0 1 798.6 369.1V405.5L798.6 405.5 685 405.5A265 265 0 0 0 658.2 405.5L636.8 405.5H585ZM125 787.3V692.3A231.4 231.4 0 0 1 272.7 478.2H275.9A12.3 12.3 0 0 1 282.7 480.5 206.4 206.4 0 0 0 413.6 525.9 203.6 203.6 0 0 0 442.3 523.2H442.3A248.6 248.6 0 0 0 405 654.5 251.8 251.8 0 0 0 446.8 793.6H133.6A8.2 8.2 0 0 1 125 787.3ZM656.8 875A218.6 218.6 0 1 1 875 656.4 218.6 218.6 0 0 1 656.8 875ZM414.1 417.3A153.2 153.2 0 0 0 554.1 254.1 153.2 153.2 0 0 0 414.1 90.9 153.2 153.2 0 0 0 272.7 254.1 153.2 153.2 0 0 0 414.1 417.3ZM414.1 125A119.5 119.5 0 0 1 520 254.1 119.1 119.1 0 0 1 414.1 383.2 119.1 119.1 0 0 1 308.6 254.1 119.5 119.5 0 0 1 414.1 125Z"
  }));
};
IconUserAddGroup.defaultProps = {
  title: 'user add group'
};
IconUserAddGroup.propTypes = {
  title: PropTypes.string
};

var IconUserAddSolid = function IconUserAddSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-user-add-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M254.1 237.7A136.4 136.4 0 0 1 380.5 90.9 136.4 136.4 0 0 1 506.4 238.2 136.4 136.4 0 0 1 380.5 384.5 136.4 136.4 0 0 1 254.1 237.7ZM444.1 432.3A150.9 150.9 0 0 1 282.7 413.2 41.8 41.8 0 0 0 241.8 409.1 237.3 237.3 0 0 0 90.9 626.8V711.4A39.5 39.5 0 0 0 130.9 750.9H363.6A306.4 306.4 0 0 1 445.9 432.7ZM909.1 656.8A252.7 252.7 0 1 1 656.4 404.1 252.7 252.7 0 0 1 909.1 656.8ZM772.7 656.8A27.3 27.3 0 0 0 745.5 629.5H681.8V565.9A27.3 27.3 0 1 0 627.3 565.9V629.5H563.6A27.3 27.3 0 0 0 536.4 656.8 26.8 26.8 0 0 0 563.6 683.6H627.3V747.7A27.3 27.3 0 0 0 681.8 747.7V681.8H745.5A26.8 26.8 0 0 0 772.7 656.8Z"
  }));
};
IconUserAddSolid.defaultProps = {
  title: 'user add solid'
};
IconUserAddSolid.propTypes = {
  title: PropTypes.string
};

var IconUserAdd = function IconUserAdd(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-user-add",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M765.9 656.4A15.9 15.9 0 0 1 750 672.3H675V747.3A15.9 15.9 0 1 1 643.2 747.3V672.3H568.2A15.9 15.9 0 1 1 568.2 640.5H643.2V565.5A15.9 15.9 0 0 1 675 565.5V640.5H750A15.9 15.9 0 0 1 765.9 656.4ZM909.1 656.4A252.7 252.7 0 0 1 421.8 750.9H130.9A39.5 39.5 0 0 1 90.9 711.4V626.8A237.3 237.3 0 0 1 241.8 409.1 41.8 41.8 0 0 1 282.7 415.5 150 150 0 0 0 474.5 415.5 41.8 41.8 0 0 1 515.5 409.1 214.1 214.1 0 0 1 553.6 428.2 249.1 249.1 0 0 1 656.4 406.4 252.7 252.7 0 0 1 909.1 656.8ZM403.6 656.4A252.3 252.3 0 0 1 517.7 445.5 142.3 142.3 0 0 0 503.2 438.6 7.3 7.3 0 0 0 495.9 438.6 185.9 185.9 0 0 1 261.4 438.6 7.3 7.3 0 0 0 254.1 438.6 202.7 202.7 0 0 0 125 626.8V711.4A5.5 5.5 0 0 0 130.9 716.8H411.4A238.6 238.6 0 0 1 403.6 656.8ZM875 656.4A218.6 218.6 0 1 0 656.4 875 218.6 218.6 0 0 0 875 656.8ZM254.1 237.7A136.4 136.4 0 0 1 380.5 90.9 136.4 136.4 0 0 1 506.4 238.2 136.4 136.4 0 0 1 380.5 384.5 136.4 136.4 0 0 1 254.1 237.7ZM288.2 237.7A104.1 104.1 0 0 0 379.1 350.5 104.1 104.1 0 0 0 470 237.7 104.5 104.5 0 0 0 379.1 124.5 104.5 104.5 0 0 0 288.2 237.7Z"
  }));
};
IconUserAdd.defaultProps = {
  title: 'user add'
};
IconUserAdd.propTypes = {
  title: PropTypes.string
};

var IconUserMinusSolid = function IconUserMinusSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-user-minus-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M444.1 432.3A150.9 150.9 0 0 1 282.7 413.2 41.8 41.8 0 0 0 241.8 409.1 237.3 237.3 0 0 0 90.9 626.8V711.4A39.5 39.5 0 0 0 130.5 750.9H363.6A306.4 306.4 0 0 1 445.9 432.7ZM656.4 404.1A252.7 252.7 0 1 0 909.1 656.8 252.7 252.7 0 0 0 656.4 404.1ZM747.3 683.6H565.5A26.8 26.8 0 0 1 538.2 656.8 27.3 27.3 0 0 1 565.5 629.5H747.3A27.3 27.3 0 0 1 774.5 656.8 26.8 26.8 0 0 1 747.3 681.8ZM380.5 384.5A136.4 136.4 0 0 0 506.4 237.7 136.4 136.4 0 0 0 380.5 90.9 136.4 136.4 0 0 0 254.1 237.7 136.4 136.4 0 0 0 380.5 384.5Z"
  }));
};
IconUserMinusSolid.defaultProps = {
  title: 'user minus solid'
};
IconUserMinusSolid.propTypes = {
  title: PropTypes.string
};

var IconUserMinus = function IconUserMinus(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-user-minus",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M380.5 384.5A136.4 136.4 0 0 0 506.4 237.7 136.4 136.4 0 0 0 380.5 90.9 136.4 136.4 0 0 0 254.1 237.7 136.4 136.4 0 0 0 380.5 384.5ZM380.5 124.5A104.5 104.5 0 0 1 471.4 237.7 104.1 104.1 0 0 1 380.5 350.5 104.1 104.1 0 0 1 289.5 237.7 104.5 104.5 0 0 1 380.5 124.5ZM656.4 404.1A249.1 249.1 0 0 0 553.6 425.9 214.1 214.1 0 0 0 515.5 409.1 41.8 41.8 0 0 0 474.5 415.5 150 150 0 0 1 282.7 415.5 41.8 41.8 0 0 0 241.8 409.1 237.3 237.3 0 0 0 90.9 626.8V711.4A39.5 39.5 0 0 0 130.5 750.9H421.8A252.7 252.7 0 1 0 656.4 404.1ZM411.4 716.8H130.5A5.5 5.5 0 0 1 125 711.4V626.8A202.7 202.7 0 0 1 254.1 438.6 7.3 7.3 0 0 1 261.4 438.6 185.9 185.9 0 0 0 495.9 438.6 7.3 7.3 0 0 1 503.2 438.6 142.3 142.3 0 0 1 517.7 445.5 252.3 252.3 0 0 0 403.6 656.8 235.9 235.9 0 0 0 411.4 716.8ZM656.4 875.5A218.6 218.6 0 1 1 875 656.8 219.1 219.1 0 0 1 656.4 875.5ZM750 640.5H568.2A15.9 15.9 0 1 0 568.2 672.3H750A15.9 15.9 0 1 0 750 640.5Z"
  }));
};
IconUserMinus.defaultProps = {
  title: 'user minus'
};
IconUserMinus.propTypes = {
  title: PropTypes.string
};

var IconUserPrivateSolid = function IconUserPrivateSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-user-private-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M506.4 237.3A136.4 136.4 0 0 1 380.5 384.1 136.4 136.4 0 0 1 254.1 237.3 136.4 136.4 0 0 1 380.5 90.9 136.4 136.4 0 0 1 506.4 237.3ZM443.2 469.5V454.5A71.8 71.8 0 0 1 447.3 432.3 151.4 151.4 0 0 1 282.7 415 40.9 40.9 0 0 0 241.8 408.2 237.7 237.7 0 0 0 90.9 626.4V710.9A40 40 0 0 0 130.9 750.9H449.1A148.2 148.2 0 0 1 443.6 716.8ZM909.1 454.5V709.1C909.1 807.7 765 886.4 720.5 907.7A36.8 36.8 0 0 1 688.6 907.7C643.2 886.4 500 807.7 500 709.1V454.5A16.4 16.4 0 0 1 506.4 441.4 15.5 15.5 0 0 1 520.5 441.4 185.5 185.5 0 0 0 695 409.1 15 15 0 0 1 714.1 409.1 185 185 0 0 0 888.2 439.5 15 15 0 0 1 902.3 439.5 15.5 15.5 0 0 1 909.1 454.5ZM822.7 658.6A27.3 27.3 0 0 0 795.5 631.4H731.8V567.7A27.3 27.3 0 1 0 677.3 567.7V631.4H613.6A27.3 27.3 0 0 0 613.6 685.9H677.3V749.5A27.3 27.3 0 1 0 731.8 749.5V685.9H795.5A27.3 27.3 0 0 0 822.7 656.8Z"
  }));
};
IconUserPrivateSolid.defaultProps = {
  title: 'user private solid'
};
IconUserPrivateSolid.propTypes = {
  title: PropTypes.string
};

var IconUserPrivate = function IconUserPrivate(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-user-private",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M367.1 370.6A131.6 131.6 0 0 0 488.6 228.9 131.6 131.6 0 0 0 367.1 87.7 131.6 131.6 0 0 0 245.2 228.9 131.6 131.6 0 0 0 367.1 370.6ZM367.1 120.2A100.4 100.4 0 0 1 454.8 228.9 100.4 100.4 0 0 1 367.1 337.7 100.4 100.4 0 0 1 279.4 228.9 100.4 100.4 0 0 1 367.1 120.2ZM782.9 633.8A15.4 15.4 0 0 1 767.5 649.1H695.2V721.5A15.4 15.4 0 0 1 664.5 721.5V649.1H592.1A15.4 15.4 0 1 1 592.1 618.4H664.5V546.1A15.4 15.4 0 0 1 695.2 546.1V618.4H767.5A15.4 15.4 0 0 1 782.9 633.8ZM870.6 424.1A14.5 14.5 0 0 0 857 424.1 178.5 178.5 0 0 1 689 394.7 14.5 14.5 0 0 0 670.6 394.7 180.3 180.3 0 0 1 561.4 433.3 219.3 219.3 0 0 0 497.4 393.9 39.5 39.5 0 0 0 457.9 400.4 146.1 146.1 0 0 1 272.8 400.4 39.5 39.5 0 0 0 233.3 393.9 229.4 229.4 0 0 0 87.7 604.4V686A38.6 38.6 0 0 0 126.3 724.6H491.7C522.8 799.1 628.1 856.1 664.5 874.1A35.5 35.5 0 0 0 695.2 874.1C739 853.5 877.2 777.6 877.2 682.5V438.6A14.9 14.9 0 0 0 870.6 424.1ZM125 691.7A5.7 5.7 0 0 1 119.3 686V604.4A196.1 196.1 0 0 1 245.2 422.8 7 7 0 0 1 252.2 422.8 178.9 178.9 0 0 0 478.5 422.8 7 7 0 0 1 485.5 422.8L489 422.8H489A15.8 15.8 0 0 0 482.5 438.6V684.2A65.4 65.4 0 0 0 482.5 693.4H126.3ZM484.6 708.3ZM493.9 421.5A18 18 0 0 1 500.9 421.5 153.5 153.5 0 0 0 528.9 428.1 200.9 200.9 0 0 1 500.9 421.5 18 18 0 0 0 495.2 421.5ZM560.1 431.6A184.6 184.6 0 0 1 532.9 429.4 184.6 184.6 0 0 0 561.4 431.6ZM845.6 682.5C845.6 764 697.4 838.6 680.7 846.9A5.3 5.3 0 0 1 676.3 846.9C648.7 833.3 511.4 762.3 511.4 682.5V456.6A205.7 205.7 0 0 0 678.5 423.7 205.7 205.7 0 0 0 845.6 456.6Z"
  }));
};
IconUserPrivate.defaultProps = {
  title: 'user private'
};
IconUserPrivate.propTypes = {
  title: PropTypes.string
};

var IconVoucherSolid = function IconVoucherSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-voucher-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M405 384.1A63.2 63.2 0 1 1 341.8 321.4 63.2 63.2 0 0 1 405 384.1ZM658.2 550.9A63.2 63.2 0 1 0 720.9 613.6 62.7 62.7 0 0 0 658.2 550.9ZM828.6 70.5V929.5A42.3 42.3 0 0 1 786.4 971.8H636.4A42.3 42.3 0 0 1 596.4 945.5 100.9 100.9 0 0 0 404.5 945.5 41.8 41.8 0 0 1 364.5 971.8H213.6A42.3 42.3 0 0 1 171.4 929.5V70.5A42.3 42.3 0 0 1 213.6 28.2H363.6A41.8 41.8 0 0 1 403.6 54.5 100.9 100.9 0 0 0 595.5 54.5 42.3 42.3 0 0 1 636.4 28.2H786.4A42.3 42.3 0 0 1 828.6 70.5ZM341.8 504.1A120 120 0 1 0 222.3 384.1 120 120 0 0 0 341.8 504.1ZM648.2 300A28.2 28.2 0 1 0 599.1 272.7L351.8 700A28.2 28.2 0 0 0 362.3 738.6 27.3 27.3 0 0 0 376.4 742.3 27.7 27.7 0 0 0 400.9 727.3ZM777.7 613.6A120 120 0 1 0 658.2 733.6 119.5 119.5 0 0 0 777.7 613.6Z"
  }));
};
IconVoucherSolid.defaultProps = {
  title: 'voucher solid'
};
IconVoucherSolid.propTypes = {
  title: PropTypes.string
};

var IconVoucher = function IconVoucher(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-voucher",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M786.4 22.7H636.4A45.5 45.5 0 0 0 590.9 52.7 95.5 95.5 0 0 1 409.1 52.7 45.5 45.5 0 0 0 363.6 22.7H213.6A45.5 45.5 0 0 0 165.9 70.5V929.5A45.5 45.5 0 0 0 213.6 977.3H363.6A45.5 45.5 0 0 0 409.1 947.3 95.5 95.5 0 0 1 590.9 947.3 45.5 45.5 0 0 0 636.4 977.3H786.4A45.5 45.5 0 0 0 834.1 929.5V70.5A45.5 45.5 0 0 0 786.4 22.7ZM800 931.8A13.2 13.2 0 0 1 786.4 945.5H636.4A14.5 14.5 0 0 1 623.2 938.6 129.1 129.1 0 0 0 377.7 938.6 14.5 14.5 0 0 1 364.5 945.5H213.6A13.2 13.2 0 0 1 200 931.8V70.5A13.2 13.2 0 0 1 213.6 56.8H363.6A14.5 14.5 0 0 1 376.8 63.6 129.1 129.1 0 0 0 622.3 63.6 14.5 14.5 0 0 1 636.4 56.8H786.4A13.2 13.2 0 0 1 800 70.5ZM636.4 294.5L390 722.7A16.4 16.4 0 0 1 375.5 730.9 14.5 14.5 0 0 1 366.8 730.9 16.8 16.8 0 0 1 360.5 707.7L607.7 277.3A16.8 16.8 0 0 1 630.9 272.7 16.8 16.8 0 0 1 636.4 294.5ZM483.6 385.5A108.2 108.2 0 1 0 375.5 494.1 108.6 108.6 0 0 0 484.5 384.1ZM301.8 385.5A74.1 74.1 0 1 1 375.9 460 74.5 74.5 0 0 1 302.3 384.1ZM623.2 506.8A108.6 108.6 0 1 0 731.8 613.6 108.6 108.6 0 0 0 623.6 505.5ZM623.2 688.6A74.5 74.5 0 1 1 697.3 614.1 74.5 74.5 0 0 1 623.6 688.2Z"
  }));
};
IconVoucher.defaultProps = {
  title: 'voucher'
};
IconVoucher.propTypes = {
  title: PropTypes.string
};

var IconWarning = function IconWarning(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-warning",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M470.9 664.1V90.9A29.5 29.5 0 0 1 500 60.9 29.1 29.1 0 0 1 529.1 90V663.6A29.5 29.5 0 1 1 470.5 663.6ZM500 805A61.4 61.4 0 1 0 561.4 866.4 61.4 61.4 0 0 0 500 805Z"
  }));
};
IconWarning.defaultProps = {
  title: 'warning'
};
IconWarning.propTypes = {
  title: PropTypes.string
};

var IconWatchSolid = function IconWatchSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-watch-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M818.2 369.1H208.2L867.7 236.8A52.7 52.7 0 0 0 900.9 214.5 51.4 51.4 0 0 0 909.1 175L899.5 129.5A53.2 53.2 0 0 0 847.7 87.3H844.1L837.3 87.3 127.3 227.3A53.2 53.2 0 0 0 86.4 290.9L95.9 336.4A52.3 52.3 0 0 0 141.4 377.3 96.4 96.4 0 0 0 86.8 464.1V818.2A96.4 96.4 0 0 0 181.8 915H818.2A96.4 96.4 0 0 0 914.5 818.2V465.9A96.8 96.8 0 0 0 818.2 369.1ZM846.4 131.4H846.4A8.2 8.2 0 0 1 853.6 137.3L863.6 181.8A5.9 5.9 0 0 1 863.6 187.3 6.4 6.4 0 0 1 859.1 190.5L827.3 196.8 733.6 151.4ZM659.1 168.6L752.7 214.1 661.8 231.8 568.6 186.4ZM495.5 201.8L589.1 247.3 498.2 265 405 219.5ZM332.3 234.5L425.5 280 334.5 298.2 243.6 252.7ZM131.8 276.8A9.1 9.1 0 0 1 136.4 272.7L168.6 266.4 261.8 311.8 147.7 335A7.7 7.7 0 0 1 140.5 329.1L130.9 283.6A8.2 8.2 0 0 1 131.8 276.8ZM170.5 477.3H130.9V465.9A51.4 51.4 0 0 1 181.8 414.5H253.6ZM245.9 477.3L329.1 414.5H420L337.3 477.3ZM412.7 477.3L495.9 414.5H586.8L504.1 477.3ZM579.5 477.3L662.3 414.5H753.2L670.5 477.3ZM869.1 477.3H745.9L826.8 416.4A50.5 50.5 0 0 1 869.1 465.9Z"
  }));
};
IconWatchSolid.defaultProps = {
  title: 'watch solid'
};
IconWatchSolid.propTypes = {
  title: PropTypes.string
};

var IconWatch = function IconWatch(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-watch",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M818.2 375H181.8A90.9 90.9 0 0 0 90.9 465.9V818.2A90.9 90.9 0 0 0 181.8 909.1H818.2A90.9 90.9 0 0 0 909.1 818.2V465.9A90.9 90.9 0 0 0 818.2 375ZM772.7 409.1L674.5 482.7H562.3L660.5 409.1ZM603.6 409.1L505.9 482.7H395.9L493.6 409.1ZM437.3 409.1L339.1 482.7H227.3L327.3 409.1ZM125 465.9A56.8 56.8 0 0 1 181.8 409.1H272.7L172.3 482.7H126.8ZM875 818.2A56.8 56.8 0 0 1 818.2 875.5H181.8A56.8 56.8 0 0 1 125 818.2V517.3H875ZM875 482.3H727.3L825 409.1A55.9 55.9 0 0 1 875 464.5ZM150.9 374.5L156.8 374.5 866.8 231.4A45.5 45.5 0 0 0 903.2 175.9L894.1 130.5A45.5 45.5 0 0 0 844.5 90.9L838.6 90.9 128.6 234.5A45.5 45.5 0 0 0 90.9 290L100.5 335.5A45.5 45.5 0 0 0 150.9 374.5ZM845.5 125.5H845.5A13.2 13.2 0 0 1 859.1 135.9L868.6 181.4A13.6 13.6 0 0 1 868.6 190.9 12.7 12.7 0 0 1 860.5 196.4L826.4 203.2 715.5 151.8ZM660 162.7L772.7 215.9 664.5 237.3 551.8 184.5ZM496.4 195.5L606.8 248.6 500 272.7 388.2 217.3ZM332.7 227.3L443.2 281.4 335 303.2 227.3 250ZM127.3 272.7A11.8 11.8 0 0 1 136.4 268.2L170 261.4 279.5 314.1 148.2 340.5A13.2 13.2 0 0 1 136.4 330L127.3 284.5A11.8 11.8 0 0 1 127.3 272.7Z"
  }));
};
IconWatch.defaultProps = {
  title: 'watch'
};
IconWatch.propTypes = {
  title: PropTypes.string
};

var IconWheelchairInfoSolid = function IconWheelchairInfoSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-wheelchair-info-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M701.8 810A103.2 103.2 0 0 1 706.4 830.9 40 40 0 0 1 702.3 846.8 38.6 38.6 0 0 1 692.7 861.8 47.7 47.7 0 0 1 677.3 871.8 39.5 39.5 0 0 1 659.5 875 50.9 50.9 0 0 1 616.8 842.3L552.3 660.5A13.6 13.6 0 0 0 539.1 651.4H381.8A61.8 61.8 0 0 1 336.4 635.9 57.7 57.7 0 0 1 320 603.6H320C314.1 565 306.4 490.5 301.8 442.3 301.8 421.4 297.7 406.4 295.9 394.1V389.5A232.3 232.3 0 0 1 292.7 356.8 83.2 83.2 0 0 1 295.9 330.5 52.3 52.3 0 0 1 307.7 310.5 53.6 53.6 0 0 1 348.6 291.8H427.3A58.6 58.6 0 0 1 479.1 355H479.1L465 526.4A16.4 16.4 0 0 0 468.6 536.8 15 15 0 0 0 479.1 541.4H562.3A49.5 49.5 0 0 1 607.7 569.5ZM383.6 686.8A95.5 95.5 0 0 1 315.9 661.8 90.9 90.9 0 0 1 289.5 609.5C281.8 571.8 272.7 500 269.1 446.4 269.1 442.3 269.1 439.1 269.1 435.5A241.4 241.4 0 1 0 554.5 765.9L526.4 686.8ZM909.1 250A159.1 159.1 0 1 1 750 90.9 159.1 159.1 0 0 1 909.1 250ZM767.3 227.3A17.3 17.3 0 0 0 732.7 227.3V332.3A17.3 17.3 0 0 0 750 349.5H750A17.3 17.3 0 0 0 767.3 332.3ZM769.5 167.3A19.5 19.5 0 1 0 730.5 167.3 19.5 19.5 0 1 0 769.5 167.3ZM389.1 250A79.5 79.5 0 1 0 309.5 170.5 79.5 79.5 0 0 0 389.1 250Z"
  }));
};
IconWheelchairInfoSolid.defaultProps = {
  title: 'wheelchair info solid'
};
IconWheelchairInfoSolid.propTypes = {
  title: PropTypes.string
};

var IconWheelchairInfo = function IconWheelchairInfo(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-wheelchair-info",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M389.1 250A79.5 79.5 0 1 0 309.5 170.5 79.5 79.5 0 0 0 389.1 250ZM389.1 125A45.5 45.5 0 1 1 343.6 170.5 45.5 45.5 0 0 1 389.1 125ZM750 90.9A159.1 159.1 0 1 0 909.1 250 159.1 159.1 0 0 0 750 90.9ZM750 375A125 125 0 1 1 875 250 125 125 0 0 1 750 375ZM625.5 563.6A66.8 66.8 0 0 0 562.3 525H482.3L495.9 356.8A75.5 75.5 0 0 0 427.3 275H349.5A68.2 68.2 0 0 0 296.4 299.1 59.5 59.5 0 0 0 280.5 325.5 100.5 100.5 0 0 0 276.8 356.8 255.9 255.9 0 0 0 279.5 391.8L279.5 397.3C279.5 409.5 283.2 424.5 285 442.7 289.1 483.6 297.3 563.6 303.6 605A72.7 72.7 0 0 0 325 647.3 78.6 78.6 0 0 0 380.9 667.7H535.9L600.5 846.8A67.3 67.3 0 0 0 658.6 890 57.7 57.7 0 0 0 683.2 885 63.2 63.2 0 0 0 704.1 871.8 71.8 71.8 0 0 0 717.3 850.9 57.3 57.3 0 0 0 722.3 828.2 90.9 90.9 0 0 0 716.8 801.8ZM686.4 840A23.6 23.6 0 0 1 680.5 850 25.9 25.9 0 0 1 670.9 855.9 25.5 25.5 0 0 1 659.5 858.2 34.5 34.5 0 0 1 633.2 836.8L568.2 655H568.2A30.9 30.9 0 0 0 539.1 634.5H381.8A45.5 45.5 0 0 1 349.5 623.6 41.4 41.4 0 0 1 338.2 600.5C332.7 565 325 494.5 320 440.5 320 419.1 315.9 403.6 314.1 391.4V387.3A198.2 198.2 0 0 1 311.4 356.8 64.5 64.5 0 0 1 311.4 335.5 32.7 32.7 0 0 1 319.5 321.8 37.3 37.3 0 0 1 347.7 309.1H425A41.8 41.8 0 0 1 462.3 354.5L448.2 525.9A32.3 32.3 0 0 0 456.4 549.5 32.7 32.7 0 0 0 479.1 559.5H562.3A32.7 32.7 0 0 1 593.6 576.8L684.5 815.5A60.9 60.9 0 0 1 688.2 831.4 20.9 20.9 0 0 1 686.4 840ZM769.5 168.6A19.5 19.5 0 1 1 730.5 168.6 19.5 19.5 0 1 1 769.5 168.6ZM526.4 740.9L542.7 786.4A241.4 241.4 0 1 1 251.4 440.5L254.5 475A207.7 207.7 0 1 0 527.3 740.9ZM767.3 227.3V332.3A17.3 17.3 0 0 1 732.7 332.3V227.3A17.3 17.3 0 0 1 767.3 227.3Z"
  }));
};
IconWheelchairInfo.defaultProps = {
  title: 'wheelchair info'
};
IconWheelchairInfo.propTypes = {
  title: PropTypes.string
};

var IconWheelchairSolid = function IconWheelchairSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-wheelchair-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M388.6 90.9A86.8 86.8 0 1 1 475.5 177.3 87.3 87.3 0 0 1 388.6 90.9ZM463.2 724.1A126.4 126.4 0 0 1 342.3 617.3 111.8 111.8 0 0 1 338.6 596.4L323.6 432.7A290.5 290.5 0 0 0 391.4 995C401.4 995 410.9 995 420.9 995A289.5 289.5 0 0 0 626.4 910 285.9 285.9 0 0 0 675.9 842.7L630.5 722.3ZM865 860.5L753.2 565A65.5 65.5 0 0 0 690.9 524.5H573.2L578.6 464.5 593.6 303.2A74.1 74.1 0 0 0 520 222.3H429.1A74.1 74.1 0 0 0 357.3 301.8L368.2 421.4 383.6 590.9A146.8 146.8 0 0 0 386.4 605.9 83.2 83.2 0 0 0 463.2 677.3H661.4L700.9 780.9 746.4 903.2A63.2 63.2 0 0 0 805.5 943.6 64.1 64.1 0 0 0 827.7 939.5 63.2 63.2 0 0 0 863.6 859.1Z"
  }));
};
IconWheelchairSolid.defaultProps = {
  title: 'wheelchair solid'
};
IconWheelchairSolid.propTypes = {
  title: PropTypes.string
};

var IconWheelchair = function IconWheelchair(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-wheelchair",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 985 985"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M852.7 875.6A44.8 44.8 0 0 1 845.1 863.5 44.8 44.8 0 0 0 852.7 875.6ZM863.9 884.1A26.4 26.4 0 0 1 855.9 878.2 26.4 26.4 0 0 0 863.9 884.1ZM878.2 888.5A38.5 38.5 0 0 1 867.9 885.9 38.5 38.5 0 0 0 878.2 888.5ZM882.3 889A36.3 36.3 0 0 0 895.3 886.3 33.6 33.6 0 0 1 880.5 889ZM468.2 193.4A94.4 94.4 0 0 0 529.1 171 96.7 96.7 0 1 0 407.3 171 94.4 94.4 0 0 0 468.2 193.4ZM468.2 33.6A63.1 63.1 0 1 1 405.1 96.7 63.1 63.1 0 0 1 468.2 33.6ZM647.3 824.5L662.5 864.8A287.8 287.8 0 0 1 626.7 913.2 295.9 295.9 0 0 1 416.7 1000C406.4 1000 396.6 1000 386.8 1000A296.8 296.8 0 0 1 306.6 426.6L309.8 461.5A261.9 261.9 0 0 0 228.3 516.6 263.7 263.7 0 0 0 600.7 889.4 268.6 268.6 0 0 0 648.2 824.5ZM861.7 849.6L751.1 558.6A75.2 75.2 0 0 0 679.5 511.6H577L577 497.3 580.6 457.9 594.4 305.7A84.6 84.6 0 0 0 510.7 216.2H421.2A84.2 84.2 0 0 0 359.4 243.5 83.3 83.3 0 0 0 337.5 308L347.4 415.4 353.6 447.6 366.6 592.2C366.6 597.6 366.6 602.5 369.7 607.9A92.7 92.7 0 0 0 456.1 687.1H643.7L671.4 761 690.7 811.5 725.2 901.1A73.9 73.9 0 0 0 794.1 948.5 66.7 66.7 0 0 0 820.1 943.6 72.5 72.5 0 0 0 860.8 905.6 74.8 74.8 0 0 0 862.6 850.5ZM829.5 892.1A40.3 40.3 0 0 1 807.1 912.7 38 38 0 0 1 793.2 915.4H789.2A47 47 0 0 1 778.4 912.7L774.4 912.7A44.8 44.8 0 0 1 766.3 906.9L763.2 904.2A44.8 44.8 0 0 1 755.6 892.1L705.5 757.8 675.9 680.8 671.4 663.8A17 17 0 0 0 655.8 653.1H456.1A60 60 0 0 1 402.9 599.4 75.6 75.6 0 0 1 400.6 588.6L387.2 440.9 384.1 407.8 374.2 302.6A50.6 50.6 0 0 1 424.4 247.5H513.9A49.7 49.7 0 0 1 551 264.1 49.2 49.2 0 0 1 564 302.6L551.5 439.1 548.3 475.8 543.4 526.9A16.1 16.1 0 0 0 547.9 539.4 16.6 16.6 0 0 0 560.4 545.2H680.4A41.6 41.6 0 0 1 720.7 570.7L831.2 861.7A42.1 42.1 0 0 1 830.3 892.1Z"
  }));
};
IconWheelchair.defaultProps = {
  title: 'wheelchair'
};
IconWheelchair.propTypes = {
  title: PropTypes.string
};

var IconWidthBigger = function IconWidthBigger(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-width-bigger",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M948.6 500H948.6A53.2 53.2 0 0 1 933.2 537.7L796.8 674.1A29.1 29.1 0 0 1 776.4 682.7H776.4A29.1 29.1 0 0 1 755.9 674.1 29.5 29.5 0 0 1 755.9 632.7L857.7 530.9H139.5L240.9 632.3A29.5 29.5 0 0 1 240.9 673.6 29.1 29.1 0 0 1 220.5 682.3H220.5A29.1 29.1 0 0 1 200 673.6L63.6 537.3A51.8 51.8 0 0 1 50.5 510.9 24.1 24.1 0 0 1 50.5 499.5H50.5A53.2 53.2 0 0 1 65.9 461.8L202.3 325.5A29.1 29.1 0 0 1 220 318.2H220A29.1 29.1 0 0 1 240.5 326.8 29.5 29.5 0 0 1 240.5 368.2L139.1 470.9H858.6L757.3 369.1A29.5 29.5 0 0 1 757.3 327.7 30 30 0 0 1 777.7 318.2H777.7A29.1 29.1 0 0 1 798.2 326.8L934.5 463.2A45.5 45.5 0 0 1 947.7 489.5 19.5 19.5 0 0 1 947.7 500.9Z"
  }));
};
IconWidthBigger.defaultProps = {
  title: 'width bigger'
};
IconWidthBigger.propTypes = {
  title: PropTypes.string
};

var IconWidthSmaller = function IconWidthSmaller(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-width-smaller",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M949.5 500A29.1 29.1 0 0 1 920.5 529.1H640.5L741.8 630.5A29.5 29.5 0 0 1 741.8 671.8 29.1 29.1 0 0 1 721.4 680.5H721.4A29.1 29.1 0 0 1 700.9 671.8L564.5 535.5A53.2 53.2 0 0 1 564.5 460L700.9 323.6A30.9 30.9 0 0 1 720.9 318.2H720.9A29.1 29.1 0 0 1 741.4 326.8 29.5 29.5 0 0 1 741.4 368.2L639.5 470H920A30 30 0 0 1 940.9 478.6 27.3 27.3 0 0 1 949.5 500ZM299.5 328.2A30 30 0 0 0 279.1 318.2H279.1A29.1 29.1 0 0 0 258.6 326.8 29.5 29.5 0 0 0 258.6 368.2L360 469.5H79.5A29.5 29.5 0 0 0 58.6 519.5 30 30 0 0 0 79.5 528.2H360L258.2 631.4A29.5 29.5 0 0 0 258.2 672.7 29.1 29.1 0 0 0 278.6 681.4H278.6A29.1 29.1 0 0 0 299.1 672.7L435.5 536.4A53.2 53.2 0 0 0 435.5 460.9Z"
  }));
};
IconWidthSmaller.defaultProps = {
  title: 'width smaller'
};
IconWidthSmaller.propTypes = {
  title: PropTypes.string
};

var IconWifiSolid = function IconWifiSolid(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-wifi-solid",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M576.8 704.1A108.6 108.6 0 1 1 423.2 704.1 108.6 108.6 0 0 1 576.8 704.1ZM500 477.3A300.9 300.9 0 0 0 285 568.2 28.6 28.6 0 0 0 285 608.2 29.1 29.1 0 0 0 325.5 608.2 246.8 246.8 0 0 1 674.5 608.2 30 30 0 0 0 695 616.4 28.2 28.2 0 0 0 715 608.2 28.6 28.6 0 0 0 715 568.2 300.5 300.5 0 0 0 500 477.3ZM500 295.5A482.3 482.3 0 0 0 155.5 436.4 28.2 28.2 0 0 0 195.5 476.4 431.4 431.4 0 0 1 804.5 476.4 27.3 27.3 0 0 0 844.5 476.4 28.2 28.2 0 0 0 844.5 436.4 484.1 484.1 0 0 0 500 293.6ZM974.5 308.2A671.4 671.4 0 0 0 25.5 308.2 28.6 28.6 0 1 0 65.5 348.6 615 615 0 0 1 934.5 348.6 28.6 28.6 0 1 0 974.5 308.2Z"
  }));
};
IconWifiSolid.defaultProps = {
  title: 'wifi solid'
};
IconWifiSolid.propTypes = {
  title: PropTypes.string
};

var IconWifi = function IconWifi(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-wifi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M423.2 698.2A108.6 108.6 0 0 0 423.2 852.3 108.6 108.6 0 0 0 576.8 852.3 108.6 108.6 0 0 0 423.2 698.2ZM552.7 828.2A74.1 74.1 0 0 1 447.3 828.2 75 75 0 0 1 447.3 722.3 74.5 74.5 0 0 1 552.7 722.3 75 75 0 0 1 552.7 828.2ZM706.8 568.6A16.8 16.8 0 0 1 706.8 592.7 17.3 17.3 0 0 1 695 597.7 17.7 17.7 0 0 1 681.8 590.9 258.6 258.6 0 0 0 318.2 590.9 17.7 17.7 0 0 1 294.1 590.9 16.8 16.8 0 0 1 294.1 566.8 292.7 292.7 0 0 1 706.8 568.6ZM836.8 438.6A17.3 17.3 0 0 1 824.5 467.7 17.3 17.3 0 0 1 812.7 462.7 443.2 443.2 0 0 0 187.3 462.7 16.8 16.8 0 0 1 163.2 462.7 17.7 17.7 0 0 1 163.2 438.6 476.8 476.8 0 0 1 836.8 438.6ZM966.8 332.7A17.3 17.3 0 0 1 942.3 332.7 626.4 626.4 0 0 0 57.7 332.7 16.4 16.4 0 0 1 45.5 337.7 16.4 16.4 0 0 1 33.2 332.7 17.7 17.7 0 0 1 33.2 308.6 661.4 661.4 0 0 1 966.8 308.6 17.7 17.7 0 0 1 966.8 332.7Z"
  }));
};
IconWifi.defaultProps = {
  title: 'wifi'
};
IconWifi.propTypes = {
  title: PropTypes.string
};

var IconZoomIn = function IconZoomIn(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-zoom-in",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M904.1 843.6L717.3 667.7A352.7 352.7 0 0 0 181.8 209.5 352.7 352.7 0 0 0 438.2 804.5H449.1A352.7 352.7 0 0 0 671.4 716.8L858.2 892.7A33.6 33.6 0 0 0 881.4 901.8 32.3 32.3 0 0 0 905.5 890.9 33.2 33.2 0 0 0 904.1 843.6ZM646.8 647.3A283.6 283.6 0 0 1 447.3 738.2 285.9 285.9 0 1 1 429.5 165.9H438.6A285.9 285.9 0 0 1 646.8 647.7ZM663.2 451.4A29.5 29.5 0 0 1 634.1 480.9H467.7V647.3A29.5 29.5 0 1 1 409.1 647.3V480.9H242.3A30 30 0 0 1 221.4 472.3 29.1 29.1 0 0 1 212.7 451.8 29.5 29.5 0 0 1 242.3 422.3H409.1V255.5A29.5 29.5 0 0 1 438.2 227.3 30 30 0 0 1 467.3 256.4V422.3H636.4A29.1 29.1 0 0 1 663.2 451.4Z"
  }));
};
IconZoomIn.defaultProps = {
  title: 'zoom in'
};
IconZoomIn.propTypes = {
  title: PropTypes.string
};

var IconZoomOut = function IconZoomOut(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    className: "hcr-svg-zoom-out",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000"
  }, rest), title && React.createElement("title", null, title), React.createElement("path", {
    d: "M904.1 843.6L717.3 667.7A352.7 352.7 0 0 0 181.8 209.5 352.7 352.7 0 0 0 438.2 804.5H449.1A352.7 352.7 0 0 0 671.4 716.8L858.2 892.7A33.6 33.6 0 0 0 881.4 901.8 32.3 32.3 0 0 0 905.5 890.9 33.2 33.2 0 0 0 904.1 843.6ZM646.8 647.3A283.6 283.6 0 0 1 447.3 738.2 285.9 285.9 0 1 1 429.5 165.9H438.6A285.9 285.9 0 0 1 646.8 647.7ZM663.2 451.4A29.5 29.5 0 0 1 634.1 480.9H242.3A30 30 0 0 1 221.4 472.3 29.1 29.1 0 0 1 212.7 451.8 29.5 29.5 0 0 1 242.3 422.3H636.4A29.1 29.1 0 0 1 663.2 451.4Z"
  }));
};
IconZoomOut.defaultProps = {
  title: 'zoom out'
};
IconZoomOut.propTypes = {
  title: PropTypes.string
};

export { IconCalendarSolid as $, IconBeachSolid as A, IconBeach as B, IconBeer as C, IconBikeSolid as D, IconBike as E, IconBirthdaySolid as F, IconBirthday as G, IconBookSolid as H, IconProfile as I, IconBook as J, IconBoosterSolid as K, IconBooster as L, IconBulbSolid as M, IconBulb as N, IconBusDoubleSolid as O, IconBusDouble as P, IconBusNightSolid as Q, IconBusNight as R, IconBusServiceSolid as S, IconBusService as T, IconBusSolid as U, IconBusStopSolid as V, IconBusStop as W, IconBusTimeSolid as X, IconBusTime as Y, IconBus as Z, IconBuses as _, IconArrowLeft as a, IconForbidden as a$, IconCalendar as a0, IconCallSolid as a1, IconCall as a2, IconCarSeatSolid as a3, IconCarSeat as a4, IconCarSolid as a5, IconCar as a6, IconCartSolid as a7, IconCart as a8, IconCash as a9, IconDirectionsSolid as aA, IconDirections as aB, IconDiscountSolid as aC, IconDiscount as aD, IconDocumentSolid as aE, IconDocument as aF, IconDownload as aG, IconDrinksSolid as aH, IconDrinks as aI, IconDriverSolid as aJ, IconDriver as aK, IconEbusSolid as aL, IconEbus as aM, IconEditSolid as aN, IconEdit as aO, IconEntertainmentSolid as aP, IconEntertainment as aQ, IconExpand as aR, IconEyeNoSolid as aS, IconEyeNo as aT, IconEyeSolid as aU, IconEye as aV, IconFerrySolid as aW, IconFerry as aX, IconFilter as aY, IconFlixtechSolid as aZ, IconFlixtech as a_, IconChatSolid as aa, IconChat as ab, IconCheckSolid as ac, IconCheck as ad, IconCheckmarkStrongSolid as ae, IconCheckmarkStrong as af, IconCheckmark as ag, IconChildSolid as ah, IconChild as ai, IconCitySolid as aj, IconCity as ak, IconClose as al, IconCollaborationSolid as am, IconCollaboration as an, IconCollapse as ao, IconConnectionTransfer as ap, IconConnection as aq, IconCopySolid as ar, IconCopy as as, IconCreditCardSolid as at, IconCreditCard as au, IconCustomerSolid as av, IconCustomer as aw, IconDeleteSolid as ax, IconDelete as ay, IconDesktop as az, IconArrowRight as b, IconPassport as b$, IconFullScreen as b0, IconGamesSolid as b1, IconGames as b2, IconGroupSolid as b3, IconGroup as b4, IconHeadphonesSolid as b5, IconHeadphones as b6, IconHome as b7, IconInfoSolid as b8, IconInfo as b9, IconLuggageHandSolid as bA, IconLuggageHand as bB, IconLuggageSolid as bC, IconLuggage as bD, IconMagnifierSolid as bE, IconMagnifier as bF, IconMapSolid as bG, IconMap as bH, IconMeatball as bI, IconMenWomenSolid as bJ, IconMenWomen as bK, IconMinus as bL, IconMountainsSolid as bM, IconMountains as bN, IconNewTabSolid as bO, IconNewTab as bP, IconNewsletterSolid as bQ, IconNewsletter as bR, IconNightSolid as bS, IconNight as bT, IconNotificationSolid as bU, IconNotification as bV, IconOfferSolid as bW, IconOffer as bX, IconPartnerSolid as bY, IconPartner as bZ, IconPassportSolid as b_, IconInterconnectionSolid as ba, IconInterconnection as bb, IconInvoice as bc, IconKebab as bd, IconLabelAttentionSolid as be, IconLabelAttention as bf, IconLabelSolid as bg, IconLabel as bh, IconLeafSolid as bi, IconLeaf as bj, IconLinkSolid as bk, IconLink as bl, IconListSolid as bm, IconList as bn, IconLocationSolid as bo, IconLocation as bp, IconLockSolid as bq, IconLock as br, IconLogoutSolid as bs, IconLogout as bt, IconLostSolid as bu, IconAccountAttention as bv, IconLuggageAdditionalSolid as bw, IconLuggageAdditional as bx, IconLuggageBulkySolid as by, IconLuggageBulky as bz, IconBurger as c, IconSuitcase as c$, IconPauseSolid as c0, IconPause as c1, IconPersonSolid as c2, IconPerson as c3, IconPhoneSolid as c4, IconPhoneTabletSolid as c5, IconPhoneTablet as c6, IconPhone as c7, IconPinSolid as c8, IconPin as c9, IconSeat as cA, IconSecurePaymentSolid as cB, IconSecurePayment as cC, IconSecuritySolid as cD, IconSecurity as cE, IconSettingsSolid as cF, IconSettings as cG, IconShareFileSolid as cH, IconShareFile as cI, IconSitSolid as cJ, IconSit as cK, IconSmokingNo as cL, IconSmoking as cM, IconSnacksSolid as cN, IconSnacks as cO, IconSocketSolid as cP, IconSocket as cQ, IconSort as cR, IconStarSolid as cS, IconStar as cT, IconStationSolid as cU, IconStation as cV, IconStopwatchSolid as cW, IconStopwatch as cX, IconStrollerSolid as cY, IconStroller as cZ, IconSuitcaseSolid as c_, IconPlaneSolid as ca, IconPlane as cb, IconPlaySolid as cc, IconPlay as cd, IconPlus as ce, IconProfileSolid as cf, IconPublicSolid as cg, IconPublic as ch, IconQAndASolid as ci, IconQAndA as cj, IconQuestionSolid as ck, IconQuestion as cl, IconRealTimeSolid as cm, IconRealTime as cn, IconRebookSolid as co, IconRebook as cp, IconRefresh as cq, IconResetSolid as cr, IconReset as cs, IconRideShareSolid as ct, IconRideShare as cu, IconSaveSolid as cv, IconSave as cw, IconSeatBeltSolid as cx, IconSeatBelt as cy, IconSeatSolid as cz, IconHomeSolid as d, IconSwitchVertical as d0, IconSwitch as d1, IconTablet as d2, IconTicketSolid as d3, IconTicketSpecialSolid as d4, IconTicketSpecial as d5, IconTicket as d6, IconTimeSolid as d7, IconTime as d8, IconToiletSolid as d9, IconUserPrivate as dA, IconVoucherSolid as dB, IconVoucher as dC, IconWarning as dD, IconWatchSolid as dE, IconWatch as dF, IconWheelchairInfoSolid as dG, IconWheelchairInfo as dH, IconWheelchairSolid as dI, IconWheelchair as dJ, IconWidthBigger as dK, IconWidthSmaller as dL, IconWifiSolid as dM, IconWifi as dN, IconZoomIn as dO, IconZoomOut as dP, IconToilet as da, IconTrainNightSolid as db, IconTrainNight as dc, IconTrainServiceSolid as dd, IconTrainService as de, IconTrainSolid as df, IconTrainStopSolid as dg, IconTrainStop as dh, IconTrainTimeSolid as di, IconTrainTime as dj, IconTrainWagonSolid as dk, IconTrain as dl, IconTransferSolid as dm, IconTransfer as dn, IconTripSolid as dp, IconTrip as dq, IconTunnel as dr, IconUpload as ds, IconUserAddGroupSolid as dt, IconUserAddGroup as du, IconUserAddSolid as dv, IconUserAdd as dw, IconUserMinusSolid as dx, IconUserMinus as dy, IconUserPrivateSolid as dz, IconLost as e, IconAccountAttentionSolid as f, IconAccountSettingsSolid as g, IconAccountSettings as h, IconAccountSolid as i, IconAccount as j, IconAirportSolid as k, IconAirport as l, IconAppsSolid as m, IconApps as n, IconArchiveSolid as o, IconArchive as p, IconArrowBigDown as q, IconArrowBigLeft as r, IconArrowBigRight as s, IconArrowBigUp as t, IconArrowDown as u, IconArrowUp as v, IconAttentionSolid as w, IconAttention as x, IconAudioSolid as y, IconAudio as z };
